[
  {
    "id": 1,
    "title": "學而 1.1",
    "text": "子曰：“学而时⑵习⑶之，不亦说⑷乎？有朋⑸自远方来，不亦乐乎？人不知⑹，而不愠⑺，不亦君子⑻乎？”",
    "translation": "译文：孔子说：“学了，然后按一定的时间去实习它，不也高兴吗？有志同道合的人从远处来，不也快乐吗？人家不了解我，我却不怨恨，不也是君子吗？”",
    "annotations": "注释：⑴子——《论语》“子曰”的“子”都是指孔子而言。\n⑵时——“时”字在周秦时候若作副词用，等于《孟子·梁惠王上》“斧斤以时入山林”的“以时”，“在一定的时候”或者“在适当的时候”的意思。王肃的《论语注》正是这样解释的。朱熹的《论语集注》把它解为“时常”，是用后代的词义解释古书。\n⑶习——一般人把习解为“温习”，但在古书中，它还有“实习”、“演习”的意义，如《礼记·射义》的“习礼乐”、“习射”。《史记·孔子世家》：“孔子去曹适宋，与弟子习礼大树下。”这一“习”字，更是演习的意思。孔子所讲的功课，一般都和当时的社会生活和政治生活密切结合。像礼（包括各种仪节）、乐（音乐）、射（射箭）、御（驾车）这些，尤其非演习、实习不可。所以这“习”字以讲为实习为好。\n⑷说——音读和意义跟“悦”字相同，高兴、愉快的意思。\n⑸有朋——古本有作“友朋”的。旧注说：“同门曰朋。”宋翔凤《朴学斋札记》说，这里的“朋”字卽指“弟子”，就是《史记·孔子世家》的“故孔子不仕，退而修诗、书、礼乐，弟子弥众，至自远方”译文用“志同道合之人”卽本此义。\n⑹人不知——这一句，“知”下没有宾语，人家不知道什么呢？当时因为有说话的实际环境，不需要说出便可以了解，所以未给说出。这却给后人留下一个谜。有人说，这一句是接上一句说的，从远方来的朋友向我求教，我告诉他，他还不懂，我却不怨恨。这样，“人不知”是“人家不知道我所讲述的”了。这种说法我嫌牵强，所以仍照一般的解释。这一句和宪问篇的“君子病无能焉，不病人之不己知也”的精神相同。\n⑺愠——yùn，怨恨。\n⑻君子——《论语》的“君子”，有时指“有德者”，有时指“有位者”，这里是指“有德者”。"
  },
  {
    "id": 2,
    "title": "學而 1.2",
    "text": "有子⑴曰：“其为人也孝弟⑵，而好犯⑶上者，鲜⑷矣；不好犯上，而好作乱者，未之有也⑸。君子务本，本立而道生。孝弟也者，其为仁之本⑹与⑺！”",
    "translation": "译文：有子说：“他的为人，孝顺爹娘，敬爱兄长，却喜欢触犯上级，这种人是很少的；不喜欢触犯上级，却喜欢造反，这种人从来没有过。君子专心致力于基础工作，基础树立了，‘道’就会产生。孝顺爹娘，敬爱兄长，这就是‘仁’的基础吧！”",
    "annotations": "注释：⑴有子——孔子学生，姓有，名若，比孔子小十三岁，一说小三十三岁，以小三十三岁之说较可信。《论语》记载孔子的学生一般称字，独曾参和有若称“子”（另外，冉有和闵子骞偶一称子，又当别论），因此很多人疑心《论语》就是由他们两人的学生所纂述的。但是有若称子，可能是由于他在孔子死后曾一度为孔门弟子所尊重的缘故（这一史实可参阅《礼记·檀弓上》、《孟子·滕文公上》和《史记·仲尼弟子列传》）。至于《左传》哀公八年说有若是一个“国士”，还未必是足以使他被尊称为“子”的原因。\n⑵孝弟——孝，奴隶社会时期所认为的子女对待父母的正确态度；弟，音读和意义跟“悌”相同，音替，tì，弟弟对待兄长的正确态度。封建时代也把“孝弟”作为维持它那时候的社会制度、社会秩序的一种基本道德力量。\n⑶犯——抵触，违反，冒犯。\n⑷鲜——音显，xiǎn，少。《论语》的“鲜”都是如此用法。\n⑸未之有也——“未有之也”的倒装形式。古代句法有一条这样的规律：否定句，宾语若是指代词，这指代词的宾语一般放在动词前。\n⑹孝弟为仁之本——“仁”是孔子的一种最高道德的名称。也有人说（宋人陈善的《扪虱新语》开始如此说，后人赞同者很多），这“仁”字就是“人”字，古书“仁”“人”两字本有很多写混了的。这里是说“孝悌是做人的根本”。这一说虽然也讲得通，但不能和“本立而道生”一句相呼应，未必符合有子的原意。《管子·戒篇》说，“孝弟者，仁之祖也”，也是这意。\n⑺与——音读和意义跟“欤”字一样，《论语》的“欤”字都写作“与”。"
  },
  {
    "id": 3,
    "title": "學而 1.3",
    "text": "子曰：“巧言令色⑴，鲜矣仁！”",
    "translation": "译文：孔子说：“花言巧语，伪善的面貌，这种人，‘仁德’是不会多的。”",
    "annotations": "注释：⑴巧言令色——朱注云：“好其言，善其色，致饰于外，务以说人。 ”所以译文以“花言巧语”译巧言，“伪善的面貌”译令色。"
  },
  {
    "id": 4,
    "title": "學而 1.4",
    "text": "曾子⑴曰：“吾日三省⑵吾身——为人谋而不忠乎？与朋友交而不信⑶乎？传⑷不习⑸乎？”",
    "translation": "译文：曾子说：“我每天多次自己反省：替别人办事是否尽心竭力了呢？同朋友往来是否诚实呢？老师传授我的学业是否复习了呢？”",
    "annotations": "注释：⑴曾子——孔子学生，名参（音森，sēn），字子舆，南武城（故城在今天的山东枣庄市附近）人，比孔子小四十六岁（公元前505—435）。\n⑵三省——“三”字有读去声的，其实不破读也可以。“省”音醒，xǐng，自我检查，反省，内省。“三省”的“三”表示多次的意思。古代在有动作性的动词上加数字，这数字一般表示动作频率。而“三”“九”等字，又一般表示次数的多，不要着实地去看待。说详汪中《述学·释三九》。这里所反省的是三件事，和“三省”的“三”只是巧合。如果这“三”字是指以下三件事而言，依《论语》的句法便应该这样说：“吾日省者三。”和宪问篇的“君子道者三”一样。\n⑶信——诚也。\n⑷传——平声，chuán，动词作名词用，老师的传授。\n⑸习——这“习”字和“学而时习之”的“习”一样，包括温习、实习、演习而言，这里概括地译为“复习”。"
  },
  {
    "id": 5,
    "title": "學而 1.5",
    "text": "子曰：“道⑴千乘之国⑵，敬事⑶而信，节用而爱人⑷，使民以时⑸。”",
    "translation": "译文：孔子说：“治理具有一千辆兵车的国家，就要严肃认真地对待工作，信实无欺，节约费用，爱护官吏，役使老百姓要在农闲时间。”",
    "annotations": "注释：⑴道——动词，治理的意思。\n⑵千乘之国——乘音剩，shèng，古代用四匹马拉着的兵车。春秋时代，打仗用车子，所以国家的强弱都用车辆的数目来计算。春秋初期，大国都没有千辆兵车。像《左传》僖公二十八年所记载的城濮之战，晋文公还只七百乘。但是在那时代，战争频繁，无论侵略者和被侵略者都必须扩充军备。侵略者更因为兼并的结果，兵车的发展速度更快；譬如晋国到平丘之会，据叔向的话，已有四千乘了（见《左传》昭公十三年）。千乘之国，在孔子之时已经不是大国，因此子路也说“千乘之国摄乎大国之间”（11.26）的话了。\n⑶敬事——“敬”字一般用于表示工作态度，因之常和“事”字连用，如卫灵公篇的“事君敬其事而后其食”。\n⑷爱人——古代“人”字有广狭两义。广义的“人”指一切人羣，狭义的人只指士大夫以上各阶层的人。这里和“民”（使“民”以时）对言，用的是狭义。\n⑸使民以时——古代以农业为主，“使民以时”卽是《孟子·梁惠王上》的“不违农时”，因此用意译。"
  },
  {
    "id": 6,
    "title": "學而 1.6",
    "text": "子曰：“弟子⑴入⑵则孝，出⑵则悌，谨⑶而信，泛爱众，而亲仁⑷。行有余力，则以学文。”",
    "translation": "译文：孔子说：“后生小子，在父母跟前，就孝顺父母；离开自己房子，便敬爱兄长；寡言少语，说则诚实可信，博爱大众，亲近有仁德的人。这样躬行实践之后，有剩余力量，就再去学习文献。”",
    "annotations": "注释：⑴弟子——一般有两种意义：（甲）年纪幼小的人，（乙）学生。这里用的是第一种意义。\n⑵入、出——《礼记·内则》：“由命士以上，父子皆异宫”，则知这里的“弟子”是指“命士”以上的人物而言。“入”是“入父宫”，“出”是“出己宫”。\n⑶谨——寡言叫做谨。详见杨遇夫先生的《积微居小学金石论丛》卷一。\n⑷仁——“仁”卽“仁人”，和雍也篇第六的“井有仁焉”的“仁”一样。古代的词汇经常运用这样一种规律：用某一具体人和事物的性质、特征甚至原料来代表那一具体的人和事物。"
  },
  {
    "id": 7,
    "title": "學而 1.7",
    "text": "子夏⑴曰：“贤贤易色⑵；事父母，能竭其力；事君，能致⑶其身；与朋友交，言而有信。虽曰未学，吾必谓之学矣。”",
    "translation": "译文：子夏说：“对妻子，重品德，不重容貌；侍奉爹娘，能尽心竭力；服事君上，能豁出生命；同朋友交往，说话诚实守信。这种人，虽说没学习过，我一定说他已经学习过了。”",
    "annotations": "注释：⑴子夏——孔子学生，姓卜，名商，字子夏，比孔子小四十四岁。（公元前507—？）\n⑵贤贤易色——这句话，一般的解释是：“用尊贵优秀品德的心来交换（或者改变）爱好美色的心。”照这种解释，这句话的意义就比较空泛。陈祖范的《经咫》、宋翔凤的《朴学斋札记》等书却说，以下三句，事父母、事君、交朋友，各指一定的人事关系；那么，“贤贤易色”也应该是指某一种人事关系而言，不能是一般的泛指。奴隶社会和封建社会把夫妻间关系看得极重，认为是“人伦之始”和“王化之基”，这里开始便谈到它，是不足为奇的。我认为这话很有道理。“易”有交换、改变的意义，也有轻视（如言“轻易”）、简慢的意义。因之我便用《汉书》卷七十五《李寻传》颜师古注的说法，把“易色”解为“不重容貌”。\n⑵致——有“委弃”、“献纳”等意义，所以用“豁出生命”来译它。"
  },
  {
    "id": 8,
    "title": "學而 1.8",
    "text": "子曰：“君子⑴不重，则不威；学则不固。主忠信⑵。无友不如己者⑶。\n过，则勿惮改。”",
    "translation": "译文：孔子说：“君子，如果不庄重，就没有威严；卽使读书，所学的也不会巩固。要以忠和信两种道德为主。不要跟不如自己的人交朋友。有了过错，就不要怕改正。”",
    "annotations": "注释：⑴君子——这一词一直贯串到末尾，因此译文将这两字作一停顿。\n⑵主忠信——颜渊篇（12.10）也说，“主忠信，徙义，崇德也”，可见“忠信”是道德。\n⑶无友不如己者——古今人对这一句发生不少怀疑，因而有一些不同的解释。译文只就字面译出。"
  },
  {
    "id": 9,
    "title": "學而 1.9",
    "text": "曾子曰：“慎终⑴，追远⑵，民德归厚矣。”",
    "translation": "译文：曾子说：“谨慎地对待父母的死亡，追念远代祖先，自然会导致老百姓归于忠厚老实了。”",
    "annotations": "注释：⑴慎终——郑玄的注：“老死曰终。”可见这“终”字是指父母的死亡。慎终的内容，刘宝楠《论语正义》引《檀弓》曾子的话是指附身（装殓）、附棺（埋葬）的事必诚必信，不要有后悔。\n⑵追远——具体地说是指“祭祀尽其敬”。两者译文都只就字面译出。"
  },
  {
    "id": 10,
    "title": "學而 1.10",
    "text": "子禽⑴问于子贡⑵曰：“夫子⑶至于是邦也，必闻其政，求之与？抑与之与？”子贡曰：“夫子温、良、恭、俭、让以得之。夫子之求之也，其诸⑷异乎人之求之与？”",
    "translation": "译文：子禽向子贡问道：“他老人家一到哪个国家，必然听得到那个国家的政事，求来的呢？还是别人自动告诉他的呢？”子贡道：“他老人家是靠温和、善良、严肃、节俭、谦逊来取得的。他老人家获得的方法，和别人获得的方法，不相同吧？”",
    "annotations": "注释：⑴子禽——陈亢（kàng）字子禽。从子张篇所载的事看来，恐怕不是孔子的学生。《史记·仲尼弟子列传》也不载此人。但郑玄注《论语》和《檀弓》都说他是孔子学生，不晓得有什么根据。（臧庸的《拜经日记》说子禽就是仲尼弟子列传的原亢禽，简朝亮的《论语集注补疏》曾加以辩驳。）\n⑵子贡——孔子学生，姓端木，名赐，字子贡，卫人，比孔子小三十一岁。（公元前520—？）\n⑶夫子——这是古代的一种敬称，凡是做过大夫的人，都可以取得这一敬称。孔子曾为鲁国的司寇，所以他的学生称他为夫子，后来因此沿袭以称呼老师。在一定的场合下，也用以特指孔子。\n⑷其诸——洪颐煊《读书丛録》云：“公羊桓六年传，‘其诸以病桓与？’闵元年传，‘其诸吾仲孙与？’僖二十四年传，‘其诸此之谓与？’宣五年传，‘其诸为其双双而俱至者与？’十五年传，‘其诸则宜于此焉变矣。’‘其诸’是齐鲁间语。”案，总上诸例，皆用来表示不肯定的语气。黄家岱《嬹艺轩杂着》说“其诸”意为“或者”，大致得之。"
  },
  {
    "id": 11,
    "title": "學而 1.11",
    "text": "子曰：“父在，观其⑴志；父没，观其⑴行⑵；三年⑶无改于父之道⑷，可谓孝矣。”",
    "translation": "译文：孔子说：“当他父亲活着，［因为他无权独立行动，］要观察他的志向;他父亲死了，要考察他的行为；若是他对他父亲的合理部分，长期地不加改变，可以说做到孝了。”",
    "annotations": "注释：⑴其——指儿子，不是指父亲。\n⑵行——去声，xìng。\n⑶三年——古人这种数字，有时不要看得太机械。它经常只表示一种很长的期间。\n⑷道——有时候是一般意义的名词，无论好坏、善恶都可以叫做道。但更多时候是积极意义的名词，表示善的好的东西。这里应该这样看，所以译为“合理部分”。"
  },
  {
    "id": 12,
    "title": "學而 1.12",
    "text": "有子曰：“礼之用，和⑴为贵。先王之道，斯为美；小大由之。有所不行⑵，知和而和，不以礼节之，亦不可行也。”",
    "translation": "译文：有子说：“礼的作用，以遇事都做得恰当为可贵。过去圣明君王的治理国家，可宝贵的地方就在这里；他们小事大事都做得恰当。但是，如有行不通的地方，便为恰当而求恰当，不用一定的规矩制度来加以节制，也是不可行的。”",
    "annotations": "注释：⑴和——《礼记·中庸》：“喜怒哀乐之未发谓之中，发而皆中节谓之和。”杨遇夫先生《论语疏证》说：“事之中节者皆谓之和，不独喜怒哀乐之发一事也。说文云：‘龢，调也。’‘盉，调味也。’乐调谓之龢，味调谓之盉，事之调适者谓之和，其义一也。和今言适合，言恰当，言恰到好处。”\n⑵有所不行——皇侃《义疏》把这句属上，全文便如此读：“礼之用，和为贵。先王之道，斯为美。小大由之，有所不行。……”他把“和”解为音乐，说：“此以下明人君行化必\n礼乐相须。……变乐言和，见乐功也。……小大由之有所不行者，言每事小大皆用礼，而不以乐和之，则其政有所不行也。”这种句读法值得考虑，但把“和”解释为音乐，而且认为“小大由之”的“之”是指“礼”而言，都觉牵强。特为注出，以供大家考虑。"
  },
  {
    "id": 13,
    "title": "學而 1.13",
    "text": "有子曰：“信近于义，言可复⑴也。恭近于礼，远⑵耻辱也。因⑶不失其亲，亦可宗⑷也。”",
    "translation": "译文：有子说：“所守的约言符合义，说的话就能兑现。态度容貌的庄矜合于礼，就不致遭受侮辱。依靠关系深的人，也就可靠了。”",
    "annotations": "注释：⑴复——《左传》僖公九年荀息说：“吾与先君言矣，不可以贰，能欲复言而爱身乎？”又哀公十六年叶公说：“吾闻胜也好复言，……复言非信也。”这“复言”都是实践诺言之义。《论语》此义当同于此。朱熹《集注》云：“复，践言也。”但未举论证，因之后代训诂家多有疑之者。童第德先生为我举出《左传》为证，足补古今字书之所未及。\n⑵远——去声，音院，yuàn，动词，使动用法，使之远离的意思。此处亦可以译为避免。\n⑶因——依靠，凭借。有人读为“姻”字，那“因不失其亲”便当译为“所与婚姻的人都是可亲的”，恐未必如此。\n⑷宗——主，可靠。一般解释为“尊敬”，不妥。"
  },
  {
    "id": 14,
    "title": "學而 1.14",
    "text": "子曰：“君子⑴食无求饱，居无求安，敏于事而慎于言，就有道而正⑵焉，可谓好学也已。”",
    "translation": "译文：孔子说：“君子，吃食不要求饱足，居住不要求舒适，对工作勤劳敏捷，说话却谨慎，到有道的人那里去匡正自己，这样，可以说是好学了。”",
    "annotations": "注释：⑴君子——《论语》的“君子”有时指“有位之人”，有时指“有德之人”。但有的地方究竟是指有位者，还是指有德者，很难分别。此处大概是指有德者。\n⑵正——《论语》“正”字用了很多次。当动词的，都作“匡正”或“端正”讲，这里不必例外。一般把“正”字解为“正其是非”、“判其得失”，我所不取。"
  },
  {
    "id": 15,
    "title": "學而 1.15",
    "text": "子贡曰：“贫而无谄，富而无骄，何如⑴？”子曰：“可也；未若贫而乐\n⑵，富而好礼者也。”子贡曰：“《诗》云：‘如切如磋，如琢如磨⑶’其斯之谓与？”子曰：“赐⑷也，始可与言诗已矣，告诸往而知来者⑸。”",
    "translation": "译文：子贡说：“贫穷却不巴结奉承，有钱却不骄傲自大，怎么样？”孔子说：“可以了；但是还不如虽贫穷却乐于道，纵有钱却谦虚好礼哩。”子贡说： “《诗经》上说：‘要像对待骨、角、象牙、玉石一样，先开料，再糙锉，细刻，然后磨光。’那就是这样的意思吧？”孔子道：“赐呀，现在可以同你讨论《诗经》了，告诉你一件，你能有所发挥，举一反三了。”",
    "annotations": "注释：⑴何如——《论语》中的“何如”，都可以译为“怎么样”。\n⑵贫而乐——皇侃本“乐”下有“道”字。郑玄注云：“乐谓志于道，不以贫为忧苦。”所以译文增“于道”两字。\n⑶如切如磋，如琢如磨——两语见于《诗经·卫风·淇奥篇》。\n⑷赐——子贡名。孔子对学生都称名。\n⑸告诸往而知来者——“诸”，在这里用法同“之”一样。“往”，过去的事，这里譬为已知的事；“来者”，未来的事，这里譬为未知的事。译文用意译法。孔子赞美子贡能运用《诗经》作譬，表示学问道德都要提高一步看。"
  },
  {
    "id": 16,
    "title": "學而 1.16",
    "text": "子曰：“不患人之不己知，患不知人也。”",
    "translation": "译文：孔子说：“别人不了解我，我不急；我急的是自己不了解别人。”",
    "annotations": ""
  },
  {
    "id": 17,
    "title": "為政 2.1",
    "text": "子曰：“为政以德，譬如北辰⑴居其所而众星共⑵之。”",
    "translation": "译文：孔子说：“用道德来治理国政，自己便会像北极星一般，在一定的位置上，别的星辰都环绕着它。”",
    "annotations": "注释：⑴北辰——由于地球自转轴正对天球北极，在地球自转和公转所反映出来的恒星周日和周年视运动中，天球北极是不动的，其它恒星则绕之旋转。我国黄河中、下游流域，约为北纬36度，因之天球北极也高出北方地平线上36度。孔子所说的北辰，不是指天球北极，而是指北极星。天球北极虽然不动，其它星辰都环绕着它动，但北极星也是动的，而且转动非常快。祗是因为它距离地球太远，约 782光年，人们不觉得它移动罢了。距今四千年前北极在右枢（天龙座α）附近，今年则在勾陈一（小熊座α）。⑵共——同拱，与《左传》僖公三十二年“尔墓之木拱矣”的“拱”意义相近，环抱、环绕之意。"
  },
  {
    "id": 18,
    "title": "為政 2.2",
    "text": "子曰：“诗三百⑴，一言以蔽之，曰：‘思无邪⑵’。”",
    "translation": "译文：孔子说：“《诗经》三百篇，用一句话来概括它，就是‘思想纯正’。”",
    "annotations": "注释：⑴诗三百——《诗经》实有三百五篇，“三百”只是举其整数。⑵思无邪——“思无邪”一语本是《诗经·鲁颂·駉篇》之文，孔子借它来评论所有诗篇。思字在《駉篇》本是无义的语首词，孔子引用它却当思想解，自是断章取义。俞樾《曲园杂纂》说项说这也是语辞，恐不合孔子原意。"
  },
  {
    "id": 19,
    "title": "為政 2.3",
    "text": "子曰：“道⑴之以政，齐之以刑，民免⑵而无耻；道之以德，齐之以礼，有耻且格⑶。”",
    "translation": "译文：孔子说：“用政法来诱导他们，使用刑罚来整顿他们，人民只是暂时地免于罪过，却没有廉耻之心。如果用道德来诱导他们，使用礼教来整顿他们，人民不但有廉耻之心，而且人心归服。”",
    "annotations": "注释：⑴道——有人把它看成“道千乘之国”的“道”一样，治理的意思。也有人把它看成“导”字，引导的意思，我取后一说。⑵免——先秦古书若单用一个“免”字，一般都是“免罪”、“免刑”、“免祸”的意思。⑶格——这个字的意义本来很多，在这里有把它解为“来”的，也有解为“至”的，还有解为“正”的，更有写作“恪”，解为“敬”的。这些不同的讲解都未必符合孔子原意。《礼记·缁衣篇》：“夫民，教之以德，齐之以礼，则民有格心；教之以政，齐之以刑，则民有遯心。”这话可以看作孔子此言的最早注释，较为可信。此处“格心”和“遯心”相对成文，“遯”卽“遁”字，逃避的意思。逃避的反面应该是亲近、归服、向往，所以用“人心归服”来译它。"
  },
  {
    "id": 20,
    "title": "為政 2.4",
    "text": "子曰：“吾十有⑴五而志于学，三十而立⑵，四十而不惑⑶，五十而知天命⑷，六十而耳顺⑸，七十而从心所欲，不踰矩⑹。”",
    "translation": "译文：孔子说：“我十五岁，有志于学问；三十岁，［懂礼仪，］说话做事都有把握；四十岁，［掌握了各种知识，］不致迷惑；五十岁，得知天命；六十岁，一听别人言语，便可以分别真假，判明是非；到了七十岁，便随心所欲，任何念头不越出规矩。”",
    "annotations": "注释：⑴有——同又。古人在整数和小一位的数字之间多用“有”字，不用“又”字。⑵立——泰伯篇说：“立于礼。”季氏篇又说：“不学礼，无以立。”因之译文添了“懂得礼仪”几个字。“立”是站立的意思，这里是“站得住”的意思，为求上下文的流畅，意译为遇事“都有把握”。⑶不惑——子罕篇和宪问篇都有“知者不惑”的话，所以译文用“掌握了知识”来说明“不惑”。⑷天命——孔子不是宿命论者，但也讲天命。孔子的天命，我已有文探讨。后来的人虽然谈得很多，未必符合孔子本意。因此，这两个字暂不译出。⑸耳顺——这两个字很难讲，企图把它讲通的也有很多人，但都觉牵强。译者姑且作如此讲解。⑷从心所欲不踰矩——“从”字有作“纵”字的，皇侃《义疏》也读为“纵”，解为放纵。柳宗元〈与杨晦之书〉说“孔子七十而纵心”，不但“从”字写作“纵”，而且以“心”字绝句，“所欲”属下读。“七十而纵心，所欲不踰矩”。但“纵”字古人多用于贬义，如《左传》昭公十年“我实纵欲”，柳读难从。"
  },
  {
    "id": 21,
    "title": "為政 2.5",
    "text": "孟懿子⑴问孝。子曰：“无违⑵。”\n樊迟⑶御，子告之曰：“孟孙问孝于我，我对曰，无违。”樊迟曰：“何谓也？”子曰：“生，事之以礼⑷；死，葬之以礼，祭之以礼。”",
    "translation": "译文：孟懿子向孔子问孝道。孔子说：“不要违背礼节。”不久，樊迟替孔子赶车子，孔子便告诉他说：“孟孙向我问孝道，我答复说，不要违背礼节。”樊迟道：“这是什么意思？”孔子道：“父母活着，依规定的礼节侍奉他们；死了，依规定的礼节埋葬他们，祭祀他们。”",
    "annotations": "注释：⑴孟懿子——鲁国的大夫，三家之一，姓仲孙，名何忌，“懿”是谥号。他父亲是孟僖子仲孙貜。《左传》昭公七年说，孟僖子将死，遗嘱要他向孔子学礼。⑵无违——黄式三《论语后案》说：“《左传》桓公二年云，‘昭德塞违’，‘灭德立违’，‘君违，不忘谏之以德’；六年传云：‘有嘉德而无违心’，襄公二十六年传云，‘正其违而治之烦’……古人凡背礼者谓之违。”因此，我把“违”译为“违礼”。王充《论衡·问孔篇》曾经质问孔子，为什么不讲“无违礼”，而故意省略讲为“无违”，难道不怕人误会为“毋违志”吗？由此可见“违”字的这一含义在后汉时已经不\n被人所了解了。⑶樊迟——孔子学生，名须，字子迟，比孔子小四十六岁。［《史记·仲尼弟子列传》作小三十六岁，《孔子家语》作小四十六岁。若从《左传》哀公十一年所记载的樊迟的事考之，可能《史记》的“三”系“亖”（古四字）之误。］⑷生，事之以礼——“生”和下句“死”都是表示时间的节缩语，所以自成一逗。古代的礼仪有一定的差等，天子、诸侯、大夫、士、庶人各不相同。鲁国的三家是大夫，不但有时用鲁公（诸侯）之礼，甚至有时用天子之礼。这种行为当时叫做“僭”，是孔子所最痛心的。孔子这几句答语，或者是针对这一现象发出的。"
  },
  {
    "id": 22,
    "title": "為政 2.6",
    "text": "孟武伯⑴问孝。子曰：“父母唯其⑵疾之忧。”",
    "translation": "译文：孟武伯向孔子请教孝道。孔子道：“做爹娘的只是为孝子的疾病发愁。”",
    "annotations": "注释：⑴孟武伯——仲孙彘，孟懿子的儿子，“武”是谥号。⑵其——第三人称表示领位的代名词，相当于“他的”、“他们的”。但这里所指代的是父母呢，还是儿女呢？便有两说。王充《论衡·问孔篇》说：“武伯善忧父母，故曰，唯其疾之忧。”《淮南子·说林训》说：“忧父之疾者子，治之者医。”高诱注云：“父母唯其疾之忧，故曰忧之者子。”可见王充、高诱都以为“其”字是指代父母而言。马融却说：“言孝子不妄为非，唯疾病然后使父母忧。”把“其”字代孝子。两说都可通，而译文采取马融之说。"
  },
  {
    "id": 23,
    "title": "為政 2.7",
    "text": "子游⑴问孝。子曰：“今之孝者，是谓能养⑵。至于⑶犬马，皆能有养⑷；不敬，何以别乎？”",
    "translation": "译文：子游问孝道。孔子说：“现在的所谓孝，就是说能够养活爹娘便行了。对于狗马都能够得到饲养；若不存心严肃地孝顺父母，那养活爹娘和饲养狗马怎样去分别呢？”",
    "annotations": "注释：⑴子游——孔子学生，姓言，名偃，字子游，吴人，小于孔子四十五岁。⑵养——“养父母”的“养”从前人都读去声，音漾，yàng。⑶至于——张相的《诗词曲语词汇释》把“至于”解作“卽使”、“就是”。在这一段中固然能够讲得文从字顺，可是“至于”的这一种用法，在先秦古书中仅此一见，还难于据以肯定。我认为这一“至于”和《孟子·告子上》的“惟耳亦然。至于声，天下期于师旷，是天下之耳相似也。惟目亦然。至于子都，天下莫不知其姣也。”的“至于”用法相似。都可用“谈到”、“讲到”来译它。不译也可。⑷至于犬马皆能有养——这一句很有些不同的讲法。一说是犬马也能养活人，人养活人，若不加以敬，便和犬马的养活人无所分别。这一说也通。还有一说是犬马也能养活它自己的爹娘（李光地《论语剳记》、翟灏《四书考异》），可是犬马在事实上是不能够养活自己爹娘的，所以这说不可信。还有人说，犬马是比喻小人之词（刘宝楠《论语正义》引刘宝树说），可是用这种比喻的修辞法，在《论语》中找不出第二个相似的例子，和《论语》的文章风格不相侔，更不足信。"
  },
  {
    "id": 24,
    "title": "為政 2.8",
    "text": "子夏问孝。子曰：“色难⑴。有事，弟子⑵服其劳；有酒食⑶，先生馔⑷，曾⑸是以为孝乎？”",
    "translation": "译文：子夏问孝道。孔子道：“儿子在父母前经常有愉悦的容色，是件难事。有事情，年轻人效劳；有酒有肴，年长的人吃喝，难道这竟可认为是孝么？”",
    "annotations": "注释：⑴色难——这句话有两说，一说是儿子侍奉父母时的容色。《礼记·祭义篇》说：“孝子之有深爱者必有和气，有和气者必有愉色，有愉色者必有婉容。 ”可以做这两个字的注脚。另一说是侍奉父母的容色，后汉的经学家包咸、马融都如此说。但是，若原意果如此的话，应该说为“侍色为难”，不该简单地说为“色难”，因之我不采取。⑵弟子、先生——刘台拱《论语骈枝》云：“《论语》言‘弟子’者七，其二皆年幼者，其五谓门人。言‘先生’者二、皆谓年长者。”马融说：“先生谓父兄也。”亦通。⑶食——旧读去声，音嗣，sì，食物。不过现在仍如字读shí，如“主食”、“副食”、“面食”。⑷馔——zhuàn，吃喝。《鲁论》作“馂”。馂，食余也。那么这句便当如此读：“有酒，食先生馂”，而如此翻译：“有酒，幼辈吃其剩余。”⑸曾——音层，céng，副词，竟也。"
  },
  {
    "id": 25,
    "title": "為政 2.9",
    "text": "子曰：“吾与回⑴言终日，不违，如愚。退而省其私⑵，亦足以发，回也不愚。”",
    "translation": "译文：孔子说：“我整天和颜回讲学，他从不提反对意见和疑问，像个蠢人。等他退回去自己研究，却也能发挥，可见颜回并不愚蠢。”",
    "annotations": "注释：⑴回——颜回，孔子最得意的学生，鲁国人，字子渊，小孔子三十岁（《史记·仲尼弟子列传》如此。但根据毛奇龄《论语稽求篇》和崔适《论语足征记》的考证，《史记》的“三十”应为“四十”之误，颜渊实比孔子小四十岁，公元前511—480）。⑵退而省其私——朱熹的《集注》以为孔子退而省颜回的私，“则见其日用动静语默之间皆足以发明夫子之道。”用颜回的实践来证明他能发挥孔子之道，说也可通。"
  },
  {
    "id": 26,
    "title": "為政 2.10",
    "text": "子曰：“视其所以⑴，观其所由⑵，察其所安⑶。人焉廋哉⑷？人焉廋哉？”",
    "translation": "译文：孔子说：“考查一个人所结交的朋友；观察他为达到一定目的所采用的方式方法；了解他的心情，安于什么，不安于什么。那么，这个人怎样隐藏得住呢？这个人怎样隐藏得住呢？”",
    "annotations": "注释：⑴所以——“以”字可以当“用”讲，也可以当“与”讲。如果解释为“用”，便和下句“所由”的意思重复，因此我把它解释为“与”，和微子篇第十八“而谁以易之”的“以”同义。有人说“以犹为也”。“视其所以”卽《大戴礼·文王官人篇》的“考其所为”，也通。⑵所由——“由”，“由此行”的意思。学而篇第一的“小大由之”，雍也篇第六的“行不由径”，泰伯篇第八的“民可使由之”的“由”都如此解。“所由”是指所从由的道路，因此我用方式方法来译述。⑶所安——“安”就是阳货篇第十七孔子对宰予说的“女安，则为之”的“安”。一个人未尝不错做一两件坏事，如果因此而心不安，仍不失为好人。因之译文多说了几句。⑷人焉廋哉——焉，何处；廋，音搜，sōu，隐藏，藏匿。这句话机械地翻译，便是：“这个人到哪里去隐藏呢。”《史记·魏世家》述说李克的观人方法是“居视其所亲，富视其所与，达视其所举，穷视其所不为，贫视其所不取”。虽较具体，却无此深刻。"
  },
  {
    "id": 27,
    "title": "為政 2.11",
    "text": "子曰：“温故而知新⑴，可以为师矣。”",
    "translation": "译文：孔子说：“在温习旧知识时，能有新体会、新发现，就可以做老师了。”",
    "annotations": "注释：⑴温故而知新——皇侃《义疏》说，“温故”就是“月无忘其所能”，“知新”就是“日知其所亡”（19.5），也通。"
  },
  {
    "id": 28,
    "title": "為政 2.12",
    "text": "子曰：“君子不器⑴。”",
    "translation": "译文：孔子说：“君子不像器皿一般，［只有一定的用途。］”",
    "annotations": "注释：⑴古代知识范围狭窄，孔子认为应该无所不通。后人还曾说，一事之不知，儒者之耻。虽然有人批评孔子“博学而无所成名”（9.2），但孔子仍说“君子不器”。"
  },
  {
    "id": 29,
    "title": "為政 2.13",
    "text": "子贡问君子。子曰：“先行其言而后从之。”",
    "translation": "译文：子贡问怎样才能做一个君子。孔子道：“对于你要说的话，先实行了，再说出来［这就够说是一个君子了］。”",
    "annotations": ""
  },
  {
    "id": 30,
    "title": "為政 2.14",
    "text": "子曰：“君子周而不比⑴，小人比而不周。”",
    "translation": "译文：孔子说：“君子是团结，而不是勾结；小人是勾结，而不是团结。”",
    "annotations": "注释：⑴周、比——“周”是以当时所谓道义来团结人，“比”则是以暂时共同利害互相勾结。“比”旧读去声bì。"
  },
  {
    "id": 31,
    "title": "為政 2.15",
    "text": "子曰：“学而不思则罔⑴，思而不学则殆⑵。”",
    "translation": "译文：孔子说：“只是读书，却不思考，就会受骗；只是空想，却不读书，就会缺乏信心。”",
    "annotations": "注释：⑴罔——诬罔的意思。“学而不思”则受欺，似乎是《孟子·尽心下》“尽信书，不如无书”的意思。⑵殆——《论语》的“殆”（dài）有两个意义。下文第十八章“多见阙殆”的“殆”当“疑惑”解（说本王引之《经义述闻》），微子篇“今之从政者殆而”的“殆”当危险解。这里两个意义都讲得过去，译文取前一义。古人常以“罔”“殆”对文，如《诗经·小雅·节南山》云：“弗问弗仕，勿罔君子，式夷式己，无小人殆。”（“无小人殆”卽“无殆小人”，因韵脚而倒装。）旧注有以“罔然无所得”释“罔”，以“精神疲殆”释“殆”的，似乎难以圆通。"
  },
  {
    "id": 32,
    "title": "為政 2.16",
    "text": "子曰：“攻⑴乎异端⑵，斯⑶害也已⑷。”",
    "translation": "译文：孔子说：“批判那些不正确的议论，祸害就可以消灭了。”",
    "annotations": "注释：⑴攻——《论语》共享四次“攻”字，像先进篇的“小子鸣鼓而攻之”，颜渊篇的“攻其恶，无攻人之恶”的三个“攻”字都当“攻击”解，这里也不应例外。很多人却把它解为“治学”的“治”。⑵异端——孔子之时，自然还没有诸子百家，因之很难译为“不同的学说”，但和孔子相异的主张、言论未必没有，所以译为“不正确的议论”。⑶斯——连词，“这就”的意思。⑷已——应该看为动词，止也。因之我译为“消灭”。如果把“攻”字解为“治”，那么“斯”字得看作指代词，“这”的意思；“也已”得看作语气词。全文便如此译：“从事于不正确的学术研究，这是祸害哩。”一般的讲法是如此的，虽能文从字顺，但和《论语》词法和句法都不合。"
  },
  {
    "id": 33,
    "title": "為政 2.17",
    "text": "子曰：“由⑴！诲女知之乎！知之为知之，不知为不知，是知也⑵。”",
    "translation": "译文：孔子说：“由！教给你对待知或不知的正确态度吧！知道就是知道，不知道就是不知道，这就是聪明智慧。”",
    "annotations": "注释：⑴由——孔子学生，仲由，字子路，卞（故城在今山东泗水县东五十里）人，小于孔子九岁。（公元前542—480）⑵是知也——《荀子·子道篇》也载了这一段话，但比这详细。其中有两句道：“言要则知，行至则仁。”因之读“知”为“智”。如果“知”如字读，便该这样翻译：这就是对待知或不知的正确态度。"
  },
  {
    "id": 34,
    "title": "為政 2.18",
    "text": "子张⑴学干禄⑵。子曰：“多闻阙疑，慎言其余，则寡尤；多见阙殆⑶，慎行其余，则寡悔。言寡尤，行⑷寡悔，禄在其中矣。”",
    "translation": "译文：子张向孔子学求官职得俸禄的方法。孔子说：“多听，有怀疑的地方，加以保留；其余足以自信的部分，谨慎地说出，就能减少错误。多看，有怀疑的地方，加以保留；其余足以自信的部分，谨慎地实行，就能减少懊悔。言语的错误少，行动的懊悔少，官职俸禄就在这里面了。”",
    "annotations": "注释：⑴子张——孔子学生颛孙师，字子张，陈人，小于孔子四十八岁。（公元前503—？）⑵干禄——干，求也，禄，旧时官吏的俸给。⑶阙殆——和“阙疑”同意。上文作“阙疑”，这里作“阙殆”。“疑”和“殆”是同义词，所谓“互文”见义。⑷行——名词，去声，xìng。"
  },
  {
    "id": 35,
    "title": "為政 2.19",
    "text": "哀公⑴问曰：“何为则民服？”孔子对曰⑵：“举直错诸枉⑶，则民服；举枉错诸直，则民不服。”",
    "translation": "译文：鲁哀公问道：“要做些甚么事才能使百姓服从呢？”，孔子答道：“把正直的人提拔出来，放在邪曲的人之上，百姓就服从了；若是把邪曲的人提拔出来，放在正直的人之上，百姓就会不服从。”",
    "annotations": "注释：⑴哀公——鲁君，姓姬，名蒋，定公之子，继定公而卽位，在位二十七年。（公元前494—466）“哀”是谥号。⑵孔子对曰——《论语》的行文体例是，臣下对答君上的询问一定用“对曰”，这里孔子答复鲁君之问，所以用“孔子对曰”。⑶错诸枉——“错”有放置的意思，也有废置的意思。一般人把它解为废置，说是“废置那些邪恶的人”（把“诸”字解为“众”）。这种解法和古汉语语法规律不相合。因为“枉”、“直”是以虚代实的名词，古文中的“众”、“诸”这类数量形容词，一般只放在真正的实体词之上，不放在这种以虚代实的词之上。这一规律，南宋人孙季和（名应时）便已明白。王应麟《困学纪闻》曾引他的话说：“若诸家解，何用二‘诸’字？”这二“诸”字只能看做“之于”的合音，“错”当“放置”解。“置之于枉”等于说“置之于枉人之上”，古代汉语“于”字之后的方位词有时可以省略。朱亦栋《论语札记》解此句不误。"
  },
  {
    "id": 36,
    "title": "為政 2.20",
    "text": "季康子⑴问：“使民敬、忠以⑵劝，如之何？”子曰：“临之以庄，则敬；孝慈，则忠；举善而教不能，则劝。”",
    "translation": "译文：季康子问道：“要使人民严肃认真，尽心竭力和互相勉励，应该怎么办呢？”孔子说：“你对待人民的事情严肃认真，他们对待你的政令也会严肃认真了；你孝顺父母，慈爱幼小，他们也就会对你尽心竭力了；你提拔好人，教育能力弱的人，他们也就会劝勉了。”",
    "annotations": "注释：⑴季康子——季孙肥，鲁哀公时正卿，当时政治上最有权力的人。“康”是谥号。⑵以——连词，与“和”同。"
  },
  {
    "id": 37,
    "title": "為政 2.21",
    "text": "或谓孔子曰：“子奚不为政？”子曰：“《书》⑴云：‘孝乎惟孝，友于兄弟，施⑵于有政⑶。’是亦为政，奚其为为政？”",
    "translation": "译文：有人对孔子道：“你为什么不参与政治？”孔子道：“《尚书》上说，‘孝呀，只有孝顺父母，友爱兄弟，把这种风气影响到政治上去。’这也就是参与政治了呀，为什么定要做官才算参与政治呢？”",
    "annotations": "注释：⑴书云——以下三句是《尚书》的逸文，作《伪古文尚书》的便从这里采入《君陈篇》。⑵施——这里应该当“延及”讲，从前人解为“施行”，不妥。⑶施于有政——“有”字无义，加于名词之前，这是古代构词法的一种形态，详拙著《文言语法》。杨遇夫先生说：“政谓卿相大臣，以职言，不以事言。”（说详增订《积微居小学金石论丛·〈论语〉子奚不为政解》）那么。这句话便当译为“把这种风气影响到卿相大臣上去”。"
  },
  {
    "id": 38,
    "title": "為政 2.22",
    "text": "子曰：“人而无信⑴，不知其可也。大车无輗，小车无軏⑵，其何以行之哉？”",
    "translation": "译文：孔子说：“做为一个人，却不讲信誉，不知那怎么可以。譬如大车子没有安横木的輗，小车子没有安横木的軏，如何能走呢？”",
    "annotations": "注释：⑴人而无信——这“而”字不能当“如果”讲。不说“人无信”，而说“人而无信”者，表示“人”字要作一读。古书多有这种句法，译文似能表达其意。⑵輗、軏——輗音倪，ní；軏音月，yuè。古代用牛力的车叫大车，用马力的车叫小车。两者都要把牲口套在车辕上。车辕前面有一道横木，就是驾牲口的地方。那横木，大车上的叫做鬲，小车上的叫做衡。鬲、衡两头都有关键（活销），輗就是鬲的关键，軏就是衡的关键。车子没有它，自然无法套住牲口，那怎么能走呢？"
  },
  {
    "id": 39,
    "title": "為政 2.23",
    "text": "子张问：“十世可知也⑴？”子曰：“殷因于夏礼，所损益，可知也；周因于殷礼，所损益，可知也。其或继周者，虽百世，可知也。”",
    "translation": "译文：子张问：“今后十代［的礼仪制度］可以预先知道吗？”孔子说：“殷朝沿袭夏朝的礼仪制度，所废除的，所增加的，是可以知道的；周朝沿袭殷朝的礼仪制度，所废除的，所增加的，也是可以知道的。那么，假定有继承周朝而当政的人，就是以后一百代，也是可以预先知道的。”",
    "annotations": "注释：⑴十世可知也——从下文孔子的答语看来，便足以断定子张是问今后十代的礼仪制度，而不是泛问，所以译文加了几个字。这“也”字同“耶”，表疑\n问。"
  },
  {
    "id": 40,
    "title": "為政 2.24",
    "text": "子曰：“非其鬼⑴而祭⑵之，谄⑶也。见义不为，无勇也。”",
    "translation": "译文：孔子说：“不是自己应该祭祀的鬼神，却去祭祀他，这是献媚。眼见应该挺身而出的事情，却袖手旁观，这是怯懦。”",
    "annotations": "注释：⑴鬼——古代人死都叫“鬼”，一般指已死的祖先而言，但也偶有泛指的。⑵祭——祭是吉祭，和凶祭的奠不同（人初死，陈设饮食以安其灵魂，叫做奠）。祭鬼的目的一般是祈福。⑶谄——chǎn，谄媚，阿谀。"
  },
  {
    "id": 41,
    "title": "八佾 3.1",
    "text": "孔子谓季氏，⑴“八佾⑵舞于庭，是可忍⑶也，孰不可忍也？”",
    "translation": "译文：孔子谈到季氏，说：“他用六十四人在庭院中奏乐舞蹈，这都可以狠心做出来，甚么事不可以狠心做出来呢？”",
    "annotations": "注释：⑴季氏——根据《左传》昭公二十五年的记载和《汉书·刘向传》，这季氏可能是指季平子，卽季孙意如。据《韩诗外传》，似以为季康子，马融注则以为季桓子，恐皆不足信。⑵八佾——佾音逸，yì。古代舞蹈奏乐，八个人为一行，这一行叫一佾。八佾是八行，八八六十四人，只有天子才能用。诸侯用六佾，卽六行，四十八人。大夫用四佾，三十二人。四佾才是季氏所应该用的。⑶忍——一般人把它解为“容忍”、“忍耐”，不好；因为孔子当时并没有讨伐季氏的条件和意志，而且季平子削弱鲁公室，鲁昭公不能忍，出走到齐，又到晋，终于死在晋国之干侯。这可能就是孔子所“孰不可忍”的事。《贾子·道术篇》：“恻隐怜人谓之慈，反慈为忍。”这“忍”字正是此意。"
  },
  {
    "id": 42,
    "title": "八佾 3.2",
    "text": "三家⑴者以《雍》⑵彻。子曰：“‘相⑶维辟公，天子穆穆’，奚取于三家之堂？”",
    "translation": "译文：仲孙、叔孙、季孙三家，当他们祭祀祖先时候，［也用天子的礼，］\n唱着雍这篇诗来撤除祭品。孔子说：“［《雍》诗上有这样的话］‘助祭的是诸侯，天子严肃静穆地在那儿主祭。’这两句话，用在三家祭祖的大厅上在意义上取它哪一点呢？”",
    "annotations": "注释：⑴三家——鲁国当政的三卿。⑵《雍》——也写作“雝”，《诗经·周颂》的一篇。⑶相——去声，音向，xiàng助祭者。"
  },
  {
    "id": 43,
    "title": "八佾 3.3",
    "text": "子曰：“人而不仁，如礼何？人而不仁，如乐何？”",
    "translation": "译文：孔子说：“做了人，却不仁，怎样来对待礼仪制度呢？做了人，却不仁，怎样来对待音乐呢？”",
    "annotations": ""
  },
  {
    "id": 44,
    "title": "八佾 3.4",
    "text": "林放⑴问礼之本。子曰：“大哉问！礼，与其奢也，宁俭；丧，与其易⑵也，宁戚。”",
    "translation": "译文：林放问礼的本质。孔子说：“你的问题意义重大呀，就一般礼仪说，与其铺张浪费，宁可朴素俭约；就丧礼说，与其仪文周到，宁可过度悲哀。”",
    "annotations": "注释：⑴林放——鲁人。⑵易——《礼记·檀弓上》云：“子路曰，‘吾闻诸夫子：丧礼，与其哀不足而礼有余也，不若礼不足而哀有余也。”可以看做“与其易也，宁戚”的最早的解释。“易”有把事情办妥的意思，如《孟子·尽心上》“易其田畴”，因此这里译为“仪文周到”。"
  },
  {
    "id": 45,
    "title": "八佾 3.5",
    "text": "子曰：“夷狄之有君，不如⑴诸夏之亡⑵也。”",
    "translation": "译文：孔子说：“文化落后国家虽然有个君主，还不如中国没有君主哩。”",
    "annotations": "注释：⑴夷狄有君……亡也——杨遇夫先生《论语疏证》说，夷狄有君指楚庄王、吴王阖庐等。君是贤明之君。句意是夷狄还有贤明之君，不像中原诸国却没有。说亦可通。⑵亡——同“无”。在《论语》中，“亡”下不用宾语，“无”下必有宾语。"
  },
  {
    "id": 46,
    "title": "八佾 3.6",
    "text": "季氏旅⑴于泰山。子谓冉有⑵曰：“女弗能救与？”对曰：“不能。”子曰：“呜呼!曾谓泰山不如林放乎？”",
    "translation": "译文：季氏要去祭祀泰山。孔子对冉有说道：“你不能阻止吗？”冉有答道：“不能。”孔子道：“哎呀！竟可以说泰山之神还不及林放［懂礼，居然接受这不合规矩的祭祀］吗？”",
    "annotations": "注释：⑴旅——动词，祭山。在当时，只有天子和诸侯才有祭祀“名山大川”的资格。季氏只是鲁国的大夫，竟去祭祀泰山，因之孔子认为是“僭礼”。⑵冉有——孔子学生冉求，字子有，小于孔子二十九岁。（公元前522—？）当时在季氏之下做事，所以孔子责备他。"
  },
  {
    "id": 47,
    "title": "八佾 3.7",
    "text": "子曰：“君子无所争。必也射乎！揖让而升，下而饮。其争也君子⑴。”",
    "translation": "译文：孔子说：“君子没有什么可争的事情。如果有所争，一定是比箭吧，［但是当射箭的时候，］相互作揖然后登堂；［射箭完毕，］走下堂来，然后［作揖］喝酒。那一种竞赛是很有礼貌的。”",
    "annotations": "注释：⑴其争也君子——这是讲古代射礼，详见《仪礼·乡射礼》和《大射仪》。登堂而射，射后计算谁中靶多，中靶少的被罚饮酒。"
  },
  {
    "id": 48,
    "title": "八佾 3.8",
    "text": "子夏问曰：“‘巧笑倩⑴兮，美目盼⑵兮，素以为绚⑶兮。’何谓也？”子曰：“绘事后素。”\n曰：“礼后⑷乎？”子曰：“起⑸予者商也！始可与言诗已矣。”",
    "translation": "译文：子夏问道：“‘有酒涡的脸笑得美呀，黑白分明的眼流转得媚呀，洁白的底子上画着花卉呀。’这几句诗是什么意思？”孔子道：“先有白色底子，然后画花。”\n子夏道：“那么，是不是礼乐的产生在［仁义］以后呢？”孔子道：“卜商呀，你真是能启发我的人。现在可以同你讨论《诗经》了。”",
    "annotations": "注释：⑴倩——音欠，qiàn，面颊长得好。⑵盼——黑白分明。⑶绚xuàn，有文采，译文为着协韵，故用“画着花卉”以代之。这三句诗，第一句第二句见于\n《诗经·卫风·硕人》。第三句可能是逸句，王先谦《三家诗义集疏》以为《鲁诗》有此一句。⑷礼后——“礼”在什么之后呢，原文没说出。根据儒家的若干文献，译文加了“仁义”两字。⑸起——友人孙子书（楷第）先生云：“凡人病困而愈谓之起，义有滞碍隐蔽，通达之，亦谓之起。”说见杨遇夫先生《汉书窥管》卷九引文。"
  },
  {
    "id": 49,
    "title": "八佾 3.9",
    "text": "子曰：“夏礼，吾能言之，杞⑴不足征也；殷礼，吾能言之，宋⑵不足征也。文献⑶不足故也。足，则吾能征之矣。”",
    "translation": "译文：孔子说：“夏代的礼，我能说出来，它的后代杞国不足以作证；殷代的礼，我能说出来，它的后代宋国不足以作证。这是他们的历史文件和贤者不够的缘故。若有足够的文件和贤者，我就可以引来作证了。”",
    "annotations": "注释：⑴杞——国名，夏禹的后代。周武王时候的故城卽今日河南的杞县。其后因为国家弱小，依赖别国的力量来延长国命，屡经迁移。⑵宋——国名，商汤的后代，故城在今日河南商邱县南。国土最大的时候，有现在河南商邱以东，江苏徐州以西之地。战国时为齐、魏、楚三国所共灭。⑵文献——《论语》的“文献”和今天所用的“文献”一词的概念有不同之处。《论语》的“文献”包括历代的历史文件和当时的贤者两项（朱注云：“文，典籍也；献，贤也。”）。今日“文献”一词只指历史文件而言。"
  },
  {
    "id": 50,
    "title": "八佾 3.10",
    "text": "子曰：“禘⑴自既灌⑵而往者，吾不欲观之矣。”",
    "translation": "译文：孔子说：“禘祭的礼，从第一次献酒以后，我就不想看了。”",
    "annotations": "注释：⑴禘——这一禘礼是指古代一种极为隆重的大祭之礼，只有天子才能举行。不过周成王曾因为周公旦对周朝有过莫大的功勋，特许他举行禘祭。以后鲁国之君都沿此惯例，“僭”用这一禘礼，因此孔子不想看。⑵灌——本作“裸”，祭祀中的一个节目。古代祭祀，用活人以代受祭者，这活人便叫“尸”。尸一般用幼小的男女。第一次献酒给尸，使他（她）闻到“郁鬯”（一种配合香料煮成的酒）的香气，叫做裸。"
  },
  {
    "id": 51,
    "title": "八佾 3.11",
    "text": "或问禘之说。子曰：“不知也⑴；知其说者之于天下也，其如示⑵诸斯乎！”指其掌。",
    "translation": "译文：有人向孔子请教关于禘祭的理论。孔子说：“我不知道；知道的人对于治理天下，会好像把东西摆在这里一样容易罢！”一面说，一面指着手掌。",
    "annotations": "注释：⑴不知也——禘是天子之礼，鲁国举行，在孔子看来，是完全不应该的。但孔子又不想明白指出，只得说“不欲观”，“不知也”，甚至说“如果有懂得的人，他对于治理天下是好像把东西放在手掌上一样的容易。”⑵示——假借字，同“置”，摆、放的意义。或曰同“视”，犹言“了如指掌”。"
  },
  {
    "id": 52,
    "title": "八佾 3.12",
    "text": "祭如在，祭神如神在。子曰：“吾不与祭，如不祭⑴。”",
    "translation": "译文：孔子祭祀祖先的时候，便好像祖先真在那里；祭神的时候，便好像神真在那里。孔子又说：“我若是不能亲自参加祭祀，是不请别人代理的。”",
    "annotations": "注释：⑴吾不与祭，如不祭——这是一般的句读法。“与”读去声，音预，yù，参预的意思。“如不祭”译文是意译。另外有人主张“与”字仍读上声，赞同的意思，而且在这里一读，便是“吾不与，祭如不祭”。译文便应改为：“若是我所不同意的祭礼，祭了同没祭一般。”我不同意此义，因为孔丘素来不赞成不合所谓礼的祭祀，如“非其鬼而祭之，谄也”，（2.24）孔丘自不会参加他所不赞同的祭祀。"
  },
  {
    "id": 53,
    "title": "八佾 3.13",
    "text": "王孙贾⑴问曰：“与其媚于奥，宁媚于灶⑵，何谓也？”子曰：“不然；获罪于天，无所祷也⑶。”",
    "translation": "译文：王孙贾问道：“‘与其巴结房屋里西南角的神，宁可巴结灶君司命，’这两句话是什么意思？”孔子道：“不对；若是得罪了上天，祈祷也没用。”",
    "annotations": "注释：⑴王孙贾——卫灵公的大臣。⑵与其媚于奥，宁媚如灶——这两句疑是当时俗语。屋内西南角叫奥，弄饭的设备叫灶，古代都以为那里有神，因而祭它。⑶王孙贾和孔子的问答都用的比喻，他们的正意何在，我们只能揣想。有人说，奥是一室之主，比喻卫君，又在室内，也可以比喻卫灵公的宠姬南子；灶则是王孙贾自比。这是王孙贾暗示孔子，“你与其巴结卫公或者南子，不如巴结我。”因此孔子答复他：“我若做了坏事，巴结也没有用处，我若不做坏事，谁都不巴结。”又有人说，这不是王孙贾暗示孔子的话，而是请教孔子的话。奥指卫君，灶指南子、弥子瑕，位职虽低，却有权有势。意思是说，“有人告诉我，与其巴结国君，不如巴结有势力的左右像南子、弥子瑕。你以为怎样？”孔子却告诉他：“这话不对；得罪了上天，那无所用其祈祷，巴结谁都不行。”我以为后一说比较近情理。"
  },
  {
    "id": 54,
    "title": "八佾 3.14",
    "text": "子曰：“周监于二代⑴，郁郁乎文哉！吾从周。”",
    "translation": "译文：孔子说：“周朝的礼仪制度是以夏商两代为根据，然后制定的，多么丰富多彩呀，我主张周朝的。”",
    "annotations": "注释：⑴二代——夏、商两朝。"
  },
  {
    "id": 55,
    "title": "八佾 3.15",
    "text": "子入太庙⑴，每事问。或曰：“孰谓鄹人之子⑵知礼乎？入太庙，每事问。”子闻之，曰：“是礼也。”",
    "translation": "译文：孔子到了周公庙，每件事情都发问。有人便说：“谁说叔梁纥的这个儿子懂得礼呢？他到了太庙，每件事都要向别人请教。”孔子听到了这话，便道：“这正是礼呀。”",
    "annotations": "注释：⑴太庙——古代开国之君叫太祖，太祖之庙便叫做太庙，周公旦是鲁国最初受封之君，因之这太庙就是周公的庙。⑵鄹人之子——鄹音邹，zōu，又作郰，地名。《史记·孔子世家》：“孔子生鲁昌平乡郰邑。”有人说，这地就是今天的山东省曲阜县东南十里的西邹集。“鄹人”指孔子父亲叔梁纥。叔梁纥曾经作过鄹大夫，古代经常把某地的大夫称为某人，因之这里也把鄹大夫叔梁纥称为“鄹人”。"
  },
  {
    "id": 56,
    "title": "八佾 3.16",
    "text": "子曰：“射不主皮⑴，为⑵力不同科⑶，古之道也。”",
    "translation": "译文：孔子说：“比箭，不一定要穿破箭靶子，因为各人的气力大小不一样，这是古时的规矩。”",
    "annotations": "注释：⑴射不主皮——“皮”代表箭靶子。古代箭靶子叫“侯”，有用布做的，也有用皮做的。当中画着各种猛兽或者别的东西，最中心的又叫做“正”或者“鹄”。孔子在这里所讲的射应该是演习礼乐的射，而不是军中的武射，因此以中不中为主，不以穿破皮侯与否为主。《仪礼·乡射礼》云，“礼射不主皮”，盖本此。⑵为——去声，wèi，因为。⑶同科——同等。"
  },
  {
    "id": 57,
    "title": "八佾 3.17",
    "text": "子贡欲去⑴告朔之饩羊⑵。子曰：“赐也！尔爱⑶其羊，我爱其礼。”",
    "translation": "译文：子贡要把鲁国每月初一告祭祖庙的那只活羊去而不用。孔子道：“赐呀，你可惜那只羊，我可惜那种礼。”",
    "annotations": "注释：⑴去——从前读为上声，因为它在这里作为及物动词，而且和“来去”的“去”意义不同。⑵告朔饩羊——“告”，从前人读梏，gù，入声。“朔”，每月的第一天，初一。“饩”，xì。“告朔饩羊”，古代的一种制度。每年秋冬之交，周天子把第二年的历书颁给诸侯。这历书包括那年有无闰月，每月初一是哪一天，因之叫“颁告朔”。诸侯接受了这一历书，藏于祖庙。每逢初一，便杀一只活羊祭于庙，然后回到朝廷听政。这祭庙叫做“告朔”，听政叫做“视朔”，或者“听朔”。到子贡的时候，每月初一，鲁君不但不亲临祖庙，而且也不听政，只是杀一只活羊“虚应故事”罢了。所以子贡认为不必留此形式，不如干脆连羊也不杀。孔子却认为尽管这是残存的形式，也比什么也不留好。⑶爱——可惜的意思。"
  },
  {
    "id": 58,
    "title": "八佾 3.18",
    "text": "子曰：“事君尽礼，人以为谄也。”",
    "translation": "译文：孔子说：“服事君主，一切依照做臣子的礼节做去，别人却以为他在谄媚哩。”",
    "annotations": ""
  },
  {
    "id": 59,
    "title": "八佾 3.19",
    "text": "定公⑴问：“君使臣，臣事君，如之何？”孔子对曰：“君使臣以礼，臣事君以忠。”",
    "translation": "译文：鲁定公问：“君主使用臣子，臣子服事君主，各应该怎么样？”孔子答道：“君主应该依礼来使用臣子，臣子应该忠心地服事君主。”",
    "annotations": "注释：⑴定公——鲁君，名宋，昭公之弟，继昭公而立，在位十五年。（公\n元前509—495）“定”是谥号。"
  },
  {
    "id": 60,
    "title": "八佾 3.20",
    "text": "子曰：“《关雎》⑴，乐而不淫⑵，哀而不伤。”",
    "translation": "译文：孔子说：“《关雎》这诗，快乐而不放荡，悲哀而不痛苦。”",
    "annotations": "注释：⑴《关雎》——《诗经》的第一篇。但这篇诗并没有悲哀的情调，因此刘台拱的《论语骈枝》说：“诗有《关雎》，乐亦有《关雎》，此章据乐言之。古之乐章皆三篇为一。……乐而不淫者，《关雎》、《葛覃》也；哀而不伤者，卷耳也。”⑵淫——古人凡过分以至于到失当的地步叫淫，如言“淫祀”（不应该祭祀而去祭祀的祭礼）、“淫雨”（过久的雨水）。"
  },
  {
    "id": 61,
    "title": "八佾 3.21",
    "text": "哀公问社⑴于宰我⑵。宰我对曰：“夏后氏以松，殷人以柏，周人以栗，曰，使民战栗。”子闻之，曰：“成事不说，遂事不谏，既往不咎。”",
    "translation": "译文：鲁哀公向宰我问，作社主用什么木。宰我答道：“夏代用松木，殷代用柏木，周代用栗木，意思是使人民战战栗栗。”孔子听到了这话，［责备宰我］说：“已经做了的事不便再解释了，已经完成的事不便再挽救了，已经过去的事不便再追究了。”",
    "annotations": "注释：⑴社——土神叫社，不过哀公所问的社，从宰我的答话中可以推知是指社主而言。古代祭祀土神，要替他立一个木制的牌位，这牌位叫主，而认为这一木主，便是神灵之所凭依。如果国家有对外战争，还必需载这一木主而行。详见俞正燮《癸巳类稾》。有人说“社”是指立社所栽的树，未必可信。⑵宰我——孔子学生，名予，字子我。"
  },
  {
    "id": 62,
    "title": "八佾 3.22",
    "text": "子曰：“管仲⑴之器小哉！”\n或曰：“管仲俭乎？”曰：“管氏有三归⑵，官事不摄⑶，焉得俭？”\n“然则管仲知礼乎？”曰：“邦君树塞门⑷，管氏亦树塞门。邦君为两君之好⑸，有反坫⑹，管氏亦有反坫。管氏而⑺知礼，孰不知礼？”",
    "translation": "译文：孔子说：“管仲的器量狭小得很呀！”\n有人便问：“他是不是很节俭呢？”孔子道：“他收取了人民的大量的市租，他手下的人员，［一人一职，］从不兼差，如何能说是节俭呢？”\n那人又问：“那末，他懂得礼节么？”孔子又道：“国君宫殿门前，立了一个塞门；管氏也立了个塞门；国君设燕招待外国的君主，在堂上有放置酒杯的设备，管氏也有这样的设备。假若说他懂得礼节，那谁不懂得礼节呢？”",
    "annotations": "注释：⑴管仲——春秋时齐国人，名夷吾，做了齐桓公的宰相，使他称霸诸侯。⑵三归——“三归”的解释还有：（甲）国君一娶三女，管仲也娶了三国之女（《集解》引包咸说，皇侃《义疏》等）；（乙）三处家庭（俞樾《羣经平议》）；（丙）地名，管仲的采邑（梁玉绳《瞥记》）；（丁）藏泉币的府库（武亿《羣经义证》）。我认为这些解释都不正确。郭嵩焘《养知书屋文集》卷一释三归云：“此盖《管子》九府轻重之法，当就《管子》书求之。〈山至数篇〉曰。‘则民之三有归于上矣。’三归之名，实本于此。是所谓三归者，市租之常例之归之公者也。桓公既霸，遂以赏管仲。《汉书·地理志》、《食货志》并云，桓公用管仲设轻重以富民，身在陪臣，而取三归。其言较然明显。《韩非子》云，‘使子有三归之家’，《说苑》作‘赏之市租’。三归之为市租，汉世儒者犹能明之，此一证也。《晏子春秋》辞三归之赏，而云厚受赏以伤国民之义，其取之民无疑也，此又一证也。”这一说法很有道理。我还再举两个间接证据。（甲）《战国策》一说：“齐桓公宫中七市，女闾七百，国人非之。管仲故为三归之家以掩桓公，非自伤于民也。”似亦以三归为市租。（乙）《三国志·魏志·武帝纪》建安十五年令曰：“若必廉士而后可用，则齐桓其何以霸？”亦以管仲不是清廉之士，当指三归。⑶摄——兼职。⑷树塞门——树，动词，立也。塞门，用以间隔内外视线的一种东西，形式和作用可以同今天的照壁相比。⑸好——古读去声，友好。⑹反坫——坫音店，diàn，用以放置器物的设备，用土筑成的，形似土堆，筑于两楹（厅堂前部东西各有一柱）之间。详全祖望《经史问答》。⑺而——假设连词，假如，假若。"
  },
  {
    "id": 63,
    "title": "八佾 3.23",
    "text": "子语⑴鲁大师⑵乐，曰：“乐其可知也：始作，翕⑶如也；从⑷之，纯如也，皦⑸如也，绎如也，以成。”",
    "translation": "译文：孔子把演奏音乐的道理告给鲁国的太师，说道：“音乐，那是可以晓得的：开始演奏，翕翕地热烈；继续下去，纯纯地和谐，皦皦地清晰，绎绎地不绝，这样，然后完成。”",
    "annotations": "注释：⑴语——去声，yù，告诉。⑵大师——大音泰，tài，乐官之长。⑶翕——xī。⑷从——去声，zòng。⑸皦——音皎，jiǎo。"
  },
  {
    "id": 64,
    "title": "八佾 3.24",
    "text": "仪封人⑴请见⑵，曰：“君子之至于斯也，吾未尝不得见也。”从者⑶见之⑵。出曰：“二三子何患于丧⑷乎？天下之无道也久矣，天将以夫子为木铎⑸。 ”",
    "translation": "译文：仪这个地方的边防官请求孔子接见他，说道：“所有到了这个地方的有道德学问的人，我从没有不和他见面的。”孔子的随行学生请求孔子接见了他。他辞出以后，对孔子的学生们说：“你们这些人为什么着急没有官位呢？天下黑暗日子也长久了，［圣人也该有得意的时候了，］上天会要把他老人家做人民的导师哩。”",
    "annotations": "注释：⑴仪封人——仪，地名。有人说当在今日的开封市内，未必可靠。封人，官名。《左传》有颖谷封人、祭封人、萧封人、吕封人，大概是典守边疆的官。说本方观旭《论语偶记》。⑵请见、见之——两个“见”字从前都读去声，音现，xiàn。“请见”是请求接见的意思，“见之”是使孔子接见了他的意思。何焯《义门读书记》云：“古者相见必由绍介，逆旅之中无可因缘，故称平日未尝见绝于贤者，见气类之同，致词以代绍介，故从者因而通之。夫子亦不拒其请，与不见孺悲异也。”⑶从者——“从”去声，zòng。⑷丧——去声，sàng，失掉官位。⑸木铎——铜质木舌的铃子。古代公家有什么事要宣布，便摇这铃，召集大家来听。"
  },
  {
    "id": 65,
    "title": "八佾 3.25",
    "text": "子谓韶⑴，“尽美⑵矣，又尽善⑵也。”谓武⑶，“尽美矣，未尽善也。”",
    "translation": "译文：孔子论到韶，说：“美极了，而且好极了。”论到武，说：“美极了，却还不够好。”",
    "annotations": "注释：⑴韶——舜时的乐曲名。⑵美、善——“美”可能指声音言，“善”可能指内容言。舜的天子之位是由尧“禅让”而来，故孔子认为“尽善”。周武王的天子之位是由讨伐商纣而来，尽管是正义战，依孔子意，却认为“未尽善”。⑶武——周武王时乐曲名。"
  },
  {
    "id": 66,
    "title": "八佾 3.26",
    "text": "子曰：“居上不宽，为礼不敬，临丧不哀，吾何以观之哉？”",
    "translation": "译文：孔子说：“居于统治地位不宽宏大量，行礼的时候不严肃认真，参加丧礼的时候不悲哀，这种样子我怎么看得下去呢？”",
    "annotations": ""
  },
  {
    "id": 67,
    "title": "里仁 4.1",
    "text": "子曰：“里⑴仁为美。择不处⑵仁，焉得知⑶？”",
    "translation": "译文：孔子说：“住的地方，要有仁德这才好。选择住处，没有仁德，怎么能是聪明呢？”",
    "annotations": "注释：⑴里——这里可以看为动词。居住也。⑵处——上声，音杵，chǔ，居住也。⑶知——《论语》的“智”字都如此写。这一段话，究竟孔子是单纯地指“择居”而言呢，还是泛指，“择邻”、“择业”、“择友”等等都包括在内呢？我们已经不敢肯定。《孟子·公孙丑上》云：“孟子曰：‘矢人岂不仁于函人哉？矢人惟恐不伤人，函人惟恐伤人。巫、匠亦然。故术不可不慎也。孔子曰，里仁为美。择不处仁，焉得智？’”便是指择业。因此译文于“仁”字仅照字面翻译，不实指为仁人。"
  },
  {
    "id": 68,
    "title": "里仁 4.2",
    "text": "子曰：“不仁者不可以久处约，不可以长处乐。仁者安仁，知者利仁。”",
    "translation": "译文：孔子说：“不仁的人不可以长久地居于穷困中，也不可以长久地居于安乐中。有仁德的人安于仁［实行仁德便心安，不实行仁德心便不安］；聪明人利用仁［他认识到仁德对他长远而巨大的利益，他便实行仁德］。”",
    "annotations": ""
  },
  {
    "id": 69,
    "title": "里仁 4.3",
    "text": "子曰：“唯仁者能好人，能恶人⑴。”",
    "translation": "译文：孔子说：“只有仁人才能够喜爱某人，厌恶某人。”",
    "annotations": "注释：⑴唯仁者能好人，能恶人——《后汉书·孝明八王传》注引《东观汉记》说：和帝赐彭城王恭诏曰：“孔子曰，‘惟仁者能好人，能恶人’。——贵仁者所好恶得其中也。”我认为“贵仁者所好恶得其中”，正可说明这句。 "
  },
  {
    "id": 70,
    "title": "里仁 4.4",
    "text": "子曰：“苟志于仁矣，无恶也。”",
    "translation": "译文：孔子说：“假如立定志向实行仁德，总没有坏处。”",
    "annotations": ""
  },
  {
    "id": 71,
    "title": "里仁 4.5",
    "text": "子曰：“富与贵，是人之所欲也；不以其道得之，不处也。贫与贱，是人之所恶也；不以其道得之⑴，不去也。君子去仁，恶乎⑵成名？君子无终食之间违⑶仁，造次必于是，颠沛必于是。”",
    "translation": "译文：孔子说：“发大财，做大官，这是人人所盼望的；不用正当的方法去得到它，君子不接受。穷困和下贱，这是人人所厌恶的；不用正当的方法去抛掉它，君子不摆脱。君子抛弃了仁德，怎样去成就他的声名呢？君子没有吃完一餐饭的时间离开仁德，就是在仓卒匆忙的时候一定和仁德同在，就是在颠沛流离的时候一定和仁德同在。”",
    "annotations": "注释：⑴贫与贱……不以其道得之——“富与贵”可以说“得之”，“贫与贱”却不是人人想“得之”的。这里也讲“不以其道得之”，“得之”应该改为“去之”。译文只就这一整段的精神加以诠释，这里为什么也讲“得之”可能是古人的不经意处，我们不必再在这上面做文章了。⑵恶乎——恶音乌，wū，何处。“恶乎”卽“于何处”，译文意译为“怎样”。⑶违——离开，和公冶长篇第五的“弃而违之”的“违”同义。"
  },
  {
    "id": 72,
    "title": "里仁 4.6",
    "text": "子曰：“我未见好仁者，恶不仁者。好仁者，无以尚⑴之；恶不仁者，其为仁矣⑵，不使不仁者加乎其身。有能一日用其力于仁矣乎？我未见力不足者。盖⑶有之矣，我未之见也。”",
    "translation": "译文：孔子说：“我不曾见到过爱好仁德的人和厌恶不仁德的人。爱好仁德的人，那是再好也没有的了；厌恶不仁德的人，他行仁德只是不使不仁德的东西加在自己身上。有谁能在某一天使用他的力量于仁德呢？我没见过力量不够的。大概这样人还是有的，我不曾见到罢了。”",
    "annotations": "注释：⑴尚——动词，超过之意。⑵矣——这个“矣”字用法同“也”，表示停顿。⑶盖——副词，大概之意。"
  },
  {
    "id": 73,
    "title": "里仁 4.7",
    "text": "子曰：“人之过也，各于其党。观过，斯知仁⑴矣。”",
    "translation": "译文：孔子说：“［人是各种各样的，人的错误也是各种各样的。］什么样的错误就是由什么样的人犯的。仔细考察某人所犯的错误，就可以知道他是什么样式的人了。”",
    "annotations": "注释：⑴仁——同“人”。《后汉书·吴佑传》引此文正作“人”（武英殿本却又改作“仁”，不可为据）。"
  },
  {
    "id": 74,
    "title": "里仁 4.8",
    "text": "子曰：“朝闻道，夕死可矣。”",
    "translation": "译文：孔子说：“早晨得知真理，要我当晚死去，都可以。”",
    "annotations": ""
  },
  {
    "id": 75,
    "title": "里仁 4.9",
    "text": "子曰：“士志于道，而耻恶衣恶食者，未足与议也。”",
    "translation": "译文：孔子说：“读书人有志于真理，但又以自己吃粗粮穿破衣为耻辱，这种人，不值得同他商议了。”",
    "annotations": ""
  },
  {
    "id": 76,
    "title": "里仁 4.10",
    "text": "子曰：“君子之于天下也，无适⑴也，无莫⑴也，义之与比⑵。”",
    "translation": "译文：孔子说：“君子对于天下的事情，没规定要怎样干，也没规定不要怎样干，只要怎样干合理恰当，便怎样干。”",
    "annotations": "注释：⑴适，莫——这两字讲法很多，有的解为“亲疏厚薄”，“无适无莫”便是“情无亲疏厚薄”。有的解为“敌对与羡慕”，“无适（读为敌）无莫（读为慕）”便是“无所为仇，无所欣羡”。我则用朱熹《集注》的说法。⑵比——去声，bì，挨着，靠拢，为邻。从孟子和以后的一些儒家看来，孔子“无必无固”（9.4），通权达变，“可以仕则仕，可以止则止，可以久则久，可以速则速”（《孟子·公孙丑上》），唯义是从，叫做“圣之时”，或者可以做这章的解释。"
  },
  {
    "id": 77,
    "title": "里仁 4.11",
    "text": "子曰：“君子怀德，小人怀土⑴；君子怀刑⑵，小人怀惠。”",
    "translation": "译文：孔子说：“君子怀念道德，小人怀念乡土；君子关心法度，小人关心恩惠。”",
    "annotations": "注释：⑴土——如果解为田土，亦通。⑵刑——古代法律制度的“刑”作“刑”，刑罚的“刑”作“”，从刀井，后来都写作“刑”了。这“刑”字应该解释为法度。"
  },
  {
    "id": 78,
    "title": "里仁 4.12",
    "text": "子曰：“放⑴于利而行，多怨。”",
    "translation": "译文：孔子说：“依据个人利益而行动，会招致很多的怨恨。”",
    "annotations": "注释：⑴放——旧读上声，音仿，fǎng，依据。"
  },
  {
    "id": 79,
    "title": "里仁 4.13",
    "text": "子曰：“能以礼让为国乎？何有⑴？不能以礼让为国，如礼何⑵？”",
    "translation": "译文：孔子说：“能够用礼让来治理国家吗？这有什么困难呢？如果不能用礼让来治理国家，又怎样来对待礼仪呢？”",
    "annotations": "注释：⑴何有——这是春秋时代的常用语，在这里是“有何困难”的意思。黄式三《论语后案》、刘宝楠《论语正义》都说：“何有，不难之词。”⑵如礼何——依孔子的意见，国家的礼仪必有其“以礼让为国”的本质，它是内容和形式的统一体。如果舍弃它的内容，徒拘守那些仪节上的形式，孔子说，是没有什么作用的。"
  },
  {
    "id": 80,
    "title": "里仁 4.14",
    "text": "子曰：“不患无位，患所以立⑴。不患莫己知，求为可知也。”",
    "translation": "译文：孔子说：“不发愁没有职位，只发愁没有任职的本领；不怕没有人知道自己，去追求足以使别人知道自己的本领好了。”",
    "annotations": "注释：⑴患所以立——“立”和“位”古通用，这“立”字便是“不患无位”的“位”字。《春秋》桓公二年“公卽位”，石经作“公卽立”可以为证。"
  },
  {
    "id": 81,
    "title": "里仁 4.15",
    "text": "子曰：“参乎！吾道一以贯⑴之。”曾子曰：“唯。”子出，门人问曰：“何谓也？”曾子曰：“夫子之道，忠恕⑵而已矣。”",
    "translation": "译文：孔子说：“参呀！我的学说贯穿着一个基本观念。”曾子说：“是。”孔子走出去以后，别的学生便问曾子道：“这是什么意思”曾子道：“他老人家的学说，只是忠和恕罢了。”",
    "annotations": "注释：⑴贯——贯穿、统贯。阮元《揅经室集》有〈一贯说〉，认为《论语》的“贯”字都是“行”、“事”的意义，未必可信。⑵忠、恕——“恕”，孔子自己下了定义：“己所不欲，勿施于人。”“忠”则是“恕”的积极一面，用孔子自己的话，便应该是：“己欲立而立人，己欲达而达人。”"
  },
  {
    "id": 82,
    "title": "里仁 4.16",
    "text": "子曰：“君子⑴喻于义，小人⑴喻于利。”",
    "translation": "译文：孔子说：“君子懂得的是义，小人懂得的是利。”",
    "annotations": "注释：⑴君子、小人——这里的“君子”、“小人”是指在位者，还是指有德者，还是两者兼指，孔子原意不得而知。《汉书·杨恽传·报孙会宗书》曾引董仲舒的话说：“明明求仁义常恐不能化民者，卿大夫之意也；明明求财利常恐困乏者，庶人之事也。”只能看作这一语的汉代经师的注解，不必过信。"
  },
  {
    "id": 83,
    "title": "里仁 4.17",
    "text": "子曰：“见贤思齐焉，见不贤而内自省也。”",
    "translation": "译文：孔子说：“看见贤人，便应该想向他看齐；看见不贤的人，便应该自己反省，［有没有同他类似的毛病。］”",
    "annotations": ""
  },
  {
    "id": 84,
    "title": "里仁 4.18",
    "text": "子曰：“事父母几⑴谏，见志不从，又敬不违⑵，劳⑶而不怨。”",
    "translation": "译文：孔子说：“侍奉父母，［如果他们有不对的地方，］得轻微婉转地劝止，看到自己的心意没有被听从，仍然恭敬地不触犯他们，虽然忧愁，但不怨恨。”",
    "annotations": "注释：⑴几——平声，音机，jī，轻微，婉转。⑵违——触忤，冒犯。⑶劳——忧愁。说见王引之《经义述闻》。"
  },
  {
    "id": 85,
    "title": "里仁 4.19",
    "text": "子曰：“父母在，不远游，游必有方。”",
    "translation": "译文：孔子说：“父母在世，不出远门，如果要出远门，必须有一定的去处。”",
    "annotations": ""
  },
  {
    "id": 86,
    "title": "里仁 4.20",
    "text": "子曰：“三年无改于父之道，可谓孝矣⑴。”",
    "translation": "译文：孔子说：“三年无改于父之道，可谓孝矣⑴。”",
    "annotations": "注释：⑴见学而篇。（1.11）"
  },
  {
    "id": 87,
    "title": "里仁 4.21",
    "text": "子曰：“父母之年，不可不知也。一则以喜，一则以惧。”",
    "translation": "译文：孔子说：“父母的年纪不能不时时记在心里：一方面因［其高寿］而喜欢，另一方面又因［其寿高］而有所恐惧。”",
    "annotations": ""
  },
  {
    "id": 88,
    "title": "里仁 4.22",
    "text": "子曰：“古者言之不出，耻⑴躬之不逮⑵也。”",
    "translation": "译文：孔子说：“古时候言语不轻易出口，就是怕自己的行动赶不上。”",
    "annotations": "注释：⑴耻——动词的意动用法，以为可耻的意思。⑵逮——音代，dài，\n及，赶上。"
  },
  {
    "id": 89,
    "title": "里仁 4.23",
    "text": "子曰：“以约⑴失之者鲜矣。”",
    "translation": "译文：孔子说：“因为对自己节制、约束而犯过失的，这种事情总不会多。 ”",
    "annotations": "注释：⑴约——《论语》的“约”字不外两个意义：（甲）穷困，（乙）约\n束。至于节俭的意义，虽然已见于《荀子》，却未必适用于这里。"
  },
  {
    "id": 90,
    "title": "里仁 4.24",
    "text": "子曰：“君子欲讷⑴于言而敏于行⑵。”",
    "translation": "译文：孔子说：“君子言语要谨慎迟钝，工作要勤劳敏捷。”",
    "annotations": "注释：⑴讷——读nà，语言迟钝。⑵讷于言敏于行——造句和学而篇的“敏于事而慎于言”意思一样，所以译文加“谨慎”两字，同时也把“行”字译为“工作”。"
  },
  {
    "id": 91,
    "title": "里仁 4.25",
    "text": "子曰：“德不孤，必有邻⑴。”",
    "translation": "译文：孔子说：“有道德的人不会孤单，一定会有［志同道合的人来和他做］伙伴。”",
    "annotations": "注释：⑴德不孤必有邻——《易·系辞上》说：“方以类聚，物以羣分。”又《干·文言》说：“子曰：同声相应，同气相求。”这都可以作为“德不孤”的解释。"
  },
  {
    "id": 92,
    "title": "里仁 4.26",
    "text": "子游曰：“事君数⑴，斯辱矣；朋友数⑴，斯疏矣。”",
    "translation": "译文：子游说：“对待君主过于烦琐，就会招致侮辱；对待朋友过于烦琐，就会反被疏远。”",
    "annotations": "注释：⑴数——音朔，shuò，密，屡屡。这里依上下文意译为“烦琐”。颜渊篇第十二说：“子贡问友。子曰：‘忠告而善道之，不可则止，无自辱焉。’”也正是这个意思。"
  },
  {
    "id": 93,
    "title": "公冶長 5.1",
    "text": "子谓公冶长⑴，“可妻⑵也。虽在缧绁⑶之中，非其罪也。”以其子⑷妻之。",
    "translation": "译文：孔子说公冶长，“可以把女儿嫁给他。他虽然曾被关在监狱之中，但不是他的罪过。”便把自己的女儿嫁给他。",
    "annotations": "注释：⑴公冶长——孔子学生，齐人。⑵妻——动词，去声，qì。⑶缧绁——缧同“累”，léi；绁音泄，xiè。缧绁，拴罪人的绳索，这里指代监狱。⑷子——\n儿女，此处指的是女儿。"
  },
  {
    "id": 94,
    "title": "公冶長 5.2",
    "text": "子谓南容⑴，“邦有道，不废；邦无道，免于刑戮。”以其兄之子妻之⑵。",
    "translation": "译文：孔子说南容，“国家政治清明，［总有官做，］不被废弃；国家政治黑暗，也不致被刑罚。”于是把自己的侄女嫁给他。",
    "annotations": "注释：⑴南容——孔子学生南宫适，字子容。⑵兄之子——孔子之兄叫孟皮，见《史记·孔子世家·索隐》引《家语》。这时孟皮可能已死，所以孔子替他女儿主婚。"
  },
  {
    "id": 95,
    "title": "公冶長 5.3",
    "text": "子谓子贱⑴，“君子哉若人！鲁无君子者，斯焉取斯？”",
    "translation": "译文：孔子评论宓子贱，说：“这人是君子呀！假若鲁国没有君子，这种人从哪里取来这种好品德呢？”",
    "annotations": "注释：⑴子贱——孔子学生宓不齐，字子贱，少于孔子四十九岁。（公元前521—？）"
  },
  {
    "id": 96,
    "title": "公冶長 5.4",
    "text": "子贡问曰：“赐也何如？”子曰：“女，器也。”曰：“何器也？”曰：“瑚琏⑴也。”",
    "translation": "译文：子贡问道：“我是一个怎样的人？”孔子道：“你好比是一个器皿。”子贡道：“什么器皿？”孔子道：“宗庙里盛黍稷的瑚琏。”",
    "annotations": "注释：⑴瑚琏——音胡连，又音胡hú辇niǎn，卽簠簋，古代祭祀时盛粮食的器皿，方形的叫簠，圆形的叫簋，是相当尊贵的。"
  },
  {
    "id": 97,
    "title": "公冶長 5.5",
    "text": "或曰：“雍⑴也仁而不佞⑵。”子曰：“焉用佞？御人以口给⑶，屡憎于人。不知其仁⑷，焉用佞？”",
    "translation": "译文：有人说：“冉雍这个人有仁德，却没有口才。”孔子道：“何必要口才\n呢？强嘴利舌地同人家辩驳，常常被人讨厌。冉雍未必仁，但为什么要有口才呢？”",
    "annotations": "注释：⑴雍——孔子学生冉雍，字仲弓。⑵佞——音泞，nìng，能言善说，有口才。⑶口给——给，足也。“口给”犹如后来所说“言词不穷”、“辩才无碍”。⑷不知其仁——孔子说不知，不是真的不知，只是否定的另一方式，实际上说冉雍还不能达到“仁”的水平。下文第八章“孟武伯问子路仁乎，子曰，不知也”，这“不知”也是如此。"
  },
  {
    "id": 98,
    "title": "公冶長 5.6",
    "text": "子使漆雕开⑴仕。对曰：“吾斯之未能信⑵。”子说。",
    "translation": "译文：孔子叫漆雕开去做官。他答道：“我对这个还没有信心。”孔子听了很欢喜。",
    "annotations": "注释：⑴漆雕开——“漆雕”是姓，“开”是名，孔子学生，字子开。⑵吾斯之未能信——这句是“吾未能信斯”的倒装形式，“之”是用来倒装的词。"
  },
  {
    "id": 99,
    "title": "公冶長 5.7",
    "text": "子曰：“道不行，乘桴⑴浮于海。从⑵我者，其由与？”子路闻之喜。子曰：“由也好勇过我，无所取材⑶。”",
    "translation": "译文：孔子道：“主张行不通了，我想坐个木簰到海外去，跟随我的恐怕只有仲由吧！”子路听到这话，高兴得很。孔子说：“仲由这个人太好勇敢了，好勇的精神大大超过了我，这就没有什么可取的呀！”",
    "annotations": "注释：桴——音孚，fú，古代把竹子或者木头编成簰，以当船用，大的叫筏，小的叫桴，也就是现在的木簰。⑵从——动词，旧读去声，跟随。⑶材——同“哉”，古字有时通用。有人解做木材，说是孔子以为子路真要到海外去，便说，“没地方去取得木材”。这种解释一定不符合孔子原意。也有人把“材”看做“翦裁”的“裁’，说是“子路太好勇了，不知道节制、检点”，这种解释不知把“取”字置于何地，因之也不采用。"
  },
  {
    "id": 100,
    "title": "公冶長 5.8",
    "text": "孟武伯问子路仁乎？子曰：“不知也。”又问。子曰：“由也，千乘之国，可使治其赋⑴也，不知其仁也。”\n“求也何如？”子曰：“求也，千室之邑⑵，百乘之家⑶，可使为之⑷宰⑸也，不知其仁也。”\n“赤也何如？”子曰：“赤也，束带立于朝，可使与宾客⑹言也，不知其仁也。 ”",
    "translation": "译文：孟武伯向孔子问子路有没有仁德。孔子道：“不晓得。”他又问。孔子道：“仲由啦，如果有一千辆兵车的国家，可以叫他负责兵役和军政的工作。至于他有没有仁德，我不晓得。”\n孟武伯继续问：“冉求又怎么样呢？”，孔子道：“求啦，千户人口的私邑，可以叫他当县长；百辆兵车的大夫封地，可以叫他当总管。至于他有没有仁德，我不晓得。”。\n“公西赤又怎么样呢？”。孔子道：“赤啦，穿着礼服，立于朝廷之中，可以叫他接待外宾，办理交涉。至于他有没有仁德，我不晓得。”",
    "annotations": "注释：⑴赋——兵赋，古代的兵役制度。这里自也包括军政工作而言。⑵邑——《左传》庄公二十八年云：“凡邑，有宗庙先王之主曰都，无曰邑。”又《公羊传》桓公元年云：“田多邑少称田，邑多田少称邑。”可见“邑”就是古代庶民聚居之所，不过有一些田地罢了。⑶家——古代的卿大夫由国家封以一定的地方，由他派人治理，并且收用当地的租税，这地方便叫采地或者采邑。“家”便是指这种采邑而言。⑷之——用法同“其”，他的。⑸宰——古代一县的县长叫做“宰”，大夫家的总管也叫做“宰”。所以“原思为之宰”（6.5）的宰为“总管”，而“季氏使闵子骞为费宰”（6.9）的“宰”是“县长”。⑹宾客——“宾”“客”两字散文则通，对文有异。一般是贵客叫宾，因之天子诸侯的客人叫宾，一般客人叫客，《易经·需卦·爻辞》“有不速之客三人来”的“客”正是此意。这里则把“宾客”合为一词了。"
  },
  {
    "id": 101,
    "title": "公冶長 5.9",
    "text": "子谓子贡曰：“女与回也孰愈？”对曰：“赐也何敢望回？回也闻一以知十，赐也闻一以知二。”子曰：“弗如也；吾与⑴女弗如也。”",
    "translation": "译文：孔子对子贡道：“你和颜回，哪一个强些？”子贡答道：“我么，怎敢和回相比？他啦，听到一件事，可以推演知道十件事；我咧，听到一件事，只能推知两件事。”孔子道：“赶不上他；我同意你的话，是赶不上他。”",
    "annotations": "注释：⑴与——动词，同意，赞同。这里不应该看作连词。"
  },
  {
    "id": 102,
    "title": "公冶長 5.10",
    "text": "宰予昼寝。子曰：“朽木不可雕也；粪土之墙不可杇⑴也；于予与何诛⑵”子曰⑶：“始吾于人也，听其言而信其行；今吾于人也，听其言而观其行。于予与改是。”",
    "translation": "译文：宰予在白天睡觉。孔子说：“腐烂了的木头雕刻不得，粪土似的墙壁粉刷不得；对于宰予么，不值得责备呀。”又说：“最初，我对人家，听到他的话，便相信他的行为；今天，我对人家，听到他的话，却要考察他的行为。从宰予的事件以后，我改变了态度。”",
    "annotations": "注释：⑴杇——音乌，wū，泥工抹墙的工具叫杇，把墙壁抹平也叫杇。这里依上文的意思译为“粉刷”。⑵何诛——机械地翻译是“责备什么呢”，这里是意译。⑶子曰——以下的话虽然也是针对“宰予昼寝”而发出，却是孔子另一个时候的言语，所以又加“子曰”两字以示区别。古人有这种修辞条例，俞樾《古书疑义举例》卷二“一人之辞而加曰字例”曾有所阐述（但未引证此条），可参阅。"
  },
  {
    "id": 103,
    "title": "公冶長 5.11",
    "text": "子曰：“吾未见刚者。”或对曰：“申枨⑴。”子曰：“枨也欲，焉得刚？”",
    "translation": "译文：孔子道：“我没见过刚毅不屈的人。”有人答道：“申枨是这样的人。 ”孔子道：“申枨啦，他欲望太多，哪里能够刚毅不屈？”",
    "annotations": "注释：⑴申枨——枨音橙，chéng。《史记·仲尼弟子列传》有申党，古音“党”和“枨”相近，那么“申枨”就是“申党”。"
  },
  {
    "id": 104,
    "title": "公冶長 5.12",
    "text": "子贡曰：“我不欲人之加⑴诸我也，吾亦欲无加诸人。”子曰：“赐也，非尔所及也。”",
    "translation": "译文：子贡道：“我不想别人欺侮我，我也不想欺侮别人。”孔子说：“赐，这不是你能做到的。”",
    "annotations": "注释：⑴加——驾凌，凌辱。"
  },
  {
    "id": 105,
    "title": "公冶長 5.13",
    "text": "子贡曰：“夫子之文章⑴，可得而闻也；夫子之言性⑵与天道⑶，不可\n得而闻也。”",
    "translation": "译文：子贡说：“老师关于文献方面的学问，我们听得到；老师辟于天性和天道的言论，我们听不到。”",
    "annotations": "注释：⑴文章——孔子是古代文化的整理者和传播者，这里的“文章”该是指有关古代文献的学问而言。在《论语》中可以考见的有诗、书、史、礼等等。⑵性——人的本性。古代不可能有阶级观点，因之不知道人的阶级性。而对人的自然的性，孟子、荀子都有所主张，孔子却只说过“性相近也，习相远也”（17.2）一句话。⑶天道——古代所讲的天道一般是指自然和人类社会吉凶祸福的关系。但《左传》昭公十八年郑国子产的话说：“天道远，人道迩，非所及也。”却是对自然和人类社会的吉凶有必然关系的否认。《左传》昭公二十六年又有晏婴的话：“天道不謟。”虽然是用人类的美德来衡量自然之神，反对禳灾，也是对当时迷信习惯的破除。这两人都与孔子同时而年龄较大，而且为孔子所称道。孔子不讲天道，对自然和人类社会的关系取存而不论的态度，不知道是否受这种思想的影响。"
  },
  {
    "id": 106,
    "title": "公冶長 5.14",
    "text": "子路有闻，未之能行，唯恐有⑴闻。",
    "translation": "译文：子路有所闻，还没有能够去做，只怕又有所闻。",
    "annotations": "注释：⑴有——同“又”。"
  },
  {
    "id": 107,
    "title": "公冶長 5.15",
    "text": "子贡问曰：“孔文子⑴何以谓之‘文’也？”子曰：“敏而好学，不耻下问，是以谓之‘文’也。”",
    "translation": "译文：子贡问道：“孔文子凭什么谥他为‘文’？”孔子道：“他聪敏灵活，爱好学问，又谦虚下问，不以为耻，所以用‘文’字做他的谥号。”",
    "annotations": "注释：⑴孔文子——卫国的大夫孔圉。考孔文子死于鲁哀公十五年，或者在此稍前，孔子卒于十六年夏四月，那么，这次问答一定在鲁哀公十五年到十六年初的一段时间内。"
  },
  {
    "id": 108,
    "title": "公冶長 5.16",
    "text": "子谓子产⑴，“有君子之道四焉：其行己也恭，其事上也敬，其养民也\n惠，其使民也义。”",
    "translation": "译文：孔子评论子产，说：“他有四种行为合于君子之道：他自己的容颜态度庄严恭敬，他对待君上负责认真，他教养人民有恩惠，他役使人民合于道理。",
    "annotations": "注释：⑴子产——公孙侨，字子产，郑穆公之孙，为春秋时郑国的贤相，在郑简公、郑定公之时执政二十二年。其时，于晋国当悼公、平公、昭公、顷公、定公五世，于楚国当共王、康王、郏敖、灵王、平王五世，正是两国争强、战争不息的时候。郑国地位冲要，而周旋于这两大强国之间，子产却能不低声下气，也不妄自尊大，使国家得到尊敬和安全，的确是古代中国的一位杰出的政治家和外交家。"
  },
  {
    "id": 109,
    "title": "公冶長 5.17",
    "text": "子曰：“晏平仲⑴善与人交，久而敬之⑵。”",
    "translation": "译文：孔子说：“晏平仲善于和别人交朋友，相交越久，别人越发恭敬他。 ”",
    "annotations": "注释：晏平仲——齐国的贤大夫，名婴。《史记》卷六十二有他的传记。现在所传的《晏子春秋》，当然不是晏婴自己的作品，但亦是西汉以前的书。⑵久而敬之——〈魏著作郎韩显宗墓志〉，“善与人交，人亦久而敬焉”，卽本《论语》，义与别本《论语》作“久而人敬之”者相合。故我以“之”字指晏平仲自己。若以为是指相交之人，译文便当这样：“相交越久，越发恭敬别人”。"
  },
  {
    "id": 110,
    "title": "公冶長 5.18",
    "text": "子曰：“臧文仲⑴居蔡⑵，山节藻梲⑵，何如其知⑷也？”",
    "translation": "译文：孔子说：“臧文仲替一种叫蔡的大乌龟盖了一间屋，有雕刻着像山一样的斗栱和画着藻草的梁上短柱，这个人的聪明怎么这样呢？”",
    "annotations": "注释：⑴臧文仲——鲁国的大夫臧孙辰。（？——公元前 617年）⑵居蔡——古代人把大乌龟叫作“蔡”。《淮南子·说山训》说：“大蔡神龟，出于沟壑。 ”高诱注说：“大蔡，元龟之所出地名，因名其龟为大蔡，臧文仲所居蔡是也。”古代人迷信卜筮，卜卦用龟，筮用蓍草。用龟，认为越大越灵。蔡便是这种大龟。臧文仲宝藏着它，使它住在讲究的地方。居，作及物动词用，使动用法，使之居住的意思。⑶山节藻梲——节，柱上斗栱；“梲”音啄，zhuō，梁上短柱。⑷知——同“智”。"
  },
  {
    "id": 111,
    "title": "公冶長 5.19",
    "text": "子张问曰：“令尹子文⑴三仕⑵为令尹，无喜色；三已⑵之，无愠色。旧令尹之政，必以告新令尹。何如？”子曰：“忠矣。”曰：“仁矣乎？”曰：“未知⑶；——焉得仁？”\n“崔子弒齐君⑷，陈文子⑸有马十乘，弃而违之。至于他邦，则曰，‘犹吾大夫崔子也。’违之。之一邦，则又曰：‘犹吾大夫崔子也。’违之。何如？”子曰：“清矣。”曰：“仁矣乎？”曰：“未知⑶；——焉得仁？”",
    "translation": "译文：子张问道：“楚国的令尹子文三次做令尹的官，没有高兴的颜色；三次被罢免，没有怨恨的颜色。［每次交代，］一定把自己的一切政令全部告诉接位的人。这个人怎么样？”孔子道：“可算尽忠于国家了。”子张道：“算不算仁呢？”孔子道：“不晓得；——这怎么能算是仁呢？”\n子张又问：“崔杼无理地杀掉齐庄公，陈文子有四十匹马，舍弃不要，离开齐国。到了另一个国家，说道：‘这里的执政者同我们的崔子差不多。’又离开。又到了一国，又说道：‘这里的执政者同我们的崔子差不多。’于是又离开。这个人怎么样？”孔子道：“清白得很。”子张道：“算不算仁呢？”孔子道：“不晓得；——这怎么能算是仁呢？”",
    "annotations": "注释：⑴令尹子文——楚国的宰相叫做令尹。子文卽鬬谷（谷音构）于菟（音乌徒）。根据《左传》，子文于鲁庄公三十年开始做令尹，到僖公二十三年让位给子玉，其中相距二十八年。在这二十八年中可能有几次被罢免又被任命，《国语·楚语下》说：“昔子文三舍令尹，无一日之积”，也就可以证明。⑵三仕——“三仕”和“三已”的“三”不一定是实数，可能只是表示那事情的次数之多。⑶未知——和上文第五章“不知其仁”，第八章“不知也”的“不知”相同，不是真的“不知”，只是否定的另一方式，孔子停了一下，又说“焉得仁”，因此用破折号表示。⑷崔子弒齐君——崔子，齐国的大夫崔杼；齐君，齐庄公，名光。弑，古代在下的人杀掉在上的人叫做弑。“崔子弑齐君”的事见《左传》襄公二十五年。⑸陈文子——也是齐国的大夫，名须无。可是《左传》没有记载他离开的事，却记载了他以后在齐国的行为很多，可能是一度离开，终于回到本国了。"
  },
  {
    "id": 112,
    "title": "公冶長 5.20",
    "text": "季文子⑴三思⑵而后行。子闻之，曰：“再⑶，斯可矣。”",
    "translation": "译文：季文子每件事考虑多次才行动。孔子听到了，说：“想两次也就可\n以了。”",
    "annotations": "注释：⑴季文子——鲁国的大夫季孙行父，历仕鲁国文公、宣公、成公、襄公诸代。孔子生于襄公二十二年，文子死在襄公五年。（？——公元前 568年）孔子说这话的时候，文子死了很久了。⑵三思——这一“三”字更其不是实实在在的“三”。⑶再——“再”在古文中一般只当副词用，其下承上文省去了动词“思”字。《唐石经》作“再思”，“思”字不省。凡事三思，一般总是利多弊少，为什么孔子却不同意季文子这样做呢？宦懋庸《论语稽说》，“文子生平盖祸福利害之计太明，故其美恶两不相掩，皆三思之病也。其思之至三者，特以世故太深，过为谨慎；然其流弊将至利害徇一己之私矣”云云。若以《左传》所载文子先后行事证明，此话不为无理。"
  },
  {
    "id": 113,
    "title": "公冶長 5.21",
    "text": "子曰：“宁武子⑴，邦有道，则知；邦无道，则愚⑵。其知可及也，其愚不可及也。”",
    "translation": "译文：孔子说：“宁武子在国家太平时节，便聪明；在国家昏暗时节，便装儍。他那聪明，别人赶得上；那装儍，别人就赶不上了。”",
    "annotations": "注释：⑴宁武子——卫国的大夫，姓宁，名俞。⑵愚——孔安国以为这“愚”是“佯愚似实”，故译为“装儍”。"
  },
  {
    "id": 114,
    "title": "公冶長 5.22",
    "text": "子在陈⑴，曰：“归与！归与！吾党之小子狂简，斐然成章，不知所以裁之⑵。”",
    "translation": "译文：孔子在陈国，说：“回去吧！回去吧！我们那里的学生们志向高大得很，文彩又都斐然可观，我不知道怎样去指导他们。”",
    "annotations": "注释：⑴陈——国名，姓妫。周武王灭殷以后，求得舜的后代叫妫满的封于陈。春秋时拥有现在河南开封以东，安徽亳县以北一带地方。都于宛丘，卽今天的河南淮阳县。春秋末为楚所灭。⑵不知所以裁之——《史记·孔子世家》作“吾不知所以裁之”。译文也认为这一句的主语不是承上文“吾党之小子”而省略，而是省略了自称代词。“裁”，翦裁。布要翦裁才能成衣，人要教育才能成才，所以译为“指导”。"
  },
  {
    "id": 115,
    "title": "公冶長 5.23",
    "text": "子曰：“伯夷、叔齐⑴不念旧恶⑵，怨是用希。”",
    "translation": "译文：孔子说：“伯夷、叔齐这两兄弟不记念过去的仇恨，别人对他们的怨恨也就很少。”",
    "annotations": "注释：⑴伯夷、叔齐——孤竹君的两个儿子，父亲死了，互相让位，而都逃到周文王那里。周武王起兵讨伐商纣，他们拦住车马劝阻。周朝统一天下，他们以吃食周朝的粮食为可耻，饿死于首阳山。《史记》卷六十一有传。⑵恶——嫌隙，仇恨。"
  },
  {
    "id": 116,
    "title": "公冶長 5.24",
    "text": "子曰：“孰谓微生高⑴直？或乞酰⑵焉，乞诸其邻而与之。”",
    "translation": "译文：孔子说：“谁说微生高这个人直爽？有人向他讨点醋，［他不说自己没有，］却到邻人那里转讨一点给人。”",
    "annotations": "注释：⑴微生高——《庄子》、《战国策》诸书载有尾生高守信的故事，说这人和一位女子相约，在桥梁之下见面。到时候，女子不来，他却老等，水涨了都不走，终于淹死。“微”、“尾”古音相近，字通，因此很多人认为微生高就是尾生高。⑵酰——xī，醋。"
  },
  {
    "id": 117,
    "title": "公冶長 5.25",
    "text": "子曰：“巧言、令色、足⑴恭，左丘明⑵耻之，丘亦耻之。匿怨而友其人，左丘明耻之，丘亦耻之。”",
    "translation": "译文：孔子说：“花言巧语，伪善的容貌，十足的恭顺，这种态度，左丘明认为可耻，我也认为可耻。内心藏着怨恨，表面上却同他要好，这种行为，左丘明认为可耻，我也认为可耻。”",
    "annotations": "注释：⑴足恭——“足”字旧读去声，zù。⑵左丘明——历来相传左丘明为《左传》的作者，又因为司马迁在报任安书中说遇：“左丘失明，厥有《国语》。 ”又说他是《国语》的作者。这一问题，经过很多人的研究，我则以为下面的两点结论是可以肯定的：（甲）《国语》和《左传》的作者不是一人，（乙）两书都不可能是和孔子同时甚或较早于孔子（因为孔子这段言语把左丘明放在自己之前，而且引以自重）的左丘明所作。"
  },
  {
    "id": 118,
    "title": "公冶長 5.26",
    "text": "颜渊季路侍⑴。子曰：“盍⑵各言尔志？”子路曰：“愿车马衣轻轻字当删裘与朋友共敝之而无憾。⑶”\n颜渊曰：“愿无伐善，无施⑷劳。”\n子路曰：“愿闻子之志。”\n子曰：“老者安之，朋友信之，少者怀之⑸。”",
    "translation": "译文：孔子坐着，颜渊、季路两人站在孔子身边。孔子道：“何不各人说说自己的志向？”\n子路道：“愿意把我的车马衣服同朋友共同使用坏了也没有什么不满”\n颜渊道：“愿意不夸耀自己的好处，不表白自己的功劳。”子路向孔子道：“希望听到您的志向。”\n孔子道：“［我的志向是，］老者使他安逸，朋友使他信任我，年青人使他怀念我。”",
    "annotations": "注释：⑴侍——《论语》有时用一“侍”字，有时用“侍侧”两字，有时用“侍坐”两字。若单用“侍”字，便是孔子坐着，弟子站着。若用“侍坐”，便是孔子和弟子都坐着。至于“侍侧”，则或坐或立，不加肯定。⑵盍——“何不”的合音字。⑶愿车马衣轻裘与朋友共敝之而无憾——这句的“轻”字是后人加上去的，有很多证据可以证明唐以前的本子并没有这一“轻”字。详见刘宝楠《论语正义》。这一句有两种读法。一种从“共”字断句，把“共”字作谓词。一种作一句读，“共”字看作副词，修饰“敝”字。这两种读法所表现的意义并无显明的区别。⑷施——《淮南子·诠言训》“功盖天下，不施其美。”这两个“施”字意义相同，《礼记·祭统》注云：“施犹着也。”卽表白的意思。⑸信之、怀之——译文把“信”和“怀”同“安”一样看做动词的使动用法。如果把它看做一般用法，那这两句便应该如此翻译：对“朋友有信任，年青人便关心他”。"
  },
  {
    "id": 119,
    "title": "公冶長 5.27",
    "text": "子曰：“已矣乎，吾未见能见其过而内自讼者也。”",
    "translation": "译文：孔子说：“算了吧，我没有看见过能够看到自己的错误便自我责备\n的哩。”",
    "annotations": ""
  },
  {
    "id": 120,
    "title": "公冶長 5.28",
    "text": "子曰：“十室之邑，必有忠信如丘者焉，不如丘之好学也。”",
    "translation": "译文：孔子说：“就是十户人家的地方，一定有像我这样又忠心又信实的人，祗是赶不上我的喜欢学问罢了。”",
    "annotations": ""
  },
  {
    "id": 121,
    "title": "雍也 6.1",
    "text": "子曰：“雍也可使南面⑴。”",
    "translation": "译文：孔子说：“冉雍这个人，可以让他做一部门或一地方的长官。”",
    "annotations": "注释：⑴南面——古代早就知道坐北朝南的方向是最好的，因此也以这个方向的位置最为尊贵，无论天子、诸侯、卿大夫，当他作为长官出现的时候，总是南面而坐的。说见王引之《经义述闻》和凌廷堪《礼经释义》。"
  },
  {
    "id": 122,
    "title": "雍也 6.2",
    "text": "仲弓问子桑伯子⑴。子曰：“可也简⑵。”仲弓曰：“居敬而行简，以临其民，不亦可乎？居简而行简，无乃⑶大⑷简乎？”子曰：“雍之言然。”",
    "translation": "译文：仲弓问到子桑伯子这个人。孔子道：“他简单得好。”仲弓道：“若存心严肃认真，而以简单行之，［抓大体，不烦琐，］来治理百姓，不也可以吗？若存心简单，又以简单行之，不是太简单了吗？”孔子道：“你这番话正确。”",
    "annotations": "注释：⑴子桑伯子——此人已经无可考。有人以为就是《庄子》的子桑户，又有人以为就是秦穆公时的子桑（公孙枝），都未必可靠。既然称“伯子”，很大可能是卿大夫。仲弓说“以临其民”。也要是卿大夫才能临民。⑵简——《说苑》有子桑伯子的一段故事，说他“不衣冠而处”，孔子却认为他“质美而无文”，因之有人认为这一“简”字是指其“无文”而言。但此处明明说他“可也简”，而《说苑》孔子却说，“吾将说而文之”，似乎不能如此解释。朱熹以为“简”之所以“可”，在于“事不烦而民不扰”，颇有道理，故译文加了两句。⑶无乃——相当于“不是”，但只用于反问句。⑷大——同“太”。"
  },
  {
    "id": 123,
    "title": "雍也 6.3",
    "text": "哀公问：“弟子孰为好学？”孔子对曰：“有颜回者好学，不迁怒，不贰过。不幸短命⑴死矣，今也则亡，未闻好学者也。”",
    "translation": "译文：鲁哀公问：“你的学生中，哪个好学？”孔子答道：“有一个叫颜回的人好学，不拿别人出气；也不再犯同样的过失。不幸短命死了，现在再没有这样的人了，再也没听过好学的人了。”",
    "annotations": "注释：⑴短命——《公羊传》把颜渊的死列在鲁哀公十四年（公元前 481年），其时孔子年七十一，依《史记·仲尼弟子列传》，颜渊少于孔子三十岁，则死时年四十一。但据《孔子家语》等书，颜回卒时年仅三十一，因此毛奇龄（《论语稽求篇》）谓《史记》“少孔子三十岁，原是四十之误”。"
  },
  {
    "id": 124,
    "title": "雍也 6.4",
    "text": "子华⑴使⑵于齐，冉子⑶为其母请粟⑷。子曰：“与之釜⑸。”\n请益。曰：“与之庾⑹。”\n冉子与之粟五秉⑺。\n子曰：“赤之适齐也，乘肥马⑻，衣⑼轻裘。吾闻之也：君子周⑽急不继富。 ”",
    "translation": "译文：公西华被派到齐国去作使者，冉有替他母亲向孔子请求小米。孔子道：“给他六斗四升。”\n冉有请求增加。孔子道：“再给他二斗四升。”\n冉有却给了他八十石。\n孔子道：“公西赤到齐国去，坐着由肥马驾的车辆，穿着又轻又暖的皮袍。我听说过：君子只是雪里送炭，不去锦上添花。“",
    "annotations": "注释：⑴子华——孔子学生，姓公西，名赤，字子华，比孔子小四十二岁。⑵使——旧读去声，出使。⑶冉子——《论语》中，孔子弟子称“子”的不过曾参、有若、闵子骞和冉有几个人，因之这冉子当然就是冉有。⑷粟——小米（详新建设杂志1954年12月号胡静〈我国古代农艺史上的几个问题〉）。一般的说法，粟是指未去壳的谷粒，去了壳就叫做米。但在古书中也有把米唤做粟的。见沈彤《周官禄田考》。⑸釜——fǔ，古代量名，容当时的量器六斗四升，约合今天的容量一斗二升八合。⑹庾——yǔ，古代量名，容当日的二斗四升，约合今日的四升八合。⑺秉——音丙，bǐng，古代量名，十六斛。五秉则是八十斛。古代以十斗为斛，所以译为八十石。南宋的贾似道才改为五斗一斛，一石两斛，沿用到民国初年，现今已经废除这一量名了。周秦的八十斛合今天的十六石。⑻乘肥马——不能解释为“骑肥马”，因为孔子时穿着大袖子宽腰身的衣裳，是不便于骑马的。直到战国时的赵武灵王才改穿少数民族服装，学习少数民族的骑着马射箭，以便利于作战。在所有“经书”中找不到骑马的文字，只有《曲礼》有“前有车骑”一语，但《曲礼》的成书在战国以后。⑼衣——去声，动词，当“穿”字解。⑽周——后人写作“赒”，救济。"
  },
  {
    "id": 125,
    "title": "雍也 6.5",
    "text": "原思⑴为之⑵宰，与之粟九百⑶，辞。子曰：“毋！以与尔邻里乡党⑷乎！ ”",
    "translation": "译文：原思任孔子家的总管，孔子给他小米九百，他不肯受。孔子道：“别辞，有多的，给你地方上［的穷人］吧！”",
    "annotations": "注释：⑴原思——孔子弟子原宪，字子思。⑵之——用法同“其”，他的，指孔子而言。⑵九百——下无量名，不知是斛是斗，还是别的。习惯上常把最通用的度、量、衡的单位省畧不说，古今大致相同。不过这一省畧，可把我们迷胡了。⑷邻里乡党——都是古代地方单位的名称，五家为邻，二十五家为里，万二千五百家为乡，五百家为党。"
  },
  {
    "id": 126,
    "title": "雍也 6.6",
    "text": "子谓仲弓，曰：“犂牛⑴之子骍⑵且角⑶；虽欲勿用⑷，山川其⑸舍诸⑹？”",
    "translation": "译文：孔子谈到冉雍，说：“耕牛的儿子长着赤色的毛，整齐的角，虽然不想用它作牺牲来祭祀，山川之神难道会舍弃它吗？”",
    "annotations": "注释：⑴犂牛——耕牛。古人的名和字，意义一定互相照应。从孔子学生冉耕字伯牛、司马耕字子牛的现象看来，足以知道生牛犂田的方法当时已经普遍实行。从前人说，耕牛制度开始于汉武帝时的赵过，那是由于误解《汉书·食货志》的缘故。⑵骍——赤色。周朝以赤色为贵，所以祭祀的时候也用赤色的牲畜。⑶角——意思是两角长得周正。这是古人用词的简略处。⑷用——义同《左传》“用牲于社”之“用”，杀之以祭也。据《史记·仲尼弟子列传》说，仲弓的父亲是贱人，仲弓却是“可使南面”的人才，因此孔子说了这番话。古代供祭祀的牺牲不用耕牛，而且认为耕牛之子也不配作牺牲。孔子的意思是，耕牛所产之子如果够得上作牺牲的条件，山川之神一定会接受这种祭享。那么，仲弓这样的人才，为什么因为他父亲“下贱”而舍弃不用呢？⑸其——意义同“岂”。⑹诸——“之乎”两字的合音字。"
  },
  {
    "id": 127,
    "title": "雍也 6.7",
    "text": "子曰：“回也，其心三月⑴不违仁，其余则日月⑵至焉而已矣。”",
    "translation": "译文：孔子说：“颜回呀，他的心长久地不离开仁德，别的学生么，只是短时期偶然想起一下罢了。”",
    "annotations": "注释：⑴三月，日月——这种词语必须活看，不要被字面所拘束，因此译文用“长久地”译“三月”，用“短时期”“偶然”来译“日月”。"
  },
  {
    "id": 128,
    "title": "雍也 6.8",
    "text": "季康子问：“仲由可使从政也与？”子曰：“由也果，于从政乎何有？”\n曰：“赐也可使从政也与？”曰：“赐也达，于从政乎何有？”\n曰：“求也可使从政也与？”曰：“求也艺，于从政乎何有？”",
    "translation": "译文：季康子问孔子：“仲由这人，可以使用他治理政事么？”孔子道：“仲由果敢决断，让他治理政事有什么困难呢？”\n又问：“端木赐可以使用他治理政事么？”孔子道：“端木赐通情达理，让他治理政事有什么困难呢？”\n又问：“冉求可以使用他治理政事么？”孔子道：“冉求多才多艺，让他治理政事有什么困难呢？”",
    "annotations": ""
  },
  {
    "id": 129,
    "title": "雍也 6.9",
    "text": "季氏使闵子骞⑴为费⑵宰。闵子骞曰：“善为我辞焉！如有复我者，则吾必在汶上⑶矣。”",
    "translation": "译文：季氏叫闵子骞作他采邑费地的县长。闵子骞对来人说道：“好好地替我辞掉吧！若是再来找我的话，那我一定会逃到汶水之北去了。”",
    "annotations": "注释：⑴闵子骞——孔子学生闵损，字子骞，比孔子小十五岁。（公元前515——？）⑵费——旧音秘，故城在今山东费县西北二十里。⑶汶上——汶音问，wèn，水名，就是山东的大汶河。桂馥《札朴》云：“水以阳为北，凡言某水上者，皆谓水北。”“汶上”暗指齐国之地。"
  },
  {
    "id": 130,
    "title": "雍也 6.10",
    "text": "伯牛⑴有疾，子问之，自牖执其手，曰：“亡之⑵，命矣夫！斯人也而有斯疾也！斯人也而有斯疾也！”",
    "translation": "译文：伯牛生了病，孔子去探问他，从窗户里握着他的手，道：“难得活了，这是命呀，这样的人竟有这样的病！这样的人竟有这样的病！”",
    "annotations": "注释：⑴伯牛——孔子学生冉耕字伯牛。⑵亡之——这“之”字不是代词，不是“亡”（死亡之意）的宾语，因为“亡”字在这里不应该有宾语，只是凑成一个音节罢了。古代常有这种形似宾语而实非宾语的“之”字，详拙著《文言语法》。"
  },
  {
    "id": 131,
    "title": "雍也 6.11",
    "text": "子曰：“贤哉，回也！一箪⑴食，一瓢饮，在陋巷，人不堪其忧，回也不改其乐。贤哉，回也！”",
    "translation": "译文：孔子说：“颜回多么有修养呀，一竹筐饭，一瓜瓢水，住在小巷子里，别人都受不了那穷苦的忧愁，颜回却不改变他自有的快乐。颜回多么有修养呀！”",
    "annotations": "注释：⑴箪——音单，dān，古代盛饭的竹器，圆形。"
  },
  {
    "id": 132,
    "title": "雍也 6.12",
    "text": "冉求曰：“非不说子之道，力不足也。”子曰：“力不足者⑴，中道而废。今女画⑵。”",
    "translation": "译文：冉求道：“不是我不喜欢您的学说，是我力量不够。”孔子道：“如果真是力量不够，走到半道会再走不动了。现在你却没有开步走。”",
    "annotations": "注释：⑴力不足者——“者”这一表示停顿的语气词，有时兼表假设语气，详《文言语法》。⑵画——停止。"
  },
  {
    "id": 133,
    "title": "雍也 6.13",
    "text": "子谓子夏曰：“女为君子儒！无为小人儒！”",
    "translation": "译文：孔子对子夏道：“你要去做个君子式的儒者，不要去做那小人式的儒者！”",
    "annotations": ""
  },
  {
    "id": 134,
    "title": "雍也 6.14",
    "text": "子游为武城⑴宰。子曰：“女得人焉耳⑵乎？”曰：“有澹台灭明者⑶，行不由径，非公事，未尝至于偃之室也。”",
    "translation": "译文：子游做武城县县长。孔子道：“你在这儿得到什么人才没有？”他道：“有一个叫澹台灭明的人，走路不插小道，不是公事，从不到我屋里来。”",
    "annotations": "注释：⑴武城——鲁国的城邑，在今山东费县西南。⑵耳——通行本作“尔”，兹依《唐石经》、《宋石经》、皇侃《义疏》本作“耳”。⑶有澹台灭明者——澹台灭明字子羽，《史记·仲尼弟子列传》也把他列入弟子。但从这里子游的答话语气来看，说这话时还没有向孔子受业。因为“有……者”的提法，是表示这人是听者以前所不知道的。若果如《史记》所记，澹台灭明在此以前便已经是孔子学生，那子游这时的语气应该与此不同。"
  },
  {
    "id": 135,
    "title": "雍也 6.15",
    "text": "子曰：“孟之反⑴不伐，奔而殿，将入门，策其马，曰：‘非敢后也，马不进也。’”",
    "translation": "译文：孔子说：“孟之反不夸耀自己，［在抵御齐国的战役中，右翼的军队溃退了，］他走在最后，掩护全军，将进城门，便鞭打着马匹，一面说道：‘不是我敢于殿后，是马匹不肯快走的缘故。’”",
    "annotations": "注释：⑴孟之反——《左传》哀公十一年作“孟之侧”，译文参照《左传》所叙述的事实有所增加。"
  },
  {
    "id": 136,
    "title": "雍也 6.16",
    "text": "子曰：“不有⑴祝鮀⑵之佞，而⑶有宋朝⑷之美，难乎免于今之世矣。”",
    "translation": "译文：孔子说：“假使没有祝鮀的口才，而仅有宋朝的美丽，在今天的社会里怕不易避免祸害了。”",
    "annotations": "注释：⑴不有——这里用以表示假设语气，“假若没有”的意思。⑵祝鮀—\n—卫国的大夫，字子鱼，《左传》定公四年曾记载着他的外交词令。⑶而——王引之《经义述闻》云：“而犹与也，言有祝鮀之佞与有宋朝之美也。”很多人同意这种讲法，但我终嫌“不有祝鮀之佞，与有宋朝之美”为语句不顺，王氏此说恐非原意。⑷宋朝——宋国的公子朝，《左传》昭公二十年和定公十四年都曾记载着他因为美丽而惹起乱子的事情。"
  },
  {
    "id": 137,
    "title": "雍也 6.17",
    "text": "子曰：“谁能出不由户？何莫由斯道也？”",
    "translation": "译文：孔子说：“谁能够走出屋外不从房门经过？为什么没有人从我这条路行走呢？”",
    "annotations": ""
  },
  {
    "id": 138,
    "title": "雍也 6.18",
    "text": "子曰：“质胜文则野，文胜质则史。文质彬彬⑴，然后君子。”",
    "translation": "译文：孔子说：“朴实多于文采，就未免粗野；文采多于朴实，又未免虚浮。文采和朴实，配合适当，这才是个君子。”",
    "annotations": "注释：⑴文质彬彬——此处形容人既文雅又朴实，后来多用来指人文雅有礼貌。"
  },
  {
    "id": 139,
    "title": "雍也 6.19",
    "text": "子曰：“人之生也⑴直，罔⑵之生也幸而免。”",
    "translation": "译文：孔子说：“人的生存由于正直，不正直的人也可以生存，那是他侥幸地免于祸害。”",
    "annotations": "注释：⑴也——语气词，表“人之生”是一词组作主语，这里无妨作一停顿，下文“直”是谓语。⑵罔——诬罔的人，不直的人。"
  },
  {
    "id": 140,
    "title": "雍也 6.20",
    "text": "子曰：“知之者不如好之者，好之者不如乐之者。”",
    "translation": "译文：孔子说：“［对于任何学问和事业，］懂得它的人不如喜爱它的人，喜爱它的人又不如以它为乐的人。”",
    "annotations": ""
  },
  {
    "id": 141,
    "title": "雍也 6.21",
    "text": "子曰：“中人以上，可以语上也；中人以下，不可以语上也。”",
    "translation": "译文：孔子说：“中等水平以上的人，可以告诉他高深学问；中等水平以下的人，不可以告诉他高深学问。”",
    "annotations": ""
  },
  {
    "id": 142,
    "title": "雍也 6.22",
    "text": "樊迟问知。子曰：“务民之义，敬鬼神而远之⑴，可谓知矣。”\n问仁。曰：“仁者先难⑵而后获，可谓仁矣。”",
    "translation": "译文：樊迟问怎么样才算聪明。孔子道：“把心力专一地放在使人民走向‘义’上，严肃地对待鬼神，但并不打算接近他，可以说是聪明了。”\n又问怎么样才叫做有仁德。孔子道：“仁德的人付出一定的力量，然后收获果实，可以说是仁德了。”",
    "annotations": "注释：⑴远之——远作及物动词，去声，yuàn。疏远，不去接近的意思。譬如祈祷、淫祀，在孔子看来都不是“远之”。⑵先难——颜渊篇第十二又有一段答樊迟的话，其中有两句道：“先事后得，非崇德与？”和这里“先难后获可谓仁矣”是一个意思，所以我把“难”字译为“付出一定的力量”。孔子对樊迟两次说这样的话，是不是樊迟有坐享其成的想法，那就不得而知了。"
  },
  {
    "id": 143,
    "title": "雍也 6.23",
    "text": "子曰：“知者乐水，仁者乐山。知者动，仁者静。知者乐，仁者寿。”",
    "translation": "译文：孔子说：“聪明人乐于水，仁人乐于山。聪明人活动，仁人沉静。聪明人快乐，仁人长寿。”",
    "annotations": ""
  },
  {
    "id": 144,
    "title": "雍也 6.24",
    "text": "子曰：“齐一变，至于鲁；鲁一变，至于道。”",
    "translation": "译文：孔子说：“齐国［的政治和教育］一有改革，便达到鲁国的样子；鲁国［的政治和教育］一有改革，便进而合于大道了。”",
    "annotations": ""
  },
  {
    "id": 145,
    "title": "雍也 6.25",
    "text": "子曰：“觚⑴不觚，觚哉！觚哉！”",
    "translation": "译文：孔子说：“觚不像个觚，这是觚吗！这是觚吗！”",
    "annotations": "注释：⑴觚——音孤，gū，古代盛酒的器皿，腹部作四条棱角，足部也作四条棱角。每器容当时容量二升（或曰三升）。孔子为什么说这话，后人有两种较为近于情理的猜想：（甲）觚有棱角，才能叫做觚。可是做出棱角比做圆的难，孔子所见的觚可能只是一个圆形的酒器，而不是上圆下方（有四条棱角）的了。但也名为棱，因之孔子慨叹当日事物名实不符，如“君不君，臣不臣，父不父，子不子”之类。（乙）觚和孤同音，寡少的意思。只能容酒两升（或者三升）的叫觚，是叫人少饮不要沉湎之意。可能当时的觚实际容量已经大大不止此数，由此孔子发出感慨。（古代酿酒，不懂得蒸酒的技术，因之酒精成份很低，而升又小，两三升酒是微不足道的。《史记·滑稽列传》载淳于髡的话，最多能够饮一石，可以想见了。）"
  },
  {
    "id": 146,
    "title": "雍也 6.26",
    "text": "宰我问曰：“仁者，虽告之曰，‘井有仁⑴焉。’其从之也？”子曰：“何为其然也？君子可逝⑵也，不可陷也；可欺⑶也，不可罔⑷也。”",
    "translation": "译文：宰我问道：“有仁德的人，就是告诉他，‘井里掉下一位仁人啦。’他是不是会跟着下去呢？”孔子道：“为什么你要这样做呢？君子可以叫他远远走开不再回来，却不可以陷害他；可以欺骗他，却不可以愚弄他。”",
    "annotations": "注释：⑴仁——卽“仁人”的意思，和学而篇第一“泛爱众而亲仁”的“仁”用法相同。⑵逝——古代“逝”字的意义和“往”字有所不同，“往”而不复返才用“逝”字。译文卽用此义。俞樾《羣经平议》读“逝”为“折”说：“逝与折古通用。君子杀身成仁则有之矣，故可得而摧折，然不可以非理陷害之，故可折而不可陷。”亦通。⑶欺、罔——《孟子·万章上》有这样一段话，和这一段结合，正好说明“欺”和“罔”的区别。那段的原文是：“昔者有馈生鱼于郑子产，子产使校人畜之池。校人烹之，反命曰：‘始舍之，圉圉焉；少则洋洋焉；攸然而逝。’子产曰：‘得其所哉！得其所哉！’校人出，曰：‘孰谓子产知？予既烹而食之，曰，得其所哉，得其所哉。’故君子可欺以其方，难罔以非其道。”那么，校人的欺骗子产，是“欺以其方”，而宰我的假设便是“罔以非其道”了。"
  },
  {
    "id": 147,
    "title": "雍也 6.27",
    "text": "子曰：“君子博学于文，约之以礼⑴，亦可以弗畔⑵矣夫！”",
    "translation": "译文：孔子说：“君子广泛地学习文献，再用礼节来加以约束，也就可以不致于离经叛道了。”",
    "annotations": "注释：⑴博学于文，约之以礼——子罕篇第九云：“颜渊喟然叹曰：‘夫子循循然善诱人，博我以文，约我以礼。’”这里的“博学于文，约之以礼”和子罕篇的“博我以文，约我以礼”是不是完全相同呢？如果完全相同，则“约之以礼”的“之”是指代“君子”而言。这是一般人的说法。但毛奇龄的《论语稽求篇》却说：“博约是两事，文礼是两物，然与‘博我以文，约我以礼’不同。何也？彼之博约是以文礼博约回；此之博约是以礼约文，以约约博也。博在文，约文又在礼也。”毛氏认为“约之以礼”的“之”是指代“文”，正是我们平常所说的“由博返约”的意思。⑵畔——同“叛”。"
  },
  {
    "id": 148,
    "title": "雍也 6.28",
    "text": "子见南子⑴，子路不说。夫子矢之曰：“予所⑵否者，天厌之！天厌之！ ”",
    "translation": "译文：孔子去和南子相见，子路不高兴。孔子发誓道：“我假若不对的话，天厌弃我罢！天厌弃我罢！”",
    "annotations": "注释：⑴南子——卫灵公夫人，把持着当日卫国的政治，而且有不正当的行为，名声不好。《史记·孔子世家》对“子见南子”的情况有生动的描述。⑵所——如果，假若。假设连词，但只用于誓词中。详阎若璩《四书释地》。"
  },
  {
    "id": 149,
    "title": "雍也 6.29",
    "text": "子曰：“中庸⑴之为德也，其至矣乎！民⑵鲜久矣。”",
    "translation": "译文：孔子说：“中庸这种道德，该是最高的了，大家已经是长久地缺乏它了。”",
    "annotations": "注释：⑴中庸——这是孔子的最高道德标准。“中”，折中，无过，也无不及，调和；“庸”，平常。孔子拈出这两个字，就表示他的最高道德标准，其实就是折中的和平常的东西。后代的儒家又根据这两个字作了一篇题为“中庸”的文章，西汉人戴圣收入《礼记》，南宋人朱熹又取入《四书》。司马迁说是子思所作，未必可靠。从其文字和内容看，可能是战国至秦的作品，难免不和孔子的“中庸”有相当距离。⑵民——这“民”字不完全指老百姓，因以“大家”译之。"
  },
  {
    "id": 150,
    "title": "雍也 6.30",
    "text": "子贡曰：“如有博施⑴于民而能济众，何如？可谓仁乎？”子曰：“何事于仁！必也圣乎！尧舜⑵其犹病诸！夫⑶仁者，己欲立而立人，己欲达而达人。能近取譬，可谓仁之方也已。”",
    "translation": "译文：子贡道：“假若有这么一个人，广泛地给人民以好处，又能帮助大家生活得很好，怎么样？可以说是仁道了吗？”孔子道：“哪里仅是仁道！那一定是圣德了！尧舜或者都难以做到哩！仁是甚么呢？自己要站得住，同时也使别人站得住；自己要事事行得通，同时也使别人事事行得通。能够就眼下的事实选择例子一步步去做，可以说是实践仁道的方法了。”",
    "annotations": "注释：⑴施——旧读去声。⑵尧舜——传说中的上古两位帝王，也是孔子心目中的榜样。⑶夫——音扶，fú，文言中的提挈词。"
  },
  {
    "id": 151,
    "title": "述而 7.1",
    "text": "子曰：“述而不作，信而好古⑴，窃比于我老彭⑵。”",
    "translation": "译文：孔子说：“阐述而不创作，以相信的态度喜爱古代文化，我私自和我那老彭相比。”",
    "annotations": "注释：⑴作，好古——下文第二十八章说：“盖有不知而作之者，我无是也。”这个“作”，大概也是“不知而作”的涵义，很难说孔子的学说中没有创造性。又第二十章说：“好古敏以求之”，也可为这个“好古”的证明。⑵老彭——人名。有人说是老子和彭祖两人，有人说是殷商时代的彭祖一人，又有人说孔子说“我的老彭”，其人一定和孔子相当亲密，未必是古人。《大戴礼·虞戴德篇》有“商老彭”，不知卽此人不。"
  },
  {
    "id": 152,
    "title": "述而 7.2",
    "text": "子曰：“默而识⑴之，学而不厌，诲人不倦，何有于我哉⑵？”",
    "translation": "译文：孔子说：“［把所见所闻的］默默地记在心里，努力学习而不厌弃，教导别人而不疲倦，这些事情我做到了哪些呢？”",
    "annotations": "注释：⑴识——音志，zhì，记住。⑵何有于我哉——“何有”在古代是一常\n用语，在不同场合表示不同意义。像《诗·邶风·谷风》“何有何亡？黾勉求之”的“何有”便是“有什么”的意思，译文就是用的这一意义。也有人说，《论语》的“何有”都是“不难之词”，那么，这句话便该译为“这些事情对我有什么困难呢”。这种译法便不是孔子谦虚之词，而和下文第二十八章的“多闻，择其善者而从之，多见而识之”以及“抑为之不厌，诲人不倦”的态度相同了。"
  },
  {
    "id": 153,
    "title": "述而 7.3",
    "text": "子曰：“德之不修，学之不讲，闻义不能徙，不善不能改，是吾忧也。”",
    "translation": "译文：孔子说：“品德不培养；学问不讲习；听到义在那里，却不能亲身赴之；有缺点不能改正，这些都是我的忧虑哩！”",
    "annotations": ""
  },
  {
    "id": 154,
    "title": "述而 7.4",
    "text": "子之燕居，申申⑴如也，夭夭⑵如也。",
    "translation": "译文：孔子在家闲居，很整齐的，很和乐而舒展的。",
    "annotations": "注释：⑴申申——整敕之貌。⑵夭夭——和舒之貌。"
  },
  {
    "id": 155,
    "title": "述而 7.5",
    "text": "子曰：“甚矣吾衰也！久矣吾不复梦见周公⑴！”",
    "translation": "译文：孔子说：“我衰老得多么厉害呀！我好长时间没再梦见周公了！”",
    "annotations": "注释：⑴周公——姓姬，名旦，周文王的儿子，武王的弟弟，成王的叔父，鲁国的始祖，又是孔子心目中最敬服的古代圣人之一。"
  },
  {
    "id": 156,
    "title": "述而 7.6",
    "text": "子曰：“志于道，据于德，依于仁，游于艺⑴。”",
    "translation": "译文：孔子说：“目标在‘道’，根据在‘德’，依靠在‘仁’，而游憩于礼、乐、射、御、书、数六艺之中。”",
    "annotations": "注释：⑴游于艺——《礼记·学记》曾说：“不兴其艺，不能乐学。故君子之于学也，藏焉，修焉，息焉，游焉。夫然，故安其学而亲其师，乐其友而信其道，是以虽离师辅而不反也。”可以阐明这里的“游于艺”。"
  },
  {
    "id": 157,
    "title": "述而 7.7",
    "text": "子曰：“自行束修⑴以上，吾未尝无诲焉。”",
    "translation": "译文：孔子说：“只要是主动地给我一点见面薄礼，我从没有不教诲的。”",
    "annotations": "注释：⑴束修——修是干肉，又叫脯。每条脯叫一脡（挺），十脡为一束。\n束修就是十条干肉，古代用来作初次拜见的礼物。但这一礼物是菲薄的。"
  },
  {
    "id": 158,
    "title": "述而 7.8",
    "text": "子曰：“不愤⑴不启，不悱⑵不发⑶。举一隅不以三隅反，则不复也。”",
    "translation": "译文：孔子说：“教导学生，不到他想求明白而不得的时候，不去开导他；不到他想说出来却说不出的时候，不去启发他。教给他东方，他却不能由此推知西、南、北三方，便不再教他了。”",
    "annotations": "注释：⑴愤——心求通而未得之意。⑵悱音斐，fěi，口欲言而未能之貌。⑶不启，不发——这是孔子自述其教学方法，必须受教者先发生困难，有求知的动机，然后去启发他。这样，教学效果自然好些。"
  },
  {
    "id": 159,
    "title": "述而 7.9",
    "text": "子食于有丧者之侧，未尝饱也。",
    "translation": "译文：孔子在死了亲属的人旁边吃饭，不曾吃饱过。",
    "annotations": ""
  },
  {
    "id": 160,
    "title": "述而 7.10",
    "text": "子于是日哭，则不歌。",
    "translation": "译文：孔子在这一天哭泣过，就不再唱歌。",
    "annotations": ""
  },
  {
    "id": 161,
    "title": "述而 7.11",
    "text": "子谓颜渊曰：“用之则行，舍之则藏，惟我与尔有是夫！”\n子路曰：“子行三军，则谁与⑴？”\n子曰：“暴虎冯河⑵，死而无悔者，吾不与也。必也临事而惧，好谋而成者\n也。”",
    "translation": "译文：孔子对颜渊道：“用我呢，就干起来；不用呢，就藏起来。只有我和你才能这样吧！”\n子路道：“您若率领军队，找谁共事？”\n孔子道：“赤手空拳和老虎搏斗，不用船只去渡河，这样死了都不后悔的人，我是不和他共事的。［我所找他共事的，］一定是面临任务便恐惧谨慎，善于谋略而能完成的人哩！”",
    "annotations": "注释：⑴子行三军，则谁与——“行”字古人用得很活，行军犹言行师。《易经·谦卦·上六》云：“利用行师征邑国”，又《复卦·上六》：“用行师终有大败”，行师似有出兵之意。这种活用，一直到中古都如此。如“子夜歌”的“欢行白日心，朝东暮还西。”“与”，动词，偕同的意思。子路好勇，看见孔子夸奖颜渊，便发此问。⑵暴虎冯河——冯音凭，píng。徒手搏虎曰暴虎，徒足涉河曰冯河。“冯河”两字最初见于《易·泰卦·爻辞》，又见于《诗·小雅·小旻》。“暴虎”也见于《诗经·郑风·大叔于田》和《小雅·小旻》，可见都是很早就有的俗语。“河”不一定是专指黄河，古代也有用作通名，泛指江河的。"
  },
  {
    "id": 162,
    "title": "述而 7.12",
    "text": "子曰：“富而⑴可求也，虽执鞭之士⑵，吾亦为之。如不可求，从吾所好。”",
    "translation": "译文：孔子说：“财富如果可以求得的话，就是做市场的守门卒我也干。如果求它不到，还是我干我的罢。”",
    "annotations": "注释：⑴而——用法同“如”，假设连词。但是用在句中的多，卽有用在句首的，那句也多半和上一句有密切的关连，独立地用在句首的极少见。⑵执鞭之士——根据《周礼》，有两种人拿着皮鞭，一种是古代天子以及诸侯出入之时，有二至八人拿着皮鞭使行路之人让道。一种是市场的守门人，手执皮鞭来维持秩序。这里讲的是求财，市场是财富所聚集之处，因此译为“市场守门卒”。"
  },
  {
    "id": 163,
    "title": "述而 7.13",
    "text": "子之所慎：齐⑴，战，疾⑵。",
    "translation": "译文：孔子所小心慎重的事有三样：斋戒，战争，疾病。",
    "annotations": "注释：⑴齐——同“斋”。古代于祭祀之前，一定先要做一番身心的整洁工\n作，这一工作便叫做‘斋’或者“斋戒”。乡党篇第十说孔子“斋必变食，居必迁坐”。⑵战，疾——上文说到孔子作战必求“临事而惧好谋而成”的人，因为它关系国家的存亡安危；乡党篇又描写孔子病了，不敢随便吃药，因为它关系个人的生死。这都是孔子不能不谨慎的地方。"
  },
  {
    "id": 164,
    "title": "述而 7.14",
    "text": "子在齐闻韶，三月不知肉味，曰：“不图为乐之至于斯也。”",
    "translation": "译文：孔子在齐国听到韶的乐章，很长时间尝不出肉味，于是道：“想不到欣赏音乐竟到了这种境界。”",
    "annotations": ""
  },
  {
    "id": 165,
    "title": "述而 7.15",
    "text": "冉有曰：“夫子为⑴卫君⑵乎？”子贡曰：“诺；吾将问之。”\n入，曰：“伯夷、叔齐何人也？”曰：“古之贤人也。”曰：“怨乎？”曰：“求仁而得仁，又何怨？”\n出，曰：“夫子不为也。”",
    "translation": "译文：冉有道：“老师赞成卫君吗？”子贡道：“好罢；我去问问他。”\n子贡进到孔子屋里，道：“伯夷、叔齐是什么样的人？”孔子道：“是古代的贤人。”子贡道： “［他们两人互相推让，都不肯做孤竹国的国君，结果都跑到国外，］是不是后来又怨悔呢？”孔子道：“他们求仁德，便得到了仁德，又怨悔什么呢？”\n子贡走出，答复冉有道：“老师不赞成卫君。”",
    "annotations": "注释：⑴为——动词，去声，本意是帮助，这里译为“赞成”，似乎更合原意。⑵卫君——指卫出公辄。辄是卫灵公之孙，太子蒯聩之子。太子蒯聩得罪了卫灵公的夫人南子，逃在晋国。灵公死，立辄为君。晋国的赵简子又把蒯聩送回，藉以侵略卫国。卫国抵御晋兵，自然也拒绝了蒯聩的回国。从蒯聩和辄是父子关系的一点看来，似乎是两父子争夺卫君的位置，和伯夷、叔齐两兄弟的互相推让，终于都抛弃了君位相比，恰恰成一对照。因之下文子贡引以发问，藉以试探孔子对出公辄的态度。孔子赞美伯夷、叔齐，自然就是不赞成出公辄了。"
  },
  {
    "id": 166,
    "title": "述而 7.16",
    "text": "子曰：“饭疏食⑴饮水⑵，曲肱⑶而枕⑷之，乐亦在其中矣。不义而富\n且贵，于我如浮云。”",
    "translation": "译文：孔子说：“吃粗粮，喝冷水，弯着胳膊做枕头，也有着乐趣。干不正当的事而得来的富贵，我看来好像浮云。”",
    "annotations": "注释：⑴疏食——有两个解释：（甲）粗粮。古代以稻梁为细粮，以稷为粗粮。见程瑶田《通艺録·九谷考》。（乙）糙米。⑵水——古代常以“汤”和“水”对言，“汤”的意义是热水，“水”就是冷水。⑶肱——音宫，gōng，胳膊。⑷枕——这里用作动词，旧读去声。"
  },
  {
    "id": 167,
    "title": "述而 7.17",
    "text": "子曰：“加我数年，五十以学《易》⑴，可以无大过矣。”",
    "translation": "译文：孔子说：“让我多活几年，到五十岁时候去学习《易经》，便可以没有大过错了。”",
    "annotations": "注释：⑴易——古代一部用以占筮的书，其中的卦辞和爻辞是孔子以前的作品。"
  },
  {
    "id": 168,
    "title": "述而 7.18",
    "text": "子之所雅言⑴，《诗》、《书》、执礼，皆雅言也。",
    "translation": "译文：孔子有用普通话的时候，读《诗》，读《书》，行礼，都用普通话。",
    "annotations": "注释：⑴雅言——当时中国所通行的语言。春秋时代各国语言不能统一，不但可以想象得到，卽从古书中也可以找到证明。当时较为通行的语言便是“雅言”。"
  },
  {
    "id": 169,
    "title": "述而 7.19",
    "text": "叶公⑴问孔子于子路，子路不对。子曰：“女奚不曰，其为人也，发愤忘食，乐以忘忧，不知老之将至云尔⑵。”",
    "translation": "译文：叶公向子路问孔子为人怎么样，子路不回答。孔子对子路道：“你为什么不这样说：他的为人，用功便忘记吃饭，快乐便忘记忧愁，不晓得衰老会要到来，如此罢了。”",
    "annotations": "注释：⑴叶——旧音摄，shè，地名，当时属楚，今河南叶县南三十里有\n古叶城。叶公是叶地方的县长，楚君称王，那县长便称公。此人叫沈诸梁，字子高，《左传》定公、哀公之间有一些关于他的记载，在楚国当时还算是一位贤者。⑵云尔——云，如此；尔同“耳”，而已，罢了。"
  },
  {
    "id": 170,
    "title": "述而 7.20",
    "text": "子曰：“我非生而知之者，好古，敏以求之者也。”",
    "translation": "译文：孔子说：“我不是生来就有知识的人，而是爱好古代文化，勤奋敏捷去求得来的人。”",
    "annotations": ""
  },
  {
    "id": 171,
    "title": "述而 7.21",
    "text": "子不语怪，力，乱，神。",
    "translation": "译文：孔子不谈怪异、勇力、叛乱和鬼神。",
    "annotations": ""
  },
  {
    "id": 172,
    "title": "述而 7.22",
    "text": "子曰：“三人行，必有我师焉：择其善者而从之，其不善者而改之⑴。”",
    "translation": "译文：孔子说：“几个人一块走路，其中便一定有可以为我所取法的人：我选取那些优点而学习，看出那些缺点而改正。”",
    "annotations": "注释：⑴子曰……改之——子贡说孔子没有特定的老师（见19.22），意思就是随处都有老师，和这章可以以互相证明，老子说：“善人，不善人之师；不善人，善人之资。”未尝不是这个道理。"
  },
  {
    "id": 173,
    "title": "述而 7.23",
    "text": "子曰：“天生德于予，桓魋⑴其如予何⑵？”",
    "translation": "译文：孔子说：“天在我身上生了这样的品德，那桓魋将把我怎样？”",
    "annotations": "注释：⑴桓魋——“魋”音颓，tuí。桓魋，宋国的司马向魋，因为是宋桓公的后代，所以又叫桓魋。⑵桓魋其如予何——《史记·孔子世家》有一段这样的记载：“孔子去曹，适宋，与弟子习礼大树下。宋司马桓魋欲杀孔子，拔其树。孔子去，弟子曰‘可以速矣！’孔子曰：‘天生德于予，桓魋其如予何？’”"
  },
  {
    "id": 174,
    "title": "述而 7.24",
    "text": "子曰：“二三子以我为隐乎？吾无隐乎尔。吾无行而不与二三子者，是丘也。”",
    "translation": "译文：孔子说：“你们这些学生以为我有所隐瞒吗？我对你们是没有隐瞒的。我没有一点不向你们公开，这就是我孔丘的为人”",
    "annotations": ""
  },
  {
    "id": 175,
    "title": "述而 7.25",
    "text": "子以四教：文，行⑴，忠，信。",
    "translation": "译文：孔子用四种内容教育学生：历代文献，社会生活的实践，对待别人的忠心，与人交际的信实。",
    "annotations": "注释：⑴行——作名词用，旧读去声。"
  },
  {
    "id": 176,
    "title": "述而 7.26",
    "text": "子曰：“圣人，吾不得而见之矣；得见君子者，斯可矣。”\n子曰：“善人，吾不得而见之矣；得见有恒⑴者，斯可矣。亡而为有，虚而为盈，约而为泰⑵，难乎有恒矣。”",
    "translation": "译文：孔子说：“圣人，我不能看见了；能看见君子，就可以了。”又说：“善人，我不能看见了，能看见有一定操守的人，就可以了。本来没有，却装做有；本来空虚，却装做充足；本来穷困，却要豪华，这样的人便难于保持一定操守了。”",
    "annotations": "注释：⑴有恒——这个“恒”字和《孟子·梁惠王上》的“无恒产而有恒心”的“恒”是一个意义。⑵泰——这“泰”字和《国语·晋语》的“恃其富宠，以泰于国”，《荀子·议兵篇》的“用财欲泰”的“泰”同义，用度豪华而不吝惜的意思。"
  },
  {
    "id": 177,
    "title": "述而 7.27",
    "text": "子曰：“子钓而不纲⑴，弋⑵不射宿⑶。”",
    "translation": "译文：孔子钓鱼，不用大绳横断流水来取鱼；用带生丝的箭射鸟，不射归巢的鸟。",
    "annotations": "注释：⑴纲——网上的大绳叫纲，用它来横断水流，再用生丝系钓，着于纲上来取鱼，这也叫纲。“不纲”的“纲”是动词。⑵弋——音亦，yì，用带生丝的\n矢来射。⑶宿——歇宿了的鸟。"
  },
  {
    "id": 178,
    "title": "述而 7.28",
    "text": "子曰：“盖有不知而作之者，我无是也。多闻，择其善者而从之；多见而识之；知之次也⑴。”",
    "translation": "译文：孔子说：“大概有一种自己不懂却凭空造作的人，我没有这种毛病。多多地听，选择其中好的加以接受；多多地看，全记在心里。这样的知，是仅次于‘生而知之’的。”",
    "annotations": "注释：⑴次——《论语》的“次”一共享了八次，都是当“差一等”、“次一等”讲。季氏篇云：“孔子曰：‘生而知之者，上也；学而知之者，次也。’”这里的“知之次也”正是“学而知之者，次也”的意思。孔子自己也说他是学而知之（好古敏以求之）的人，所以译文加了几个字。"
  },
  {
    "id": 179,
    "title": "述而 7.29",
    "text": "互乡⑴难与言，童子见，门人惑。子曰：“与其进也，不与其退也，唯何甚？人洁己以进，与其洁也，不保⑵其往也。”",
    "translation": "译文：互乡这地方的人难于交谈，一个童子得到孔子的接见，弟子们疑惑。孔子道：“我们赞成他的进步，不赞成他的退步，何必做得太过？别人把自己弄得干干净净而来，便应当赞成他的干净，不要死记住他那过去。”",
    "annotations": "注释：⑴互乡——地名，现在已不详其所在。⑵保——守也，所以译为“死记住”。"
  },
  {
    "id": 180,
    "title": "述而 7.30",
    "text": "子曰：“仁远乎哉？我欲仁，斯仁至矣。”",
    "translation": "译文：孔子道：“仁德难道离我们很远吗？我要它，它就来了。”",
    "annotations": ""
  },
  {
    "id": 181,
    "title": "述而 7.31",
    "text": "陈司败⑴问昭公⑵知礼乎，孔子曰：“知礼。”\n孔子退，揖巫马期⑶而进之，曰：“吾闻君子不党，君子亦党乎？君取于吴⑷，为同姓⑸，谓之吴孟子⑹。君而知礼，孰不知礼？”\n巫马期以告。子曰：“丘也幸，苟有过⑺，人必知之。”",
    "translation": "译文：陈司败向孔子问鲁昭公懂不懂礼，孔子道：“懂礼。”\n孔子走了出来，陈司败便向巫马期作了个揖。请他走近自己，然后说道：“我听说君子无所偏袒，难道孔子竟偏袒吗？鲁君从吴国娶了位夫人，吴和鲁是同姓国家，［不便叫她做吴姬，］于是叫她做吴孟子。鲁君若是懂得礼，谁不懂得礼呢？”\n巫马期把这话转告给孔子。孔子道：“我真幸运，假若有错误，人家一定给指出来，”",
    "annotations": "注释：⑴陈司败——人名。有人说“司败”是官名，也有人说是人名，究竟是什么样的人，今天已经无法知道。⑵昭公——鲁昭公，名裯，襄公庶子，继襄公而为君。“昭”是谥号，陈司败之问若在昭公死后，则“昭公知礼乎”可能是原来语言。如果他这次发问尚在昭公生时，那“昭公”字眼当是后人的记述。我们已无从判断，所以这句不加引号。⑶巫马期——孔子学生，姓巫马，名施，字子期，小于孔子三十岁。⑷君取于吴——“取”这里用作“娶”字。吴，当时的国名，拥有今天淮水、泗水以南以及浙江的嘉兴、湖州等地。哀公时，为越王勾践所灭。⑸为同姓——鲁为周公之后，姬姓；吴为太伯之后，也是姬姓。⑹吴孟子——春秋时代，国君夫人的称号一般是所生长之国名加她的本姓。鲁娶于吴，这位夫人便应该称为吴姬。但“同姓不婚”是周朝的礼法，鲁君夫人的称号而把“姬”字标明出来，便是很显明地表示出鲁君的违背了“同姓不婚”的礼制，因之改称为“吴孟子”。“孟子”可能是这位夫人的字。《左传》哀公十二年亦书曰：“昭夫人孟子卒”。⑺苟有过——根据《荀子·子道篇》关于孔子的另一段故事，和《史记·仲尼弟子列传》对这一事“臣不可言君亲之恶，为讳者礼也”的解释，则孔子对鲁昭公所谓不合礼的行为不是不知，而是不说，最后只得归过于自己。"
  },
  {
    "id": 182,
    "title": "述而 7.32",
    "text": "子与人歌而善，必使反之，而后和之。",
    "translation": "译文：孔子同别人一道唱歌，如果唱得好，一定请他再唱一遍，然后自己又和他。",
    "annotations": ""
  },
  {
    "id": 183,
    "title": "述而 7.33",
    "text": "子曰：“文，莫⑴吾犹人也。躬行君子，则吾未之有得。”",
    "translation": "译文：孔子说：“书本上的学问，大约我同别人差不多。在生活实践中做一个君子，那我还没有成功。”",
    "annotations": "注释：⑴文莫——以前人都把“文莫”两字连读，看成一个双音词，但又不能得出恰当的解释。吴检斋（承仕）先生在〈亡莫无虑同词说〉（载于前北京中国大学《国学丛编》第一期第一册）中以为“文”是一词，指孔子所谓的“文章”，“莫”是一词，“大约”的意思。关于“莫”字的说法在先秦古籍中虽然缺乏坚强的论证，但解释本文却比所有各家来得较为满意，因之为译者所采用。朱熹《集注》亦云，“莫，疑辞”，或为吴说所本。"
  },
  {
    "id": 184,
    "title": "述而 7.34",
    "text": "子曰：“若圣⑴与仁，则吾岂敢？抑为之不厌，诲人不倦，则可谓云尔已矣。”公西华曰：“正唯弟子不能学也。”",
    "translation": "译文：孔子说道：“讲到圣和仁，我怎么敢当？不过是学习和工作总不厌倦，教导别人总不疲劳，就是如此如此罢了。”公西华道：“这正是我们学不到的。 ”",
    "annotations": "注释：⑴圣——《孟子·公孙丑上》载子贡对这事的看法说：“学不厌，智也；教不倦，仁也。仁且智，夫子既圣矣。”可见当时的学生就已把孔子看成圣人。"
  },
  {
    "id": 185,
    "title": "述而 7.35",
    "text": "子疾病⑴，子路请祷。子曰：“有诸？”子路对曰：“有之；〈诔〉⑵曰：‘祷尔于上下神祇⑶。’”子曰：“丘之祷久矣。”",
    "translation": "译文：孔子病重，子路请求祈祷。孔子道：“有这回事吗？”子路答道：“有的；〈诔文〉说过：‘替你向天神地祇祈祷。’”孔子道：“我早就祈祷过了。”",
    "annotations": "注释：⑴疾病——“疾病”连言，是重病。⑵诔——音耒，lèi，本应作讄，祈祷文。和哀悼死者的“诔”不同。⑶祇——音祁，qí，地神。"
  },
  {
    "id": 186,
    "title": "述而 7.36",
    "text": "子曰：“奢则不孙⑴，俭则固⑵。与其不孙也，宁固。“",
    "translation": "译文：孔子说：“奢侈豪华就显得骄傲，省俭朴素就显得寒伧。与其骄傲，宁可寒伧。”",
    "annotations": "注释：⑴孙——同“逊”。⑵固——固陋，寒伧。"
  },
  {
    "id": 187,
    "title": "述而 7.37",
    "text": "子曰：“君子坦荡荡，小人长戚戚。”",
    "translation": "译文：孔子说：“君子心地平坦宽广，小人却经常局促忧愁。”",
    "annotations": ""
  },
  {
    "id": 188,
    "title": "述而 7.38",
    "text": "子温而厉，威而不猛，恭而安。",
    "translation": "译文：孔子温和而严厉，有威仪而不凶猛，庄严而安详。",
    "annotations": ""
  },
  {
    "id": 189,
    "title": "泰伯 8.1",
    "text": "子曰：“泰伯⑴，其可谓至德也已矣。三以天下⑵让，民无得而称焉。”",
    "translation": "译文：孔子说：“泰伯，那可以说是品德极崇高了。屡次地把天下让给季历，老百姓简直找不出恰当的词语来称赞他。”",
    "annotations": "注释：】⑴泰伯——亦作“太伯”，周朝祖先古公亶父的长子。古公有三子，太伯、仲雍、季历。季历的儿子就是姬昌（周文王）。据传说，古公预见到昌的圣德，因此想打破惯例，把君位不传长子太伯，而传给幼子季历，从而传给昌。太伯为着实现他父亲的意愿，便偕同仲雍出走至勾吴（为吴国的始祖），终于把君位传给季历和昌。昌后来扩张国势，竟有天下的三分之二，到他儿子姬发（周武王），便灭了殷商，统一天下。⑵天下——当古公、泰伯之时，周室仅是一个小的部落，谈不上“天下”。这“天下”两字可能卽指其当时的部落而言。也有人说，是预指以后的周部落统一了中原的天下而言。"
  },
  {
    "id": 190,
    "title": "泰伯 8.2",
    "text": "子曰：“恭而无礼则劳⑴，慎而无礼则葸⑵，勇而无礼则乱，直而无礼则绞⑶。君子笃于亲，则民兴于仁；故旧不遗，则民不偷⑷。”",
    "translation": "译文：孔子说：“注重容貌态度的端庄，却不知礼，就未免劳倦；只知谨慎，却不知礼，就流于畏葸懦弱；专凭敢作敢为的胆量，却不知礼，就会盲动闯\n祸；心直口快，却不知礼，就会尖刻刺人。在上位的人能用深厚感情对待亲族，老百姓就会走向仁德；在上位的人不遗弃他的老同事、老朋友，那老百姓就不致对人冷淡无情。",
    "annotations": "注释：⑴礼——这里指的是礼的本质。⑵葸——xǐ，胆怯，害怕。⑶绞——尖刻刺人。⑷偷——淡薄，这里指人与人的感情而言。"
  },
  {
    "id": 191,
    "title": "泰伯 8.3",
    "text": "曾子有疾，召门弟子曰：“启⑴予足！启予手！《诗》云⑵，‘战战兢兢，如临深渊，如履⑶薄冰。’而今而后，吾知免夫！小子！”",
    "translation": "译文：曾参病了，把他的学生召集拢来，说道：“看看我的脚！看看我的手！《诗经》上说：‘小心呀！谨慎呀！好像面临深深水坑之旁，好像行走薄薄冰层之上。’从今以后，我才晓得自己是可以免于祸害刑戮的了！学生们！”",
    "annotations": "注释：⑴启——说文有“”字，云：“视也。”王念孙《广雅疏证》（《释诂》）说，《论语》的这“启”字就是说文的“”字。⑵《诗》云——三句诗见《诗经·小雅·小旻篇》。⑶履——《易·履卦》爻辞：“眇能视，跛能履。”履，步行也。"
  },
  {
    "id": 192,
    "title": "泰伯 8.4",
    "text": "曾子有疾，孟敬子⑴问之。曾子言曰：“鸟之将死，其鸣也哀；人之将死，其言也善。君子所贵乎道者三：动容貌，斯远暴慢⑵矣；正颜色，斯近信矣；出辞气，斯远鄙倍⑶矣。笾豆之事⑷，则有司⑸存。”",
    "translation": "译文：曾参病了，孟敬子探问他。曾子说：“鸟要死了，鸣声是悲哀的；人要死了，说出的话是善意的。在上位的人待人接物有三方面应该注重：严肃自己的容貌，就可以避免别人的粗暴和懈怠；端正自己的脸色，就容易使人相信；说话的时候，多考虑言辞和声调，就可以避免鄙陋粗野和错误。至于礼仪的细节，自有主管人员。”",
    "annotations": "注释：⑴孟敬子——鲁国大夫仲孙捷。⑵暴慢——暴是粗暴无礼，慢是懈怠不敬。⑶鄙倍——鄙是粗野鄙陋；倍同“背”，不合理，错误。⑷笾豆之事——笾音边，古代的一种竹器，高脚，上面圆口，有些像碗，祭祀时用以盛果实等食品。豆也是古代一种像笾一般的器皿，木料做的，有盖，用以盛有汁的食物，祭祀时也用它。这里“笾豆之事”系代表礼仪中的一切具体细节。⑸有司——主管其事的小吏。"
  },
  {
    "id": 193,
    "title": "泰伯 8.5",
    "text": "曾子曰：“以能问于不能，以多问于寡；有若无，实若虚，犯而不校——昔者吾友⑴尝从事于斯矣。”",
    "translation": "译文：曾子说：“有能力却向无能力的人请教，知识丰富却向知识缺少的人请教；有学问像没学问一样，满腹知识像空无所有一样；纵被欺侮，也不计较——从前我的一位朋友便曾这样做了。”",
    "annotations": "注释：⑴吾友——历来的注释家都以为是指颜回。"
  },
  {
    "id": 194,
    "title": "泰伯 8.6",
    "text": "曾子曰：“可以托六尺⑴之孤，可以寄百里之命，临大节而不可夺也——君子人与？君子人也。”",
    "translation": "译文：曾子说：“可以把幼小的孤儿和国家的命脉都交付给他，面临安危存亡的紧要关头，却不动摇屈服——这种人，是君子人吗？是君子人哩。”",
    "annotations": "注释：⑴六尺——古代尺短，六尺约合今日一百三十八厘米，市尺四尺一寸四分。身长六尺的人还是小孩，一般指十五岁以下的人。"
  },
  {
    "id": 195,
    "title": "泰伯 8.7",
    "text": "曾子曰：“士不可以不弘毅⑴，任重而道远。仁以为己任，不亦重乎？死而后已，不亦远乎？”",
    "translation": "译文：曾子说：“读书人不可以不刚强而有毅力，因为他负担沉重，路程遥远。以实现仁德于天下为己任，不也沉重吗？到死方休，不也遥远吗？”",
    "annotations": "注释：⑴弘毅——就是“强毅”。章太炎（炳麟）先生《广论语骈枝》说：“说文：‘弘，弓声也。’后人借‘强’为之，用为‘强’义。此‘弘’字卽今之‘强’字也。说文：‘毅，有决也。’任重须强，不强则力绌；致远须决，不决则志渝。”"
  },
  {
    "id": 196,
    "title": "泰伯 8.8",
    "text": "子曰：“兴于《诗》，立于礼，成于乐⑴。”",
    "translation": "译文：孔子说：“诗篇使我振奋，礼使我能在社会上站得住，音乐使我的所学得以完成。”",
    "annotations": "注释：⑴成于乐——孔子所谓“乐”的内容和本质都离不开“礼”，因此常常“礼乐”连言。他本人也很懂音乐，因此把音乐作为他的教学工作的一个最后阶段。"
  },
  {
    "id": 197,
    "title": "泰伯 8.9",
    "text": "子曰：“民可使由之，不可使知之⑴。”",
    "translation": "译文：孔子说：“老百姓，可以使他们照着我们的道路走去，不可以使他们知道那是为什么。”",
    "annotations": "注释：⑴子曰……知之——这两句与“民可以乐成，不可与虑始”（《史记·滑稽列传》补所载西门豹之言，《商君列传》作“民不可与虑始，而可与乐成”）意思大致相同，不必深求。后来有些人觉得这种说法不很妥当，于是别生解释，意在为孔子这位“圣人”回护，虽煞费苦心，反失孔子本意。如刘宝楠《正义》以为“上章是夫子教弟子之法，此‘民’字亦指弟子”。不知上章“兴于诗”三句与此章旨意各别，自古以来亦曾未有以“民”代“弟子”者。宦懋庸《论语稽》则云：“对于民，其可者使其自由之，而所不可者亦使知之。或曰，舆论所可者则使共由之，其不可者亦使共知之。”则原文当读为“民可，使由之；不可，使知之”。恐怕古人无此语法。若是古人果是此意，必用“则”字，甚至“使”下再用“之”字以重指“民”，作“民可，则使（之）由之，不可，则使（之）知之”，方不致晦涩而误解。"
  },
  {
    "id": 198,
    "title": "泰伯 8.10",
    "text": "子曰：“好勇疾贫，乱也。人而不仁，疾之已甚，乱也。”",
    "translation": "译文：孔子说：“以勇敢自喜却厌恶贫困，是一种祸害。对于不仁的人，痛恨太甚，也是一种祸害。”",
    "annotations": ""
  },
  {
    "id": 199,
    "title": "泰伯 8.11",
    "text": "子曰：“如有周公之才之美，使骄且吝，其余不足观也已。”",
    "translation": "译文：孔子说：“假如才能的美妙真比得上周公，只要骄傲而吝啬，别的方面也就不值得一看了。”",
    "annotations": ""
  },
  {
    "id": 200,
    "title": "泰伯 8.12",
    "text": "子曰：“三年学，不至⑴于谷⑵，不易得也。”",
    "translation": "译文：孔子说：“读书三年并不存做官的念头，这是难得的。”",
    "annotations": "注释：⑴至——这“至”字和雍也篇第六“回也其心三月不违仁，其余则日月至焉而已矣”的“至”用法相同，指意念之所至。⑵谷——古代以谷米为俸禄（作用相当于今日的工资），所以“谷”有“禄”的意义。宪问篇第十四的“邦有道，谷；邦无道，谷”的“谷”正与此同。"
  },
  {
    "id": 201,
    "title": "泰伯 8.13",
    "text": "子曰：“笃信⑴好学，守死善道。危邦不入，乱邦不居⑵。天下有道则见⑶，无道则隐。邦有道，贫且贱焉，耻也；邦无道，富且贵焉，耻也。”",
    "translation": "译文：孔子说：“坚定地相信我们的道，努力学习它，誓死保全它。不进入危险的国家，不居住祸乱的国家。天下太平，就出来工作；不太平，就隐居。政治清明，自己贫贱，是耻辱；政治黑暗，自己富贵，也是耻辱。”",
    "annotations": "注释：⑴笃信——子张篇：“执德不弘，信道不笃，焉能为有？焉能为亡？”这一“笃信”应该和“信道不笃”的意思一样。⑵危邦乱邦——包咸云“臣弒君，子弑父，乱也；危者，将乱之兆也。”⑶见——同“现”。"
  },
  {
    "id": 202,
    "title": "泰伯 8.14",
    "text": "子曰：“不在其位，不谋其政。”",
    "translation": "译文：孔子说：“不居于那个职位，便不考虑它的政务。”",
    "annotations": ""
  },
  {
    "id": 203,
    "title": "泰伯 8.15",
    "text": "子曰：“师挚之始⑴，《关雎》之乱⑵，洋洋乎盈耳哉！”",
    "translation": "译文：孔子说：“当太师挚开始演奏的时候，当结尾演奏《关雎》之曲的时候，满耳朵都是音乐呀！”",
    "annotations": "注释：⑴师挚之始——“始”是乐曲的开端，古代奏乐，开始叫做“升歌”，一般由太师演奏。师挚是鲁国的太师，名挚，由他演奏，所以说“师挚之始”。⑵《关雎》之乱——“始”是乐的开端，“乱”是乐的结束。由“始”到“乱”，叫做“一成”。“乱”是“合乐”，犹如今日的合唱。当合奏之时，奏《关雎》的乐章，所以说“《关雎》之乱”。"
  },
  {
    "id": 204,
    "title": "泰伯 8.16",
    "text": "子曰：“狂而不直，侗而不愿，悾悾而不信，吾不知之矣。”",
    "translation": "译文：孔子说：“狂妄而不直率，幼稚而不老实，无能而不讲信用，这种\n人我是不知道其所以然的。”",
    "annotations": ""
  },
  {
    "id": 205,
    "title": "泰伯 8.17",
    "text": "子曰：“学如不及，犹恐失之。”",
    "translation": "译文：孔子说：“做学问好像［追逐什么似的，］生怕赶不上；［赶上了，］还生怕丢掉了。”",
    "annotations": ""
  },
  {
    "id": 206,
    "title": "泰伯 8.18",
    "text": "子曰：“巍巍乎，舜禹⑴之有天下也而不与⑵焉！”",
    "translation": "译文：孔子说：“舜和禹真是崇高得很呀！贵为天子，富有四海，［却整年地为百姓勤劳，］一点也不为自己。”",
    "annotations": "注释：⑴禹——夏朝开国之君。据传说，受虞舜的禅让而卽帝位。又是中国主持水利工程最早的有着功勋的人物。⑵与——音预yù，参与，关连。这里含着“私有”、“享受”的意思。"
  },
  {
    "id": 207,
    "title": "泰伯 8.19",
    "text": "子曰：“大哉尧之为君也！巍巍乎！唯天为大，唯尧则之。荡荡乎，民无能名焉。巍巍乎其有成功也，焕乎其有文章！”",
    "translation": "译文：孔子说：“尧真是了不得呀！真高大得很呀！只有天最高最大，只有尧能够学习天。他的恩惠真是广博呀！老百姓简直不知道怎样称赞他。他的功绩实在太崇高了，他的礼仪制度也真够美好了！”",
    "annotations": ""
  },
  {
    "id": 208,
    "title": "泰伯 8.20",
    "text": "舜有臣五人而天下治。武王曰：“予有乱臣⑴十人。”孔子曰：“才难，不其然乎！唐虞之际，于斯为盛。有妇人焉，九人而已。三分天下有其二⑵，以服事殷。周之德，其可谓至德也已矣。”",
    "translation": "译文：舜有五位贤臣，天下便太平。武王也说过，“我有十位能治理天下的臣子。”孔子因此说道：“［常言道：］‘人才不易得。’不是这样吗？唐尧和虞舜之间以及周武王说那话的时候，人才最兴盛。然而武王十位人才之中还有一位妇女，实际上只是九位罢了。周文王得了天下的三分之二，仍然向商纣称臣，周\n朝的道德，可以说是最高的了。”",
    "annotations": "注释：⑴乱臣——说文：“乱，治也。”《尔雅·释诂》同。《左传》昭公二十四年引《大誓》说：“余有乱臣十人，同心同德。”则“乱臣”就是“治国之臣”。近人周谷城（《古史零证》）认为“乱”有“亲近”的意义，则“乱臣”相当于《孟子·粱惠王下》“王无亲臣矣”的“亲臣”，虽然言之亦能成理，但和下文“才难”之意不吻合，恐非孔子原意。⑵三分天下有其二——《逸周书·程典篇》说：“文王合九州岛之侯，奉勤于商”。相传当时分九州岛，文王得六州，是有三分之二。"
  },
  {
    "id": 209,
    "title": "泰伯 8.21",
    "text": "子曰：“禹，吾无间然矣。菲饮食而致孝乎鬼神，恶衣服而致美乎黻冕⑴，卑宫室而尽力乎沟洫⑵。禹，吾无间然矣。”",
    "translation": "译文：孔子说：“禹，我对他没有批评了。他自己吃得很坏，却把祭品办得极丰盛；穿得很坏，却把祭服做得极华美；住得很坏，却把力量完全用于沟渠水利。禹，我对他没有批评了。”",
    "annotations": "注释：⑴黻冕——黻音弗，fú，祭祀时穿的礼服；冕音免，miǎn，古代大夫以上的人的帽子都叫冕，后来只有帝王的帽子才叫冕。这里指祭祀时的礼帽。⑵沟洫——就是沟渠，这里指农田水利而言。"
  },
  {
    "id": 210,
    "title": "子罕 9.1",
    "text": "子罕⑴言利与命与仁。",
    "translation": "译文：孔子很少［主动］谈到功利、命运和仁德。",
    "annotations": "注释：⑴罕——副词，少也，只表示动作频率。而《论语》一书，讲“利”的六次，讲“命”的八、九次，若以孔子全部语言比较起来，可能还算少的。因之子贡也说过，“夫子之言性与天道，不可得而闻也。”（公冶长篇第五）至于“仁”，在《论语》中讲得最多，为什么还说“孔子罕言”呢？于是对这一句话便生出别的解释了。金人王若虚（《误谬杂辨》）、清人史绳祖（《学斋占毕》）都以为造句应如此读：“子罕言利，与命，与仁。”“与”，许也。意思是“孔子很少谈到利，却赞成命，赞成仁”。黄式三（《论语后案》）则认为“罕”读为“轩”，显也。意思\n是“孔子很明显地谈到利、命和仁”。遇夫先生（《论语疏证》）又以为“所谓罕言仁者，乃不轻许人以仁之意，与罕言利命之义似不同。试以圣人评论仲弓、子路、冉有、公西华、令尹子文、陈文子之为人及克伐怨欲不行之德，皆云不知其仁，更参之以儒行之说，可以证明矣”。我则以为《论语》中讲“仁”虽多，但是一方面多半是和别人问答之词，另一方面，“仁”又是孔门的最高道德标准，正因为少谈，孔子偶一谈到，便有记载。不能以记载的多便推论孔子谈得也多。孔子平生所言，自然千万倍于《论语》所记载的，《论语》出现孔子论“仁”之处若用来和所有孔子平生之言相比，可能还是少的。诸家之说未免对于《论语》一书过于拘泥，恐怕不与当时事实相符，所以不取。于省吾读“仁”为“”，卽“夷狄”之“夷”，未必确。"
  },
  {
    "id": 211,
    "title": "子罕 9.2",
    "text": "达巷党⑴人曰：“大哉孔子！博学而无所成名。”子闻之，谓门弟子曰：“吾何执？执御乎？执射乎？吾执御矣。”",
    "translation": "译文：达街的一个人说：“孔子真伟大！学问广博，可惜没有足以树立名声的专长。”孔子听了这话，就对学生们说：“我干什么呢？赶马车呢？做射击手呢？我赶马车好了。”",
    "annotations": "注释：⑴达巷党——《礼记·杂记》有“余从老聃助葬于巷党”的话，可见“巷党”两字为一词，“里巷”的意思。"
  },
  {
    "id": 212,
    "title": "子罕 9.3",
    "text": "子曰：“麻冕⑴，礼也；今也纯⑵，俭⑶，吾从众。拜下⑷，礼也；今拜乎上，泰也。虽违众，吾从下。”",
    "translation": "译文：孔子说：“礼帽用麻料来织，这是合于传统的礼的；今天大家都用丝料，这样省俭些，我同意大家的做法。臣见君，先在堂下磕头，然后升堂又磕头，这是合于传统的礼的。今天大家都免除了堂下的磕头，只升堂后磕头，这是倨傲的表现。虽然违反大家，我仍然主张要先在堂下磕头。”",
    "annotations": "注释：⑴麻冕——一种礼帽，有人说就是缁布冠（古人一到二十岁，便举行加帽子的仪式，叫“冠礼”。第一次加的便是缁布冠），未必可信。⑵纯——黑色的丝。⑶俭——绩麻做礼帽，依照规定，要用二千四百缕经线。麻质较粗，必须织得非常细密，这很费工。若用丝，丝质细，容易织成，因而省俭些。⑷拜下——指臣子对君主的行礼，先在堂下磕头，然后升堂再磕头。《左传》僖公九年和《国语·齐语》都记述齐桓公不听从周襄王的辞让，终于下拜的事。到孔子时，下拜的礼似乎废弃了。"
  },
  {
    "id": 213,
    "title": "子罕 9.4",
    "text": "子絶四——毋意，毋必，毋固，毋我。",
    "translation": "译文：孔子一点也没有四种毛病——不悬空揣测，不绝对肯定，不拘泥固执，不唯我独是。",
    "annotations": ""
  },
  {
    "id": 214,
    "title": "子罕 9.5",
    "text": "子畏于匡⑴，曰：“文王既没，文不在兹乎？天之将丧斯文也，后死者⑵不得与⑶于斯文也；天之未丧斯文也，匡人其如予何？”",
    "translation": "译文：孔子被匡地的羣众所拘禁，便道：“周文王死了以后，一切文化遗产不都在我这里吗？天若是要消灭这种文化，那我也不会掌握这些文化了；天若是不要消灭这一文化，那匡人将把我怎么样呢？”",
    "annotations": "注释：⑴子畏于匡——《史记·孔子世家》说，孔子离开卫国，准备到陈国去，经过匡。匡人曾经遭受过鲁国阳货的掠夺和残杀，而孔子的相貌很像阳货，便以为孔子就是过去曾经残害过匡地的人，于是囚禁了孔子。“畏”是拘囚的意思，《荀子·赋篇》云：“比干见刳，孔子拘匡。”《史记·孔子世家》作“拘焉五日”，可见这一“畏”字和《礼记·檀弓》“死而不吊者三，畏、厌、溺”的“畏”相同，说见俞樾《羣经平议》。今河南省长垣县西南十五里有匡城，可能就是当日孔子被囚之地。⑵后死者——孔子自谓。⑶与——音预。"
  },
  {
    "id": 215,
    "title": "子罕 9.6",
    "text": "太宰⑴问于子贡曰：“夫子圣者与？何其多能也？”子贡曰：“固天纵之将圣，又多能也。”\n子闻之，曰：“太宰知我乎！吾少也贱，故多能鄙事。君子多乎哉？不多也。 ”",
    "translation": "译文：太宰向子贡问道：“孔老先生是位圣人吗？为什么这样多才多艺呢？”子贡道：“这本是上天让他成为圣人，又使他多才多艺。”\n孔子听到，便道：“太宰知道我呀！我小时候穷苦，所以学会了不少鄙贱的技艺。真正的君子会有这样多的技巧吗？是不会的。”",
    "annotations": "注释：⑴太宰——官名。这位太宰已经不知是哪一国人以及姓甚名谁了。"
  },
  {
    "id": 216,
    "title": "子罕 9.7",
    "text": "牢⑴曰：“子云，‘吾不试⑵，故艺。’”",
    "translation": "译文：牢说：“孔子说过，我不曾被国家所用，所以学得一些技艺。“",
    "annotations": "注释：⑴牢——郑玄说是孔子学生，但《史记·仲尼弟子列传》无此人。王肃伪撰之《孔子家语》说“琴张，一名牢，字子开，亦字子张，卫人也”，尤其不可信。说本王引之，详王念孙《读书杂志》卷四之三。⑵试——《论衡·正说篇》云：“尧曰：‘我其试哉！’说《尚书》曰：‘试者用也。’”这“试”字也应当“用”字解。"
  },
  {
    "id": 217,
    "title": "子罕 9.8",
    "text": "子曰：“吾有知乎哉？无知也。有鄙夫问于我，空空如也。我叩其两端而竭焉。”",
    "translation": "译文：孔子说：“我有知识吗？没有哩。有一个庄稼汉问我，我本是一点也不知道的；我从他那个问题的首尾两头去盘问，［才得到很多意思，］然后尽量地告诉他。”",
    "annotations": ""
  },
  {
    "id": 218,
    "title": "子罕 9.9",
    "text": "子曰：“凤鸟不至，河不出图⑴，吾已矣夫！”",
    "translation": "译文：孔子说：“凤凰不飞来了，黄河也没有图画出来了，我这一生恐怕是完了吧！”",
    "annotations": "注释：⑴凤鸟河图——古代传说，凤凰是一种神鸟，祥瑞的象征，出现就是表示天下太平。又说，圣人受命，黄河就出现图画。孔子说这几句话，不过藉此比喻当时天下无清明之望罢了。"
  },
  {
    "id": 219,
    "title": "子罕 9.10",
    "text": "子见齐衰⑴者、冕衣裳者⑵与瞽者，见之，虽少，必作⑶；过之，必趋⑶。",
    "translation": "译文：孔子看见穿丧服的人、穿戴着礼帽礼服的人以及瞎了眼睛的人，相见的时候，他们虽然年轻，孔子一定站起来；走过的时候，一定快走几步。",
    "annotations": "注释：⑴齐衰——齐音咨，zī；衰音崔，cuī。齐衰，古代丧服，用熟麻布做的，其下边缝齐（斩衰则用粗而生的麻布，左右及下边也都不缝）。齐衰又有齐衰三年、齐衰期（一年）、齐衰五月、齐衰三月几等；看死了什么人，便服多长日子的孝。这里讲齐衰，自然也包括斩衰而言。斩衰是最重的孝服，儿子对父亲，臣下对君上才斩衰三年。⑵冕衣裳者——卽衣冠整齐的贵族。冕是高等贵族所戴的礼帽，后来只有皇帝所戴才称冕。衣是上衣，裳是下衣，相当现代的帬。古代男子上穿衣，下着帬。⑶作，趋——作，起；趋，疾行。这都是一种敬意的表示。"
  },
  {
    "id": 220,
    "title": "子罕 9.11",
    "text": "颜渊喟然叹曰：“仰之弥高，钻之弥坚。瞻之在前，忽焉在后。夫子循循然善诱人，博我以文，约我以礼，欲罢不能。既竭吾才，如有所立卓尔。虽欲从之，末由也已。“",
    "translation": "译文：颜渊感叹着说：“老师之道，越抬头看，越觉得高；越用力钻研，越觉得深。看看，似乎在前面，忽然又到后面去了。［虽然这样高深和不容易捉摸，可是］老师善于有步骤地诱导我们，用各种文献来丰富我的知识，又用一定的礼节来约束我的行为，使我想停止学习都不可能。我已经用尽我的才力，似乎能够独立地工作。要想再向前迈进一步，又不知怎样着手了。”",
    "annotations": ""
  },
  {
    "id": 221,
    "title": "子罕 9.12",
    "text": "子疾病，子路使门人为臣⑴。病间，曰：“久矣哉，由之行诈也！无臣而为有臣。吾谁欺？欺天乎！且予与其死于臣之手也，无宁⑵死于二三子之手乎！且予纵不得大葬，予死于道路乎？”",
    "translation": "译文：孔子病得厉害，子路便命孔子的学生组织治丧处。很久以后，孔子的病渐渐好了，就道：“仲由干这种欺假的勾当竟太长久了呀！我本不该有治丧的组织，却一定要使人组织治丧处。我欺哄谁呢？欺哄上天吗？我与其死在治丧的人的手里，宁肯死在你们学生们的手里，不还好些吗？卽使不能热热闹闹地办理丧葬，我会死在路上吗？”",
    "annotations": "注释：⑴为臣——和今天的组织治丧处有相似之处，所以译文用来比傅。但也有不同之处。相似之处是死者有一定的社会地位才给他组织治丧处。古代，诸侯之死才能有“臣”；孔子当时，可能有许多卿大夫也“僭”行此礼。不同之处是治丧处人死以后才组织，才开始工作。“臣”却不然，死前便工作，死者的衣衾手足的安排以及翦须诸事都由“臣”去处理。所以孔子这里也说“死于臣之手”的话。⑵无宁——“无”为发语词，无义。《左传》隐公十一年云：“无宁兹许公复奉其社稷。”杜预的注说：“无宁，宁也。”"
  },
  {
    "id": 222,
    "title": "子罕 9.13",
    "text": "子贡曰：“有美玉于斯，韫椟而藏诸？求善贾⑴而沽诸？”子曰：“沽之哉！沽之哉！我待贾者也。”",
    "translation": "译文：子贡道：“这里有一块美玉，把它放在柜子里藏起来呢？还是找一个识货的商人卖掉呢？”孔子道：“卖掉，卖掉，我是在等待识货者哩。”",
    "annotations": "注释：⑴贾——音古，gǔ，商人。又同“价”，价钱。如果取后一义，“善贾”便是“好价钱”，“待贾”便是“等好价钱”。不过与其说孔子是等价钱的人，不如说他是等识货者的人。"
  },
  {
    "id": 223,
    "title": "子罕 9.14",
    "text": "子欲居九夷⑴。或曰：“陋，如之何？”子曰：“君子居之，何陋之有⑵？”",
    "translation": "译文：孔子想搬到九夷去住。有人说：“那地方非常简陋，怎么好住？，”孔子道：“有君子去住，就不简陋了。”",
    "annotations": "注释：⑴九夷——九夷就是淮夷。《韩非子·说林上篇》云：“周公旦攻九夷而商盖伏。”商盖就是商奄，则九夷本居鲁国之地，周公曾用武力降服他们。春秋以后，盖臣属楚、吴、越三国，战国时又专属楚。以《说苑·君道篇》、《淮南子·齐俗训》、《战国策·秦策》与《魏策》、李斯〈上秦始皇书〉诸说九夷者考之，九夷实散居于淮、泗之间，北与齐、鲁接壤（说本孙诒让《墨子闲诂·非攻篇》）。⑵何陋之有——直译是“有什么简陋呢”，此用意译。"
  },
  {
    "id": 224,
    "title": "子罕 9.15",
    "text": "子曰：“吾自卫反鲁⑴，然后乐正，《雅》、《颂》各得其所⑵。”",
    "translation": "译文：孔子说：“我从卫国回到鲁国，才把音乐［的篇章］整理出来，使《雅》归《雅》，《颂》归《颂》，各有适当的安置。”",
    "annotations": "注释：⑴自卫反鲁——根据《左传》，事在鲁哀公十一年冬。⑵雅颂各得其所——“雅”和“颂”一方面是《诗经》内容分类的类名，一方面也是乐曲分类的\n类名。篇章内容的分类，可以由今日的《诗经》考见；乐曲的分类，因为古乐早已失传，便无可考证了。孔子的正雅颂，究竟是正其篇章呢？还是正其乐曲呢？或者两者都正呢？《史记·孔子世家》和《汉书·礼乐志》则以为主要的是正其篇章，因为我们已经得不到别的材料，只得依从此说。孔子只“正乐”，调整《诗经》篇章的次序，太史公在孔子世家中因而说孔子曾把三千余篇的古诗删为三百余篇，是不可信的。"
  },
  {
    "id": 225,
    "title": "子罕 9.16",
    "text": "子曰：“出则事公卿，入则事父兄⑴，丧事不敢不勉，不为酒困，何有于我哉⑵？”",
    "translation": "译文：孔子说：“出外便服事公卿，入门便服事父兄，有丧事不敢不尽礼，不被酒所困扰，这些事我做到了哪些呢？”",
    "annotations": "注释：⑴父兄——孔子父亲早死，说这话时候，或者他哥孟皮还在，“父兄”二字，只“兄”字有义，古人常有这用法。“父兄”或者在此引伸为长者之义。⑵何有于我哉——如果把“何有”看为“不难之词”，那这一句便当译为“这些事对我有什么困难呢”。全文由自谦之词变为自述之词了。"
  },
  {
    "id": 226,
    "title": "子罕 9.17",
    "text": "子在川上，曰：“逝者如斯夫！不舍⑴昼夜。”",
    "translation": "译文：孔子在河边，叹道：“消逝的时光像河水一样呀！日夜不停地流去。 ”",
    "annotations": "注释：⑴舍——上、去两声都可以读。上声，同舍；去声，也作动词，居住，停留。孔子这话不过感叹光阴之奔驶而不复返吧了，未必有其它深刻的意义。《孟子·离娄下》、《荀子·宥坐篇》、《春秋繁露·山川颂》对此都各有阐发，很难说是孔子本意。"
  },
  {
    "id": 227,
    "title": "子罕 9.18",
    "text": "子曰：“吾未见好德如好色者也。”",
    "translation": "译文：孔子说：“我没有看见过这样的人，喜爱道德赛过喜爱美貌。”",
    "annotations": ""
  },
  {
    "id": 228,
    "title": "子罕 9.19",
    "text": "子曰：“譬如为山，未成一篑，止，吾止也。譬如平地，虽覆一篑，进，吾往也⑴。”",
    "translation": "译文：孔子说：“好比堆土成山，只要再加一筐土便成山了，如果懒得做下去，这是我自己停止的。又好比在平地上堆土成山，纵是刚刚倒下一筐土，如果决心努力前进，还是要自己坚持呵！”",
    "annotations": "注释：⑴子曰……往也——这一章也可以这样讲解：“好比堆土成山，只差一筐土了，如果［应该］停止，我便停止。好比平地堆土成山，纵是刚刚倒下一筐土，如果［应该］前进，我便前进。”依照前一讲解，便是“为仁由己”的意思；依照后一讲解，便是“唯义与比”的意思。"
  },
  {
    "id": 229,
    "title": "子罕 9.20",
    "text": "子曰：“语之而不惰者，其回也与！”",
    "translation": "译文：孔子说：“听我说话始终不懈怠的，大概只有颜回一个人吧！”",
    "annotations": ""
  },
  {
    "id": 230,
    "title": "子罕 9.21",
    "text": "子谓颜渊，曰：“惜乎！吾见其进也，未见其止也。“",
    "translation": "译文：孔子谈到颜渊，说道：“可惜呀［他死了］！我只看见他不断地进步，从没看见他停留。”",
    "annotations": ""
  },
  {
    "id": 231,
    "title": "子罕 9.22",
    "text": "子曰:“苗而不秀⑴者有矣夫！秀而不实者有矣夫！”",
    "translation": "译文：孔子说：“庄稼生长了，却不吐穗开花的，有过的罢！吐穗开花了，却不凝浆结实的，有过的罢！”",
    "annotations": "注释：⑴秀——“秀”字从禾，则只是指禾黍的吐花。《诗经·大雅·生民》云：“实发实秀，实坚实好。”“发”和“秀”是指庄稼的生长和吐穗开花；“坚”和“好”是指谷粒的坚实和壮大。这都是“秀”的本义。现在还把庄稼的吐穗开花叫做“秀穗”。因此译文点明是指庄稼而言。汉人唐人多以为孔子这话是为颜回短命而发。但颜回只是“秀而不实”（祢衡〈颜子碑〉如此说），则“苗而不秀”又指谁呢？孔子此言必有为而发，但究竟何所指，则不必妄测。"
  },
  {
    "id": 232,
    "title": "子罕 9.23",
    "text": "子曰：“后生可畏，焉知来者之不如今也？四十、五十而无闻焉，斯亦不足畏也已。”",
    "translation": "译文：孔子说：“年少的人是可怕的，怎能断定他的将来赶不上现在的人呢，一个人到了四、五十岁还没有什么名望，也就值不得惧怕了。”",
    "annotations": ""
  },
  {
    "id": 233,
    "title": "子罕 9.24",
    "text": "子曰：“法语之言，能无从乎？改之为贵。巽与之言，能无说乎？绎之为贵。说而不绎，从而不改，吾末如之何也已矣。”",
    "translation": "译文：孔子说：“严肃而合乎原则的话，能够不接受吗？改正错误才可贵。顺从己意的话，能够不高兴吗？分析一下才可贵。盲目高兴，不加分析；表面接受，实际不改，这种人我是没有办法对付他的了。”",
    "annotations": ""
  },
  {
    "id": 234,
    "title": "子罕 9.25",
    "text": "子曰：“主忠信，毋友不如己者，过则勿惮改⑴。”",
    "translation": "译文：子曰：“主忠信，毋友不如己者，过则勿惮改⑴。”",
    "annotations": "注释：⑴见卷一学而篇。"
  },
  {
    "id": 235,
    "title": "子罕 9.26",
    "text": "子曰：“三军⑴可夺帅也，匹夫不可夺志也。”",
    "translation": "译文：孔子说：“一国军队，可以使它丧失主帅；一个男子汉，却不能强迫他放弃主张。”",
    "annotations": "注释：⑴三军——周朝的制度，诸侯中的大国可以拥有军队三军。因此便用“三军”作军队的通称。"
  },
  {
    "id": 236,
    "title": "子罕 9.27",
    "text": "子曰：“衣⑴敝缊⑵袍，与衣⑴狐貉者立，而不耻者，其由也与？‘不忮不求，何用不臧⑶？’”子路终身诵之。子曰：“是道也，何足以臧？”",
    "translation": "译文：孔子说道：“穿着破烂的旧丝绵袍子和穿着狐貉裘的人一道站着，不觉得惭愧的，恐怕只有仲由罢！《诗经》上说：‘不嫉妒，不贪求，为什么不\n会好？’”子路听了，便老念着这两句诗。孔子又道：“仅仅这个样子，怎样能够好得起来？”",
    "annotations": "注释：⑴衣——去声，动词，当“穿”字解。⑵缊——音运，yùn，旧絮。古代没有草棉，所有“絮”字都是指丝绵。一曰，乱麻也。⑶不忮不求，何用不臧——两句见于《诗经·邶风·雄雉篇》。"
  },
  {
    "id": 237,
    "title": "子罕 9.28",
    "text": "子曰：“岁寒，然后知松柏之后雕⑴也。”",
    "translation": "译文：孔子说：“天冷了，才晓得松柏树是最后落叶的。”",
    "annotations": "注释：⑴雕——同凋、凋零，零落。"
  },
  {
    "id": 238,
    "title": "子罕 9.29",
    "text": "子曰：“知者不惑，仁者不忧，勇者不惧。”",
    "translation": "译文：孔子说：“聪明人不致疑惑，仁德的人经常乐观，勇敢的人无所畏惧。”",
    "annotations": ""
  },
  {
    "id": 239,
    "title": "子罕 9.30",
    "text": "子曰：“可与共学，未可与适道；可与适道，未可与立⑴；可与立，未可与权。”",
    "translation": "译文：孔子说：“可以同他一道学习的人，未必可以同他一道取得某种成就；可以同他一道取得某种成就的人，未必可以同他一道事事依体而行；可以同他一道事事依体而行的人，未必可以同他一道通权达变。”",
    "annotations": "注释：⑴立——《论语》的“立”经常包含着“立于礼”的意思，所以这里译为“事事依礼而行”。"
  },
  {
    "id": 240,
    "title": "子罕 9.31",
    "text": "“唐棣⑴之华，偏其反而。岂不尔思？室是远而。”子曰：“未之思也，夫何远之有？”",
    "translation": "译文：古代有几句这样的诗：“唐棣树的花，翩翩地摇摆。难道我不想念\n你？因为家住得太遥远。”孔子道：“他是不去想念哩，真的想念，有什么遥远呢？”",
    "annotations": "注释：⑴唐棣……何远之有——唐棣，一种植物，陆玑《毛诗草木鸟兽虫鱼疏》以为就是郁李（蔷薇科，落叶乔木），李时珍《本草纲目》却以为是扶栘（蔷薇科，落叶乔木）。“唐棣之华，偏其反而”似是捉摸不定的意思，或者和颜回讲孔子之道“瞻之在前，忽焉在后”（9.11）意思差不多。“夫何远之有”可能是“仁远乎哉？我欲仁，斯仁至矣”（7.30）的意思。或者当时有人引此诗（这是“逸诗”，不在今《诗经》中），意在证明道之远而不可捉摸，孔子则说，你不曾努力罢了，其实是一呼卽至的。"
  },
  {
    "id": 241,
    "title": "鄉黨 10.1",
    "text": "孔子于乡党，恂恂⑴如也，似不能言者。其在宗庙朝廷，便便⑵言，唯谨尔。",
    "translation": "译文：孔子在本乡的地方上非常恭顺，好像不能说话的样子。他在宗庙里、朝廷上，有话便明白而流畅地说出，只是说得很少。",
    "annotations": "注释：⑴恂恂——恂音旬，xún，恭顺貌。⑵便便——便旧读骈，pián。"
  },
  {
    "id": 242,
    "title": "鄉黨 10.2",
    "text": "朝，与下大夫言，侃侃如也；与上大夫言，誾誾⑴如也。君在，踧踖如也，与与如也。",
    "translation": "译文：上朝的时候，［君主还没有到来，］同下大夫说话，温和而快乐的样子；同上大夫说话，正直而恭敬的样子。君主已经来了，恭敬而心中不安的样子，行步安祥的样子。",
    "annotations": "注释：⑴誾——音银，yín。"
  },
  {
    "id": 243,
    "title": "鄉黨 10.3",
    "text": "君召使摈，色勃如也，足躩⑴如也。揖所与立，左右手，衣前后⑵，襜⑶如也。趋进⑷，翼如也。宾退，必复命曰：“宾不顾矣。”",
    "translation": "译文：鲁君召他去接待外国的贵宾，面色矜持庄重，脚步也快起来。向两旁的人作揖，或者向左拱手，或者向右拱手，衣裳一俯一仰，却很整齐。快步向前，好像鸟儿舒展了翅膀。贵宾辞别后一定向君主回报说：“客人已经不回头了。 ”",
    "annotations": "注释：⑴躩——音矍，jué，皇侃《义疏》引江熙云：“不暇闲步，躩，速貌也。”⑵前后——俯仰的意思。⑵襜——音幨，chān，整齐之貌。⑷趋进——在行步时一种表示敬意的行动。"
  },
  {
    "id": 244,
    "title": "鄉黨 10.4",
    "text": "入公门，鞠躬如⑴也，如不容。 立不中门，行不履阈。 过位⑵，色勃如也，足躩如也，其言似不足者。 摄齐⑶升堂，鞠躬如也，屏气⑷似不息者。 出，降一等，逞颜色，怡怡如也。 没阶，趋进⑸，翼如也。 复其位，踧踖如也。",
    "translation": "译文：孔子走进朝廷的门，害怕而谨慎的样子，好像没有容身之地。 站，不站在门的中间；走，不踩门坎。 经过国君的坐位，面色便矜庄，脚步也快，言语也好像中气不足。 提起下襬向堂上走，恭敬谨慎的样子，憋住气好像不呼吸一般。 走出来，降下台阶一级，面色便放松，怡然自得。 走完了台阶，快快地向前走几步，好像鸟儿舒展翅膀。 回到自己的位置，恭敬而内心不安的样子。",
    "annotations": "注释：⑴鞠躬如——这“鞠躬”两字不能当“曲身”讲。这是双声字，用以形\n容谨慎恭敬的样子。《论语》所有“□□如”的区别词（区别词是形容词、副词的合称），都不用动词结构。清人卢文弨《龙城札记》说：“……且曲身乃实事，而\n云曲身如，更无此文法。”⑵过位——过旧音戈，平声。位是人君的坐位，经过之时，人君并不在，坐位是空的。⑶摄齐——齐音咨，zī，衣裳缝了边的下襬；摄，提起。⑷屏——音丙，又音并，bìng，屏气卽屏息，压抑呼吸。⑸趋进——有些本子无“进”字，不对。自汉以来所有引《论语》此文的都有“进”字，《唐石经》也有“进”字，《太平御览》居处部、人事部引文，张子《正蒙》引文也都有“进”字。"
  },
  {
    "id": 245,
    "title": "鄉黨 10.5",
    "text": "执圭⑴，鞠躬如也，如不胜⑵。上如揖，下如授。勃如战色，足蹜蹜如有循⑶。\n享礼⑷，有容色⑸。\n私觌⑹，愉愉如也。",
    "translation": "译文：［孔子出使到外国，举行典礼，］拿着圭，恭敬谨慎地，好像举不起来。向上举好像在作揖，向下拿好像在交给别人。面色矜庄好像在作战。脚步也紧凑狭窄，好像在沿着［一条线］走过。\n献礼物的时候，满脸和气。\n用私人身分和外国君臣会见，显得轻松愉快。",
    "annotations": "注释：⑴圭——一种玉器，上圆，或者作剑头形，下方，举行典礼的时候，君臣都拿着。⑵胜——音升，shēng，能担负得了。⑶足蹜蹜如有循——蹜音缩，“蹜蹜”，举脚密而狭的样子。“如有循”，所沿循的应当是很窄狭的东西，所以译文加了“一条线”诸字以示意。⑷享礼——古代出使外国，初到所聘问的国家，便行聘问礼。“执圭”一段所写的正是行聘问礼时孔子的情貌。聘问之后，便行享献之礼。“享礼”就是享献礼，使臣把所带来的各种礼物罗列满庭。⑸有容色——《仪礼·聘礼》：“及享，发气焉盈容。”“有容色”就是“发气焉盈容”。⑹觌——音狄，dí，相见。"
  },
  {
    "id": 246,
    "title": "鄉黨 10.6",
    "text": "君子不以绀緅饰⑴，红紫不以为亵服⑵。\n当暑，袗絺绤⑶，必表而出之。\n缁衣，羔裘；素衣，麑裘；黄衣，狐裘⑷。 亵裘长⑸，短右袂⑹。 必有寝衣⑺，长一身有半。 狐貉之厚以居。 去丧，无所不佩。 非帷裳⑻，必杀之⑼。 羔裘玄冠不以吊⑽。 吉月⑾，必朝服而朝。",
    "translation": "译文：君子不用［近乎黑色的］天青色和铁灰色作镶边，［近乎赤色的］\n浅红色和紫色不用来作平常居家的衣服。\n当暑，穿着粗的或者细的葛布单衣，但一定裹着衬衫，使它露在外面。\n黑色的衣配紫羔，白色的衣配麑裘，黄色的衣配狐裘。 \n居家的皮袄身材较长，可是右边的袖子要做得短些。 必有寝衣⑺，长一身有半。 狐貉之厚以居。 去丧，无所不佩。 非帷裳⑻，必杀之⑼。 羔裘玄冠不以吊⑽。 吉月⑾，必朝服而朝。",
    "annotations": "注释：⑴绀緅饰——绀音赣，gàn；緅音邹，zōu；都是表示颜色的名称。\n“绀”是深青中透红的颜色，相当今天的“天青”；“緅”是青多红少，比绀更暗的颜色，这里用“铁灰色”来表明它。“饰”是滚边，镶边，缘边。古代，黑色是正式礼服的颜色，而这两种颜色都近于黑色，所以不用来镶边，为别的颜色作装饰。⑵红紫不以为亵服——古代大红色叫“朱”，这是很贵重的颜色。“红”和“紫”都属此类，也连带地被重视，不用为平常家居衣服的颜色。⑶袗絺绤——袗音轸，zhěn，单也。此处用为动词。絺音痴，chī，细葛布；绤音隙，xì，粗葛布。⑷缁衣羔裘等三句——这三句表示衣服里外的颜色应该相称。古代穿皮衣，毛向外，因之外面一定要用罩衣，这罩衣就叫做裼（音锡）衣。这里“缁衣”、“素衣”、“黄衣”的“衣”指的正是裼衣。缁，黑色。古代所谓“羔裘”都是黑色的羊毛，就是今天的紫羔。麑音倪，ní，小鹿，它的毛是白色。⑸亵裘长——亵裘长为着保暖。古代男子上面穿衣，下面穿裳（裙），衣裳不相连。因之孔子在家的皮袄就做得比较长。⑹短右袂——袂，mèi，袖子。右袖较短，为着做事方便。有人认为衣袖一长一短，不大好看，孔子不会如此，于是对这一句别生解释，我认为那些解释都不可信。⑺寝衣——卽被。古代大被叫“衾”，小被叫“被”。⑻帷裳——礼服，上朝和祭祀时穿，用整幅布做，不加翦裁，多余的布作褶迭（褶迭古代叫做襞积），犹如今天的百褶裙。古代男子上衣下裙。⑼杀——去声，shài，减少，裁去。“杀之”就是缝制之先裁去多余的布，不用褶迭，省工省料。⑽羔裘玄冠不以吊——玄冠，一种礼帽。“羔裘玄冠”都是黑色的，古代都用作吉服。丧事是凶事，因之不能穿戴着去吊丧。⑾吉月——这两个字有各种解释：（甲）每月初一（旧注都如此）；（乙）“吉”字误，应该作“告”。“告月”就是每月月底，司历者以下月初一告之于君（王引之《经义述闻》、俞樾《羣经平议》）；两说都不可信。今从程树德《论语集释》之说。"
  },
  {
    "id": 247,
    "title": "鄉黨 10.7",
    "text": "齐，必有明衣，布⑴。\n齐必变食⑵，居必迁坐⑶。",
    "translation": "译文：斋戒沐浴的时候，一定有浴衣，用布做的。\n斋戒的时候，一定改变平常的饮食；居住也一定搬移地方［不和妻妾同房］。",
    "annotations": "注释：⑴布——现在的布一般是用草棉（棉花）纺织的，但古代没有草棉，布的质料，王夫之《四书稗疏》说：“古之言布者，兼丝麻枲葛而言之。练丝为帛，未练为布，盖今之生丝绢也。清商曲有云：‘丝布涩难缝’，则晋宋间犹有丝布之名。唯孔丛子谓麻苎葛曰布，当亦一隅之论。”赵翼《陔余丛考》说：“古时未有棉布，凡布皆麻为之。记曰：‘治其丝麻，以为布帛’是也。”⑵变食——变食的内容，古人有三种说法：（甲）《庄子·人间世篇》说：“颜回曰：‘回之家贫，惟不饮酒不茹荤者数月矣。如此，则可以为齐乎？’曰：‘是祭祀之齐，非心齐也。 ’”有人据此，便把“不饮酒，不茹荤（荤是有浓厚气味的蔬菜，如蒜、韭、葱之属） ” 来解释“变食”。（乙）《周礼·天官·膳夫》：“王日一举……王齐，日三举。”这意思是王每天虽然吃饭三顿，却只在第一顿饭时杀牲，其余两顿，只把第一顿的剩菜回锅罢了。天子如此，其它的人更不会顿顿吃新鲜的。若在斋戒之时那就顿顿吃新鲜的，不吃回锅的剩菜，取其洁净，这便是“变食”。（丙）金鹗《求古録·礼说补遗》说，变食不但不饮酒、不食葱蒜等，也不食鱼肉。⑶迁坐——等于说改变卧室。古代的上层人物平常和妻室居于“燕寝”；斋戒之时则居于“外寝”（也叫“正寝”），和妻室不同房。唐朝的法律还规定着举行大祭，在斋戒之时官吏不宿于正寝的，每一晚打五十竹板。这或者犹是古代风俗的残余。"
  },
  {
    "id": 248,
    "title": "鄉黨 10.8",
    "text": "食不厌精，脍不厌细。\n食饐而餲⑴，鱼馁而肉败⑵，不食。色恶，不食。臭恶，不食。失饪，不食。不时⑶，不食。割不正⑷，不食。不得其酱，不食。\n肉虽多，不使胜食气⑸。\n唯酒无量，不及乱⑹。\n沽酒市脯不食。\n不撤姜食，不多食。",
    "translation": "译文：粮食不嫌舂得精，鱼和肉不嫌切得细。\n粮食霉烂发臭，鱼和肉腐烂，都不吃。食物颜色难看，不吃。气味难闻，不吃。烹调不当，不吃。不到该当吃食时候，不吃。不是按一定方法砍割的肉，不吃。没有一定调味的酱醋，不吃。\n席上肉虽然多，吃它不超过主食。\n只有酒不限量，却不至醉。\n买来的酒和肉干不吃。\n吃完了，姜不撤除，但吃得不多。",
    "annotations": "注释：⑴饐而餲——饐音懿，yì；餲，ài；饮食经久而腐臭。⑵馁，败——馁音“内”的上声，něi，鱼腐烂叫“馁”，肉腐烂叫“败”。⑶不时——有两说：（甲）过早的食物，冬天在温室种菜蔬，在《汉书·循吏·召信臣传》和桓宽《盐铁论·散不足篇》里便称为“不时之物”。但在汉朝，也只有“太官园”和其它少数园圃才能供奉，也只有皇上和极为富贵之家才能享受，而在孔子时，不但不必有温室种菜的技术，卽有，孔子也未必能够享受。（乙）不是该当吃食的时候。《吕氏春秋·尽数篇》：“食能以时，身必无灾。”卽此意。⑷割不正——“割”和“切”不同。“割”指宰杀猪牛羊时肢体的分解。古人有一定的分解方法，不按那方法分解的，便叫“割不正”。说本王夫之《四书稗疏》。⑸食气——食音嗣，“气”，说文引作“既”。“既”、“气”、“饩”三字古书通用。“食气”，饭料。⑹乱——高亨《周易古经今注》云：“乱者神志昏乱也。《左传》宣公十五年传：‘疾病则乱’。《论语·乡党篇》：‘唯酒无量不及乱’。易象传曰：‘乃乱乃萃，其志乱也。’得其恉矣。”"
  },
  {
    "id": 249,
    "title": "鄉黨 10.9",
    "text": "祭于公，不宿肉⑴。祭肉⑵不出三日。出三日，不食之矣。",
    "translation": "译文：参与国家祭祀典礼，不把祭肉留到第二天。别的祭肉留存不超过三天。若是存放过了三天，便不吃了。",
    "annotations": "注释：⑴不宿肉——古代的大夫、士都有助君祭祀之礼。天子诸侯的祭礼，当天清早宰杀牲畜，然后举行祭典。第二天又祭，叫做“绎祭”。绎祭之后才令各人拿自己带来助祭的肉回去，或者又依贵贱等级分别颁赐祭肉。这样，祭于公的肉，在未颁下来以前，至少是放了一两宵了，因之不能再存放一夜。⑵祭肉——这一祭肉或者指自己家中的，或者指朋友送来的，都可以。"
  },
  {
    "id": 250,
    "title": "鄉黨 10.10",
    "text": "食不语，寝不言。",
    "translation": "译文：吃饭的时候不交谈，睡觉的时候不说话。",
    "annotations": ""
  },
  {
    "id": 251,
    "title": "鄉黨 10.11",
    "text": "虽疏食菜羹，瓜祭⑴，必齐如也。",
    "translation": "译文：虽然是糙米饭小菜汤，也一定得先祭一祭，而且祭的时候还一定恭恭敬敬，好像斋戒了的一样。",
    "annotations": "注释：⑴瓜祭——有些本子作“必祭”，“瓜”恐怕是错字。这是食前将席上各种食品拿出少许，放在食器之间，祭最初发明饮食的人，《左传》叫泛祭。"
  },
  {
    "id": 252,
    "title": "鄉黨 10.12",
    "text": "席⑴不正，不坐。",
    "translation": "译文：坐席摆的方向不合礼制，不坐。",
    "annotations": "注释：⑴席——古代没有椅和櫈，都是在地面上铺席子，坐在席子上。席子一般是用蒲苇、蒯草、竹篾以至禾穰为质料。现在日本人还保留着席地而坐的习惯。《墨子·非儒篇》说：“哀公迎孔子，席不端，不坐。”以“端”解“正”，则“席不正”，是坐席不端正之意。然而《汉书·王尊传》说，“［匡］衡与中二千石大鸿胪赏等会坐殿门下，衡南乡，赏等西乡。衡更为赏布束乡席，起立延赏坐……而设不正之席，使下坐上”云云，那么，“席不正”是布席不合礼制之意。"
  },
  {
    "id": 253,
    "title": "鄉黨 10.13",
    "text": "乡人饮酒⑴，杖者出，斯出矣。",
    "translation": "译文：行乡饮酒礼后，要等老年人都出去了，自己这纔出去。",
    "annotations": "注释：⑴乡人饮酒——卽行乡饮酒礼，据《礼记·乡饮酒义》“少长以齿”。《王制》也说：“习乡尚齿”。既论年龄大小，所以孔子必须让杖者先出。"
  },
  {
    "id": 254,
    "title": "鄉黨 10.14",
    "text": "乡人傩⑴，朝服而立于阼阶⑵。",
    "translation": "译文：本地方人迎神驱鬼，穿着朝服站在东边的台阶上。",
    "annotations": "注释：⑴滩——音挪，nuó，古代的一种风俗，迎神以驱逐疫鬼。解放前的湖南，如果家中有病人，还有雇请巫师以驱逐疫鬼的迷信，叫做“冲傩”，可能是这种风俗的残余。⑵阼阶——阼音祚，zuò，东面的台阶，主人所立之地。"
  },
  {
    "id": 255,
    "title": "鄉黨 10.15",
    "text": "问⑴人于他邦，再拜⑵而送之。",
    "translation": "译文：托人给在外国的朋友问好送礼，便向受托者拜两次送行。",
    "annotations": "注释：⑴问——问讯，问好。不过古代问好，也致送礼物以表示情意，如《诗经·郑风·女曰鸡鸣》“杂佩以问之”，《左传》成公十六年“楚子使工尹襄问之以弓”，哀公十一年“使问弦多以琴”，因此译文加了“送礼”两字。⑵拜——拱手并弯腰。"
  },
  {
    "id": 256,
    "title": "鄉黨 10.16",
    "text": "康子馈药，拜而受之。曰：“丘未达，不敢尝。”",
    "translation": "译文：季康子给孔子送药，孔子拜而接受，却说道：“我对这药性不很了解，不敢试服。”",
    "annotations": ""
  },
  {
    "id": 257,
    "title": "鄉黨 10.17",
    "text": "厩焚。子退朝，曰：“伤人乎？”不问马。",
    "translation": "译文：孔子的马棚失了火。孔子从朝廷回来，道：“伤了人吗？”，不问到马。",
    "annotations": ""
  },
  {
    "id": 258,
    "title": "鄉黨 10.18",
    "text": "君赐食，必正席先尝之。君赐腥，必熟而荐⑴之。君赐生，必畜之。侍食于君，君祭，先饭。",
    "translation": "译文：国君赐以熟食，孔子一定摆正坐位先尝一尝。国君赐以生肉，一定\n煮熟了，先［给祖宗］进供。国君赐以活物，一定养着它。 同国君一道吃饭，当他举行饭前祭礼的时候，自己先吃饭，［不吃菜。］",
    "annotations": "注释：⑴荐——进奉。这里进奉的对象是自己的祖先，但不能看为祭祀。"
  },
  {
    "id": 259,
    "title": "鄉黨 10.19",
    "text": "疾，君视之，东首⑴，加朝服，拖绅⑵。",
    "translation": "译文：孔子病了，国君来探问，他便脑袋朝东，把上朝的礼服披在身上，拖着大带。",
    "annotations": "注释：⑴东首——指孔子病中仍旧卧床而言。古人卧榻一般设在南窗的西面。国君来，从东边台阶走上来（东阶就是阼阶，原是主人的位向，但国君自以为是全国的主人，就是到其臣下家中，仍从阼阶上下），所以孔子面朝东来迎接他。⑵加朝服，拖绅——孔子卧病在床，自不能穿朝服，只能盖在身上。绅是束在腰间的大带。束了以后，仍有一节垂下来。"
  },
  {
    "id": 260,
    "title": "鄉黨 10.20",
    "text": "君命召，不俟驾行矣。",
    "translation": "译文：国君呼唤，孔子不等待车辆驾好马，立卽先步行。",
    "annotations": ""
  },
  {
    "id": 261,
    "title": "鄉黨 10.21",
    "text": "入太庙，每事问⑴。",
    "translation": "译文：入太庙，每事问⑴。",
    "annotations": "注释：⑴见八佾篇。"
  },
  {
    "id": 262,
    "title": "鄉黨 10.22",
    "text": "朋友死，无所归，曰：“于我殡⑴。”",
    "translation": "译文：朋友死亡，没有负责收敛的人，孔子便道：“丧葬由我来料理。”",
    "annotations": "注释：⑴殡——停放灵柩叫殡，埋葬也可以叫殡，这里当指一切丧葬事务而言。"
  },
  {
    "id": 263,
    "title": "鄉黨 10.23",
    "text": "朋友之馈，虽车马，非祭肉，不拜。",
    "translation": "译文：朋友的赠品，卽使是车马，只要不是祭肉，孔子在接受的时候，不行礼。",
    "annotations": ""
  },
  {
    "id": 264,
    "title": "鄉黨 10.24",
    "text": "寝不尸，居不客⑴。",
    "translation": "译文：孔子睡觉不像死尸一样［直躺着］，平日坐着，也不像接见客人或者自己做客人一样，［跪着两膝在席上。］",
    "annotations": "注释：⑴居不客——“客”本作“容”，今从《释文》和《唐石经》校订作“客”。居，坐；客，宾客。古人的坐法有几种，恭敬的是屈着两膝，膝盖着地，而足跟承着臀部。作客和见客时必须如此。不过这样难以持久，居家不必如此。省力的坐法是脚板着地，两膝耸起，臀部向下而不贴地，和蹲一样。所以《说文》说：“居，蹲也。”（这几个字是依从段玉裁的校本。）最不恭敬的坐法是臀部贴地，两腿张开，平放而直伸，像箕一样，叫做“箕踞”。孔子平日的坐式可能像蹲。说见段玉裁《说文解字注》。"
  },
  {
    "id": 265,
    "title": "鄉黨 10.25",
    "text": "见齐衰者，虽狎，必变。见冕者与瞽者，虽亵，必以貌。 凶服者式⑴之。式负版⑵者。 有盛馔，必变色而作。 迅雷风烈⑶必变。",
    "translation": "译文：孔子看见穿齐衰孝服的人，就是极亲密的，也一定改变态度，［表\n示同情。］看见戴着礼帽和瞎了眼睛的人，卽使常相见，也一定有礼貌。 在车中遇着拿了送死人衣物的人，便把身体微微地向前一俯，手伏着车前的\n横木，［表示同情。］遇见背负国家图籍的人，也手伏车前横木。 一有丰富的菜肴，一定神色变动，站立起来。 遇见疾雷、大风，一定改变态度。",
    "annotations": "注释：⑴式——同“轼”，古代车辆前的横木叫“轼”，这里作动词用，用手\n伏轼的意思。⑵版——国家图籍。⑶迅雷风烈——就是“迅雷烈风”的意思。"
  },
  {
    "id": 266,
    "title": "鄉黨 10.26",
    "text": "升车，必正立，执绥。 车中，不内顾，不疾言，不亲指。",
    "translation": "译文：孔子上车，一定先端正地站好，拉着扶手带［登车］。在车中，不\n向内回顾，不很快地说话，不用手指指画画。",
    "annotations": ""
  },
  {
    "id": 267,
    "title": "鄉黨 10.27",
    "text": "色斯举矣，翔而后集。曰：“山梁雌雉，时哉时哉！”子路共⑴之，三嗅⑵而作⑶。",
    "translation": "译文：［孔子在山谷中行走，看见几只野鸡。］孔子的脸色一动，野鸡便飞向天空，盘旋一阵，又都停在一处。孔子道：“这些山梁上雌雉，得其时呀，得其时呀，”子路向它们拱拱手，它们又振一振翅膀飞去了。",
    "annotations": "注释：⑴共——同“拱”。⑵嗅——当作狊，jù，张两翅之貌。⑶这段文字很费解，自古以来就没有满意的解释，很多人疑它有脱误，我只能取前人的解释之较为平易者翻译出来。"
  },
  {
    "id": 268,
    "title": "鄉黨 10.25",
    "text": "见齐衰者，虽狎，必变。见冕者与瞽者，虽亵，必以貌。 凶服者式⑴之。式负版⑵者。 有盛馔，必变色而作。 迅雷风烈⑶必变。",
    "translation": "译文：孔子看见穿齐衰孝服的人，就是极亲密的，也一定改变态度，［表\n示同情。］看见戴着礼帽和瞎了眼睛的人，卽使常相见，也一定有礼貌。 在车中遇着拿了送死人衣物的人，便把身体微微地向前一俯，手伏着车前的\n横木，［表示同情。］遇见背负国家图籍的人，也手伏车前横木。 一有丰富的菜肴，一定神色变动，站立起来。 遇见疾雷、大风，一定改变态度。",
    "annotations": "注释：⑴式——同“轼”，古代车辆前的横木叫“轼”，这里作动词用，用手\n伏轼的意思。⑵版——国家图籍。⑶迅雷风烈——就是“迅雷烈风”的意思。",
    "displayAliasOf": 265
  },
  {
    "id": 269,
    "title": "鄉黨 10.26",
    "text": "升车，必正立，执绥。 车中，不内顾，不疾言，不亲指。",
    "translation": "译文：孔子上车，一定先端正地站好，拉着扶手带［登车］。在车中，不\n向内回顾，不很快地说话，不用手指指画画。",
    "annotations": "",
    "displayAliasOf": 266
  },
  {
    "id": 270,
    "title": "鄉黨 10.27",
    "text": "色斯举矣，翔而后集。曰：“山梁雌雉，时哉时哉！”子路共⑴之，三嗅⑵而作⑶。",
    "translation": "译文：［孔子在山谷中行走，看见几只野鸡。］孔子的脸色一动，野鸡便飞向天空，盘旋一阵，又都停在一处。孔子道：“这些山梁上雌雉，得其时呀，得其时呀，”子路向它们拱拱手，它们又振一振翅膀飞去了。",
    "annotations": "注释：⑴共——同“拱”。⑵嗅——当作狊，jù，张两翅之貌。⑶这段文字很费解，自古以来就没有满意的解释，很多人疑它有脱误，我只能取前人的解释之较为平易者翻译出来。",
    "displayAliasOf": 267
  },
  {
    "id": 271,
    "title": "先進 11.1",
    "text": "子曰：“先进⑴于礼乐，野人也；后进⑴于礼乐，君子也。如用之，则吾从先进。”",
    "translation": "译文：孔子说：“先学习礼乐而后做官的是未曾有过爵禄的一般人，先有了官位而后学习礼乐的是卿大夫的子弟。如果要我选用人才，我主张选用先学习礼乐的人。”",
    "annotations": "【注释】⑴先进，后进——这两个术语的解释很多，都不恰当。译文本刘宝楠《论语正义》之说而略有取舍。孔子是主张“学而优则仕”的人，对于当时的卿大夫子弟，承袭父兄的庇荫，在做官中去学习的情况可能不满意。《孟子·告子下》引葵丘之会盟约说，“士无世官”，又说，“取士必得”，那么，孔子所谓“先进”一般指“士”。"
  },
  {
    "id": 272,
    "title": "先進 11.2",
    "text": "子曰：“从我于陈、蔡⑴者，皆不及门⑵也。”",
    "translation": "译文：孔子说：“跟着我在陈国、蔡国之间忍饥受饿的人，都不在我这里了。”",
    "annotations": "【注释】⑴从我于陈、蔡——“从”读去声，zòng。《史记·孔子世家》云：“吴伐陈，楚救陈，军于城父。闻孔子在陈、蔡之间，楚使人聘孔子，孔子将往拜礼。陈、蔡大夫谋曰：‘孔子贤者，所刺讥皆中诸侯之疾，今者久留陈、蔡之间，诸大夫所设行皆非仲尼之意。今楚，大国也，来聘孔子。孔子用于楚，则陈、蔡用事大夫危矣。’乃相与发徒役围孔子于野。不得已，绝粮。从者病，莫能兴。……于是使子贡至楚。楚昭王兴师迎孔子，然后得免。”⑵不及门——汉唐旧解“不及门”为“不及仕进之门”或“不仕于卿大夫之门”，刘宝楠因而傅会孟子的“无上下之交”，解为“孔子弟子无仕陈蔡者”，我则终嫌与文意不甚密合，故不取，而用朱熹之说。郑珍《巢经巢文集》卷二〈驳朱竹垞孔子门人考〉有云：“古之教者家有塾，塾在门堂之左右，施教受业者居焉。所谓‘皆不及门’，及此门也。‘奚为于丘（原作某，由于避讳故，今改）之门’，于此门也。滕更之‘在门’，在此门也，故曰‘愿留而受业于门’（按上两句俱见《孟子》）。”亦见朱熹此说之有据。"
  },
  {
    "id": 273,
    "title": "先進 11.3",
    "text": "德行：颜渊，闵子骞，冉伯牛，仲弓。言语：宰我，子贡。政事：冉有，季路。文学⑴：子游，子夏。",
    "translation": "译文：［孔子的学生各有所长。］德行好的：颜渊，闵子骞，冉伯牛，仲弓。会说话的：宰我，子贡。能办理政事的：冉有，季路。熟悉古代文献的：子游，子夏。",
    "annotations": "【注释】⑴文学——指古代文献，卽孔子所传的《诗》、《书》、《易》等。皇侃《义疏》引范宁说如此。《后汉书·徐防传》说：“防上疏云：‘经书礼乐，定自孔子；发明章句，始于子夏”。似亦可为证。又这一章和上一章“从我于陈蔡者”不相连。朱熹《四书集注》说这十人卽当在陈、蔡之时随行的人，是错误的。根据《左传》，冉有其时在鲁国为季氏之臣，未必随行。根据《史记·仲尼弟子列传》，当时随行的还有子张，何以这里不说及？根据各种史料，确知孔子在陈绝粮之时为鲁哀公四年，时孔子六十一岁。又据《史记·仲尼弟子列传》，子游小于孔子四十五岁，子夏小于孔子四十四岁，那么，孔子在陈、蔡受困时，子游不过十六岁，子夏不过十七岁，都不算成人。这么年幼的人卽使已经在孔子门下受业，也未必都跟去了。可见这几句话不过是孔子对这十个学生的一时的叙述，由弟子转述下来的记载而已。"
  },
  {
    "id": 274,
    "title": "先進 11.4",
    "text": "子曰：“回也非助我者也，于吾言无所不说。”",
    "translation": "译文：孔子说：“颜回不是对我有所帮助的人，他对我的话没有不喜欢的。 ”",
    "annotations": ""
  },
  {
    "id": 275,
    "title": "先進 11.5",
    "text": "子曰：“孝哉闵子骞！人不间于其父母昆弟之言。”",
    "translation": "译文：孔子说：“闵子骞真是孝顺呀，别人对于他爹娘兄弟称赞他的言语并无异议。”",
    "annotations": ""
  },
  {
    "id": 276,
    "title": "先進 11.6",
    "text": "南容三复白圭⑴，孔子以其兄之子妻之。",
    "translation": "译文：南容把“白圭之玷，尚可磨也；斯言之玷，不可为也”的几句诗读了又读，孔子便把自己的侄女嫁给他。",
    "annotations": "【注释】⑴白圭——白圭的诗四句见于《诗经·大雅·抑篇》，意思是白圭的污点还可以磨掉；我们言语中的污点便没有办法去掉。大概南容是一个谨小慎微的人，所以能做到“邦有道，不废；邦无道，免于刑戮”。（5.2）"
  },
  {
    "id": 277,
    "title": "先進 11.7",
    "text": "季康子问⑴：“弟子孰为好学？”孔子对曰：“有颜回者好学，不幸短命死矣，今也则亡。”",
    "translation": "译文：季康子问道：“你学生中谁用功？”孔子答道：“有一个叫颜回的用功，不幸短命死了，现在就再没有这样的人了。”",
    "annotations": "【注释】⑴季康子问——鲁哀公曾经也有此问（6.3），孔子的回答较为详细。有人说，从此可见孔子与鲁君的问答和与季氏的问答有繁简之不同。"
  },
  {
    "id": 278,
    "title": "先進 11.8",
    "text": "颜渊死，颜路⑴请子之车以为之⑵椁⑶。子曰：“才不才，亦各言其子也。鲤⑷也死，有棺而无椁。吾不徒行以为之椁。以吾从大夫之后⑸，不可徒行也。”",
    "translation": "译文：颜渊死了，他父亲颜路请求孔子卖掉车子来替颜渊办外椁。孔子道：“不管有才能或者没有才能，但总是自己的儿子。我的儿子鲤死了，也只有内棺，没有外椁。我不能［卖掉车子］步行来替他买椁。因为我也曾做过大夫，是不可以步行的。”",
    "annotations": "【注释】⑴颜路——颜回的父亲，据《史记·仲尼弟子列传》，名无繇，字路，也是孔子学生。⑵之——用法同“其”。⑶椁——也作“椁”，音果，guǒ。古代大官棺木至少用两重，里面的一重叫棺，外面又一重大的叫椁，平常我们说“内棺外椁”就是这个意思。⑷鲤也死——鲤，字伯鱼，年五十死，那时孔子年七十。⑹从大夫之后——孔子在鲁国曾经做过司寇的官，是大夫之位。不过此时孔子已经去位多年。他不说“我曾为大夫”，而说“吾从大夫之后”（在大夫行列之后随行的意思）只是一种谦逊的口气罢了。"
  },
  {
    "id": 279,
    "title": "先進 11.9",
    "text": "颜渊死。子曰：“噫！天丧予！天丧予⑴！”",
    "translation": "译文：颜渊死了，孔子道：“咳！天老爷要我的命呀！天老爷要我的命呀！ ”",
    "annotations": "【注释】⑴天丧予——译文只就字面译出。"
  },
  {
    "id": 280,
    "title": "先進 11.10",
    "text": "颜渊死，子哭之恸⑴。从者曰：“子恸矣！”曰：“有恸乎？非夫人之为恸⑵而谁为？”",
    "translation": "译文：颜渊死了，孔子哭得很伤心。跟着孔子的人道：“您太伤心了！”孔子道：“真的太伤心了吗？我不为这样的人伤心，还为什么人伤心呢！”",
    "annotations": "【注释】⑴恸——郑注：“恸，变动容貌”。马融注：“恸，哀过也”。译文从马。⑵非夫人之为恸而谁为——“非夫人之为恸”是“非为夫人恸”的倒装形式。“夫人”的“夫”读阳平，音扶，指示形容词，“那”的意思。“之为”的“之”是专作帮助倒装用的，无实际意义。这一整句下文的“谁为”，依现代汉语的格式说也是倒装，不过在古代，如果介词或者动词的宾语是疑问代词，一般都放在介词或者动词之上。"
  },
  {
    "id": 281,
    "title": "先進 11.11",
    "text": "颜渊死，门人欲厚葬⑴之。子曰：“不可。”门人厚葬之。子曰：“回也视予犹父也，予不得视犹子也。非我也，夫二三子也。”",
    "translation": "译文：颜渊死了，孔子的学生们想要很丰厚地埋葬他。孔子道：“不可以。 ”学生们仍然很丰厚地埋葬了他。孔子道：“颜回呀，你看待我好像看待父亲，我却不能够像对待儿子一般地看待你。这不是我的主意呀，是你那班同学干的呀。 ”",
    "annotations": "【注释】⑴厚葬——根据《檀弓》所记载孔子的话，丧葬应该“称家之有亡，有，毋过礼。苟亡矣，敛首足形，还葬，县棺而封。”颜子家中本穷，而用厚葬，从孔子看来，是不应该的。孔子的叹，实是责备那些主持厚葬的学生。"
  },
  {
    "id": 282,
    "title": "先進 11.12",
    "text": "季路问事鬼神。子曰：“未能事人，焉能事鬼？”\n曰：“敢⑴问死。”曰：“未知生，焉知死？”",
    "translation": "译文：子路问服事鬼神的方法。孔子道：“活人还不能服事，怎么能去服事死人？”\n子路又道：“我大胆地请问死是怎么回事。”孔子道：“生的道理还没有弄明白，怎么能够懂得死？”",
    "annotations": "【注释】⑴敢——表敬副词，无实际意义。《仪礼·士虞礼》郑玄注云：“敢，冒昧之词。”贾公彦疏云：“凡言‘敢’者，皆是以卑触尊不自明之意。”"
  },
  {
    "id": 283,
    "title": "先進 11.13",
    "text": "闵子侍侧，誾誾如也；子路，行行⑴如也；冉有、子贡，侃侃如也。子乐。“若由也，不得其死然⑵。”",
    "translation": "译文：闵子骞站在孔子身旁，恭敬而正直的样子；子路很刚强的样子；冉有、子贡温和而快乐的样子。孔子高兴起来了。［不过，又道：］“像仲由吧，怕得不到好死。”",
    "annotations": "【注释】⑴行行——旧读去声，hàng。⑵不得其死然——得死，当时俗语，谓得善终。《左传》僖公十九年“得死为幸”；哀公十六年“得死，乃非我”。然，语气词，用法同“焉”。"
  },
  {
    "id": 284,
    "title": "先進 11.14",
    "text": "鲁人⑴为长府。闵子骞曰：“仍旧贯，如之何？何必改作？”子曰：“夫人不言，言必有中。”",
    "translation": "译文：鲁国翻修叫长府的金库。闵子骞道：“照着老样子下去怎么样？为什么一定要翻造呢？”孔子道：“这个人平日不大开口，一开口一定中肯。”",
    "annotations": "【注释】⑴鲁人——“鲁人”的“人”指其国的执政大臣而言。此“人”和“民”的区别。"
  },
  {
    "id": 285,
    "title": "先進 11.15",
    "text": "子曰：“由之瑟⑴奚为于丘之门？”门人不敬子路。子曰：“由也升堂矣，未入于室⑵也。”",
    "translation": "译文：孔子道：“仲由弹瑟，为什么在我这里来弹呢？”因此孔子的学生们瞧不起子路。孔子道：“由么，学问已经不错了，只是还不够精深罢了。”",
    "annotations": "【注释】⑴瑟——音涩，sè，古代的乐器，和琴同类。这里孔子不是不高兴子路弹瑟，而是不高兴他所弹的音调。《说苑·修文篇》对这段文字曾有所发挥。⑵升堂入室——这是比喻话。“堂”是正厅，“室”是内室。先入门，次升堂，最后入室，表示做学问的几个阶段。“入室”犹如今天的俗语“到家”。我们说，“这个人的学问到家了”，正是表示他的学问极好。"
  },
  {
    "id": 286,
    "title": "先進 11.16",
    "text": "子贡问：“师与商也孰贤？”子曰：“师也过，商也不及。”\n曰：“然则师愈与？”子曰：“过犹不及。”",
    "translation": "译文：子贡问孔子：“颛孙师（子张）和卜商（子夏）两个人，谁强一些？”孔子道：“师呢，有些过分；商呢，有些赶不上。”子贡道：“那么，师强一些吗？”孔子道：“过分和赶不上同样不好。”",
    "annotations": ""
  },
  {
    "id": 287,
    "title": "先進 11.17",
    "text": "季氏富于周公⑴，而求也为之聚敛而附益之⑵。子曰：“非吾徒也。小子鸣鼓而攻之，可也。”",
    "translation": "译文：季氏比周公还有钱，冉求却又替他搜括，增加更多的财富。孔子道：“冉求不是我们的人，你们学生很可以大张旗鼓地来攻击他。”",
    "annotations": "【注释】⑴周公——有两说：（甲）周公旦；（乙）泛指在周天子左右作卿士的人，如周公黑肩、周公阅之类。⑵聚敛而附益之——事实可参阅《左传》哀公十一年和十二年文。季氏要用田赋制度，增加赋税，使冉求征求孔子的意见，孔子则主张“施取其厚，事举其中，敛从其薄”。结果冉求仍旧听从季氏，实行田赋制度。聚敛，《礼记·大学》说：“百乘之家，不畜聚敛之臣。与其有聚敛之臣，宁有盗臣。”可见儒家为了维护统治，反对对人民的过分剥削。其思想渊源或者本于此章。"
  },
  {
    "id": 288,
    "title": "先進 11.18",
    "text": "柴⑴也愚，参也鲁，师也辟⑵，由也喭。",
    "translation": "译文：高柴愚笨，曾参迟钝，颛孙师偏激，仲由卤莽。",
    "annotations": "【注释】⑴柴——高柴，字子羔，孔子学生，比孔子小三十岁（公元前521—？）。⑵辟——音辟，pì。黄式三《论语后案》云：“辟读若《左传》‘阙西辟’之辟，偏也。以其志过高而流于一偏也”。"
  },
  {
    "id": 289,
    "title": "先進 11.19",
    "text": "子曰：“回也其庶⑴乎，屡空⑵。赐不受命⑶，而货殖焉，亿则屡中。 ”",
    "translation": "译文：孔子说：“颜回的学问道德差不多了罢，可是常常穷得没有办法。端木赐不安本分，去囤积投机，猜测行情，竟每每猜对了。”",
    "annotations": "【注释】⑴庶——庶几，差不多。一般用在称赞的场合。⑵空——世俗把“空”字读去声，不但无根据，也无此必要。“贫”和“穷”两字在古代有时有些区别，财货的缺少叫贫，生活无着落，前途无出路叫穷。“空”字却兼有这两方面的意思，所以用“穷得没有办法”来译它。⑶赐不受命——此语古今颇有不同解释，关键在于“命”字的涵义。有把“命”解为“教命”的，则“不受命”为“不率教”，其为错误甚明显。王弼、江熙把“命”解为“爵命”“禄命”，则“不受命”为“不做官”，自然很讲得通，可是子贡并不是不曾做官。《史记·仲尼弟子列传》说他“常相鲁卫”，《货殖列传》又说他“既学于仲尼，退而仕于卫，废着鬻财于曹鲁之间”，则子贡的经商和做官是不相先后的。那么，这一说既不合事实，也就不合孔子原意了。又有人把“命”讲为“天命”（皇《疏》引或说，朱熹《集注》），俞樾《羣经平议》则以为古之经商皆受命于官，“若夫不受命于官而自以其财市贱鬻贵，逐什一之利，是谓不受命而货殖。”两说皆言之成理，而未知孰是，故译文仅以“不安本分”言之。"
  },
  {
    "id": 290,
    "title": "先進 11.20",
    "text": "子张问善人之道。子曰：“不践迹，亦不入于室⑴。”",
    "translation": "译文：子张问怎样才是善人。孔子道：“善人不踩着别人的脚印走，学问道德也难以到家。”",
    "annotations": "【注释】⑴善人——孔子曾三次论到“善人”，这章可和（7.26）（13.11）两章合看。"
  },
  {
    "id": 291,
    "title": "先進 11.21",
    "text": "子曰：“论笃是与⑴，君子者乎？色庄者乎？”",
    "translation": "译文：孔子说：“总是推许言论笃实的人，这种笃实的人是真正的君子呢？\n还是神情上伪装庄重的人呢？”",
    "annotations": "【注释】⑴论笃是与——这是“与论笃”的倒装形式，“是”是帮助倒装之用的词，和“唯你是问”的“是”用法相同。“与”，许也。“论笃”就是“论笃者”的意思。"
  },
  {
    "id": 292,
    "title": "先進 11.22",
    "text": "子路问：“闻斯行诸？”子曰：“有父兄在，如之何其闻斯行之？” 冉有问：“闻斯行诸？”子曰：“闻斯行之。” 公西华曰：“由也问闻斯行诸，子曰，‘有父兄在’，求也问闻斯行诸，子曰，\n‘闻斯行之’。赤也惑，敢问。”子曰：“求也退，故进之；由也兼人⑴，故退之。”",
    "translation": "译文：子路问：“听到就干起来吗？”孔子道：“有爸爸哥哥活着，怎么能听\n到就干起来？” 冉有问：“听到就干起来吗？”孔子道：“听到就干起来。” 公西华道：“仲由问听到就干起来吗，您说‘有爸爸哥哥活着，［不能这样做；］ ’\n冉求问听到就干起来吗，您说‘听到就干起来。’［两个人问题相同，而您的答复相反，］我有些胡涂，大胆地来问问。” 孔子道：“冉求平日做事退缩，所以我给他壮胆；仲由的胆量却有两个人的大，勇于作为，所以我要压压他。”",
    "annotations": "【注释】⑴兼人——孔安国和朱熹都把“兼人”解为“胜人”，但子路虽勇，未必“务在胜尚人”；反不如张敬夫把“兼人”解为“勇为”为适当。"
  },
  {
    "id": 293,
    "title": "先進 11.23",
    "text": "子畏于匡，颜渊后。子曰：“吾以女为死矣。”曰：“子在，回何敢死？”",
    "translation": "译文：孔子在匡被囚禁了之后，颜渊最后才来。孔子道：“我以为你是死了。”颜渊道：“您还活着，我怎么敢死呢？”",
    "annotations": ""
  },
  {
    "id": 294,
    "title": "先進 11.24",
    "text": "季子然⑴问：“仲由、冉求可谓大臣与？”子曰：“吾以子为异之问，曾\n由与求之问。所谓大臣者，以道事君，不可则止。今由与求也，可谓具臣矣⑵。”\n曰：“然则从之者与？”子曰：“弑父与君，亦不从也。”",
    "translation": "译文：季子然问：“仲由和冉求可以说是大臣吗”孔子道：“我以为你是问别的人，竟问由和求呀。我们所说的大臣，他用最合于仁义的内容和方式来对待君主，如果这样行不通，宁肯辞职不干。如今由和求这两个人，可以说是具有相当才能的臣属了。”\n季子然又道：“那么，他们会一切顺从上级吗？”孔子道：“杀父亲、杀君主的事情，他们也不会顺从的。”",
    "annotations": "【注释】⑴季子然——当为季氏的同族之人，《史记·仲尼弟子列传》作“季孙问曰：子路可谓大臣与”，与《论语》稍异。⑵这一章可以和孔子不以仁来许他们的一章（5.8）以及季氏旅泰山冉有不救章（3.6）、季氏伐颛臾冉有子路为他解脱章（16.1）合看。"
  },
  {
    "id": 295,
    "title": "先進 11.25",
    "text": "子路使子羔为费宰。子曰：“贼夫人之子。” 子路曰：“有民人焉，有社禝焉，何必读书，然后为学？” 子曰：“是故恶夫佞者。”",
    "translation": "译文：子路叫子羔去做费县县长。孔子道：“这是害了别人的儿子！” 子路道：“那地方有老百姓，有土地和五谷，为什么定要读书才叫做学问呢？”孔子道：“所以我讨厌强嘴利舌的人。”",
    "annotations": ""
  },
  {
    "id": 296,
    "title": "先進 11.26",
    "text": "子路、曾晳⑴、冉有、公西华侍坐。\n子曰：“以吾一日长乎尔，毋吾以也。居⑵则曰：‘不吾知也！’如或知尔，则何以哉？”\n子路率尔而对曰“千乘之国，摄乎大国之间，加之以师旅，因之以饥馑；由也为之，比⑶及三年，可使有勇，且知方也。” 夫子哂之。\n“求！尔何如？” 对曰：“方六七十⑷，如⑸五六十，求也为之，比⑶及三年，可使足民。如\n其礼乐，以俟君子。” “赤！尔何如？” 对曰：“非曰能之，愿学焉。宗庙之事，如会同，端章甫⑹，愿为小相⑺焉。 ” “点！尔何如？” 鼓瑟希，铿尔，舍瑟而作⑻，对曰：“异乎三子者之撰。” 子曰：“何伤乎？亦各言其志也。” 曰：“莫⑼春者，春服既成⑽，冠者五六人，童子六七人，浴乎沂⑾，风乎\n舞雩⑿，咏而归。” 夫子喟然叹曰：“吾与点也！” 三子者出，曾晳后。曾晳曰：“夫三子者之言何如？” 子曰：“亦各言其志也已矣。” 曰：“夫子何哂由也？” 曰：“为国以礼，其言不让，是故哂之。” “唯⒀求则非邦也与？” “安见方六七十如五六十而非邦也者？” “唯赤则非邦也与？” “宗庙会同，非诸侯而何？赤也为之⒁小，孰能为之⒁大？”",
    "translation": "译文：子路、曾晳、冉有、公西华四个人陪着孔子坐着。孔子说道：“因\n为我比你们年纪都大，［老了，］没有人用我了。你们平日说：‘人家不了解我呀！’假若有人了解你们，［打算请你们出去，］那你们怎么办呢？”\n子路不加思索地答道：“一千辆兵车的国家，局促地处于几个大国的中间，\n外面有军队侵犯它，国内又加以灾荒。我去治理，等到三年光景，可以使人人有勇气，而且懂得大道理。” 孔子微微一笑。 又问：“冉求，你怎么样？” 答道：“国土纵横各六七十里或者五六十里的小国家，我去治理，等到三年光景，可以使人人富足。至于修明礼乐，那只有等待贤人君子了。” 又问：“公西赤！你怎么样？” 答道：“不是说我已经很有本领了，我愿意这样学习：祭祀的工作或者同外国盟会，我愿意穿着礼服，戴着礼帽，做一个小司仪者。” 又问：“曾点！你怎么样？” 他弹瑟正近尾声，铿的一声把瑟放下，站了起来答道：“我的志向和他们三位所讲的不同。” 孔子道：“那有什么妨碍呢？正是要各人说出自己的志向呵！” 曾晳便道：“暮春三月，春天衣服都穿定了，我陪同五六位成年人，六七个小孩，在沂水旁边洗洗澡，在舞雩台上吹吹风，一路唱歌，一路走回来。” 孔子长叹一声道：“我同意曾点的主张呀！”子路、冉有、公西华三人都出来了，曾晳后走。曾晳问道：“那三位同学的话怎样？” 孔子道：“也不过各人说说自己的志向罢了。” 曾晳又道：“您为什么对仲由微笑呢？” 孔子道：“治理国家应该讲求礼让，可是他的话却一点不谦虚，所以笑笑他。 ” “难道冉求所讲的就不是国家吗？” 孔子道：“怎样见得横纵各六七十里或者五六十里的土地就不够是一个国家呢？” “公西赤所讲的不是国家吗？”\n孔子道：“有宗庙，有国际间的盟会，不是国家是什么？［我笑仲由的不是说他不能治理国家，关键不在是不是国家，而是笑他说话的内容和态度不够谦虚。譬如公西赤，他是个十分懂得礼仪的人，但他只说愿意学着做一个小司仪者。］如果他只做一小司仪者，又有谁来做大司仪者呢？”",
    "annotations": "【注释】⑴曾晳——名点，曾参的父亲，也是孔子的学生。⑵居——义与唐、宋人口语“平居”同，平日、平常的意思。⑶比——去声，bì，等到的意思。⑷方六七十——这是古代的土地面积计算方式，“方六七十”不等于“六七十方里”，而是每边长六七十里的意思。⑸如——或者的意思。⑹端章甫——端，古代礼服之名；章甫，古代礼帽之名。“端章甫”为修饰句，在古代可以不用动词。⑺相——去声，名词，赞礼之人。⑻舍瑟而作——作，站起来的意思。曾点答孔子之问站了起来，其它学生也同样站了起来可以推知，不过上文未曾明说罢了。⑼莫——同“暮”。⑽成——定也。《国语·吴语》：“吴晋争长未成”，就是争为盟主而未定的意思。⑾沂——水名，但和大沂河以及流入于大沂河的小沂河都不同。这沂水源出山东邹县东北，西流经曲阜与洙水合，入于泗水。也就是《左传》昭公二十五年“季平子请待于沂上”的“沂”。⑿舞雩——《水经注》：“沂水北对稷门，一名高门，一名雩门。南隔水有雩坛，坛高三丈。卽曾点所欲风处也。”当在今曲阜县南。⒀唯——语首词，无义。⒁之——用法同“其”。"
  },
  {
    "id": 297,
    "title": "先進 11.1",
    "text": "子曰：“先进⑴于礼乐，野人也；后进⑴于礼乐，君子也。如用之，则吾从先进。”",
    "translation": "译文：孔子说：“先学习礼乐而后做官的是未曾有过爵禄的一般人，先有了官位而后学习礼乐的是卿大夫的子弟。如果要我选用人才，我主张选用先学习礼乐的人。”",
    "annotations": "【注释】⑴先进，后进——这两个术语的解释很多，都不恰当。译文本刘宝楠《论语正义》之说而略有取舍。孔子是主张“学而优则仕”的人，对于当时的卿大夫子弟，承袭父兄的庇荫，在做官中去学习的情况可能不满意。《孟子·告子下》引葵丘之会盟约说，“士无世官”，又说，“取士必得”，那么，孔子所谓“先进”一般指“士”。",
    "displayAliasOf": 271
  },
  {
    "id": 298,
    "title": "先進 11.2",
    "text": "子曰：“从我于陈、蔡⑴者，皆不及门⑵也。”",
    "translation": "译文：孔子说：“跟着我在陈国、蔡国之间忍饥受饿的人，都不在我这里了。”",
    "annotations": "【注释】⑴从我于陈、蔡——“从”读去声，zòng。《史记·孔子世家》云：“吴伐陈，楚救陈，军于城父。闻孔子在陈、蔡之间，楚使人聘孔子，孔子将往拜礼。陈、蔡大夫谋曰：‘孔子贤者，所刺讥皆中诸侯之疾，今者久留陈、蔡之间，诸大夫所设行皆非仲尼之意。今楚，大国也，来聘孔子。孔子用于楚，则陈、蔡用事大夫危矣。’乃相与发徒役围孔子于野。不得已，绝粮。从者病，莫能兴。……于是使子贡至楚。楚昭王兴师迎孔子，然后得免。”⑵不及门——汉唐旧解“不及门”为“不及仕进之门”或“不仕于卿大夫之门”，刘宝楠因而傅会孟子的“无上下之交”，解为“孔子弟子无仕陈蔡者”，我则终嫌与文意不甚密合，故不取，而用朱熹之说。郑珍《巢经巢文集》卷二〈驳朱竹垞孔子门人考〉有云：“古之教者家有塾，塾在门堂之左右，施教受业者居焉。所谓‘皆不及门’，及此门也。‘奚为于丘（原作某，由于避讳故，今改）之门’，于此门也。滕更之‘在门’，在此门也，故曰‘愿留而受业于门’（按上两句俱见《孟子》）。”亦见朱熹此说之有据。",
    "displayAliasOf": 272
  },
  {
    "id": 299,
    "title": "先進 11.3",
    "text": "德行：颜渊，闵子骞，冉伯牛，仲弓。言语：宰我，子贡。政事：冉有，季路。文学⑴：子游，子夏。",
    "translation": "译文：［孔子的学生各有所长。］德行好的：颜渊，闵子骞，冉伯牛，仲弓。会说话的：宰我，子贡。能办理政事的：冉有，季路。熟悉古代文献的：子游，子夏。",
    "annotations": "【注释】⑴文学——指古代文献，卽孔子所传的《诗》、《书》、《易》等。皇侃《义疏》引范宁说如此。《后汉书·徐防传》说：“防上疏云：‘经书礼乐，定自孔子；发明章句，始于子夏”。似亦可为证。又这一章和上一章“从我于陈蔡者”不相连。朱熹《四书集注》说这十人卽当在陈、蔡之时随行的人，是错误的。根据《左传》，冉有其时在鲁国为季氏之臣，未必随行。根据《史记·仲尼弟子列传》，当时随行的还有子张，何以这里不说及？根据各种史料，确知孔子在陈绝粮之时为鲁哀公四年，时孔子六十一岁。又据《史记·仲尼弟子列传》，子游小于孔子四十五岁，子夏小于孔子四十四岁，那么，孔子在陈、蔡受困时，子游不过十六岁，子夏不过十七岁，都不算成人。这么年幼的人卽使已经在孔子门下受业，也未必都跟去了。可见这几句话不过是孔子对这十个学生的一时的叙述，由弟子转述下来的记载而已。",
    "displayAliasOf": 273
  },
  {
    "id": 300,
    "title": "先進 11.4",
    "text": "子曰：“回也非助我者也，于吾言无所不说。”",
    "translation": "译文：孔子说：“颜回不是对我有所帮助的人，他对我的话没有不喜欢的。 ”",
    "annotations": "",
    "displayAliasOf": 274
  },
  {
    "id": 301,
    "title": "先進 11.5",
    "text": "子曰：“孝哉闵子骞！人不间于其父母昆弟之言。”",
    "translation": "译文：孔子说：“闵子骞真是孝顺呀，别人对于他爹娘兄弟称赞他的言语并无异议。”",
    "annotations": "",
    "displayAliasOf": 275
  },
  {
    "id": 302,
    "title": "先進 11.6",
    "text": "南容三复白圭⑴，孔子以其兄之子妻之。",
    "translation": "译文：南容把“白圭之玷，尚可磨也；斯言之玷，不可为也”的几句诗读了又读，孔子便把自己的侄女嫁给他。",
    "annotations": "【注释】⑴白圭——白圭的诗四句见于《诗经·大雅·抑篇》，意思是白圭的污点还可以磨掉；我们言语中的污点便没有办法去掉。大概南容是一个谨小慎微的人，所以能做到“邦有道，不废；邦无道，免于刑戮”。（5.2）",
    "displayAliasOf": 276
  },
  {
    "id": 303,
    "title": "先進 11.7",
    "text": "季康子问⑴：“弟子孰为好学？”孔子对曰：“有颜回者好学，不幸短命死矣，今也则亡。”",
    "translation": "译文：季康子问道：“你学生中谁用功？”孔子答道：“有一个叫颜回的用功，不幸短命死了，现在就再没有这样的人了。”",
    "annotations": "【注释】⑴季康子问——鲁哀公曾经也有此问（6.3），孔子的回答较为详细。有人说，从此可见孔子与鲁君的问答和与季氏的问答有繁简之不同。",
    "displayAliasOf": 277
  },
  {
    "id": 304,
    "title": "先進 11.8",
    "text": "颜渊死，颜路⑴请子之车以为之⑵椁⑶。子曰：“才不才，亦各言其子也。鲤⑷也死，有棺而无椁。吾不徒行以为之椁。以吾从大夫之后⑸，不可徒行也。”",
    "translation": "译文：颜渊死了，他父亲颜路请求孔子卖掉车子来替颜渊办外椁。孔子道：“不管有才能或者没有才能，但总是自己的儿子。我的儿子鲤死了，也只有内棺，没有外椁。我不能［卖掉车子］步行来替他买椁。因为我也曾做过大夫，是不可以步行的。”",
    "annotations": "【注释】⑴颜路——颜回的父亲，据《史记·仲尼弟子列传》，名无繇，字路，也是孔子学生。⑵之——用法同“其”。⑶椁——也作“椁”，音果，guǒ。古代大官棺木至少用两重，里面的一重叫棺，外面又一重大的叫椁，平常我们说“内棺外椁”就是这个意思。⑷鲤也死——鲤，字伯鱼，年五十死，那时孔子年七十。⑹从大夫之后——孔子在鲁国曾经做过司寇的官，是大夫之位。不过此时孔子已经去位多年。他不说“我曾为大夫”，而说“吾从大夫之后”（在大夫行列之后随行的意思）只是一种谦逊的口气罢了。",
    "displayAliasOf": 278
  },
  {
    "id": 305,
    "title": "先進 11.9",
    "text": "颜渊死。子曰：“噫！天丧予！天丧予⑴！”",
    "translation": "译文：颜渊死了，孔子道：“咳！天老爷要我的命呀！天老爷要我的命呀！ ”",
    "annotations": "【注释】⑴天丧予——译文只就字面译出。",
    "displayAliasOf": 279
  },
  {
    "id": 306,
    "title": "先進 11.10",
    "text": "颜渊死，子哭之恸⑴。从者曰：“子恸矣！”曰：“有恸乎？非夫人之为恸⑵而谁为？”",
    "translation": "译文：颜渊死了，孔子哭得很伤心。跟着孔子的人道：“您太伤心了！”孔子道：“真的太伤心了吗？我不为这样的人伤心，还为什么人伤心呢！”",
    "annotations": "【注释】⑴恸——郑注：“恸，变动容貌”。马融注：“恸，哀过也”。译文从马。⑵非夫人之为恸而谁为——“非夫人之为恸”是“非为夫人恸”的倒装形式。“夫人”的“夫”读阳平，音扶，指示形容词，“那”的意思。“之为”的“之”是专作帮助倒装用的，无实际意义。这一整句下文的“谁为”，依现代汉语的格式说也是倒装，不过在古代，如果介词或者动词的宾语是疑问代词，一般都放在介词或者动词之上。",
    "displayAliasOf": 280
  },
  {
    "id": 307,
    "title": "先進 11.11",
    "text": "颜渊死，门人欲厚葬⑴之。子曰：“不可。”门人厚葬之。子曰：“回也视予犹父也，予不得视犹子也。非我也，夫二三子也。”",
    "translation": "译文：颜渊死了，孔子的学生们想要很丰厚地埋葬他。孔子道：“不可以。 ”学生们仍然很丰厚地埋葬了他。孔子道：“颜回呀，你看待我好像看待父亲，我却不能够像对待儿子一般地看待你。这不是我的主意呀，是你那班同学干的呀。 ”",
    "annotations": "【注释】⑴厚葬——根据《檀弓》所记载孔子的话，丧葬应该“称家之有亡，有，毋过礼。苟亡矣，敛首足形，还葬，县棺而封。”颜子家中本穷，而用厚葬，从孔子看来，是不应该的。孔子的叹，实是责备那些主持厚葬的学生。",
    "displayAliasOf": 281
  },
  {
    "id": 308,
    "title": "先進 11.12",
    "text": "季路问事鬼神。子曰：“未能事人，焉能事鬼？”\n曰：“敢⑴问死。”曰：“未知生，焉知死？”",
    "translation": "译文：子路问服事鬼神的方法。孔子道：“活人还不能服事，怎么能去服事死人？”\n子路又道：“我大胆地请问死是怎么回事。”孔子道：“生的道理还没有弄明白，怎么能够懂得死？”",
    "annotations": "【注释】⑴敢——表敬副词，无实际意义。《仪礼·士虞礼》郑玄注云：“敢，冒昧之词。”贾公彦疏云：“凡言‘敢’者，皆是以卑触尊不自明之意。”",
    "displayAliasOf": 282
  },
  {
    "id": 309,
    "title": "先進 11.13",
    "text": "闵子侍侧，誾誾如也；子路，行行⑴如也；冉有、子贡，侃侃如也。子乐。“若由也，不得其死然⑵。”",
    "translation": "译文：闵子骞站在孔子身旁，恭敬而正直的样子；子路很刚强的样子；冉有、子贡温和而快乐的样子。孔子高兴起来了。［不过，又道：］“像仲由吧，怕得不到好死。”",
    "annotations": "【注释】⑴行行——旧读去声，hàng。⑵不得其死然——得死，当时俗语，谓得善终。《左传》僖公十九年“得死为幸”；哀公十六年“得死，乃非我”。然，语气词，用法同“焉”。",
    "displayAliasOf": 283
  },
  {
    "id": 310,
    "title": "先進 11.14",
    "text": "鲁人⑴为长府。闵子骞曰：“仍旧贯，如之何？何必改作？”子曰：“夫人不言，言必有中。”",
    "translation": "译文：鲁国翻修叫长府的金库。闵子骞道：“照着老样子下去怎么样？为什么一定要翻造呢？”孔子道：“这个人平日不大开口，一开口一定中肯。”",
    "annotations": "【注释】⑴鲁人——“鲁人”的“人”指其国的执政大臣而言。此“人”和“民”的区别。",
    "displayAliasOf": 284
  },
  {
    "id": 311,
    "title": "先進 11.15",
    "text": "子曰：“由之瑟⑴奚为于丘之门？”门人不敬子路。子曰：“由也升堂矣，未入于室⑵也。”",
    "translation": "译文：孔子道：“仲由弹瑟，为什么在我这里来弹呢？”因此孔子的学生们瞧不起子路。孔子道：“由么，学问已经不错了，只是还不够精深罢了。”",
    "annotations": "【注释】⑴瑟——音涩，sè，古代的乐器，和琴同类。这里孔子不是不高兴子路弹瑟，而是不高兴他所弹的音调。《说苑·修文篇》对这段文字曾有所发挥。⑵升堂入室——这是比喻话。“堂”是正厅，“室”是内室。先入门，次升堂，最后入室，表示做学问的几个阶段。“入室”犹如今天的俗语“到家”。我们说，“这个人的学问到家了”，正是表示他的学问极好。",
    "displayAliasOf": 285
  },
  {
    "id": 312,
    "title": "先進 11.16",
    "text": "子贡问：“师与商也孰贤？”子曰：“师也过，商也不及。”\n曰：“然则师愈与？”子曰：“过犹不及。”",
    "translation": "译文：子贡问孔子：“颛孙师（子张）和卜商（子夏）两个人，谁强一些？”孔子道：“师呢，有些过分；商呢，有些赶不上。”子贡道：“那么，师强一些吗？”孔子道：“过分和赶不上同样不好。”",
    "annotations": "",
    "displayAliasOf": 286
  },
  {
    "id": 313,
    "title": "先進 11.17",
    "text": "季氏富于周公⑴，而求也为之聚敛而附益之⑵。子曰：“非吾徒也。小子鸣鼓而攻之，可也。”",
    "translation": "译文：季氏比周公还有钱，冉求却又替他搜括，增加更多的财富。孔子道：“冉求不是我们的人，你们学生很可以大张旗鼓地来攻击他。”",
    "annotations": "【注释】⑴周公——有两说：（甲）周公旦；（乙）泛指在周天子左右作卿士的人，如周公黑肩、周公阅之类。⑵聚敛而附益之——事实可参阅《左传》哀公十一年和十二年文。季氏要用田赋制度，增加赋税，使冉求征求孔子的意见，孔子则主张“施取其厚，事举其中，敛从其薄”。结果冉求仍旧听从季氏，实行田赋制度。聚敛，《礼记·大学》说：“百乘之家，不畜聚敛之臣。与其有聚敛之臣，宁有盗臣。”可见儒家为了维护统治，反对对人民的过分剥削。其思想渊源或者本于此章。",
    "displayAliasOf": 287
  },
  {
    "id": 314,
    "title": "先進 11.18",
    "text": "柴⑴也愚，参也鲁，师也辟⑵，由也喭。",
    "translation": "译文：高柴愚笨，曾参迟钝，颛孙师偏激，仲由卤莽。",
    "annotations": "【注释】⑴柴——高柴，字子羔，孔子学生，比孔子小三十岁（公元前521—？）。⑵辟——音辟，pì。黄式三《论语后案》云：“辟读若《左传》‘阙西辟’之辟，偏也。以其志过高而流于一偏也”。",
    "displayAliasOf": 288
  },
  {
    "id": 315,
    "title": "先進 11.19",
    "text": "子曰：“回也其庶⑴乎，屡空⑵。赐不受命⑶，而货殖焉，亿则屡中。 ”",
    "translation": "译文：孔子说：“颜回的学问道德差不多了罢，可是常常穷得没有办法。端木赐不安本分，去囤积投机，猜测行情，竟每每猜对了。”",
    "annotations": "【注释】⑴庶——庶几，差不多。一般用在称赞的场合。⑵空——世俗把“空”字读去声，不但无根据，也无此必要。“贫”和“穷”两字在古代有时有些区别，财货的缺少叫贫，生活无着落，前途无出路叫穷。“空”字却兼有这两方面的意思，所以用“穷得没有办法”来译它。⑶赐不受命——此语古今颇有不同解释，关键在于“命”字的涵义。有把“命”解为“教命”的，则“不受命”为“不率教”，其为错误甚明显。王弼、江熙把“命”解为“爵命”“禄命”，则“不受命”为“不做官”，自然很讲得通，可是子贡并不是不曾做官。《史记·仲尼弟子列传》说他“常相鲁卫”，《货殖列传》又说他“既学于仲尼，退而仕于卫，废着鬻财于曹鲁之间”，则子贡的经商和做官是不相先后的。那么，这一说既不合事实，也就不合孔子原意了。又有人把“命”讲为“天命”（皇《疏》引或说，朱熹《集注》），俞樾《羣经平议》则以为古之经商皆受命于官，“若夫不受命于官而自以其财市贱鬻贵，逐什一之利，是谓不受命而货殖。”两说皆言之成理，而未知孰是，故译文仅以“不安本分”言之。",
    "displayAliasOf": 289
  },
  {
    "id": 316,
    "title": "先進 11.20",
    "text": "子张问善人之道。子曰：“不践迹，亦不入于室⑴。”",
    "translation": "译文：子张问怎样才是善人。孔子道：“善人不踩着别人的脚印走，学问道德也难以到家。”",
    "annotations": "【注释】⑴善人——孔子曾三次论到“善人”，这章可和（7.26）（13.11）两章合看。",
    "displayAliasOf": 290
  },
  {
    "id": 317,
    "title": "先進 11.21",
    "text": "子曰：“论笃是与⑴，君子者乎？色庄者乎？”",
    "translation": "译文：孔子说：“总是推许言论笃实的人，这种笃实的人是真正的君子呢？\n还是神情上伪装庄重的人呢？”",
    "annotations": "【注释】⑴论笃是与——这是“与论笃”的倒装形式，“是”是帮助倒装之用的词，和“唯你是问”的“是”用法相同。“与”，许也。“论笃”就是“论笃者”的意思。",
    "displayAliasOf": 291
  },
  {
    "id": 318,
    "title": "先進 11.22",
    "text": "子路问：“闻斯行诸？”子曰：“有父兄在，如之何其闻斯行之？” 冉有问：“闻斯行诸？”子曰：“闻斯行之。” 公西华曰：“由也问闻斯行诸，子曰，‘有父兄在’，求也问闻斯行诸，子曰，\n‘闻斯行之’。赤也惑，敢问。”子曰：“求也退，故进之；由也兼人⑴，故退之。”",
    "translation": "译文：子路问：“听到就干起来吗？”孔子道：“有爸爸哥哥活着，怎么能听\n到就干起来？” 冉有问：“听到就干起来吗？”孔子道：“听到就干起来。” 公西华道：“仲由问听到就干起来吗，您说‘有爸爸哥哥活着，［不能这样做；］ ’\n冉求问听到就干起来吗，您说‘听到就干起来。’［两个人问题相同，而您的答复相反，］我有些胡涂，大胆地来问问。” 孔子道：“冉求平日做事退缩，所以我给他壮胆；仲由的胆量却有两个人的大，勇于作为，所以我要压压他。”",
    "annotations": "【注释】⑴兼人——孔安国和朱熹都把“兼人”解为“胜人”，但子路虽勇，未必“务在胜尚人”；反不如张敬夫把“兼人”解为“勇为”为适当。",
    "displayAliasOf": 292
  },
  {
    "id": 319,
    "title": "先進 11.23",
    "text": "子畏于匡，颜渊后。子曰：“吾以女为死矣。”曰：“子在，回何敢死？”",
    "translation": "译文：孔子在匡被囚禁了之后，颜渊最后才来。孔子道：“我以为你是死了。”颜渊道：“您还活着，我怎么敢死呢？”",
    "annotations": "",
    "displayAliasOf": 293
  },
  {
    "id": 320,
    "title": "先進 11.24",
    "text": "季子然⑴问：“仲由、冉求可谓大臣与？”子曰：“吾以子为异之问，曾\n由与求之问。所谓大臣者，以道事君，不可则止。今由与求也，可谓具臣矣⑵。”\n曰：“然则从之者与？”子曰：“弑父与君，亦不从也。”",
    "translation": "译文：季子然问：“仲由和冉求可以说是大臣吗”孔子道：“我以为你是问别的人，竟问由和求呀。我们所说的大臣，他用最合于仁义的内容和方式来对待君主，如果这样行不通，宁肯辞职不干。如今由和求这两个人，可以说是具有相当才能的臣属了。”\n季子然又道：“那么，他们会一切顺从上级吗？”孔子道：“杀父亲、杀君主的事情，他们也不会顺从的。”",
    "annotations": "【注释】⑴季子然——当为季氏的同族之人，《史记·仲尼弟子列传》作“季孙问曰：子路可谓大臣与”，与《论语》稍异。⑵这一章可以和孔子不以仁来许他们的一章（5.8）以及季氏旅泰山冉有不救章（3.6）、季氏伐颛臾冉有子路为他解脱章（16.1）合看。",
    "displayAliasOf": 294
  },
  {
    "id": 321,
    "title": "先進 11.25",
    "text": "子路使子羔为费宰。子曰：“贼夫人之子。” 子路曰：“有民人焉，有社禝焉，何必读书，然后为学？” 子曰：“是故恶夫佞者。”",
    "translation": "译文：子路叫子羔去做费县县长。孔子道：“这是害了别人的儿子！” 子路道：“那地方有老百姓，有土地和五谷，为什么定要读书才叫做学问呢？”孔子道：“所以我讨厌强嘴利舌的人。”",
    "annotations": "",
    "displayAliasOf": 295
  },
  {
    "id": 322,
    "title": "先進 11.26",
    "text": "子路、曾晳⑴、冉有、公西华侍坐。\n子曰：“以吾一日长乎尔，毋吾以也。居⑵则曰：‘不吾知也！’如或知尔，则何以哉？”\n子路率尔而对曰“千乘之国，摄乎大国之间，加之以师旅，因之以饥馑；由也为之，比⑶及三年，可使有勇，且知方也。” 夫子哂之。\n“求！尔何如？” 对曰：“方六七十⑷，如⑸五六十，求也为之，比⑶及三年，可使足民。如\n其礼乐，以俟君子。” “赤！尔何如？” 对曰：“非曰能之，愿学焉。宗庙之事，如会同，端章甫⑹，愿为小相⑺焉。 ” “点！尔何如？” 鼓瑟希，铿尔，舍瑟而作⑻，对曰：“异乎三子者之撰。” 子曰：“何伤乎？亦各言其志也。” 曰：“莫⑼春者，春服既成⑽，冠者五六人，童子六七人，浴乎沂⑾，风乎\n舞雩⑿，咏而归。” 夫子喟然叹曰：“吾与点也！” 三子者出，曾晳后。曾晳曰：“夫三子者之言何如？” 子曰：“亦各言其志也已矣。” 曰：“夫子何哂由也？” 曰：“为国以礼，其言不让，是故哂之。” “唯⒀求则非邦也与？” “安见方六七十如五六十而非邦也者？” “唯赤则非邦也与？” “宗庙会同，非诸侯而何？赤也为之⒁小，孰能为之⒁大？”",
    "translation": "译文：子路、曾晳、冉有、公西华四个人陪着孔子坐着。孔子说道：“因\n为我比你们年纪都大，［老了，］没有人用我了。你们平日说：‘人家不了解我呀！’假若有人了解你们，［打算请你们出去，］那你们怎么办呢？”\n子路不加思索地答道：“一千辆兵车的国家，局促地处于几个大国的中间，\n外面有军队侵犯它，国内又加以灾荒。我去治理，等到三年光景，可以使人人有勇气，而且懂得大道理。” 孔子微微一笑。 又问：“冉求，你怎么样？” 答道：“国土纵横各六七十里或者五六十里的小国家，我去治理，等到三年光景，可以使人人富足。至于修明礼乐，那只有等待贤人君子了。” 又问：“公西赤！你怎么样？” 答道：“不是说我已经很有本领了，我愿意这样学习：祭祀的工作或者同外国盟会，我愿意穿着礼服，戴着礼帽，做一个小司仪者。” 又问：“曾点！你怎么样？” 他弹瑟正近尾声，铿的一声把瑟放下，站了起来答道：“我的志向和他们三位所讲的不同。” 孔子道：“那有什么妨碍呢？正是要各人说出自己的志向呵！” 曾晳便道：“暮春三月，春天衣服都穿定了，我陪同五六位成年人，六七个小孩，在沂水旁边洗洗澡，在舞雩台上吹吹风，一路唱歌，一路走回来。” 孔子长叹一声道：“我同意曾点的主张呀！”子路、冉有、公西华三人都出来了，曾晳后走。曾晳问道：“那三位同学的话怎样？” 孔子道：“也不过各人说说自己的志向罢了。” 曾晳又道：“您为什么对仲由微笑呢？” 孔子道：“治理国家应该讲求礼让，可是他的话却一点不谦虚，所以笑笑他。 ” “难道冉求所讲的就不是国家吗？” 孔子道：“怎样见得横纵各六七十里或者五六十里的土地就不够是一个国家呢？” “公西赤所讲的不是国家吗？”\n孔子道：“有宗庙，有国际间的盟会，不是国家是什么？［我笑仲由的不是说他不能治理国家，关键不在是不是国家，而是笑他说话的内容和态度不够谦虚。譬如公西赤，他是个十分懂得礼仪的人，但他只说愿意学着做一个小司仪者。］如果他只做一小司仪者，又有谁来做大司仪者呢？”",
    "annotations": "【注释】⑴曾晳——名点，曾参的父亲，也是孔子的学生。⑵居——义与唐、宋人口语“平居”同，平日、平常的意思。⑶比——去声，bì，等到的意思。⑷方六七十——这是古代的土地面积计算方式，“方六七十”不等于“六七十方里”，而是每边长六七十里的意思。⑸如——或者的意思。⑹端章甫——端，古代礼服之名；章甫，古代礼帽之名。“端章甫”为修饰句，在古代可以不用动词。⑺相——去声，名词，赞礼之人。⑻舍瑟而作——作，站起来的意思。曾点答孔子之问站了起来，其它学生也同样站了起来可以推知，不过上文未曾明说罢了。⑼莫——同“暮”。⑽成——定也。《国语·吴语》：“吴晋争长未成”，就是争为盟主而未定的意思。⑾沂——水名，但和大沂河以及流入于大沂河的小沂河都不同。这沂水源出山东邹县东北，西流经曲阜与洙水合，入于泗水。也就是《左传》昭公二十五年“季平子请待于沂上”的“沂”。⑿舞雩——《水经注》：“沂水北对稷门，一名高门，一名雩门。南隔水有雩坛，坛高三丈。卽曾点所欲风处也。”当在今曲阜县南。⒀唯——语首词，无义。⒁之——用法同“其”。",
    "displayAliasOf": 296
  },
  {
    "id": 323,
    "title": "顏淵 12.1",
    "text": "颜渊问仁。子曰：“克己复礼为仁⑴。一日克己复礼，天下归仁⑵焉。为仁由己，而由人乎哉？”\n颜渊曰：“请问其目。”子曰：“非礼勿视，非礼勿听，非礼勿言，非礼勿动。”\n颜渊曰：“回虽不敏，请事斯语矣。”",
    "translation": "颜渊问仁德。孔子道：“抑制自己，使言语行动都合于礼，就是仁。一旦这样做到了，天下的人都会称许你是仁人。实践仁德，全凭自己，还凭别人吗？”\n颜渊道：“请问行动的纲领。”孔子道：“不合礼的事不看，不合礼的话不听，不合礼的话不说，不合礼的事不做。”\n颜渊道：“我虽然迟钝，也要实行您这话。”",
    "annotations": "【注释】⑴克己复礼——《左传》昭公十二年说：“仲尼曰：‘古也有志：克己复礼，仁也。’”那么，“克己复礼为仁”是孔子用前人的话赋予新的含义。⑵归仁——“称仁”的意思，说见毛奇龄《论语稽求篇》。朱熹《集注》谓“归，犹与也”，也是此意。"
  },
  {
    "id": 324,
    "title": "顏淵 12.2",
    "text": "仲弓问仁。子曰：“出门如见大宾，使民如承大祭。己所不欲，勿施于人。在邦无怨，在家⑴无怨。”\n仲弓曰：“雍虽不敏，请事斯语矣。”",
    "translation": "仲弓问仁德。孔子道：“出门［工作］好像去接待贵宾，役使百姓好像去承当大祀典，［都得严肃认真，小心谨慎。］自己所不喜欢的事物，就不强加于别人。在工作岗位上不对工作有怨恨，就是不在工作岗位上也没有怨恨。 ”\n仲弓道：“我虽然迟钝，也要实行您这话。”",
    "annotations": "【注释】⑴在家——刘宝楠《论语正义》说：“在邦谓仕于诸侯之邦，在家谓仕于卿大夫之家也。”把“家”字拘泥于“大夫曰家”的一个意义，不妥当。"
  },
  {
    "id": 325,
    "title": "顏淵 12.3",
    "text": "司马牛⑴问仁。子曰：“仁者，其言也讱。”\n曰：“其言也讱，斯谓之仁已乎？”子曰：“为之难，言之得无讱乎？”",
    "translation": "司马牛问仁德。孔子道：“仁人，他的言语迟钝。”\n司马牛道：“言语迟钝，造就叫做仁了吗？”孔子道：“做起来不容易，说话能够不迟钝吗？”",
    "annotations": "【注释】⑴司马牛——《史记·仲尼弟子列传》云：“司马耕，字子牛。牛多言而躁，问仁于孔子。孔子曰：‘仁者其言也讱。’”根据司马迁的这一说法，孔子的答语是针对问者“多言而躁”的缺点而说的。"
  },
  {
    "id": 326,
    "title": "顏淵 12.4",
    "text": "司马牛问君子。子曰：“君子不忧不惧。”\n曰：“不忧不惧，斯谓之君子已乎？”子曰：“内省不疚，夫何忧何惧？”",
    "translation": "司马牛问怎样去做一个君子。孔子道：“君子不忧愁，不恐惧。”司马牛道：“不忧愁，不恐惧，这样就可以叫做君子了吗？”孔子道：“自己问心无愧，那有什么可以忧愁和恐惧的呢？”",
    "annotations": "【注释】"
  },
  {
    "id": 327,
    "title": "顏淵 12.5",
    "text": "司马牛忧曰：“人皆有兄弟，我独亡⑴。”子夏曰：“商闻之矣：死生有命，富贵在天。君子敬而无失，与人恭而有礼。四海之内，皆兄弟也——君子何患乎无兄弟也？”",
    "translation": "司马牛忧愁地说道：“别人都有好兄弟，单单我没有。”子夏道：“我听说过：死生听之命运，富贵由天安排。君子只是对待工作严肃认真，不出差错，对待别人词色恭谨，合乎礼节，天下之大，到处都是好兄弟——君子又何必着急没有好兄弟呢？”",
    "annotations": "【注释】⑴人皆有兄弟，我独亡——自来的注释家都说这个司马牛就是宋国桓魋的兄弟。桓魋为人很坏，结果是谋反失败，他的几个兄弟也都跟着失败了。其中只有司马牛不赞同他这些兄弟的行为。但结果也是逃亡在外，死于道路（事见《左传》哀公十四年）。译文姑且根据这种说法。但我却认为，孔子的学生司马牛和宋国桓魋的弟弟司马牛可能是两个不同的人，难于混为一谈。第一，《史记·仲尼弟子列传》既不说这一个司马牛是宋人，更没有把《左传》上司马牛的事情记载上去，太史公如果看到了这类史料而不采取，可见他是把两个司马牛作不同的人看待的。第二，说《论语》的司马牛就是《左传》的司马牛者始于孔安国。孔安国又说司马牛名犂，又和《史记·仲尼弟子列传》说司马牛名耕的不同。如果孔安国之言有所本，那么，原本就有两个司马牛，一个名耕，孔子弟子；一个名犂，桓魋之弟。但自孔安国以后的若干人却误把名犂的也当作孔子学生了。姑识于此，以供参考。"
  },
  {
    "id": 328,
    "title": "顏淵 12.6",
    "text": "子张问明。子曰：“浸润之谮，肤受之愬，不行焉，可谓明也已矣。浸润之谮，肤受之愬，不行焉，可谓远也已矣。”",
    "translation": "子张问怎样才叫做见事明白。孔子道：“点滴而来，日积月累的谗\n言和肌肤所受、急迫切身的诬告都在你这里行不通，那你可以说是看得明白的了。点滴而来，日积月累的谗言和肌肤所受、急迫切身的诬告也都在你这里行不通，那你可以说是看得远的了。”",
    "annotations": ""
  },
  {
    "id": 329,
    "title": "顏淵 12.7",
    "text": "子贡问政。子曰：“足食，足兵⑴，民信之矣。”\n子贡曰：“必不得已而去，于斯三者何先？”曰：“去兵。”\n子贡曰：“必不得已而去，于斯二者何先？”曰：“去食。自古皆有死，民无信不立。”",
    "translation": "子贡问怎样去治理政事。孔子道：“充足粮食，充足军备，百姓对政府就有信心了。”\n子贡道：“如果迫于不得已，在粮食、军备和人民的信心三者之中一定要去掉一项，先去掉哪一项？”孔子道：“去掉军备。”\n子贡道：“如果迫于不得已，在粮食和人民的信心两者之中一定要去掉一项，先去掉哪一项？”孔子道：“去掉粮食。［没有粮食，不过死亡，但］自古以来谁都免不了死亡。如果人民对政府缺乏信心，国家是站不起来的。”",
    "annotations": "【注释】⑴兵——在五经和《论语》、《孟子》中，“兵”字多指兵器而言，但也偶有解作兵士的。如《左传》隐公四年“诸侯之师败郑徒兵”，襄公元年“败其徒兵于洧上”。顾炎武、阎若璩都以为五经中的“兵”字无作士兵解者，恐未谛（刘宝楠说）。但此“兵”字仍以解为军器为宜，故以军备译之。"
  },
  {
    "id": 330,
    "title": "顏淵 12.8",
    "text": "棘子成⑴曰：“君子质而已矣，何以文为？”子贡曰：“惜乎，夫子之说君子也⑵！驷不及舌。文犹质也，质犹文也。虎豹之鞟犹犬羊之鞟。”",
    "translation": "棘子成道：“君子只要有好的本质便够了，要那些文彩［那些仪节、那些形式］干什么？”子贡道：“先生这样地谈论君子，可惜说错了。一言既出，驷马难追。本质和文彩，是同等重要的。假若把虎豹和犬羊两类兽皮拔去有文彩的毛，那这两类皮革就很少区别了。”",
    "annotations": "【注释】⑴棘子成——卫国大夫。古代大夫都可以被尊称为“夫子”，所以子\n贡这样称呼他。⑵惜乎夫子之说君子也——朱熹《集注》把它作两句读：“惜乎！夫子之说，君子也。”便应该这样翻译：“先生的话，是出自君子之口，可惜说错了。”我则以为“夫子之说君子也”为主语，“惜乎”为谓语，此为倒装句。"
  },
  {
    "id": 331,
    "title": "顏淵 12.9",
    "text": "哀公问于有若曰：“年饥，用不足，如之何？”\n有若对曰：“盍彻乎？”\n曰：“二，吾犹不足，如之何其彻也？”\n对曰：“百姓足，君孰与不足？百姓不足，君孰与足？”",
    "translation": "鲁哀公向有若问道：“年成不好，国家用度不够，应该怎么办？”\n有若答道：“为什么不实行十分抽一的税率呢？”\n哀公道：“十分抽二，我还不够，怎么能十分抽一呢？”\n答道：“如果百姓的用度够，您怎么会不够？如果百姓的用度不够，您又怎\n么会够？”",
    "annotations": ""
  },
  {
    "id": 332,
    "title": "顏淵 12.10",
    "text": "子张问崇德辨惑。子曰：“主忠信，徙义，崇德也。爱之欲其生，恶之欲其死。既欲其生，又欲其死，是惑也。‘诚不以富，亦祗以异⑴。’”",
    "translation": "子张问如何去提高品德，辨别迷惑。孔子道：“以忠诚信实为主，唯义是从，这就可以提高品德。爱一个人，希望他长寿；厌恶起来，恨不得他马上死去。既要他长寿，又要他短命，这便是迷惑。这样，的确对自己毫无好处，只是使人奇怪罢了。”",
    "annotations": "【注释】⑴诚不以富，亦祗以异——《诗经·小雅·我行其野篇》诗句，引在这里，很难解释。程颐说是“错简”（别章的文句，因为书页次序错了，误在此处），但无证据。我这里姑且依朱熹《集注》的解释而意译之。"
  },
  {
    "id": 333,
    "title": "顏淵 12.11",
    "text": "齐景公问政于孔子。孔子对曰：“君君，臣臣，父父，子子。”公曰：“善\n哉！信如君不君，臣不臣，父不父，子不子，虽有粟，吾得而食诸？”",
    "translation": "齐景公向孔子问政治。孔子答道：“君要像个君，臣要像个臣，父亲要像父亲，儿子要像儿子。”景公道：“对呀！若是君不像君，臣不像臣，父不像父，子不像子，卽使粮食很多，我能吃得着吗？”",
    "annotations": ""
  },
  {
    "id": 334,
    "title": "顏淵 12.12",
    "text": "子曰：“片言可以折狱⑴者，其由也与？”\n子路无宿诺⑵。",
    "translation": "孔子说：“根据一方面的语言就可以判决案件的，大概只有仲由吧！ ”\n子路从不拖延诺言。",
    "annotations": "【注释】⑴片言折狱——“片言”古人也叫做“单辞”。打官司一定有原告和被告两方面的人，叫做两造。自古迄今从没有只根据一造的言辞来判决案件的（除掉被告缺席裁判）。孔子说子路“片言可以折狱”，不过表示他的为人诚实直率，别人不愿欺他罢了。⑵子路无宿诺——这句话与上文有什么逻辑关系，从来没有人说得明白（焦循《论语补疏》的解释也不可信）。唐陆德明《经典释文》云：“或分此为别章。”"
  },
  {
    "id": 335,
    "title": "顏淵 12.13",
    "text": "子曰：“听讼⑴，吾犹人也。必也使无讼乎！”",
    "translation": "孔子说：“审理诉讼，我同别人差不多。一定要使诉讼的事件完全消灭才好。”",
    "annotations": "【注释】⑴听讼——据《史记·孔子世家》，孔子在鲁定公时，曾为大司寇，司寇为治理刑事的官，孔子这话或许是刚作司寇时所说。"
  },
  {
    "id": 336,
    "title": "顏淵 12.14",
    "text": "子张问政。子曰：“居之无倦，行之以忠。”",
    "translation": "子张问政治。孔子道：“在位不要疲倦懈怠，执行政令要忠心。”",
    "annotations": ""
  },
  {
    "id": 337,
    "title": "顏淵 12.15",
    "text": "子曰：“博学于文，约之以礼，亦可以弗畔矣夫！”",
    "translation": "【注释】⑴见雍也篇第六。",
    "annotations": "【注释】⑴见雍也篇第六。"
  },
  {
    "id": 338,
    "title": "顏淵 12.16",
    "text": "子曰：“君子成人之美，不成人之恶。小人反是。”",
    "translation": "孔子说：“君子成全别人的好事，不促成别人的坏事。小人却和这相反。”",
    "annotations": ""
  },
  {
    "id": 339,
    "title": "顏淵 12.17",
    "text": "季康子问政于孔子。孔子对曰：”政者，正也。子帅以正，孰敢不正？”",
    "translation": "季康子向孔子问政治。孔子答道：“政字的意思就是端正。您自己带头端正，谁敢不端正呢？”",
    "annotations": ""
  },
  {
    "id": 340,
    "title": "顏淵 12.18",
    "text": "季康子患盗，问于孔子。孔子对曰：“苟子之不欲，虽赏之不窃。”",
    "translation": "季康子苦于盗贼太多，向孔子求教。孔子答道：“假若您不贪求太多的财货，就是奖励偷抢，他们也不会干。”",
    "annotations": ""
  },
  {
    "id": 341,
    "title": "顏淵 12.19",
    "text": "季康子⑴问政于孔子曰：“如杀无道，以就有道何如？”孔子对曰：“子为政，焉用杀？子欲善而民善矣。君子之德风，小人之德草。草上之风，必偃。”",
    "translation": "季康子向孔子请教政治，说道：“假若杀掉坏人来亲近好人，怎么样？”孔子答道：“您治理政治，为什么要杀戮？您想把国家搞好，百姓就会好起来。领导人的作风好比风，老百姓的作风好比草，风向哪边吹，草向哪边倒。”",
    "annotations": "【注释】⑴季康子——根据《春秋》以及《左传》，季孙斯（桓子）死于哀公三年秋七月，季孙肥（康子）随卽袭位。则以上三章季康子之问，当在鲁哀公三年七月以后。"
  },
  {
    "id": 342,
    "title": "顏淵 12.20",
    "text": "子张问：“士何如斯可谓之达矣？”子曰：“何哉，尔所谓达者？”子张对\n曰：“在邦必闻，在家必闻。”子曰：“是闻也，非达也。夫达也者，质直而好义，察言",
    "translation": "子张问：“读书人要怎样做才可以叫达？”孔子道：“你所说的达是什么意思？”子张答道：“做国家的官时一定有名望，在大夫家工作时一定有名望。 ”孔子道：“这个叫闻，不叫达。怎样才是达呢？质量正直，遇事讲理，善于分析别人的言语，观察别人的颜色，从思想上愿意对别人退让。这种人，做国家的官时固然事事行得通，在大夫家一定事事行得通。至于闻，表面上似乎爱好仁德，实际行为却不如此，可是自己竟以仁人自居而不加疑惑。这种人，做官的时候一定会骗取名望，居家的时候也一定会骗取名望。”",
    "annotations": ""
  },
  {
    "id": 343,
    "title": "顏淵 12.21",
    "text": "樊迟从游于舞雩之下，曰：“敢问崇德，修慝，辨惑。”子曰：“善哉问！先事后得，非崇德与？攻其恶，无攻人之恶，非修慝与？一朝之忿，忘其身，以及其亲，非惑与？”",
    "translation": "樊迟陪侍孔子在舞雩台下游逛，说道：“请问怎样提高自己的品德，怎样消除别人对自己不露面的怨恨，怎样辨别出哪种是胡涂事。”孔子道：“问得好！首先付出劳动，然后收获，不是提高品德了吗？批判自己的坏处，不去批判别人的坏处，不就消除无形的怨恨了吗？因为偶然的忿怒，便忘记自己，甚至也忘记了爹娘，不是胡涂吗？”",
    "annotations": ""
  },
  {
    "id": 344,
    "title": "顏淵 12.22",
    "text": "樊迟问仁。子曰：“爱人。”问知。子曰：“知人。”\n樊迟未达。子曰：“举直错诸枉，能使枉者直。”\n樊迟退，见子夏曰：“乡⑴也吾见于夫子而问知，子曰，‘举直错诸枉，能使枉者直’，何谓也？”\n子夏曰：“富哉言乎！舜有天下，选于众，举皋陶⑵，不仁者远⑶矣。汤⑷有天下，选于众，举伊尹⑸，不仁者远矣⑹。”",
    "translation": "樊迟问仁。孔子道：“爱人。”又问智。孔子道：“善于鉴别人物。”\n樊迟还不透澈了解。孔子道：“把正直人提拔出来，位置在邪恶人之上，能\n够使邪恶人正直。”\n樊迟退了出来，找着子夏，说道：“刚纔我去见老师向他问智，他说，‘把正直人提拔出来，位置在邪恶人之上’，这是什么意思？”\n子夏道：“意义多么丰富的话呀！舜有了天下，在众人之中挑选，把皋陶提拔出来，坏人就难以存在了。汤有了天下，在众人之中挑选，把伊尹提拔出来，坏人也就难以存在了。”",
    "annotations": "【注释】⑴乡——去声，同“向”。⑵皋陶——音高摇，gāoyáo，舜的臣子。⑶远——本是“离开”“逋逃”之意，但人是可以转变的，何必非逃离不可。译文用“难以存在”来表达，比之拘泥字面或者还符合子夏的本意些。⑷汤——卜辞作“唐”，罗振玉云：“唐殆太乙之谥。 ”（《增订殷虚书契考释》）商朝开国之君，名履（卜辞作“大乙”，而无“履”字），伐夏桀而得天下。⑸伊尹——汤的辅相。⑹“举直”而“使枉者直”，属于“仁”；知道谁是直人而举他，属于“智”，所以“举直错诸枉”是仁智之事，而孔子屡言之（参2.19）。"
  },
  {
    "id": 345,
    "title": "顏淵 12.23",
    "text": "子贡问友。子曰：“忠告⑴而善道之，不可则止，毋自辱焉。”",
    "translation": "子贡问对待朋友的方法。孔子道：“忠心地劝告他，好好地引导他，他不听从，也就罢了，不要自找侮辱。”",
    "annotations": "【注释】⑴告——旧读梏，gù。"
  },
  {
    "id": 346,
    "title": "顏淵 12.24",
    "text": "曾子曰：“君子以文会友，以友辅仁。”",
    "translation": "曾子说：“君子用文章学问来聚会朋友，用朋友来帮助我培养仁德。 ”",
    "annotations": ""
  },
  {
    "id": 347,
    "title": "子路 13.1",
    "text": "子路问政。子曰：“先之⑴劳之。”请益。曰：“无倦⑵。”",
    "translation": "子路问政治。孔子道：“自己给百姓带头，然后让他们勤劳地工作。 ”\n子路请求多讲一点。孔子又道：“永远不要懈怠。”",
    "annotations": "【注释】⑴先之——就是下一章“先有司”之意。⑵无倦——也就是“居之无倦”（12.14）之意。"
  },
  {
    "id": 348,
    "title": "子路 13.2",
    "text": "仲弓为季氏宰，问政。子曰：“先有司，赦小过，举贤才。” 曰：“焉知贤才而举之？”子曰：“举尔所知；尔所不知，人其舍诸？”",
    "translation": "仲弓做了季氏的总管，向孔子问政治。孔子道：“给工作人员带头，\n不计较人家的小错误，提拔优秀人才。” 仲弓道：“怎样去识别优秀人才把他们提拔出来呢？”孔子道：“提拔你所知道的；那些你所不知道的，别人难道会埋没他吗？”",
    "annotations": ""
  },
  {
    "id": 349,
    "title": "子路 13.3",
    "text": "子路曰：“卫君⑴待子而为政，子将奚先？” 子曰：“必也正名⑵乎！” 子路曰：“有是哉，子之迂也！奚其正？” 子曰：“野哉，由也！君子于其所不知，盖阙如也。名不正，则言不顺；言\n不顺，则事不成；事不成，则礼乐不兴；礼乐不兴，则刑罚不中；刑罚不中，则民无所错⑶手足。故君子名之必可言也，言之必可行也。君子于其言，无所苟而已矣。”",
    "translation": "子路对孔子说：“卫君等着您去治理国政，您准备首先干什么？” 孔子道：“那一定是纠正名分上的用词不当罢！” 子路道：“您的迂腐竟到如此地步吗！这又何必纠正？” 孔子道：“你怎么这样卤莽！君子对于他所不懂的，大概采取保留态度，［你\n怎么能乱说呢？］用词不当，言语就不能顺理成章；言语不顺理成章，工作就不可能搞好；工作搞不好，国家的礼乐制度也就举办不起来；礼乐制度举办不起来，刑罚也就不会得当；刑罚不得当，百姓就会［惶惶不安，］连手脚都不晓得摆在\n哪里才好。所以君子用一个词，一定［有它一定的理由，］可以说得出来；而顺理成章的话也一定行得通。君子对于措词说话要没有一点马虎的地方才罢了。”",
    "annotations": "【注释】⑴卫君——历来的注释家都说是卫出公辄。⑵正名——关于这两个字的解释，从汉以来便异说纷纭。皇侃《义疏》引郑玄的注云：“正名谓正书字也，古者曰名，今世曰字。”这说恐不合孔子原意。《左传》成公二年曾经载有孔子的话，说：“唯器（礼器）与名（名义、名分）不可以假人。”《论语》这一“名”字应该和《左传》的这一“名”字相同。《论语》中有孔子“觚不觚”之叹。“觚”而不像“觚”，有其名，无其实，就是名不正。孔子对齐景公之问，说，“君君，臣臣，父父，子子”，也就是正名。《韩诗外传》卷五记载着孔子的一段故事，说，“孔子侍坐于季孙，季孙之宰通曰：‘君使人假马，其与之乎？’孔子曰：‘吾闻：君取于臣曰取，不曰假。’季孙悟，告宰通曰：‘今以往，君有取谓之取，无曰假。’孔子曰：‘正假马之言而君臣之义定矣。’”更可以说明孔子正名的实际意义。我这里用“名分上的用词不当”来解释“名不正”，似乎较为接近孔子原意。但孔子所要纠正的，只是有关古代礼制、名分上的用词不当的现象，而不是一般的用词不当的现象。一般的用词不当的现象，是语法修辞范畴中的问题；礼制上、名分上用词不当的现象，依孔子的意见，是有关伦理和政治的问题，这两点必须区别开来。⑶错——同“措”，安置也。"
  },
  {
    "id": 350,
    "title": "子路 13.4",
    "text": "樊迟请学稼。子曰：“吾不如老农。”请学为圃。曰：“吾不如老圃。”\n樊迟出。子曰：“小人哉，樊须也！上好礼，则民莫敢不敬；上好义，则民莫敢不服；上好信，则民莫敢不用情。夫如是，则四方之民襁负其子而至矣，焉用稼？”",
    "translation": "樊迟请求学种庄稼。孔子道：“我不如老农民。”又请求学种菜蔬。孔子道：“我不如老菜农。”\n樊迟退了出来。孔子道：“樊迟真是小人，统治者讲究礼节，百姓就没有人敢不尊敬；统治者行为正当，百姓就没有人敢不服从；统治者诚恳信实，百姓就没有人敢不说真话。做到这样，四方的百姓都会背负着小儿女来投奔，为什么要自己种庄稼呢？”",
    "annotations": "【注释】"
  },
  {
    "id": 351,
    "title": "子路 13.5",
    "text": "子曰：“诵《诗》三百，授之以政，不达；使于四方，不能专对⑴；虽\n多，亦奚以为⑵？”",
    "translation": "孔子说：“熟读《诗经》三百篇，交给他以政治任务，却办不通；叫他出使外国，又不能独立地去谈判酬酢；纵是读得多，有什么用处呢？”",
    "annotations": "【注释】⑴不能专对——古代的使节，只接受使命，至于如何去交涉应对，只能随机应变，独立行事，更不能事事请示或者早就在国内一切安排好，这便叫做“受命不受辞”，也就是这里的“专对”。同时春秋时代的外交酬酢和谈判，多半背诵诗篇来代替语言（《左传》里充满了这种记载），所以诗是外交人才的必读书。⑵亦奚以为——“以”，动词，用也。“为”，表疑问的语气词，但只跟“奚”、“何”诸字连用，如“何以文为”、“何以伐为”。"
  },
  {
    "id": 352,
    "title": "子路 13.6",
    "text": "子曰：“其身正，不令而行；其身不正，虽令不从。”",
    "translation": "孔子说：“统治者本身行为正当，不发命令，事情也行得通。他本身行为不正当，纵三令五申，百姓也不会信从。”",
    "annotations": ""
  },
  {
    "id": 353,
    "title": "子路 13.7",
    "text": "子曰：“鲁、卫之政，兄弟也。”",
    "translation": "孔子说：“鲁国的政治和卫国的政治，像兄弟一般［地相差不远］。 ”",
    "annotations": ""
  },
  {
    "id": 354,
    "title": "子路 13.8",
    "text": "子谓卫公子荆⑴，“善居室⑵，始有，曰：‘苟合⑶矣。’少有，曰：‘苟完矣。’富有，曰：‘茍美矣。’”",
    "translation": "孔子谈到卫国的公子荆，说：“他善于居家过日子，刚有一点，便说道：‘差不多够了。’增加了一点，又说道：‘差不多完备了。’多有一点，便说道：‘差不多富丽堂皇了。”",
    "annotations": "【注释】⑴卫公子荆——卫国的公子，吴季札曾把他列为卫国的君子，见《左传》襄公二十九年。有人说：“此取荆之善居室以风有位者也。”因为当时的卿大夫，不但贪污，而且奢侈成风，所以孔子“以廉风贪，以俭风侈。”似可备一说。⑵居室——这一词组意义甚多：（甲）居住房舍，《礼记·曲礼》“君子将营宫室，宗庙为先，廐库为次，居室为后。”（乙）夫妇同居，《孟子·万章》：“男女居室，人之大伦也。”（丙）汉代又以为狱名，《史记·卫青传》：“青尝从入甘泉居室。”（丁）此则为积蓄家业居家度日之义。“居”读为“奇货可居”之“居”。⑶合——给也，足也。此依俞樾《羣经平议》说。"
  },
  {
    "id": 355,
    "title": "子路 13.9",
    "text": "子适卫，冉有仆⑴。子曰：“庶矣哉！” 冉有曰：“既庶矣，又何加焉？”曰：“富之。” 曰：“既富矣，又何加焉？”曰：“教之⑵。”",
    "translation": "孔子到卫国，冉有替他驾车子。孔子道：“好稠密的人口！” 冉有道：“人口已经众多了，又该怎么办呢？”孔子道：“使他们富裕起来。” 冉有道：“已经富裕了，又该怎么办呢？”孔子道：“教育他们”",
    "annotations": "【注释】⑴仆——动词，驾御车马。其人则谓之仆夫，《诗·小雅·出车》“仆\n夫况瘁”可证。仆亦作名词，驾车者，《诗·小雅·正月》“屡顾尔仆”是也。⑵既富……教之——孔子主张“先富后教”，孟子、荀子也都继续发挥了这一主张。所以孟子说“乐岁终身苦，凶年不免于死亡。此惟救死而恐不赡，奚暇治礼义哉？”（《梁惠王上》）也和《管子·治国篇》的“凡治国之道，必先富民”主张相同。"
  },
  {
    "id": 356,
    "title": "子路 13.10",
    "text": "子曰：“苟有用我者，期月⑴而已可也，三年有成。“",
    "translation": "孔子说：“假若有用我主持国家政事的，一年便差不多了，三年便会很有成绩。”",
    "annotations": "【注释】⑴期月——期同“朞”，有些本子卽作“朞”，音姬，jī。期月，一年。"
  },
  {
    "id": 357,
    "title": "子路 13.11",
    "text": "子曰：“‘善人为邦百年，亦可以胜⑴残去⑵杀矣⑶。’诚哉是言也！”",
    "translation": "孔子说：“‘善人治理国政连续到一百年，也可以克服残暴免除虐杀了。’这句话真说得对呀！”",
    "annotations": "【注释】⑴胜——旧读平声。⑵去——旧读上声。⑶善人……去杀矣——依\n文意是孔子引别人的话。"
  },
  {
    "id": 358,
    "title": "子路 13.12",
    "text": "子曰：“如有王者，必世而后仁。”",
    "translation": "孔子说：“假若有王者兴起，一定需要三十年才能使仁政大行。”",
    "annotations": ""
  },
  {
    "id": 359,
    "title": "子路 13.13",
    "text": "子曰：“苟正其身矣，于从政乎何有？不能正其身，如正人何？”",
    "translation": "孔子说：“假若端正了自己，治理国政有什么困难呢？连本身都不能端正，怎么端正别人呢？”",
    "annotations": ""
  },
  {
    "id": 360,
    "title": "子路 13.14",
    "text": "冉子退朝。子曰：“何晏也？”对曰：“有政。”子曰：“其事也。如有政，虽不吾以，吾其与闻之⑴。”",
    "translation": "冉有从办公的地方回来。孔子道：“为什么今天回得这样晚呢？”答道：“有政务。”孔子道：“那只是事务罢了。若是有政务，虽然不用我了，我也会知道的。”",
    "annotations": "【注释】⑴与闻之——与，去声，参预之意。《左传》哀公十一年曾有记载，季氏以用田赋的事征求孔子意见，并且说，“子为国老，待子而行。”可见孔子“如有政，吾其与闻之”这话是有根据的。只是冉有不明白“政”和“事”的分别，一时用词不当罢了。依我看，这章并无其它意义，前人有故求深解的，未必对。"
  },
  {
    "id": 361,
    "title": "子路 13.15",
    "text": "定公问：“一言而可以兴邦，有诸？”\n孔子对曰：“言不可以若是其几也。人之言曰：‘为君难，为臣不易。’如知为君之难也，不几乎一言而兴邦乎？”\n曰：“一言而丧邦，有诸？”\n孔子对曰：“言不可以若是其几也。人之言曰：‘予无乐乎为君，唯其言而莫予违也。’如其善而莫之违也，不亦善乎？如不善而莫之违也，不几乎一言而丧\n邦乎？”",
    "translation": "鲁定公问：“一句话兴盛国家，有这事么？”\n孔子答道：“说话不可以像这样地简单机械。不过，人家都说：‘做君上很难，做臣子不容易。’假若知道做君上的艰难，［自然会谨慎认真地干去，］不近于一句话便兴盛国家么？”\n定公又道：“一句话丧失国家，有这事么？”\n孔子答道：“说话不可以像这样地简单机械。不过，大家都说：‘我做国君没有别的快乐，只是我说什么话都没有人违抗我。’假若说的话正确而没有人违抗，不也好么？假若说的话不正确而也没有人违抗，不近于一句话便丧失国家么？”",
    "annotations": ""
  },
  {
    "id": 362,
    "title": "子路 13.16",
    "text": "叶公问政。子曰：“近者悦，远者来。”",
    "translation": "叶公问政治。孔子道：“境内的人使他高兴，境外的人使他来投奔。 ”",
    "annotations": ""
  },
  {
    "id": 363,
    "title": "子路 13.17",
    "text": "子夏为莒父⑴宰，问政。子曰：“无欲速，无见小利。欲速，则不达；见小利，则大事不成。”",
    "translation": "子夏做了莒父的县长，问政治。孔子道：“不要图快，不要顾小利。图快，反而不能达到目的；顾小利，就办不成大事。”",
    "annotations": "【注释】⑴莒父——鲁国之一邑，现在已经不能确知其所在。山东通志认为在今山东高密县东南。"
  },
  {
    "id": 364,
    "title": "子路 13.18",
    "text": "叶公语孔子曰：“吾党有直躬者，其父攘羊，而子证⑴之。”孔子曰：“吾党之直者异于是：父为子隐，子为父隐。——直在其中⑵矣。”",
    "translation": "叶公告诉孔子道：“我那里有个坦白直率的人，他父亲偷了羊，他便告发。”孔子道：“我们那里坦白直率的人和你们的不同：父亲替儿子隐瞒，儿子替父亲隐瞒——直率就在这里面。”",
    "annotations": "【注释】⑴证——《说文》云：“证，告也。”正是此义。相当今日的“检举”“揭发”，《韩非子·五蠹篇》述此事作“谒之吏”，《吕氏春秋·当务篇》述此事作“谒之上”，都可以说明正是其子去告发他父亲。“证明”的“证”，古书一般用“征”字为之。⑵直在其中——孔子伦理哲学的基础就在于“孝”和“慈”因之说父子相隐，直在其中。"
  },
  {
    "id": 365,
    "title": "子路 13.19",
    "text": "樊迟问仁。子曰：“居处恭，执事敬，与人忠。虽之⑴夷狄，不可弃也。 ”",
    "translation": "樊迟问仁。孔子道：“平日容貌态度端正庄严，工作严肃认真，为别人忠心诚意。这几种品德，纵到外国去，也是不能废弃的。”",
    "annotations": "【注释】⑴之——动词，到也。"
  },
  {
    "id": 366,
    "title": "子路 13.20",
    "text": "子贡问曰：“何如斯可谓之士矣？”子曰：“行己有耻，使于四方，不辱君命，可谓士矣。”\n曰：“敢问其次。”曰：“宗族称孝焉，乡党称弟焉。”\n曰：“敢问其次。”曰：“言必信，行必果，硁硁然小人哉！——抑亦可以为次矣。”\n曰：“今之从政者何如？”子曰：“噫！斗筲之人⑴，何足算也？”",
    "translation": "子贡问道：“怎样才可以叫做‘士’？”孔子道：“自己行为保持羞耻之心，出使外国，很好地完成君主的使命，可以叫做‘士’了。”\n子贡道：“请问次一等的。”孔子道：“宗族称赞他孝顺父母，乡里称赞他恭敬尊长。”\n子贡又道：“请问再次一等的。”孔子道：“言语一定信实，行为一定坚决，这是不问是非黑白而只管自己贯彻言行的小人呀，但也可以说是再次一等的‘士’了。”\n子贡道：“现在的执政诸公怎么样？”孔子道：“咳！这班器识狭小的人算得什么？”",
    "annotations": "【注释】⑴斗筲之人——斗是古代的量名，筲音梢，shāo，古代的饭筐（《说文》作），能容五升。斗筲譬如度量和见识的狭小。有人说，“斗筲之人”也可以译为“车载斗量之人”，言其不足为奇。"
  },
  {
    "id": 367,
    "title": "子路 13.21",
    "text": "子曰：“不得中行而与之，必也狂狷⑴乎！狂者进取，狷者有所不为也。 ”",
    "translation": "孔子说：“得不到言行合乎中庸的人和他相交，那一定要交到激进的人和狷介的人罢，激进者一意向前，狷介者也不肯做坏事。”",
    "annotations": "【注释】⑴狂狷——《孟子·尽心篇下》有一段话可以为本文的解释，録之于下：“孟子曰：‘孔子不得中道而与之，必也狂獧（同“狷”）乎！狂者进取，獧者有所不为也。孔子岂不欲中道哉？不可必得，故思其次也。’‘敢问何如斯可谓狂矣？’（此万章问词，下同。）曰：‘如琴张、曾晳、牧皮者，孔子之所谓狂矣。’何以谓之狂也？’曰：‘其志嘐嘐然，曰：古之人！古之人！夷考其行而不掩焉者也。狂者又不可得，欲得不屑不洁之士而与之，是獧也，是又其次也。’”孟轲这话未必尽合孔子本意，但可备参考。"
  },
  {
    "id": 368,
    "title": "子路 13.22",
    "text": "子曰：“南人有言曰：‘人而无恒，不可以作巫医⑴。’善夫！”\n“不恒其德⑵，或承之羞。”子曰：“不占而已矣。”",
    "translation": "孔子说：“南方人有句话说，‘人假若没有恒心，连巫医都做不了。’这句话很好呀！”\n《易经·恒卦》的爻辞说：“三心二意，翻云覆雨，总有人招致羞耻。”孔子又说：“这话的意思是叫无恒心的人不必去占卦罢了。”",
    "annotations": "【注释】⑴巫医——巫医是一词，不应分为卜筮的巫和治病的医两种。古代常以禳祷之术替人治疗，这种人便叫巫医。⑵不恒其德——这有两种意义：（甲）不能持久，时作时辍；（乙）没有一定的操守。译文用“三心二意”表示“不能持久”，用“翻云覆雨”表示“没有操守”。"
  },
  {
    "id": 369,
    "title": "子路 13.23",
    "text": "子曰：“君子和而不同，小人同而不和⑴。”",
    "translation": "孔子说：“君子用自己的正确意见来纠正别人的错误意见，使一切都做到恰到好处，却不肯盲从附和。小人只是盲从附和，却不肯表示自己的不同意见。”",
    "annotations": "【注释】⑴和，同——“和”与“同”是春秋时代的两个常用术语，《左传》昭公二十年所载晏子对齐景公批评梁丘据的话，和《国语·郑语》所载史伯的话都解说得非常详细。“和”如五味的调和，八音的和谐，一定要有水、火、酱、醋各种不同的材料才能调和滋味，一定要有高下、长短、疾徐各种不同的声调才能使乐曲和谐。晏子说：“君臣亦然。君所谓可，而有否焉，臣献其否以成其可；君所谓否，而有可焉，臣献其可以去其否。”因此史伯也说，“以他平他谓之和”。“同”就不如此，用晏子的话说：“君所谓可，据亦曰可；君所谓否，据亦曰否；若以水济水，谁能食之？若琴瑟之专一，谁能听之？‘同’之不可也如是。”我又认为这个“和”字与“礼之用和为贵”的“和”有相通之处。因此译文也出现了“恰到好处”的字眼。"
  },
  {
    "id": 370,
    "title": "子路 13.24",
    "text": "子贡问曰：“乡人皆好之，何如？”子曰：“未可也⑴。”\n“乡人皆恶之，何如？”子曰：“未可也；不如乡人之善者好之，其不善者恶之。 ”",
    "translation": "子贡问道：“满乡村的人都喜欢他，这个人怎么样？”孔子道：“还不行。”\n子贡便又道：“满乡村的人都厌恶他，这个人怎么样？”孔子道：“还不行。最好是满乡村的好人都喜欢他，满乡村的坏人都厌恶他。”",
    "annotations": "【注释】⑴未可也——如果一乡之人皆好之，便近乎所谓好好先生，孔、孟叫他为“乡愿。”因之孔子便说：“众好之，必察焉；众恶之，必察焉。”（15.28）又说，“唯仁者能好人，能恶人。”（4.3）这可以为“善者好之，不善者恶之”的解释。"
  },
  {
    "id": 371,
    "title": "子路 13.25",
    "text": "子曰：“君子易事⑴而难说也。说之不以道，不说也；及其使人也，器之。小人难事而易说也。说之虽不以道，说也；及其使人也，求备焉。”",
    "translation": "孔子说：“在君子底下工作很容易，讨他的欢喜却难。不用正当的\n方式去讨他的欢喜，他不会欢喜的；等到他使用人的时候，却衡量各人的才德去分配任务。在小人底下工作很难，讨他的欢喜却容易。用不正当的方式去讨他的欢喜，他会欢喜的；等到他使用人的时候，便会百般挑剔，求全责备。”",
    "annotations": "【注释】⑴易事——《说苑·雅言篇》说：“曾子曰，‘夫子见人之一善而忘其百非，是夫子之易事也’。”这话可以作“君子易事”的一个说明。"
  },
  {
    "id": 372,
    "title": "子路 13.26",
    "text": "子曰：“君子泰而不骄⑴，小人骄而不泰。”",
    "translation": "孔子说：“君子安详舒泰，却不骄傲凌人；小人骄傲凌人，却不安详舒泰。”",
    "annotations": "【注释】⑴泰，骄——皇侃《义疏》云：“君子坦荡荡，心貌怡平，是泰而不为骄慢也；小人性好轻凌，而心恒戚戚，是骄而不泰也。”李塨《论语传注》云：“君子无众寡，无小大，无敢慢（按：见20.2），何其舒泰！小人矜己傲物，惟恐失尊，何其骄侈，而安得泰？”译文正取此义。"
  },
  {
    "id": 373,
    "title": "子路 13.27",
    "text": "子曰：“刚、毅、木、讷近仁。”",
    "translation": "孔子说：“刚强、果决、朴质，而言语不轻易出口，有这四种品德的人近于仁德。”",
    "annotations": ""
  },
  {
    "id": 374,
    "title": "子路 13.28",
    "text": "子路问曰：“何如斯可谓之士矣？”子曰：“切切偲偲⑴，怡怡⑵如也，可谓士矣。朋友切切偲偲，兄弟怡怡。”",
    "translation": "子路问道：“怎么样才可以叫做‘士’了呢？”孔子道：“互相批评，和睦共处，可以叫做‘士’了。朋友之间，互相批评；兄弟之间，和睦共处。”",
    "annotations": "【注释】⑴切切偲偲——偲音思，sī。切切偲偲，互相责善的样子。⑵怡怡——和顺的样子。"
  },
  {
    "id": 375,
    "title": "子路 13.29",
    "text": "子曰：“善人教民七年，亦可以卽戎⑴矣。”",
    "translation": "孔子说：“善人教导人民达七年之久，也能够叫他们作战了。“",
    "annotations": "【注释】⑴卽戎——“卽”是“卽位”的“卽”，就也，往那里去的意思。“戎”是“兵戎”的意思。"
  },
  {
    "id": 376,
    "title": "子路 13.30",
    "text": "子曰：“以不教民⑴战，是谓弃之。”",
    "translation": "孔子道：“用未经受过训练的人民去作战，这等于糟踏生命。“",
    "annotations": "【注释】⑴不教民——“不教民”三字构成一个名词语，意思就是“不教之民”，正如《诗经·邶风·柏舟》“心之忧矣，如匪澣衣”的“匪澣衣”一样，意思就是“匪澣之衣”（不曾洗涤过的衣服）。"
  },
  {
    "id": 377,
    "title": "憲問 14.1",
    "text": "宪问耻。子曰：“邦有道，谷；邦无道，谷，耻也。”\n“克、伐、怨、欲不行焉，可以为仁矣？⑴”子曰：“可以为难矣，仁则吾不知也。”",
    "translation": "原宪问如何叫耻辱。孔子道：“国家政治清明，做官领薪俸；国家政治黑暗，做官领薪俸，这就是耻辱。”\n原宪又道：“好胜、自夸、怨恨和贪心四种毛病都不曾表现过，这可以说是仁人了吗？”孔子道：“可以说是难能可贵的了，若说是仁人，那我不能同意。”",
    "annotations": "【注释】⑴可以为仁矣——这句话从形式上看应是肯定句，但从上下文看，实际应是疑问句，不过疑问只从说话者的语势来表示，不藉助于别的表达形式而已。这一段可以和“邦有道，贫且贱焉，耻也；邦无道，富且贵焉，耻也。 ”（8.13）互相发明。"
  },
  {
    "id": 378,
    "title": "憲問 14.2",
    "text": "子曰：“士而怀居⑴，不足以为士矣。”",
    "translation": "孔子说：“读书人而留恋安逸，便不配做读书人了。”",
    "annotations": "【注释】⑴怀居——怀，怀思，留恋；居，安居。《左传》僖公二十三年记载着晋文公的流亡故事，说他在齐国安居下来，有妻妾，有家财，便不肯再移动了。他老婆姜氏便对他说：“行也！怀与安，实败名。”便和此意相近。"
  },
  {
    "id": 379,
    "title": "憲問 14.3",
    "text": "子曰：“邦有道，危⑴言危行；邦无道，危行言孙⑵。”",
    "translation": "孔子说：“政治清明，言语正直，行为正直；政治黑暗，行为正直，言语谦顺。”",
    "annotations": "【注释】⑴危——《礼记·缁衣》注：“危，高峻也。”意谓高于俗，朱熹《集注》用之，固然可通。但《广雅》云：“危，正也。”王念孙《疏证》卽引《论语》此文来作证，更为恰当，译文卽用此解。⑵孙——同逊。"
  },
  {
    "id": 380,
    "title": "憲問 14.4",
    "text": "子曰：“有德者必有言，有言者不必有德。仁者必有勇，勇者不必有仁。 ”",
    "translation": "孔子说：“有道德的人一定有名言，但有名言的人不一定有道德。仁人一定勇敢，但勇敢的人不一定仁。”",
    "annotations": ""
  },
  {
    "id": 381,
    "title": "憲問 14.5",
    "text": "南宫适⑴问于孔子曰：“羿⑵善射，奡⑶荡舟⑷，俱不得其死然。禹稷躬稼而有天下。”夫子不答。\n南宫适出，子曰：“君子哉若人！尚德哉若人⑸！”",
    "translation": "南宫适向孔子问道：“羿擅长射箭，奡擅长水战，都没有得到好死。禹和稷自己下地种田，却得到了天下。［怎样解释这些历史？］”孔子没有答复。\n南宫适退了出来。孔子道：“这个人，好一个君子！这个人，多么尊尚道德！ ”",
    "annotations": "【注释】⑴南宫适——孔子学生南容。⑵羿——音诣，yì。在古代传说中有三个羿，都是射箭能手。一为帝喾的射师，见于说文；二为唐尧时人，传说当时\n十个太阳同时出现，羿射落了九个，见《淮南子·本经训》；三为夏代有穷国的君主，见《左传》襄公四年。这里所指的和《孟子·离娄篇》所载的“逢蒙学射于羿”的羿，据说都是夏代的羿。⑶奡——音傲，aò。也是古代传说中的人物，夏代寒浞的儿子。字又作“浇”。⑷荡舟——顾炎武《日知録》云：“古人以左右冲杀为荡。陈其锐卒，谓之跳荡；别帅谓之荡主。荡舟盖兼此义。”译成现代汉语，就是用舟师冲锋陷阵。⑸君子……尚德哉若人——南宫适托古代的事来问孔子，中心思想是当今尚力不尚德，但按之历史，尚力者不得善终，尚德者终有天下。因之孔子称赞他。"
  },
  {
    "id": 382,
    "title": "憲問 14.6",
    "text": "子曰：“君子⑴而不仁者有矣夫，未有小人⑵而仁者也。”",
    "translation": "孔子说：“君子之中不仁的人有的罢，小人之中却不会有仁人。”",
    "annotations": "【注释】⑴君子，小人——这个“君子”“小人”的含义不大清楚。“君子”“小人”若指有德者无德者而言，则第二句可以不说；看来，这里似乎是指在位者和老百姓而言。"
  },
  {
    "id": 383,
    "title": "憲問 14.7",
    "text": "子曰：“爱之，能勿劳乎⑴？忠焉，能勿诲乎？”",
    "translation": "孔子说：“爱他，能不叫他劳苦吗？忠于他，能够不教诲他吗？”",
    "annotations": "【注释】⑴能勿劳乎——《国语·鲁语下》说：“夫民劳则思，思则善心生；逸则淫，淫则忘善，忘善则恶心生。”可以为“能勿劳乎”的注脚。"
  },
  {
    "id": 384,
    "title": "憲問 14.8",
    "text": "子曰：“为命⑴，裨谌⑵草创之，世叔⑶讨论⑷之，行人子羽⑸修饰之，东里子产⑹润色之。”",
    "translation": "孔子说：“郑国外交辞令的创制，裨谌拟稿，世叔提意见，外交官子羽修改，子产作文词上的加工。”",
    "annotations": "【注释】⑴为命——《左传》襄公三十一年云：“郑国将有诸侯之事，子产乃问四国之为于子羽，且使多为辞令，与裨谌乘以适野，使谋可否，而告冯简子使断之。事成，乃授子太叔使行之，以应对宾客，是以鲜有败事。”可与《论语》此文相参校。《左传》所讲的过程和《论语》此文虽然有些出入，但主题是相同的，因此我把“命”译为“外交辞令”，不作一般的政令讲。⑵裨谌——音庇臣，bìchén，郑国大夫，见《左传》。⑶世叔——卽《左传》的子太叔（古代，“太”和“世”两字通用），名游吉。⑷讨论——意义和今天的“讨论”不同，这是一个人去研究而后提意见的意思。⑸行人子羽——行人，官名，卽古代的外交官。子羽，公孙挥的字。⑹东里子产——东里，地名，今在郑州市，子产所居。"
  },
  {
    "id": 385,
    "title": "憲問 14.9",
    "text": "或问子产。子曰：“惠人也。”\n问子西⑴。曰：“彼哉！彼哉⑵！”\n问管仲。曰：“人也。夺伯氏⑶骈邑⑷三百，饭疏食，没齿无怨言。”",
    "translation": "有人向孔子问子产是怎样的人物。孔子道：“是宽厚慈惠的人。”\n又问到子西。孔子道：“他呀，他呀！”\n又问到管仲。孔子道：“他是人才。剥夺了伯氏骈邑三百户的采地，使伯氏只能吃粗粮，到死没有怨恨的话。”",
    "annotations": "【注释】⑴子西——春秋时有三个子西，一是郑国的公孙夏，生当鲁襄公之世，为子产的同宗兄弟，子产便是继他而主持郑国政治的。二是楚国的鬬宜申，生当鲁僖公、文公之世。三是楚国的公子申，和孔子同时。鬬宜申去孔子太远，公子申又太近，这人所问的当是公孙夏。⑵彼哉彼哉——《公羊传》定公八年记载阳虎谋杀季孙的事，说阳虎谋杀未成，在郊外休息，忽然望见公敛处父领着追兵而来，便道：“彼哉彼哉！”毛奇龄《论语稽求篇》因云：“此必古成语，而夫子引以作答者。”案：这是当时表示轻视的习惯语。⑶伯氏——齐国的大夫，皇侃《义疏》云：“伯氏名偃。”不知何据。⑷骈邑——地名。阮元曾得伯爵彝，说是乾隆五十六年出土于山东临朐县柳山寨。他在《积古斋锺鼎彝器款识》里说，柳山寨有古城的城基，卽春秋的骈邑。用《水经·巨洋水注》证之，阮氏之言很可信。"
  },
  {
    "id": 386,
    "title": "憲問 14.10",
    "text": "子曰：“贫而无怨难，富而无骄易。”",
    "translation": "孔子说：“贫穷却没有怨恨，很难；富贵却不骄傲，倒容易做到”",
    "annotations": ""
  },
  {
    "id": 387,
    "title": "憲問 14.11",
    "text": "子曰：“孟公绰⑴为赵魏老⑵则优⑶，不可以为滕、薛⑷大夫。”",
    "translation": "孔子说：“孟公绰，若是叫他做晋国诸卿赵氏、魏氏的家臣，那是力有余裕的；却没有才能来做滕、薛这样小国的大夫。”",
    "annotations": "【注释】⑴孟公绰——鲁国大夫，《左传》襄公二十五年记载着他的一段事。《史记·仲尼弟子列传》说他是孔子所尊敬的人。⑵老——古代，大夫的家臣称老，也称室老。⑶优——本意是“优裕”，所以用“力有余裕”来译它。⑷滕、薛——当时的小国，都在鲁国附近。滕的故城在今山东滕县西南十五里，薛的故城在今滕县南四十四里官桥公社处。"
  },
  {
    "id": 388,
    "title": "憲問 14.12",
    "text": "子路问成人。子曰：“若臧武仲⑴之知，公绰之不欲，卞庄子⑵之勇，冉求之艺，文之以礼乐，亦可以为成人矣。”曰：“今之成人者何必然？见利思义，见危授命，久要⑶不忘平生之言，亦可以为成人矣。”",
    "translation": "子路问怎样才是全人。孔子道：“智慧像臧武仲，清心寡欲像孟公绰，勇敢像卞庄子，多才多艺像冉求，再用礼乐来成就他的文采，也可以说是全人了。”等了一会，又道：“现在的全人哪里一定要这样？看见利益便能想起该得不该得，遇到危险便肯付出生命，经过长久的穷困日子都不忘记平日的诺言，也可以说是全人了。”",
    "annotations": "【注释】⑴臧武仲——鲁大夫臧孙纥。他很聪明，逃到齐国之后，能预见齐庄公的被杀而设法辞去庄公给他的田。事见《左传》襄公二十三年。⑵卞庄子——鲁国的勇士。《荀子·大略篇》和《韩诗外传》卷十都载有他的勇敢故事。⑵久要——“要”为“约”的借字，“约”，穷困之意。说见杨遇夫先生的《积微居小学述林》。"
  },
  {
    "id": 389,
    "title": "憲問 14.13",
    "text": "子问公叔文子⑴于公明贾⑵曰：“信乎，夫子不言，不笑，不取乎？”\n公明贾对曰：“以⑶告者过也。夫子时然后言，人不厌其言；乐然后笑，人不厌其笑；义然后取，人不厌其取。”\n子曰：“其然？岂其然乎？”",
    "translation": "孔子向公明贾问到公叔文子，说：“他老人家不言语，不笑，不取，是真的吗？”\n公明贾答道：“这是传话的人说错了。他老人家到应说话的时候才说话，别人不厌恶他的话；高兴了才笑，别人不厌恶他的笑；应该取才取，别人不厌恶他的取。”\n孔子道：“如此的吗？难道真是如此的吗？”",
    "annotations": "【注释】⑴公叔文子——卫国大夫，《檀弓》载有他的故事。⑵公明贾——卫人，姓公明，名贾。贾音假，jiǎ。《左传》哀公十四年楚有蔿贾也音假。⑶以——代词，此也。例证可参考杨遇夫先生的《词诠》。"
  },
  {
    "id": 390,
    "title": "憲問 14.14",
    "text": "子曰：“臧武仲以防求为后于鲁⑴，虽曰不要⑵君，吾不信也。”",
    "translation": "孔子说：“臧武仲［逃到齐国之前，］凭借着他的采邑防城请求立其子弟嗣为鲁国卿大夫，纵然有人说他不是要挟，我是不相信的。”",
    "annotations": "【注释】⑴臧武仲以防求为后于鲁——事见《左传》襄公二十三年。防，臧武仲的封邑，在今山东费县东北六十里之华城，离齐国边境很近。⑵要——平声，音腰，yāo。"
  },
  {
    "id": 391,
    "title": "憲問 14.15",
    "text": "子曰：“晋文公⑴谲⑵而不正，齐桓公⑴正而不谲。”",
    "translation": "孔子说：“晋文公诡诈好耍手段，作风不正派；齐桓公作风正派，不用诡诈，不耍手段。”",
    "annotations": "【注释】⑴晋文公、齐桓公——晋文公名重耳，齐桓公名小白。齐桓、晋文是春秋时五霸中最有名声的两个霸主。⑵谲——音决，jué，欺诈，玩弄权术阴谋。"
  },
  {
    "id": 392,
    "title": "憲問 14.16",
    "text": "子路曰：“桓公杀公子纠，召忽死之，管仲不死⑴。”曰：“未仁乎？”子曰：“桓公九合⑵诸侯，不以兵车，管仲之力也。如其仁，如其仁⑶。”",
    "translation": "子路道：“齐桓公杀了他哥哥公子纠，［公子纠的师傅］召忽因此自杀，［但是他的另一师傅］管仲却活着。”接着又道：“管仲该不是有仁德的罢？”孔子道：“齐桓公多次地主持诸侯间的盟会，停止了战争，都是管仲的力量。这就是管仲的仁德，这就是管仲的仁德。”",
    "annotations": "【注释】⑴管仲不死——齐桓公和公子纠都是齐襄公的弟弟。齐襄公无道，两人都怕牵累，桓公便由鲍叔牙侍奉逃往莒国，公子纠也由管仲和召忽侍奉逃往鲁国。襄公被杀以后，桓公先入齐国，立为君，便兴兵伐鲁，逼迫鲁国杀了公子纠，召忽自杀以殉，管仲却做了桓公的宰相。这段历史可看《左传》庄公八年和九年。⑵九合——齐桓公纠合诸侯共计十一次。这一“九”字实是虚数，不过表示其多罢了。⑶如其仁——王引之《经传释词》云：“如犹乃也。”扬雄《法言》三次仿用这种句法，义同。"
  },
  {
    "id": 393,
    "title": "憲問 14.17",
    "text": "子贡曰：“管仲非仁者与？桓公杀公子纠，不能死，又相之。”子曰：“管仲相桓公，霸诸侯，一匡天下，民到于今受其赐。微⑴管仲，吾其被⑵发左衽矣。岂若匹夫匹妇之为谅也，自经⑶于沟渎⑷而莫之知也？”",
    "translation": "子贡道：“管仲不是仁人罢？桓公杀掉了公子纠，他不但不以身殉难，还去辅相他。”孔子道：“管仲辅相桓公，称霸诸侯，使天下一切得到匡正，人民到今天还受到他的好处。假若没有管仲，我们都会披散着头发，衣襟向左边开，［沦为落后民族］了。他难道要像普通老百姓一样守着小节小信，在山沟中自杀，还没有人知道的吗？”",
    "annotations": "【注释】⑴微——假若没有的意思，只用于和既成事实相反的假设句之首。⑵被——同“披”。⑶自经——自缢。⑷沟渎——犹《孟子·梁惠王》的“沟壑”。王夫之《四书稗疏》认为它是地名，就是《左传》的“句渎”，《史记》的“笙渎”，那么，孔子的匹夫匹妇就是指召忽而言，恐不可信。"
  },
  {
    "id": 394,
    "title": "憲問 14.18",
    "text": "公叔文子之臣大夫⑴僎与文子同升诸⑵公。子闻之，曰：“可以为‘文’⑶矣。”",
    "translation": "公叔文子的家臣大夫僎，［由于文子的推荐，］和文子一道做了国家的大臣。孔子知道这事，便道：“这便可以谥为‘文’了。”",
    "annotations": "【注释】⑴毛奇龄《四书剩言》云：“臣大夫卽家大夫也。”把“臣大夫”三字不分，今不取。《后汉书·吴良传》李贤注说：“文子家臣名僎”云云，也可见唐初人不以“臣大夫”为一词。⑵诸——用法同“于”。⑶据《礼记·檀弓》，公叔文子实谥为贞惠文子。郑玄《礼记》注说：“不言‘贞惠’者？‘文’足以兼之。”"
  },
  {
    "id": 395,
    "title": "憲問 14.19",
    "text": "子言卫灵公之无道也，康子曰：“夫如是，奚而⑴不丧？”孔子曰：“仲叔圉⑵治宾客，祝鮀治宗庙，王孙贾治军旅。夫如是，奚其丧？”",
    "translation": "孔子讲到卫灵公的昏乱，康子道：“既然这样，为什么不败亡？”孔子道：“他有仲叔圉接待宾客，祝鮀管理祭祀，王孙贾统率军队，像这样，怎么会败亡？”",
    "annotations": "【注释】⑴奚而——俞樾《羣经平议》云：“奚而犹奚为也。”⑵仲叔圉——就是孔文子。"
  },
  {
    "id": 396,
    "title": "憲問 14.20",
    "text": "子曰：“其言之不怍，则为之也难。”",
    "translation": "孔子说：“那个人大言不惭，他实行就不容易。”",
    "annotations": ""
  },
  {
    "id": 397,
    "title": "憲問 14.21",
    "text": "陈成子⑴弑简公⑵。孔子沐浴而朝⑶，告于哀公曰：“陈恒弑其君，请讨之⑷。”公曰：“告夫三子！”\n孔子曰⑸：“以吾从大夫之后，不敢不告也。君曰‘告夫三子’者！”\n之三子告，不可。孔子曰：“以吾从大夫之后，不敢不告也。”",
    "translation": "陈恒杀了齐简公。孔子斋戒沐浴而后朝见鲁哀公，报告道：“陈恒杀了他的君主，请你出兵讨伐他。”哀公道：“你向季孙、仲孙、孟孙三人去报告罢！”\n孔子［退了出来］，道：“因为我曾忝为大夫，不敢不来报告，但是君上却对我说，‘给那三人报告吧’！”\n孔子又去报告三位大臣，不肯出兵。孔子道：“因为我曾忝为大夫，不敢不\n报告。”",
    "annotations": "【注释】⑴陈成子——就是陈恒。⑵简公——齐简公，名壬。⑶孔子沐浴而朝——这时孔子已经告老还家，特为这事来朝见鲁君。⑷请讨之——孔子请讨陈恒，主要地由于陈恒以臣杀君，依孔子的学说，非讨不可。同时孔子也估计了战争的胜负。《左传》记载着孔子的话道：“陈恒弒其君，民之不与者半。以鲁之众加齐之半，可克也。”但这事仍可讨论。⑸孔子曰——这是孔子退朝后的话，参校《左传》哀公十四年的记载便可以知道。"
  },
  {
    "id": 398,
    "title": "憲問 14.22",
    "text": "子路问事君。子曰：“勿欺也，而犯之。”",
    "translation": "子路问怎样服侍人君。孔子道：“不要［阳奉阴违地］欺骗他，却可以［当面］触犯他。”",
    "annotations": ""
  },
  {
    "id": 399,
    "title": "憲問 14.23",
    "text": "子曰：“君子上达⑴，小人下达⑴。”",
    "translation": "孔子说：“君子通达于仁义，小人通达于财利。”",
    "annotations": "【注释】⑴上达下达——古今学人各有解释，译文采取了皇侃《义疏》的说法。"
  },
  {
    "id": 400,
    "title": "憲問 14.24",
    "text": "子曰：“古之学者为己⑴，今之学者为人⑴。”",
    "translation": "孔子说：“古代学者的目的在修养自己的学问道德，现代学者的目的却在装饰自己，给别人看。”",
    "annotations": "【注释】为己为人——如何叫做“为己”和“为人”，译文采用了《荀子·劝学篇》、《北堂书钞》所引《新序》和《后汉书·桓荣传论》（俱见杨遇夫先生《论语疏证》）的解释。"
  },
  {
    "id": 401,
    "title": "憲問 14.25",
    "text": "蘧伯玉⑴使人于孔子。孔子与之坐而问焉，曰：“夫子何为？”对曰：“夫子欲寡其过⑵而未能也。”\n使者出。子曰“使乎！使乎！”",
    "translation": "蘧伯玉派一位使者访问孔子。孔子给他坐位，而后问道：“他老人家干些什么？”使者答道：“他老人家想减少过错却还没能做到。”\n使者辞了出来。孔子道：“好一位使者！好一位使者！”",
    "annotations": "【注释】⑴蘧伯玉——卫国的大夫，名瑗。孔子在卫国之时，曾经住过他家。⑵寡其过——《庄子·则阳篇》说：“蘧伯玉行年六十而六十化，未尝不始于是之，而卒诎之以非也；或未知今之所谓是之非五十九非也（六十之是或为五十九之非）。”《淮南子·原道篇》也说：“蘧伯玉年五十而知四十九年非。”大概这人是位求进甚急善于改过的人。使者之言既得其实，又不卑不亢，所以孔子连声称赞。"
  },
  {
    "id": 402,
    "title": "憲問 14.26",
    "text": "子曰：“不在其位，不谋其政⑴。”\n曾子曰：“君子思不出其位。”",
    "translation": "曾子说：“君子所思虑的不超出自己的工作岗位。”",
    "annotations": "【注释】⑴见泰伯篇。（8.14）"
  },
  {
    "id": 403,
    "title": "憲問 14.27",
    "text": "子曰：“君子耻其言而⑴过其行。”",
    "translation": "孔子说：“说得多，做得少，君子以为耻。”",
    "annotations": "【注释】⑴而——用法同“之”，说详《词诠》。皇侃所据本，日本足利本，这一“而”字都作“之”。"
  },
  {
    "id": 404,
    "title": "憲問 14.28",
    "text": "子曰：“君子道者三，我无能焉：仁者不忧，知者不惑，勇者不惧。”子贡曰：“夫子自道也。”",
    "translation": "孔子说：“君子所行的三件事，我一件也没能做到：仁德的人不忧虑，智慧的人不迷惑，勇敢的人不惧怕。”子贡道：“这正是他老人家对自己的叙述哩。”",
    "annotations": ""
  },
  {
    "id": 405,
    "title": "憲問 14.29",
    "text": "子贡方人⑴。子曰：“赐也贤乎哉？夫我则不暇。”",
    "translation": "子贡讥评别人。孔子对他道：“你就够好了吗？我却没有这闲工夫。 ”",
    "annotations": "【注释】⑴方人——《经典释文》说，郑玄注的《论语》作“谤人”，又引郑注云“谓言人之遇恶”。因此译文译为“讥评”。《世说新语·容止篇》：“或以方谢仁祖不乃重者。”这“方”字作品评解，其用法可能出于此。"
  },
  {
    "id": 406,
    "title": "憲問 14.30",
    "text": "子曰：“不患人之不己知，患其不能也。”",
    "translation": "孔子说：“不着急别人不知道我，只着急自己没有能力。”",
    "annotations": ""
  },
  {
    "id": 407,
    "title": "憲問 14.31",
    "text": "子曰：“不逆诈，不亿不信，抑亦先觉者，是贤乎！”",
    "translation": "孔子说：“不预先怀疑别人的欺诈，也不无根据地猜测别人的不老实，却能及早发觉，这样的人是一位贤者罢！”",
    "annotations": ""
  },
  {
    "id": 408,
    "title": "憲問 14.32",
    "text": "微生亩⑴谓孔子曰：“丘何为是⑵栖栖者与？无乃为佞乎？”孔子曰：“非敢为佞也，疾固也。”",
    "translation": "微生亩对孔子道：“你为什么这样忙忙碌碌的呢？不是要逞你的口才吗？”孔子道：“我不是敢逞口才，而是讨厌那种顽固不通的人。”",
    "annotations": "【注释】⑴微生亩——“微生是姓，“亩”是名。⑵是——这里作副词用，当“如此”解。"
  },
  {
    "id": 409,
    "title": "憲問 14.33",
    "text": "子曰：“骥不称其力，称其德也。”",
    "translation": "孔子说：“称千里马叫做骥，并不是赞美它的气力，而是赞美他的质量。”",
    "annotations": ""
  },
  {
    "id": 410,
    "title": "憲問 14.34",
    "text": "或曰：“以德报怨⑴，何如？”子曰：“何以报德？以直报怨，以德报德。 ”",
    "translation": "有人对孔子道：“拿恩惠来回答怨恨，怎么样？”孔子道：“拿什么来酬答恩惠呢？拿公平正直来回答怨恨，拿恩惠来酬答恩惠。”",
    "annotations": "【注释】⑴以德报怨——《老子》也说：“大小多少，报怨以德。”可能当日流行此语。"
  },
  {
    "id": 411,
    "title": "憲問 14.35",
    "text": "子曰：“莫我知也夫！”子贡曰：“何为其莫知子也？”子曰：“不怨天，不尤人，下学而上达⑴。知我者其天乎！”",
    "translation": "孔子叹道：“没有人知道我呀！”子贡道：“为什么没有人知道您呢？”孔子道：“不怨恨天，不责备人，学习一些平常的知识，却透澈了解很高的道理。知道我的，只是天罢！”",
    "annotations": "【注释】⑴下学而上达——这句话具体的意义是什么，古今颇有不同解释，译文所言只能备参考。皇侃《义疏》云：“下学，学人事；上达，达天命。我既学人事，人事有否有泰，故不尤人。上达天命，天命有穷有通，故我不怨天也。”全部意思都贯通了，虽不敢说合于孔子本意，无妨録供参考。"
  },
  {
    "id": 412,
    "title": "憲問 14.36",
    "text": "公伯寮⑴愬⑵子路于季孙。子服景伯⑶以告，曰：“夫子固有惑志于公伯寮，吾力犹能肆诸市朝⑷。”\n子曰：“道之将行也与，命也；道之将废也与，命也。公伯寮其如命何！”",
    "translation": "公伯寮向季孙毁谤子路。子服景伯告诉孔子，并且说：“他老人家已经被公伯寮所迷惑了，可是我的力量还能把他的尸首在街头示众。”\n孔子道：“我的主张将实现吗，听之于命运；我的主张将永不实现吗，也听之于命运。公伯寮能把我的命运怎样呢！”",
    "annotations": "【注释】⑴公伯寮——《史记·仲尼弟子列传》作“公伯僚”云“字子周”。⑵愬——同“诉”。⑶子服景伯——鲁大夫，名何。⑷市朝——古人把罪人之尸示众，或者于朝廷，或者于市集。"
  },
  {
    "id": 413,
    "title": "憲問 14.37",
    "text": "子曰：“贤者辟⑴世，其次辟地，其次辟色，其次辟言。” 子曰：“作者七人矣。”",
    "translation": "孔子说：“有些贤者逃避恶浊社会而隐居，次一等的择地而处，再\n次一等的避免不好的脸色，再次一等的迥避恶言。” 孔子又说：“像这样的人已经有七位了。”",
    "annotations": "【注释】⑴辟——同“避”。"
  },
  {
    "id": 414,
    "title": "憲問 14.38",
    "text": "子路宿于石门⑴。晨门曰：“奚自？”子路曰：“自孔氏。”曰：“是知其不可而为之者与？”",
    "translation": "子路在石门住了一宵，［第二天清早进城，］司门者道：“从哪儿来？”子路道：“从孔家来。”司门者道：“就是那位知道做不到却定要去做的人吗？”",
    "annotations": "【注释】⑴石门——《后汉书·张皓王龚传论》注引郑玄《论语注》云：“石门，鲁城外门也。”"
  },
  {
    "id": 415,
    "title": "憲問 14.39",
    "text": "子击磬于卫，有荷蒉而过孔氏之门者，曰：“有心哉，击磬乎！”既而曰：“鄙哉，踁踁乎！莫己知也，斯己而已矣。深则厉，浅则揭⑴。”\n子曰：“果哉！末之难矣。”",
    "translation": "孔子在卫国，一天正敲着磬，有一个挑着草筐子的汉子恰在门前走过，便说道：“这个敲磬是有深意的呀！”等一会又说道：“磬声踁踁的，可鄙呀，［它好像在说，没有人知道我呀！］没有人知道自己，这就罢休好了。水深，索性连衣裳走过去；水浅，无妨撩起衣裳走过去。”\n孔子道：“好坚决！没有办法说服他了。”",
    "annotations": "【注释】⑴深厉浅揭——两句见于《诗经·邶风·匏有苦叶》。这是比喻。水深比喻社会非常黑暗，只得听之任之；水浅比喻黑暗的程度不深，还可以使自己不受沾染，便无妨撩起衣裳，免得濡湿。"
  },
  {
    "id": 416,
    "title": "憲問 14.40",
    "text": "子张曰：“《书》云：‘高宗谅阴⑴，三年不言。’何谓也？”子曰：“何必高宗，古之人皆然。君薨，百官总己以听于冢宰三年。”",
    "translation": "子张道：“《尚书》说：‘殷高宗守孝，住在凶庐，三年不言语。’这是什么意思？”孔子道：“不仅仅高宗，古人都是这样：国君死了，继承的君王三年不问政治，各部门的官员听命于宰相。”",
    "annotations": "【注释】⑴谅阴——居丧时所住的房子，又叫“凶庐”。两语见《无逸篇》。"
  },
  {
    "id": 417,
    "title": "憲問 14.41",
    "text": "子曰：“上好礼，则民易使也。”",
    "translation": "孔子说：“在上位的人若遇事依礼而行，就容易使百姓听从指挥。”",
    "annotations": ""
  },
  {
    "id": 418,
    "title": "憲問 14.42",
    "text": "子路问君子。子曰：“修己以敬。” 曰：“如斯而已乎？”曰：“修己以安人⑴。” 曰：“如斯而已乎？”曰：“修己以安百姓。修己以安百姓⑵，尧舜其犹病诸？”",
    "translation": "子路问怎样才能算是一个君子。孔子道：“修养自己来严肃认真地\n对待工作。” 子路道：“这样就够了吗？”孔子道：“修养自己来使上层人物安乐。” 子路道：“这样就够了吗？”孔子道：“修养自己来使所有老百姓安乐。修养自\n己来使所有老百姓安乐，尧舜大概还没有完全做到哩！”",
    "annotations": "【注释】⑴人——这个“人”字显然是狭义的“人”（参见1.5注四），没有把“百姓”包括在内。⑵修己以安百姓——雍也篇说：“博施于民……尧舜其犹病诸。”（6.30）这里说：“修己以安百姓，尧舜其犹病诸。”可见这里的“修己以安百姓”就是“博施于民”。"
  },
  {
    "id": 419,
    "title": "憲問 14.43",
    "text": "原壤⑴夷俟⑵。子曰：“幼而不孙弟⑶，长而无述焉，老而不死，是为贼。”以杖叩其胫。",
    "translation": "原壤两腿像八字一样张开坐在地上，等着孔子。孔子骂道：“你幼小时候不懂礼节，长大了毫无贡献，老了还白吃粮食，真是个害人精。”说完，用拐杖敲了敲他的小腿。",
    "annotations": "【注释】⑴原壤——孔子的老朋友，《礼记·檀弓》记载他一段故事，说他母亲死了，孔子去帮助他治丧，他却站在棺材上唱起歌来了，孔子也只好装做没听见。大概这人是一位另有主张而立意反对孔子的人。⑵夷俟——夷，箕踞；俟，等待。⑵孙弟——同逊悌。"
  },
  {
    "id": 420,
    "title": "憲問 14.44",
    "text": "阙党⑴童子将命。或问之曰：“益者与？”子曰：“吾见其居于位⑵也。见其与先生并行⑶也。非求益者也，欲速成者也。”",
    "translation": "阙党的一个童子来向孔子传达信息。有人问孔子道：“这小孩是肯求上进的人吗？孔子道：“我看见他[大模大样地]坐在位上，又看见他同长辈并肩而行。这不是个肯求上进的人，只是一个急于求成的人。”",
    "annotations": "【注释】⑴阙党——顾炎武的《日知録》说：“《史记·鲁世家》‘炀公筑茅阙门’，盖阙门之下，其里卽名阙里，夫子之宅在焉。亦谓之阙党。”案顾氏此说很对（阎若璩《四书释地》的驳论不对），《荀子·儒效篇》也有孔子“居于阙党”的记载，可见阙党为孔子所居之地名。⑵居于位——根据《礼记·玉藻》的记载，“童子无事则立主人之北，南面。”则“居于位”是不合当日礼节的。⑶与先生并行 ——《礼记·曲礼》上篇说：“五年以长，则肩随之”（“肩随”就是与之并行而稍后），而童子的年龄相差甚远，依当日礼节，不能和成人并行。"
  },
  {
    "id": 421,
    "title": "衛靈公 15.1",
    "text": "卫灵公问陈⑴于孔子。孔子对曰：“俎豆⑵之事，则尝闻之矣；军旅之事，未之学也。”明日遂行。",
    "translation": "卫灵公向孔子问军队陈列之法。孔子答道：“礼仪的事情，我曾经听到过；军队的事情，从来没学习过。”第二天便离开卫国。",
    "annotations": "【注释】⑴陈——就是今天的“阵”字。⑵俎豆之事——俎和豆都是古代盛肉食的器皿，行礼时用它，因之藉以表示礼仪之事。这种用法和泰伯篇第八的“笾豆之事”相同。"
  },
  {
    "id": 422,
    "title": "衛靈公 15.2",
    "text": "在陈绝粮，从者病，莫能兴。子路愠见曰：“君子亦有穷乎？”子曰：“君子固穷，小人穷斯滥矣。”",
    "translation": "孔子在陈国断绝了粮食，跟随的人都饿病了，爬不起床来。子路很不高兴地来见孔子，说道：“君子也有穷得毫无办法的时候吗？”孔子道：“君子虽然穷，还是坚持着；小人一穷便无所不为了。”",
    "annotations": ""
  },
  {
    "id": 423,
    "title": "衛靈公 15.3",
    "text": "子曰：“赐也，女以予为多学而识之者与？”对曰：“然，非与？”曰：“非也，予一以贯之⑴。”",
    "translation": "孔子道：“赐！你以为我是多多地学习又能够记得住的吗？”子贡答道：“对呀，难道不是这样吗？”孔子道：“不是的，我有一个基本观念来贯串它。 ”",
    "annotations": "【注释】⑴一以贯之——这和里仁篇的“夫子之道，忠恕而已矣”（4.15）的“一贯”相同。从这里可以看出，子贡他们所重视的，是孔子的博学多才，因之认为他是“多学而识之”；而孔子自己所重视的，则在于他的以忠恕之道贯穿于其整个学行之中。"
  },
  {
    "id": 424,
    "title": "衛靈公 15.4",
    "text": "子曰：“由！知德者鲜矣。”",
    "translation": "孔子对子路道：“由！懂得‘德’的人可少啦。”",
    "annotations": ""
  },
  {
    "id": 425,
    "title": "衛靈公 15.5",
    "text": "子曰：“无为而治⑴者其舜也与？夫何为哉？恭己正南面而已矣。”",
    "translation": "孔子说：“自己从容安静而使天下太平的人大概只有舜罢？他干了\n什么呢？庄严端正地坐朝廷罢了。”",
    "annotations": "【注释】⑴无为而治——舜何以能如此？一般儒者都以为他能“所任得其人，故优游而自逸也。”（《三国志·吴志·楼玄传》）如《大戴礼·主言篇》云：“昔者舜左禹而右皋陶，不下席而天下治。”《新序·杂事三》云：“故王者劳于求人，佚于得贤。舜举众贤在位，垂衣裳恭己无为而天下治。”赵岐《孟子注》也说：“言任官得其人，故无为而治”。"
  },
  {
    "id": 426,
    "title": "衛靈公 15.6",
    "text": "子张问行。子曰：“言忠信，行笃敬，虽蛮貊之邦，行矣。言不忠信，行不笃敬，虽州里，行乎哉？立则见其参于前也，在舆则见其倚于衡也，夫然后行。”子张书诸绅。",
    "translation": "子张问如何才能使自己到处行得通。孔子道：“言语忠诚老实，行为忠厚严肃，纵到了别的部族国家，也行得通。言语欺诈无信，行为刻薄轻浮，就是在本乡本土，能行得通吗？站立的时候，就［彷佛］看见“忠诚老实忠厚严肃”几个字在我们面前；在车箱里，也［彷佛］看见它刻在前面的横木上；［时时刻刻记着它，］这才能使自己到处行得通。”子张把这些话写在大带上。",
    "annotations": ""
  },
  {
    "id": 427,
    "title": "衛靈公 15.7",
    "text": "子曰：“直哉史鱼⑴！邦有道，如矢；邦无道，如矢。君子哉蘧伯玉⑵！邦有道，则仕；邦无道，则可卷而怀之。“",
    "translation": "孔子说：“好一个刚直不屈的史鱼！政治清明也像箭一样直，政治黑暗也像箭一样直。好一个君子蘧伯玉！政治清明就出来做官，政治黑暗就可以把自己的本领收藏起来。”",
    "annotations": "【注释】⑴史鱼——卫国的大夫史鳅，字子鱼。他临死时嘱咐他的儿子，不要“治丧正室”，以此劝告卫灵公进用蘧伯玉，斥退弥子瑕，古人叫为“尸谏”，事见《韩诗外传》卷七。⑵蘧伯玉——事可参见《左传》襄公十四年和二十六年。"
  },
  {
    "id": 428,
    "title": "衛靈公 15.8",
    "text": "子曰：“可与言而不与之言，失人；不可与言而与之言，失言。知者不失人，亦不失言。”",
    "translation": "孔子说：“可以同他谈，却不同他谈，这是错过人才；不可以同他\n谈，却同他谈，这是浪费言语。聪明人既不错过人才，也不浪费言语。”",
    "annotations": ""
  },
  {
    "id": 429,
    "title": "衛靈公 15.9",
    "text": "子曰：“志士仁人，无求生以害仁，有杀身以成仁。“",
    "translation": "孔子说：“志士仁人，不贪生怕死因而损害仁德，只勇于牺牲来成全仁德。”",
    "annotations": ""
  },
  {
    "id": 430,
    "title": "衛靈公 15.10",
    "text": "子贡问为仁。子曰：“工欲善其事，必先利其器。居是邦也，事其大夫之贤者，友其士⑴之仁者。”",
    "translation": "子贡问怎样去培养仁德。孔子道：“工人要搞好他的工作，一定先要搞好他的工具。我们住在一个国家，就要敬奉那些大官中的贤人，结交那些士人中的仁人。”",
    "annotations": "【注释】⑴士——《论语》中的“士”，有时指有一定修养的人，如“士志于道”（4.9）的“士”。有时指有一定社会地位的人。如“使于四方，不辱君命，可调士矣”的“士”（13.20）。此处和“大夫”并言，可能是“士、大夫”之“士”，卽已做官而位置下于大夫的人。"
  },
  {
    "id": 431,
    "title": "衛靈公 15.11",
    "text": "颜渊问为邦。子曰：“行夏之时⑴，乘殷之辂⑵，服周之冕⑶，乐则韶、舞⑷。放郑声⑸，远佞人。郑声淫，佞人殆。”",
    "translation": "颜渊问怎样去治理国家。孔子道：“用夏朝的历法，坐殷朝的车子，戴周朝的礼帽，音乐就用韶和武。舍弃郑国的乐曲，斥退小人。郑国的乐曲靡曼淫秽，小人危险。”",
    "annotations": "【注释】⑴行夏之时——据古史记载，夏朝用的自然历，以建寅之月（旧历正月）为每年的第一月，春、夏、秋、冬合乎自然现象。周朝则以建子之月（旧历十一月）为每年的第一月，而且以冬至日为元日。这个虽然在观测天象方面比较以前进步，但实用起来却不及夏历方便于农业生产。就是在周朝，也有很多国家是仍旧用夏朝历法。⑵乘殷之辂——辂音路，商代的车子，比周代的车子自然朴质些。所以《左传》桓公二年也说：“大辂、越席，昭其俭也。”⑵服周之冕——周代的礼帽自然又比以前的华美，孔子是不反对礼服的华美的，赞美禹“致美乎黻冕”可见。⑷韶、舞——韶是舜时的音乐，“舞”同“武”，周武王时的音乐。⑸放郑声——“郑声”和“郑诗”不同。郑诗指其文辞，郑声指其乐曲。说本明人杨慎《丹铅总録》。清人陈启源《毛诗稽古篇》。"
  },
  {
    "id": 432,
    "title": "衛靈公 15.12",
    "text": "子曰：“人无远虑，必有近忧。”",
    "translation": "孔子说：“一个人没有长远的考虑，一定会有眼前的忧患。”",
    "annotations": ""
  },
  {
    "id": 433,
    "title": "衛靈公 15.13",
    "text": "子曰：“已矣乎！吾未见好德如好色⑴者也。”",
    "translation": "孔子说：“完了吧！我从没见过像喜欢美貌一般地喜欢美德的人哩。 ”",
    "annotations": "【注释】⑴好色——据《史记·孔子世家》，孔子“居卫月余，灵公与夫人（南子）同车，宦者雍渠参乘出，使孔子为次乘，招摇市过之。”孔子因发这一感叹。"
  },
  {
    "id": 434,
    "title": "衛靈公 15.14",
    "text": "子曰：“藏文仲⑴其窃位者与！知柳下惠⑵之贤而不与立⑶也。”",
    "translation": "孔子说：“臧文仲大概是个做官不管事的人，他明知柳下惠贤良，却不给他官位。”",
    "annotations": "【注释】⑴臧文仲——鲁国的大夫臧孙辰，历仕庄、闵、僖、文四朝。⑵柳下惠——鲁国贤者，本名展获，字禽，又叫展季。“柳下”可能是其所居，因以为号；据《列女传》，“惠”是由他的妻子的倡议给他的私谥（不由国家授予的谥号叫私谥）。⑶立——同“位”，说详俞樾《羣经平议》。"
  },
  {
    "id": 435,
    "title": "衛靈公 15.15",
    "text": "子曰：“躬自厚⑴而薄责于人，则远怨矣。”",
    "translation": "孔子说：“多责备自己，而少责备别人，怨恨自然不会来了。“",
    "annotations": "【注释】⑴躬自厚——本当作“躬自厚责”，“责”字探下文“薄责”之“责”而省略。说详拙著《文言语法》。“躬自”是一双音节的副词，和《诗经·卫风·氓》的“静言思之，躬自悼矣”的“躬自”用法一样。"
  },
  {
    "id": 436,
    "title": "衛靈公 15.16",
    "text": "子曰：“不曰‘如之何⑴，如之何’者，吾末如之何也已矣。”",
    "translation": "孔子说：“［一个人］不想想‘怎么办，怎么办’的，对这种人，我也不知道怎么办了。”",
    "annotations": "【注释】⑴如之何——“不曰如之何”意思就是不动脑筋。《荀子·大略篇》说：“天子卽位，上卿进曰，如之何，忧之长也。”则说如之何的，便是深忧远虑的人。"
  },
  {
    "id": 437,
    "title": "衛靈公 15.17",
    "text": "子曰：“羣居终日，言不及义，好行小慧，难矣哉！”",
    "translation": "孔子说：“同大家整天在一块，不说一句有道理的话，只喜欢卖弄小聪明，这种人真难教导！”",
    "annotations": ""
  },
  {
    "id": 438,
    "title": "衛靈公 15.18",
    "text": "子曰：“君子义以为质，礼以行之，孙以出之⑴，信以成之。君子哉！ ”",
    "translation": "孔子说：“君子［对于事业］，以合宜为原则，依礼节实行它，用谦逊的言语说出它，用诚实的态度完成它。真个是位君子呀！”",
    "annotations": "【注释】⑴孙以出之——“出”谓出言。何晏《论语集解》引郑玄注云：“孙以出之谓言语。”"
  },
  {
    "id": 439,
    "title": "衛靈公 15.19",
    "text": "子曰：“君子病无能焉，不病人之不己知也。”",
    "translation": "孔子说：“君子只惭愧自己没有能力，不怨恨别人不知道自己。”",
    "annotations": ""
  },
  {
    "id": 440,
    "title": "衛靈公 15.20",
    "text": "子曰：“君子疾没世而名不称焉。”",
    "translation": "孔子说：“到死而名声不被人家称述，君子引以为恨。”",
    "annotations": ""
  },
  {
    "id": 441,
    "title": "衛靈公 15.21",
    "text": "子曰：“君子求诸己，小人求诸人。”",
    "translation": "孔子说：“君子要求自己，小人要求别人。”",
    "annotations": ""
  },
  {
    "id": 442,
    "title": "衛靈公 15.22",
    "text": "子曰：“君子矜而不争，羣而不党⑴。”",
    "translation": "孔子说：“君子庄矜而不争执，合羣而不闹宗派。”",
    "annotations": "【注释】⑴羣而不党——“羣而不党”可能包含着“周而不比”（2.14）以及“和而不同”（13.23）两个意思。"
  },
  {
    "id": 443,
    "title": "衛靈公 15.23",
    "text": "子曰：“君子不以言举人，不以人废言。”",
    "translation": "孔子说：“君子不因为人家一句话［说得好］便提拔他，不因为他是坏人而鄙弃他的好话。”",
    "annotations": ""
  },
  {
    "id": 444,
    "title": "衛靈公 15.24",
    "text": "子贡问曰：“有一言而可以终身行之者乎？”子曰：“其恕⑴乎！己所不欲，勿施于人。”",
    "translation": "子贡问道：“有没有一句可以终身奉行的话呢？”孔子道：“大概是‘恕’罢！自己所不想要的任何事物，就不要加给别人。”",
    "annotations": "【注释】⑴恕——“忠”（己欲立而立人，己欲达而达人）是有积极意义的道德，未必每个人都有条件来实行。“恕”只是“己所不欲，勿施于人”，则谁都可以这样做，因之孔子在这里言“恕”不言“忠”。《礼记·大学》篇的“絜矩之道”就是“恕”道。可是在阶级社会里，也只能是幻想。"
  },
  {
    "id": 445,
    "title": "衛靈公 15.25",
    "text": "子曰：“吾之于人也，谁毁谁誉？如有所誉者，其有所试矣。斯民也，三代之所以直道而行也。”",
    "translation": "孔子说：“我对于别人，诋毁了谁？称赞了谁？假若我有所称赞，必然是曾经考验过他的。夏、商、周三代的人都如此，所以三代能直道而行。”",
    "annotations": ""
  },
  {
    "id": 446,
    "title": "衛靈公 15.26",
    "text": "子曰：“吾犹及史之阙文也。有马者借人乘之，今亡矣夫！”",
    "translation": "孔子说：“我还能够看到史书存疑的地方。有马的人［自己不会训练，］先给别人使用，这种精神，今天也没有了罢，”",
    "annotations": "【注释】“史之阙文”和“有马借人乘之”，其间有什么关连，很难理解。包咸的《论语章句》和皇侃的《义疏》都把它们看成两件不相关的事。宋叶梦得《石林燕语》却根据《汉书·艺文志》的引文无“有马”等七个字，因疑这七个字是衍文。其它穿凿的解释很多，依我看来，还是把它看为两件事较妥当。又有人说这七字当作“有焉者晋人之乘”（见《诂经精舍六集》卷九〈方赞尧有马者借人乘之解〉），更是毫无凭据的臆测。"
  },
  {
    "id": 447,
    "title": "衛靈公 15.27",
    "text": "子曰：“巧言乱德。小不忍⑴，则乱大谋。”",
    "translation": "孔子说：“花言巧语足以败坏道德。小事情不忍耐，便会败坏大事情。”",
    "annotations": "【注释】⑴小不忍——“小不忍”不仅是不忍小忿怒，也包括不忍小仁小恩，没有“蝮蛇螫手，壮士断腕”的勇气，也包括吝财不忍舍，以及见小利而贪。"
  },
  {
    "id": 448,
    "title": "衛靈公 15.28",
    "text": "子曰：“众恶之，必察焉⑴；众好之，必察焉。”",
    "translation": "孔子说：“大家厌恶他，一定要去考察；大家喜爱他，也一定要去考察。”",
    "annotations": "【注释】⑴必察焉——子路篇有这样一段：“子贡问曰：‘乡人皆好之，何如？’子曰：‘未可也。’‘乡人皆恶之，何如？’子曰：‘未可也。不如乡人之善者好之，其不善者恶之。’”（13.24）可以和这段话互相发明。"
  },
  {
    "id": 449,
    "title": "衛靈公 15.29",
    "text": "子曰：“人能弘道，非道弘人⑴。”",
    "translation": "孔子说：“人能够把道廓大，不是用道来廓大人。”",
    "annotations": "【注释】⑴这一章只能就字面来翻译，孔子的真意何在，又如何叫做“非道\n弘人”，很难体会。朱熹曾经强为解释，而郑皓的《论语集注述要》却说，“此章最不烦解而最可疑”，则我们也只好不加臆测。《汉书·董仲舒传》所载董仲舒的对策和《礼乐志》所载的平当对策都引此二句，都以为是治乱兴废在于人的意思，但细加思考，仍未必相合。"
  },
  {
    "id": 450,
    "title": "衛靈公 15.30",
    "text": "子曰：“过而不改，是谓过矣⑴。”",
    "translation": "孔子说：“有错误而不改正，那个错误便真叫做错误了。”",
    "annotations": "【注释】⑴是谓过矣——《韩诗外传》卷三曾引孔子的话说：“过而改之，是不过也。”"
  },
  {
    "id": 451,
    "title": "衛靈公 15.31",
    "text": "子曰：“吾尝终日不食，终夜不寝，以思，无益，不如学也。”",
    "translation": "孔子说：“我曾经整天不吃，整晚不睡，去想，没有益处，不如去学习。”",
    "annotations": ""
  },
  {
    "id": 452,
    "title": "衛靈公 15.32",
    "text": "子曰：“君子谋道不谋食。耕也，馁在其中矣；学也，禄在其中⑴矣。君子忧道不忧贫。”",
    "translation": "孔子说：“君子用心力于学术，不用心力于衣食。耕田，也常常饿着肚皮；学习，常常得到俸禄。君子只着急得不到道，不着急得不到财。”",
    "annotations": "【注释】⑴禄在其中——这一章可以和“樊迟请学稼”章（13.4）结合着看。"
  },
  {
    "id": 453,
    "title": "衛靈公 15.33",
    "text": "子曰：“知及之⑴，仁不能守之；虽得之，必失之。知及之，仁能守之。不庄以莅之，则民不敬。知及之，仁能守之，庄以莅之，动之不以礼，未善也。”",
    "translation": "孔子说：“聪明才智足以得到它，仁德不能保持它；就是得到，一定会丧失。聪明才智足以得到它，仁德能保持它。不用严肃态度来治理百姓，百姓也不会认真［地生活和工作］。聪明才智足以得到它，仁德能保持它，能用严肃的态度来治理百姓，假若不合理合法地动员百姓，是不够好的。”",
    "annotations": "【注释】⑴知及之——“知及之”诸“之”字究竟何指，原文未曾说出。以“不庄以莅之”“动之不以礼”诸句来看，似是小则指卿大夫士的禄位，大则指天下国家。不然，不会涉及临民和动员人民的。"
  },
  {
    "id": 454,
    "title": "衛靈公 15.34",
    "text": "子曰：“君子不可小知而可大受也，小人不可大受而可小知也。”",
    "translation": "孔子道：“君子不可以用小事情考验他，却可以接受重大任务；小人不可以接受重大任务，却可以用小事情考验他。”",
    "annotations": ""
  },
  {
    "id": 455,
    "title": "衛靈公 15.35",
    "text": "子曰：“民之于仁也，甚于水火⑴。水火，吾见蹈而死者矣，未见蹈仁而死者也。”",
    "translation": "孔子说：“百姓需要仁德，更急于需要水火。往水火里去，我看见因而死了的，却从没有看见践履仁德因而死了的。”",
    "annotations": "【注释】⑴甚于水火——《孟子·尽心上》说：“民非水火不生活”，译文摘取此意，故加“需要”两字。"
  },
  {
    "id": 456,
    "title": "衛靈公 15.36",
    "text": "子曰：“当仁，不让于师。”",
    "translation": "孔子说：“面临着仁德，就是老师，也不同他谦让。”",
    "annotations": ""
  },
  {
    "id": 457,
    "title": "衛靈公 15.37",
    "text": "子曰：“君子贞⑴而不谅⑵。”",
    "translation": "孔子说：“君子讲大信，却不讲小信。”",
    "annotations": "【注释】⑴贞——《贾子·道术篇》云：“言行抱一谓之贞。”所以译文以“大信”译之。⑵谅——朱骏声《说文通训定声说》这“谅”字假借为“勍”，犹固执也。则他把这“贞”字解为《伪古文尚书·太甲》“万邦以贞”的“贞”，正也。似不妥。"
  },
  {
    "id": 458,
    "title": "衛靈公 15.38",
    "text": "子曰：“事君，敬其事而后其食⑴。”",
    "translation": "孔子说：“对待君上，认真工作，把拿俸禄的事放在后面。”",
    "annotations": "【注释】⑴而后其食——据宋晁公武《郡斋读书志》的记载，蜀石经作“而后食其禄”。"
  },
  {
    "id": 459,
    "title": "衛靈公 15.39",
    "text": "子曰：“有教无类⑴。”",
    "translation": "孔子说：“人人我都教育，没有［贫富、地域等等］区别。”",
    "annotations": "【注释】⑴无类——“自行束修以上，吾未尝无诲焉”（7.7），便是“有教无\n类。”"
  },
  {
    "id": 460,
    "title": "衛靈公 15.40",
    "text": "子曰：“道不同，不相为谋。”",
    "translation": "孔子说：“主张不同，不互相商议。”",
    "annotations": ""
  },
  {
    "id": 461,
    "title": "衛靈公 15.41",
    "text": "子曰：“辞达⑴而已矣。”",
    "translation": "孔子说：“言辞，足以达意便罢了。”",
    "annotations": "【注释】⑴辞达——可以和“文胜质则史”（6.18）参看。过于浮华的词藻，\n是孔子所不同意的。"
  },
  {
    "id": 462,
    "title": "衛靈公 15.42",
    "text": "师冕⑴见，及阶，子曰：“阶也。”及席，子曰：“席也。”皆坐，子告之曰：“某在斯，某在斯。”\n师冕出。子张问曰：“与师言之道与？”子曰：“然；固相师之道也。”",
    "translation": "师冕来见孔子，走到阶沿，孔子道：“这是阶沿啦。”走到坐席旁，孔子道：“这是坐席啦。”都坐定了，孔子告诉他说：“某人在这里，某人在这里。”\n师冕辞了出来。子张问道：“这是同瞎子讲话的方式吗？”孔子道：“对的；这本来是帮助瞎子的方式。”",
    "annotations": "【注释】⑴师冕——师，乐师，冕，这人之名。古代乐官一般用瞎子充当。"
  },
  {
    "id": 463,
    "title": "季氏 16.1",
    "text": "季氏将伐颛臾⑴。冉有、季路见于孔子曰：“季氏将有事⑵于颛臾。”\n孔子曰：“求！无乃尔是过⑶与？夫颛臾，昔者先王以为东蒙⑷主，且在邦域之中矣，是社稷之臣也。何以伐为？”\n冉有曰：“夫子欲之，吾二臣者皆不欲也。”\n孔子曰：“求！周任⑸有言曰：‘陈力就列，不能者止。’危而不持，颠而不扶，则将焉用彼相矣？且尔言过矣，虎兕出于柙，龟玉毁于椟中，是谁之过与？”\n冉有曰：“今夫颛臾，固而近于费⑹。今不取，后世必为子孙忧。”\n孔子曰：“求！君子疾夫舍⑺曰欲之而必为之辞。丘也闻有国有家者，不患寡当作贫而患不均，不患贫当作寡而患不安⑻。盖均无贫，和无寡，安无倾。夫如是，故远人不服，则修文德以来之。既来之，则安之。今由与求也，相夫子，远人不服，而不能来也；邦分崩离析，而不能守也；而谋动干戈于邦内。吾恐季孙之忧，不在颛臾，而在萧墙之内⑼也。”",
    "translation": "季氏准备攻打颛臾。冉有、子路两人谒见孔子，说道：“季氏准备对颛臾使用兵力。”\n孔子道：“冉求，这难道不应该责备你吗？颛臾，上代的君王曾经授权他主持东蒙山的祭祀，而且它的国境早在我们最初被封时的疆土之中，这正是和鲁国共安危存亡的藩属，为什么要去攻打它呢？”\n冉有道：“季孙要这么干，我们两人本来都是不同意的。”\n孔子道：“冉求！周任有句话说：‘能够贡献自己的力量，这再任职；如果不行，就该辞职。’譬如瞎子遇到危险，不去扶持；将要摔倒了，不去搀扶，那又何必用助手呢？你的话是错了。老虎犀牛从槛里逃了出来，龟壳美玉在匣子里毁坏了，这是谁的责任呢？”\n冉有道：“颛臾，城墙既然坚牢，而且离季孙的采邑费地很近。现今不把它占领，日子久了，一定会给子孙留下祸害。”\n孔子道：“冉求！君子就讨厌［那种态度，］不说自己贪心无厌，却一定另找借口。我听说过：无论是诸侯或者大夫，不必着急财富不多，只须着急财富不均；不必着急人民太少，只须着急境内不安。若是财富平均，便无所谓贫穷；境内和平团结，便不会觉得人少；境内平安，便不会倾危。做到这样，远方的人还不归服，便再修仁义礼乐的政教来招致他们。他们来了，就得使他们安心。如今仲由和冉求两人辅相季孙，远方之人不归服，却不能招致；国家支离破碎，却不能保全；反而想在国境以内使用兵力。我恐怕季孙的忧愁不在颛臾，却在鲁君哩。”",
    "annotations": "【注释】⑴颛臾——鲁国的附庸国家，现在山东省费县西北八十里有颛臾村，当是古颛臾之地。⑵有事——《左传》成公十三年，“国之大事，在祀与戎。”这“有事”卽指用兵。⑶尔是过——不能解作“尔之过”，因为古代人称代词表示领位极少再加别的虚词的（像《尚书·康诰》“朕其弟小子封”只是极个别的例子）。这里“过”字可看作动词，“是”字是表示倒装之用的词，顺装便是“过尔”，“责备你”、“归罪于你”的意思。⑷东蒙——卽蒙山，在今山东蒙阴县南，接费县界。⑸周任——古代的一位史官。⑹费——音秘，bèi，鲁国季氏采邑，今山东费县西南七十里有费城。⑺舍——同“舍”。⑻不患寡而患不均，不患贫而患不安——当作“不患贫而患不均，不患寡而患不安”，“贫”和“均”是从财富着眼，下文“均无贫”可以为证；“寡”和“安”是从人民着眼，下文“和无寡”可以为证。说详俞樾《羣经平议》。⑼萧墙之内——“萧墙”是鲁君所用的屏风。人臣至此屏风，便会肃然起敬，所以叫做萧墙（萧字从肃得声）。“萧墙之内”指鲁君。当时季孙把持鲁国政治，和鲁君矛盾很大，也知道鲁君想收拾他以收回主权，因此怕颛臾凭借有利的地势起而帮助鲁国，于是要先下手为强，攻打颛臾。孔子这句话，深深地刺中了季孙的内心。"
  },
  {
    "id": 464,
    "title": "季氏 16.2",
    "text": "孔子曰：“天下有道，则礼乐征伐自天子出；天下无道，则礼乐征伐自诸侯出。自诸侯出，盖十世希不失矣；自大夫出，五世希不失矣；陪臣执国命，三世希不失矣⑴。天下有道，则政不在大夫。天下有道，则庶人不议。”",
    "translation": "孔子说：“天下太平，制礼作乐以及出兵都决定于天子；天下昏乱，制礼作乐以及出兵便决定于诸侯。决定于诸侯，大概传到十代，很少还能继续的；决定于大夫，传到五代，很少还能继续的；若是大夫的家臣把持国家政权，传到三代很少还能继续的。天下太平，国家的最高政治权力就不会掌握在大夫之手。天下太平，老百姓就不会议论纷纷。”",
    "annotations": "【注释】⑴孔子这一段话可能是从考察历史，尤其是当日时事所得出的结论。“自天子出”，孔子认为尧、舜、禹、汤以及西周都如此的；“天下无道”则自齐桓公以后，周天子已无发号施令的力量了。齐自桓公称霸，历孝公、昭公、懿公、惠公、顷公、灵公、庄公、景公、悼公、简公十公，至简公而为陈恒所杀，孔子亲身见之；晋自文公称霸，历襄公、灵公、成公、景公、厉公、平公、昭公、顷公九公，六卿专权，也是孔子所亲见的。所以说：“十世希不失”。鲁自季友专政，历文子、武子、平子、桓子而为阳虎所执，更是孔子所亲见的。所以说“五世希不失”。至于鲁季氏家臣南蒯、公山弗扰、阳虎之流都当身而败，不曾到过三世。当时各国家臣有专政的，孔子言“三世希不失”，盖宽言之。这也是历史演变的必然，愈近变动时代，权力再分配的鬬争，一定愈加激烈。这却是孔子所不明白的。"
  },
  {
    "id": 465,
    "title": "季氏 16.3",
    "text": "孔子曰：“禄之去公室五世⑴矣，政逮于大夫四世⑴矣，故夫三桓⑵之子孙微矣。”",
    "translation": "孔子说：“国家政权离开了鲁君，［从鲁君来说，］已经五代了；政权到了大夫之手，［从季氏来说，］已经四代了，所以桓公的三房子孙现在也衰微了。”",
    "annotations": "【注释】⑴五世四世——自鲁君丧失政治权力到孔子说这段话的时候，经历了宣公、成公、襄公、昭公、定公五代；自季氏最初把持鲁国政治到孔子说这段话时，经历了文子、武子、平子、桓子四代。说本毛奇龄《论语稽求篇》。⑵三桓——鲁国的三卿，仲孙（卽孟孙）、叔孙、季孙都出于鲁桓公，故称“三桓”。"
  },
  {
    "id": 466,
    "title": "季氏 16.4",
    "text": "孔子曰：“益者三友，损者三友。友直，友谅⑴，友多闻，益矣。友便辟，友善柔，友便佞，损矣。”",
    "translation": "孔子说：“有益的朋友三种，有害的朋友三种。同正直的人交友，同信实的人交友，同见闻广博的人交友，便有益了。同谄媚奉承的人交友，同当面恭维背面毁谤的人交友，同夸夸其谈的人交友，便有害了。”",
    "annotations": "【注释】⑴谅——《说文》：“谅，信也。”“谅”和“信”有时意义相同，这里便\n如此。有时意义有别。如宪问篇第十四“岂若匹夫匹妇之为谅也”的“谅”只是“小信”的意思。"
  },
  {
    "id": 467,
    "title": "季氏 16.5",
    "text": "孔子曰：“益者三乐，损者三乐。乐节礼乐，乐道人之善，乐多贤友，益矣。乐骄乐，乐佚游，乐晏乐，损矣。“",
    "translation": "孔子说：“有益的快乐三种，有害的快乐三种。以得到礼乐的调节为快乐，以宣扬别人的好处为快乐，以交了不少有益的朋友为快乐，便有益了。以骄傲为快乐，以游荡忘返为快乐，以饮食荒淫为快乐，便有害了。”",
    "annotations": ""
  },
  {
    "id": 468,
    "title": "季氏 16.6",
    "text": "孔子曰：“侍于君子有三愆：言未及之而言谓之躁，言及之而不言谓之隐，未见颜色而言谓之瞽。”",
    "translation": "孔子说：“陪着君子说话容易犯三种过失：没轮到他说话，却先说，叫做急躁；该说话了，却不说，叫做隐瞒；不看看君子的脸色便贸然开口，叫做瞎眼睛。”",
    "annotations": ""
  },
  {
    "id": 469,
    "title": "季氏 16.7",
    "text": "孔子曰：“君子有三戒：少之时，血气未定，戒之在色；及其壮也，血气方刚，戒之在鬬；及其老也，血气既衰，戒之在得⑴。”",
    "translation": "孔子说：“君子有三件事情应该警惕戒备：年轻的时候，血气未定，便要警戒，莫迷恋女色；等到壮大了，血气正旺盛，便要警戒，莫好胜喜鬬；等到年老了，血气已经衰弱，便要警戒，莫贪求无厌。”",
    "annotations": "【注释】⑴孔安国注云：“得，贪得。”所贪者可能包括名誉、地位、财货在内。《淮南子·诠言训》：“凡人之性，少则猖狂，壮则强暴，老则好利。”意本于此章，而以“好利”释得，可能涵义太狭。"
  },
  {
    "id": 470,
    "title": "季氏 16.8",
    "text": "孔子曰：“君子有三畏：畏天命，畏大人⑴，畏圣人之言。小人不知天命而不畏也，狎大人，侮圣人之言。”",
    "translation": "孔子说：“君子害怕的有三件事：怕天命，怕王公大人，怕圣人的\n言语。小人不懂得天命，因而不怕它；轻视王公大人，轻侮圣人的言语。”",
    "annotations": "【注释】⑴大人——古代对于在高位的人叫“大人”，如《易·干卦》“利见大人”，《礼记·礼运》“大人世及以为礼”，《孟子·尽心下》“说大人，则藐之”。对于有道德的人也可以叫“大人”，如《孟子·告子上》“从其大体为大人”。这里的“大人”是指在高位的人，而“圣人”则是指有道德的人。"
  },
  {
    "id": 471,
    "title": "季氏 16.9",
    "text": "孔子曰：“生而知之者上也，学而知之者次也；困而学之，又其次也；困而不学，民斯为下矣。”",
    "translation": "孔子说：“生来就知道的是上等，学习然后知道的是次一等；实践中遇见困难，再去学它，又是再次一等；遇见困难而不学，老百姓就是这种最下等的了。”",
    "annotations": "【注释】"
  },
  {
    "id": 472,
    "title": "季氏 16.10",
    "text": "孔子曰：“君子有九思：视思明，听思聪，色思温，貌思恭，言思忠，事思敬，疑思问，忿思难，见得思义。”",
    "translation": "孔子说：“君子有九种考虑：看的时候，考虑看明白了没有；听的时候，考虑听清楚了没有；脸上的颜色，考虑温和么；容貌态度，考虑庄矜么；说的言语，考虑忠诚老实么；对待工作，考虑严肃认真么；遇到疑问，考虑怎样向人家请教；将发怒了，考虑有什么后患；看见可得的，考虑我是否应该得。”",
    "annotations": "【注释】"
  },
  {
    "id": 473,
    "title": "季氏 16.11",
    "text": "孔子曰：“见善如不及，见不善如探汤。吾见其人矣，吾闻其语矣。隐居以求其志，行义以达其道。吾闻其语矣，未见其人也。”",
    "translation": "孔子说：“看见善良，努力追求，好像赶不上似的；遇见邪恶，使劲避开，好像将伸手到沸水里。我看见这样的人，也听过这样的话。避世隐居求保全他的意志，依义而行来贯彻他的主张。我听过这样的话，却没有见过这样的人。”",
    "annotations": "【注释】"
  },
  {
    "id": 474,
    "title": "季氏 16.12",
    "text": "齐景公有马千驷⑴，死之日，民无德而称焉。伯夷、叔齐饿于首阳⑵\n之下，民到于今称之。其斯之谓与⑶？",
    "translation": "齐景公有马四千匹，死了以后，谁都不觉得他有什么好行为可以称述。伯夷、叔齐两人饿死在首阳山下，大家到现在还称颂他。那就是这个意思吧！",
    "annotations": "【注释】⑴千驷——古代一般用四匹马驾一辆车，所以一驷就是四匹马。《左传》哀公八年：“鲍牧谓羣公子曰：‘使女有马千乘乎？’”这“千乘”就是景公所遗留的“千驷”。鲍牧用此来诱劝羣公子争夺君位，可见“千乘”是一笔相当富厚的私产。⑵首阳——山名，现在何地，古今传说纷歧，总之，已经难于确指。⑶其斯之谓与——这一章既然没有“子曰”字样，而且“其斯之谓与”的上面无所承受，程颐以为颜渊篇第十二的“诚不以富，亦祗以异”两句引文应该放在此处“其斯之谓与”之上，但无证据。朱熹〈答江德功书〉云：“此章文势或有断续，或有阙文，或非一章，皆不可考。”"
  },
  {
    "id": 475,
    "title": "季氏 16.13",
    "text": "陈亢⑴问于伯鱼曰：“子亦有异闻乎？”\n对曰：“未也。尝独立，鲤趋而过庭。曰：‘学诗乎？’对曰：‘未也。’‘不学诗，无以言。’鲤退而学诗。他日，又独立，鲤趋而过庭。曰：‘学礼乎？’对曰：‘未也。’‘不学礼，无以立。’鲤退而学礼。闻斯二者。”\n陈亢退而喜曰：“问一得三，闻诗，闻礼，又闻君子之远其子也。”",
    "translation": "陈亢向孔子的儿子伯鱼问道：“您在老师那儿，也得着与众不同的传授吗？”\n答道：“没有。他曾经一个人站在庭中，我恭敬地走过。他问我道：‘学诗没有？’我道：‘没有。’他便道：‘不学诗就不会说话。’我退回便学诗。过了几天，他又一个人站在庭中，我又恭敬地走过。他问道：‘学礼没有？’我答道：‘没有。’他道：‘不学礼，便没有立足社会的依据。’我退回便学礼。只听到这两件。”\n陈亢回去非常高兴地道：“我问一件事，知道了三件事。知道诗，知道礼，又知道君子对他儿子的态度。”",
    "annotations": "【注释】⑴陈亢——亢音刚，gāng，就是陈子禽。"
  },
  {
    "id": 476,
    "title": "季氏 16.14",
    "text": "邦君之妻，君称之曰夫人，夫人自称曰小童；邦人称之曰君夫人，称诸异邦曰寡小君；异邦人称之亦曰君夫人⑴。",
    "translation": "国君的妻子，国君称她为夫人，她自称为小童；国内的人称她为君夫人，但对外国人便称她为寡小君；外国人称她也为君夫人。",
    "annotations": "【注释】⑴这章可能也是孔子所言，却遗落了“子曰”两字。有人疑心这是后人见竹简有空白处，任意附记的。殊不知书写《论语》的竹简不过八寸，短者每章一简，长者一章数简，断断没有多大空白能书写这四十多字。而且这一章既见于《古论》，又见于《鲁论》（《鲁论》作“固君之妻”），尤其可见各种古本都有之，决非后人所搀入。"
  },
  {
    "id": 477,
    "title": "陽貨 17.1",
    "text": "阳货⑴欲见孔子，孔子不见，归孔子豚⑵。\n孔子时其亡也，而往拜之。\n遇诸涂。\n谓孔子曰：“来！予与尔言。”曰⑶：“怀其宝而迷其邦，可谓仁乎？”曰：“不可。——好从事而亟⑷失时，可谓知乎？”曰：“不可。——日月逝矣，岁不我与。 ”\n孔子曰：“诺；吾将仕矣⑸。”",
    "translation": "阳货想要孔子来拜会他，孔子不去，他便送孔子一个［蒸熟了的］小猪，［使孔子到他家来道谢。］\n孔子探听他不在家的时候，去拜谢。\n两人在路上碰着了。\n他叫着孔子道：“来，我同你说话。”［孔子走了过去。］他又道：“自己有一身的本领，却听任着国家的事情糊里胡涂，可以叫做仁爱吗？”［孔子没吭声。］他便自己接口道：“不可以；——一个人喜欢做官，却屡屡错过机会，可以叫做\n聪明吗？”［孔子仍然没吭声。］他又自己接口道：“不可以；——时光一去，就不再回来了呀。”\n孔子这才说道：“好吧；我打算做官了。”",
    "annotations": "【注释】⑴阳贷——又叫阳虎，季氏的家臣。季氏几代以来把持鲁国的政治，阳货这时正又把持季氏的权柄。最后因企图削除三桓而未成，逃往晋国。⑵归孔子豚——“归”同“馈”，赠送也。《孟子·滕文公下》对这事有一段说明，他说，当时，“大夫有赐于士，不得受于其家，则往拜其门。”阳货便利用这一礼俗，趁孔子不在家，送一个蒸熟了的小猪去。孔子也就趁阳货不在家才去登门拜谢。⑵曰——自此以下的几个“曰”字，都是阳贷的自为问答。说本毛奇龄《论语稽求篇》引明人郝敬之说。俞樾《古书疑义举例》卷二有“一人之辞而加曰字例”，对这种修辞方式更有详细引证。⑷亟——去声，音气，qì，屡也。⑸吾将仕矣——孔子于阳虎当权之时，并未仕于阳虎。可参《左传》定公八、九年传。"
  },
  {
    "id": 478,
    "title": "陽貨 17.2",
    "text": "子曰：“性相近也，习相远也。”",
    "translation": "孔子说：“人性情本相近，因为习染不同，便相距悬远。”",
    "annotations": "【注释】"
  },
  {
    "id": 479,
    "title": "陽貨 17.3",
    "text": "子曰：“唯上知与下愚⑴不移。”",
    "translation": "孔子说：“只有上等的智者和下等的愚人是改变不了的。”",
    "annotations": "【注释】⑴上知下愚——关于“上知”下愚”的解释，古今颇有异说。《汉书·古今人表》说：“可与为善，不可与为恶，是谓上智。可与为恶，不可与为善，是谓下愚。”则是以其品质言。孙星衍《问字堂集》说：“上知谓生而知之，下愚谓困而不学。”则是兼以其知识与质量而言。译文仅就字面译出。但孔子说过“生而知之者上也”（16.9），这里的“上知”可能就是“生而知之”的人。当然这种人是不会有的。可是当时的人却以为一定有，甚至孔子都曾否认地说过“我非生而知之者”（7.20）。"
  },
  {
    "id": 480,
    "title": "陽貨 17.4",
    "text": "子之武城，闻弦歌之声。夫子莞尔而笑，曰：“割鸡焉用牛刀？”\n子游对曰：“昔者偃也闻诸夫子曰：‘君子学道则爱人，小人学道则易使也。 ’”\n子曰：“二三子！偃之言是也。前言戏之耳。”",
    "translation": "孔子到了［子游作县长］的武城，听到了弹琴瑟唱诗歌的声音。孔子微微笑着，说道：“宰鸡，何必用宰牛的刀？［治理这个小地方，用得着教育吗？］”\n子游答道：“以前我听老师说过，做官的学习了，就会有仁爱之心；老百姓学习了，就容易听指挥，听使唤。［教育总是有用的。］”\n孔子便向学生们道：“二三子！言偃的这话是正确的。我刚才那句话不过同他开顽笑吧了。”",
    "annotations": "【注释】"
  },
  {
    "id": 481,
    "title": "陽貨 17.5",
    "text": "公山弗扰⑴以费畔⑵，召，子欲往。\n子路不说，曰：“末之也，已⑶，何必公山氏之之⑷也？”\n子曰：“夫召我者，而岂徒哉⑸？如有用我者，吾其为东周乎？”",
    "translation": "公山弗扰盘踞在费邑图谋造反，叫孔子去，孔子准备去。子路很不高兴，说道：“没有地方去便算了，为什么一定要去公山氏那里呢？”\n孔子道：“那个叫我去的人，难道是白白召我吗？假若有人用我，我将使周文王武王之道在东方复兴。”",
    "annotations": "【注释】⑴公山弗扰——疑卽《左传》定公五年、八年、十二年及哀公八年之公山不狃（唯陈天祥的《四书辨疑》认为是两人）。不过《论语》所叙之事不见于《左传》，而《左传》定公十二年所叙的公山不狃反叛鲁国的事，不但没有叫孔子去，而且孔子当时正为司寇，命人打败了他。因此赵翼的《陔余丛考》、崔述的《洙泗考信録》都疑心这段文字不可信。但是其后又有一些人，如刘宝楠《论语正义》，则说赵、崔不该信《左传》而疑《论语》。我们于此等处只能存疑。⑵畔——毛奇龄说，“畔是谋逆”，译文取这一义。⑶末之也已——旧作一句读，此依武亿《经读考异》作两句读。“末”，没有地方的意思；“之”，动词，往也；“已”，止也。⑷何必公山氏之之也——“何必之公山氏也”的倒装。“之之”的第一个“之”字只是帮助倒装用的结构助词，第二个“之”字是动词。⑸而岂徒哉——“徒”下省略动宾结构，说完全是“而岂徒召我哉”。"
  },
  {
    "id": 482,
    "title": "陽貨 17.6",
    "text": "子张问仁于孔子。孔子曰：“能行五者于天下为仁矣。”\n“请问之。”曰：“恭，宽，信，敏，惠。恭则不侮，宽则得众，信则人任焉，敏则有功，惠则足以使人。”",
    "translation": "子张向孔子问仁。孔子道：“能够处处实行五种品德，便是仁人了。 ”\n子张道：“请问哪五种。”孔子道：“庄重，宽厚，诚实，勤敏，慈惠。庄重就不致遭受侮辱，宽厚就会得到大众的拥护，诚实就会得到别人的任用，勤敏就会工作效率高、贡献大，慈惠就能够使唤人。”",
    "annotations": "【注释】"
  },
  {
    "id": 483,
    "title": "陽貨 17.7",
    "text": "佛肸⑴召，子欲往。\n子路曰：“昔者由也闻诸夫子曰：‘亲于其身为不善者，君子不入也。’佛肸以中牟⑵畔，子之往也，如之何？”\n子曰：“然，有是言也。不曰坚乎，磨而不磷⑶；不曰白乎，湼⑷而不缁。吾岂匏瓜⑸也哉？焉能系而不食？”",
    "translation": "佛肸叫孔子，孔子打算去。\n子路道：“从前我听老师说过，‘亲自做坏事的人那里，君子不去的。’如今佛肸盘踞中牟谋反，您却要去，怎么说得过去呢？”\n孔子道：“对，我有过这话。但是，你不知道吗？最坚固的东西，磨也磨不薄；最白的东西，染也染不黑。我难道是匏瓜吗？哪里能够只是被悬挂着而不给人吃食呢？”",
    "annotations": "【注释】⑴佛肸——晋国赵简子攻打范中行，佛肸是范中行的家臣，为中牟的县长，因此依据中牟来抗拒赵简子。⑵中牟——春秋时晋邑，故址当在今日河北省邢台和邯郸之间，跟河南的中牟了不相涉。⑶磷——音吝，lìn，薄也。⑷湼——niè，本是一种矿物，古人用作黑色染料，这里作动词，染黑之意。⑹匏瓜——卽匏子，古有甘、苦两种，苦的不能吃，但因它比水轻，可以系于腰，用以泅渡。《国语·鲁语》“苦瓠不材，于人共济而已。”《庄子·逍遥游》：“今子有五石之匏，何不虑以为大樽，而浮乎江湖。”皆可以为证。"
  },
  {
    "id": 484,
    "title": "陽貨 17.8",
    "text": "子曰：“由也！女闻六言⑴六蔽矣乎？”对曰：“未也。”\n“居！吾语女。好仁不好学⑵，其蔽也愚⑶；好知不好学，其蔽也荡⑷；好信不好学，其蔽也贼⑸；好直不好学，共蔽也绞；好勇不好学，其蔽也乱；好刚不好学，其蔽也狂。”",
    "translation": "孔子说：“仲由，你听过有六种品德便会有六种弊病吗？”子路答道：“没有。”\n孔子道：“坐下！我告诉你。爱仁德，却不爱学问，那种弊病就是容易被人愚弄；爱耍聪明，却不爱学问，那种弊病就是放荡而无基础；爱诚实，却不爱学问，那种弊病就是［容易被人利用，反而］害了自己；爱直率，却不爱学问，那种弊病就是说话尖刻，刺痛人心；爱勇敢，却不爱学问，那种弊病就是捣乱闯祸；爱刚强，却不爱学问，那种弊病就是胆大妄为。”",
    "annotations": "【注释】⑴言——这个“言”字和“有一言而可以终身行之”（15.24）的“言”相同，名曰“言”，实是指“德”。“一言”，孔子拈出“恕”字；“六言”，孔子拈出“仁”、“知”、“信”、“直”、“勇”、“刚”六宇。后代“五言诗”、“七言诗”以一字为“言”之义盖本于此。⑵不好学——不学则不能明其理。⑶愚——朱熹《集注》云：“愚若可陷可罔之类。”译文取之。⑷荡——孔安国云：“荡，无所适守也。”译文取之。⑹贼——管同《四书纪闻》云：“大人之所以不必信者，惟其为学而知义之所在也。苟好信不好学，则惟知重然诺而不明事理之是非，谨厚者则硁硁为小人；苟又挟以刚勇之气，必如周汉刺客游侠，轻身殉人，扞文网而犯公义，自圣贤观之，非贼而何？”这是根据春秋侠勇之士的事实，又根据儒家明哲保身的理论所发的议论，似乎近于孔子本意。"
  },
  {
    "id": 485,
    "title": "陽貨 17.9",
    "text": "子曰：“小子何莫学夫诗？诗，可以兴，可以观，可以羣，可以怨。迩之事父，远之事君；多识于鸟兽草木之名。”",
    "translation": "孔子说：“学生们为什么没有人研究诗？读诗，可以培养联想力，可以提高观察力，可以锻炼合羣性，可以学得讽刺方法。近呢，可以运用其中道理来事奉父母；远呢，可以用来服事君上；而且多多认识鸟兽草木的名称。”",
    "annotations": "【注释】"
  },
  {
    "id": 486,
    "title": "陽貨 17.10",
    "text": "子谓伯鱼曰：“女为《周南》、《召南》⑴矣乎？人而不为《周南》、《召南》，其犹正墙面而立⑵也与？”",
    "translation": "孔子对伯鱼说道：“你研究过《周南》和《召南》了吗？人假若不研究《周南》和《召南》，那会像面正对着墙壁而站着罢！”",
    "annotations": "【注释】⑴《周南》、《召南》——现存《诗经·国风》中。但沈括《梦溪笔谈》卷三说： “《周南》、《召南》，乐名也。……有乐有舞焉，学者之事。……所谓为《周南》、《召南》者，不独诵其诗而已。”⑵正墙面而立——朱熹云：“言卽其至近之地，而一物无所见，一步不可行。”"
  },
  {
    "id": 487,
    "title": "陽貨 17.11",
    "text": "子曰：“礼云礼云，玉帛云乎哉？乐云乐云，钟鼓云乎哉？”",
    "translation": "孔子说：“礼呀礼呀，仅是指玉帛等等礼物而说的吗？乐呀乐呀，仅是指钟鼓等等乐器而说的吗？”",
    "annotations": "【注释】"
  },
  {
    "id": 488,
    "title": "陽貨 17.12",
    "text": "子曰：“色厉而内荏，譬诸小人，其犹穿窬之盗也与？”",
    "translation": "孔子说：“颜色严厉，内心怯弱，若用坏人作比喻，怕像个挖洞跳墙的小偷罢！”",
    "annotations": "【注释】"
  },
  {
    "id": 489,
    "title": "陽貨 17.13",
    "text": "子曰：“乡愿⑴，德之贼也。”",
    "translation": "孔子说：“没有真是非的好好先生是足以败坏道德的小人。“",
    "annotations": "【注释】⑴乡愿——愿音愿，yuàn，孟子作“原”。《孟子·尽心下》对“乡愿”有一段最具体的解释：“何以是嘐嘐也？言不顾行，行不顾言，则曰：‘古之人，古之人，行何为踽踽凉凉？生斯世也，为斯世也，善斯可矣。’阉然媚于世也者，是乡原也。”又说；“非之无举也，刺之无刺也。同乎流俗，合乎污世。居之似忠信，行之似廉洁。众皆悦之，自以为是，而不可与入尧舜之道。故曰‘德之贼’也。 ”"
  },
  {
    "id": 490,
    "title": "陽貨 17.14",
    "text": "子曰：“道听而涂说，德之弃也。”",
    "translation": "孔子说：“听到道路传言就四处传播，这是应该革除的作风。”",
    "annotations": "【注释】"
  },
  {
    "id": 491,
    "title": "陽貨 17.15",
    "text": "子曰：“鄙夫可与⑴事君也与哉？其未得之也，患得之当作患不得之⑵。既得之，患失之。苟患失之，无所不至矣。”",
    "translation": "孔子说：“鄙夫，难道能同他共事吗？当他没有得到职位的时候，生怕得不着；已经得着了，又怕失去。假若生怕失去，会无所不用其极了。”",
    "annotations": "【注释】⑴可与——王引之《释词》谓卽“可以”，今不取。⑵患得之——王符《潜夫论·爱日篇》云：“孔子疾夫未之得也，患不得之，既得之，患失之者。”可见东汉人所据的本子有“不”字。《荀子·子道篇》说：“孔子曰，……小人者，其未得也，则忧不得；既已得之，又恐失之。”（《说苑·杂言篇》同）此虽是述意，“得”上也有“不”字。宋人沈作喆寓简云：“东坡解云，‘患得之’当作‘患不得之’”，可见宋人所见的本子已脱此“不”字。"
  },
  {
    "id": 492,
    "title": "陽貨 17.16",
    "text": "子曰：“古者民有三疾，今也或是之亡也。古之狂也肆，今之狂也荡；古之矜也廉⑴，今之矜也忿戾；古之愚也直，今之愚也诈而已矣。”",
    "translation": "孔子说：“古代的人民还有三种［可贵的］毛病，现在呢，或许都没有了。古代的狂人肆意直言，现在的狂人便放荡无羁了；古代自己矜持的人还有些不能触犯的地方，现在自己矜持的人却只是一味老羞成怒，无理取闹罢了；古代的愚人还直率，现在的愚人却只是欺诈耍手段罢了。”",
    "annotations": "【注释】⑴廉——“廉隅”的“廉”，本义是器物的棱角，人的行为方正有威也叫“廉”。"
  },
  {
    "id": 493,
    "title": "陽貨 17.17",
    "text": "子曰：“巧言令色，鲜矣仁⑴。”",
    "translation": "译文：孔子说：“花言巧语，伪善的面貌，这种人，‘仁德’是不会多的。”",
    "annotations": "【注释】⑴见学而篇（1.3）。"
  },
  {
    "id": 494,
    "title": "陽貨 17.18",
    "text": "子曰：“恶紫之夺朱⑴也，恶郑声之乱雅乐也，恶利口之覆邦家者。”",
    "translation": "孔子说：“紫色夺去了大红色的光彩和地位，可憎恶；郑国的乐曲破坏了典雅的乐曲，可憎恶；强嘴利舌颠覆国家，可憎恶。”",
    "annotations": "【注释】⑴紫之夺朱——春秋时候，鲁桓公和齐桓公都喜欢穿紫色衣服。从《左传》哀公十七年卫浑良夫“紫衣狐裘”而被罪的事情看来，那时的紫色可能已代替了朱色而变为诸侯衣服的正色了。"
  },
  {
    "id": 495,
    "title": "陽貨 17.19",
    "text": "子曰：“予欲无言。”子贡曰：“子如不言，则小子何述焉？”子曰：“天何言哉？四时行焉，百物生焉，天何言哉？”",
    "translation": "孔子说：“我想不说话了。”子贡道：“您假若不说话，那我们传述什么呢？”孔子道：“天说了什么呢？四季照样运行，百物照样生长，天说了什么呢？”",
    "annotations": "【注释】"
  },
  {
    "id": 496,
    "title": "陽貨 17.20",
    "text": "孺悲⑴欲见孔子，孔子辞以疾⑵。将命者出户，取瑟而歌，使之闻之。",
    "translation": "孺悲来，要会晤孔子，孔子托言有病，拒绝接待。传命的人刚出房门，孔子便把瑟拿下来弹，并且唱着歌，故意使孺悲听到。",
    "annotations": "【注释】⑴孺悲——鲁国人。《礼记·杂记》云：“恤由之丧，哀公使孺悲之孔子学士丧礼，《士丧礼》于是乎书。”⑵辞以疾——《孟子·告子下》说：“教亦多术矣。予不屑之教诲也者，是亦教诲之而已矣。”孔子故意不接见孺悲，并且使他知道，是不是也是如此的呢？"
  },
  {
    "id": 497,
    "title": "陽貨 17.21",
    "text": "宰我问：“三年之丧，期已久矣。君子三年不为礼，礼必坏；三年不为乐，乐必崩。旧谷既没，新谷既升，钻燧改火⑴，期⑵可已矣。”\n子曰：“食夫稻⑶，衣夫锦，于女安乎？”\n曰：“安。”\n“女安，则为之！。夫君子之居丧，食旨不甘，闻乐不乐，居处不安⑷，故不为也。今女安，则为之！”\n宰我出，子曰：“予之不仁也！子生三年，然后免于父母之怀。夫三年之丧，\n天下之通丧也，予也有三年之爱于其父母乎！”",
    "translation": "宰我间道：“父母死了，守孝三年，为期也太久了。君子有三年不去习礼仪，礼仪一定会废弃掉；三年不去奏音乐，音乐一定会失传。陈谷既已吃完了，新谷又已登场；打火用的燧木又经过了一个轮回，一年也就可以了。”\n孔子道：“［父母死了，不到三年，］你便吃那个白米饭，穿那个花缎衣，你心里安不安呢？”\n宰我道：“安。”\n孔子便抢着道：“你安，你就去干吧，君子的守孝，吃美味不晓得甜，听音乐不觉得快乐，住在家里不以为舒适，才不这样干。如今你既然觉得心安，便去干好了。”\n宰我退了出来。孔子道：“宰予真不仁呀，儿女生下地来，三年以后才能完全脱离父母的怀抱。替父母守孝三年，天下都是如此的。宰予难道就没有从他父母那里得着三年怀抱的爱护吗？”",
    "annotations": "【注释】钻燧改火——古代用的是钻木取火的方法，被钻的木，四季不同，所谓“春取榆柳之火，夏取枣杏之火，季夏取桑柘之火，秋取柞楢之火，冬取槐檀之火”（马融引《周书·月令篇》文），一年一轮回。⑵期——同朞，音基。jī，一年。⑶稻——古代北方以稷（小米）为主要粮食，水稻和粱（精细的小米）是珍品，而稻的耕种面积更小，所以这里特别提出它来和“锦”为对文。⑷居处不安——古代孝子要“居倚庐，寝苫枕块”，就是住临时用草料木料搭成的凶庐，睡在用草编成的藁垫上，用土块做枕头。这里的“居处”是指平日的居住生活而言。"
  },
  {
    "id": 498,
    "title": "陽貨 17.22",
    "text": "子曰：“饱食终日，无所用心，难矣哉！不有博⑴弈者乎？为之，犹贤乎已⑵。”",
    "translation": "孔子说：“整天吃饱了饭，什么事也不做，不行的呀！不是有掷采下弈的游戏吗？干干也比闲着好。”",
    "annotations": "【注释】⑴博——古代的一种棊局。焦循的《孟子正义》说：“盖弈但行棊，博以掷采（骰子）而后行棊。”又说：“后人不行棊而专掷采，遂称掷采为博（赌博），博与弈益远矣。”⑵犹贤乎已——句法与意义和《墨子·法仪篇》的“犹逾（同愈）已”，《孟子·尽心上》的“犹愈于已”全同。“已”是不动作的意思。"
  },
  {
    "id": 499,
    "title": "陽貨 17.23",
    "text": "子路曰：“君子尚⑴勇乎？”子曰：“君子义以为上⑴，君子有勇而无义为乱，小人有勇而无义为盗。”",
    "translation": "子路问道：“君子尊贵勇敢不？”孔子道：“君子认为义是最可尊贵的，君子只有勇，没有义，就会捣乱造反；小人只有勇，没有义，就会做土匪强盗。”",
    "annotations": "【注释】⑴尚，上——“尚勇”的“尚”和“上”相同。不过用作动词。"
  },
  {
    "id": 500,
    "title": "陽貨 17.24",
    "text": "子贡曰：“君子亦有恶乎？”子曰：“有恶：恶称人之恶者，恶居下流流字衍文⑴而讪上者，恶勇而无礼者，恶果敢而窒者。”\n曰：“赐也亦有恶乎？”“恶徼以为知者，恶不孙以为勇者，恶讦以为直者。”",
    "translation": "子贡道：“君子也有憎恨的事吗？”孔子道：“有憎恨的事：憎恨一味传播别人的坏处的人，憎恨在下位而毁谤上级的人，憎恨勇敢却不懂礼节的人，憎恨勇于贯彻自己的主张，却顽固不通、执抝到底的人。”\n孔子又道：“赐，你也有憎恶的事吗？”子贡随卽答道：“我憎恨偷袭别人的成绩却作为自己的聪明的人，憎恨毫不谦虚却自以为勇敢的人，憎恨揭发别人阴私却自以为直率的人。”",
    "annotations": "【注释】⑴下流——根据惠栋的《九经古义》和冯登府的《论语异文考证》，证明了晚唐以前的本子没有这个“流”字。案文义，这个“流”字也是不应该有的。但苏轼〈上韩太尉书〉引此文时已有“流”字，可见北宋时已经误衍。"
  },
  {
    "id": 501,
    "title": "陽貨 17.25",
    "text": "子曰：“唯女子与小人为难养也，近之则不孙，远之则怨。”",
    "translation": "孔子道：“只有女子和小人是难得同他们共处的，亲近了，他会无礼；疏远了，他会怨恨。”",
    "annotations": "【注释】"
  },
  {
    "id": 502,
    "title": "陽貨 17.26",
    "text": "子曰：“年四十而见恶焉，其终也已⑴。”",
    "translation": "孔子说：“到了四十岁还被厌恶，他这一生也就完了。”",
    "annotations": "【注释】⑴其终也已——“已”是动词，和“末之也已”（17.4）“斯害也已”（2.16）的“已”字相同，句法更和“斯害也已”一致。“其终也”“斯害也”为主语；“已”为动词，谓语。如在“其终也”下作一停顿，文意便显豁了。"
  },
  {
    "id": 503,
    "title": "微子 18.1",
    "text": "微子⑴去之，箕子为之奴⑵，比干谏而死⑶。孔子曰：“殷有三仁焉。”",
    "translation": "［纣王昏乱残暴，］微子便离开了他，箕子做了他的奴隶，比干谏劝而被杀。孔子说：“殷商末年有三位仁人。”",
    "annotations": "【注释】⑴微子——名启，纣王的同母兄，不过当他出生时，他的母亲尚为帝乙之妾，其后才立为妻，然后生了纣，所以帝乙死后，纣得嗣立，而微子不得立。事见《吕氏春秋·仲冬纪》。古书中唯《孟子·告子篇》认为微子是纣的叔父。⑵箕子为之奴——箕子，纣王的叔父。纣王无道，他曾进谏而不听，便披发佯狂，降为奴隶。⑶比干谏而死——比干也是纣的叔父，力谏纣王，纣王说，我听说圣人的心有七个孔，便剖开他的心而死。"
  },
  {
    "id": 504,
    "title": "微子 18.2",
    "text": "柳下惠为士师，三黜。人曰：“子未可以去乎？”曰：“直道而事人，焉往而不三黜？枉道而事人，何必去父母之邦？”",
    "translation": "柳下惠做法官，多次地被撤职。有人对他说：“您不可以离开鲁国吗？”他道：“正直地工作，到哪里去不多次被撤职？不正直地工作，为什么一定要离开祖国呢？”",
    "annotations": "【注释】"
  },
  {
    "id": 505,
    "title": "微子 18.3",
    "text": "齐景公待孔子曰：“若季氏，则吾不能；以季孟之间待之。”曰：“吾老矣，不能用也。”孔子行。",
    "translation": "齐景公讲到对待孔子的打算时说：“用鲁君对待季氏的模样对待孔\n子，那我做不到；我要用次于季氏而高于孟氏的待遇来对待他。”不久，又说道：“我老了，没有什么作为了。”孔子离开了齐国。",
    "annotations": "【注释】"
  },
  {
    "id": 506,
    "title": "微子 18.4",
    "text": "齐人归女乐⑴，季桓子⑵受之，三日不朝，孔子行。",
    "translation": "齐国送了许多歌姬舞女给鲁国，季桓子接受了，三天不问政事，孔子就离职走了。",
    "annotations": "【注释】⑴齐人归女乐——“归”同“馈”。此事可参阅《史记·孔子世家》和《韩非子·内储说》。⑵季桓子——季孙斯，鲁国定公以至哀公初年时的执政上卿，死于哀公三年。"
  },
  {
    "id": 507,
    "title": "微子 18.5",
    "text": "楚狂接舆⑴歌而过孔子曰：“凤兮凤兮！何德之衰？往者不可谏，来者犹可追⑵。已而，已而！今之从政者殆而！”\n孔子下，欲与之言。趋而辟之，不得与之言。",
    "translation": "楚国的狂人接舆一面走过孔子的车子，一面唱着歌，道：“凤凰呀，凤凰呀！为什么这么倒霉？过去的不能再挽回，未来的还可不再着迷。算了吧，算了吧！现在的执政诸公危乎其危！”\n孔子下车，想同他谈谈，他却赶快避开，孔子没法同他谈。",
    "annotations": "【注释】⑴接舆——曹之升《四书摭余说》云：“《论语》所记隐士皆以其事名之。门者谓之‘晨门’，杖者谓之‘丈人’，津者谓之‘沮’、‘溺’，接孔子之舆者谓之‘接舆’，非名亦非字也。”⑵犹可追——赶得上、来得及的意思，译文因图押韵，故用意译法。"
  },
  {
    "id": 508,
    "title": "微子 18.6",
    "text": "长沮、桀溺耦而耕⑴，孔子过之，使子路问津焉。\n长沮曰：“夫执舆⑵者为谁？”\n子路曰：“为孔丘。”\n曰：“是鲁孔丘与？”\n曰：“是也。” 曰：“是知津矣。” 问于桀溺。 桀溺曰：“子为谁？” 曰：“为仲由。” 曰：“是鲁孔丘之徒与？” 对曰：“然。” 曰：“滔滔者天下皆是也，而谁以⑶易之？且而⑷与其从辟⑸人之士也，岂\n若从辟世之士哉？”耰⑹而不辍。 子路行以告。 夫子怃⑺然曰：“鸟兽不可与同羣，吾非斯人之徒与而谁与？天下有道，丘\n不与易也。”",
    "translation": "长沮、桀溺两人一同耕田，孔子在那儿经过，叫子路去问渡口。 长沮问子路道：“那位驾车子的是谁？” 子路道：“是孔丘。” 他又道：“是鲁国的那位孔丘吗？” 子路道：“是的。” 他便道：“他么，早晓得渡口在哪儿了。” 去问桀溺。 桀溺道：“您是谁？” 子路道：“我是仲由。”\n桀溺道：“您是鲁国孔丘的门徒吗？”\n答道：“对的。”\n他便道：“像洪水一样的坏东西到处都是，你们同谁去改革它呢？你若从辟世之士哉？”说完，仍旧不停地做田里工夫。\n子路回来报告给孔子。\n孔子很失望地道：“我们既然不可以同飞禽走兽合羣共处，若不同人羣打交道，又同什么去打交道呢？如果天下太平，我就不会同你们一道来从事改革了。 ”",
    "annotations": "【注释】⑴长沮、桀溺耦而耕——“长溺”“桀溺”不是真姓名。其姓名当时已经不暇询问，后世更无由知道了。耦耕是古代耕田的一种方法。春秋时代已经用牛耕田，不但由冉耕字伯牛、司马耕字子牛的现象可以看出，《国语·晋语》云：“其子孙将耕于齐，宗庙之牺为畎亩之勤”，尤为确证。耦耕的方法说法不少，都难说很精确。下文又说“耰而不辍”，则这耦耕未必是执耒，像夏炘学《礼管释·释二耜为耦》所说的。估计这个耦耕不过说二人做庄稼活罢了。1959年科学出版社《农史研究集刊》万国钧〈耦耕考〉对此有解释。上海中华书局《中华文史论丛》第三辑何兹全〈谈耦耕〉对万说有补充，也只能作参考。⑵执舆——就是执辔（拉马的缰绳）。本是子路做的，因子路已下车，所以孔子代为驾御。⑶以——与也，和下文“不可与同羣”，“斯人之徒与而谁与”，“丘不与易也”诸“与”字同义。⑷而——同“尔”。⑸辟——同“避”。⑹耰——音忧，yōu，播种之后，再以土覆之，摩而平之，使种入土，鸟不能啄，这便叫耰。⑺惄——音舞。wǔ，怃然，怅惘失意之貌。"
  },
  {
    "id": 509,
    "title": "微子 18.7",
    "text": "子路从而后，遇丈人，以杖荷筱⑴。\n子路问曰：“子见夫子乎？”\n丈人曰：“四体不勤，五谷不分⑵。孰为夫子？”植其杖而芸。\n子路拱而立。\n止子路宿，杀鸡为黍⑶而食之，见其二子焉。\n明日，子路行以告。\n子曰：“隐者也。”使子路反见之。至，则行矣。\n子路曰：“不仕无义。长幼之节，不可废也；君臣之义，如之何其废之？欲洁其身，而乱大伦。君子之仕也，行其义也。道之不行，已知之矣。”",
    "translation": "子路跟随着孔子，却远落在后面，碰到一个老头，用拐杖挑着除草用的工具。\n子路问道：“您看见我的老师吗？”\n老头道：“你这人，四肢不劳动，五谷不认识，谁晓得你的老师是什么人？”说完，便扶着拐杖去锄草。\n子路拱着手恭敬地站着。\n他便留子路到他家住宿，杀鸡、作饭给子路吃，又叫他两个儿子出来相见。\n第二天，子路赶上了孔子，报告了这件事。\n孔子道：“这是位隐士。”叫子路回去再看看他。子路到了那里，他却走开了。\n子路便道：“不做官是不对的。长幼间的关系，是不可能废弃的；君臣间的关系，怎么能不管呢？你原想不沾污自身，却不知道这样隐居便是忽视了君臣间的必要关系。君子出来做官，只是尽应尽之责。至于我们的政治主张行不通，早就知道了。”",
    "annotations": "【注释】⑴筱——音掉，diào，古代除田中草所用的工具。说文作“莜”。⑵四体不勤，五谷不分——这二句，宋吕本中《紫微杂说》以至清朱彬《经传考证》、宋翔凤《论语发微》都说是丈人说自己。其余更多人主张说是丈人责子路。译文从后说。⑶为黍——黍就是现在的黍子，也叫黄米。它比当时的主要食粮稷（小米）的收获量小，因此在一般人中也算是比较珍贵的主食。杀鸡做菜，为黍做饭，这在当时是很好的招待了。"
  },
  {
    "id": 510,
    "title": "微子 18.8",
    "text": "逸⑴民：伯夷、叔齐、虞仲、夷逸、朱张、柳下惠、少连⑵。子曰：“不降其志，不辱其身，伯夷、叔齐与！”谓“柳下惠、少连，降志辱身矣，言中伦，行中虑，其斯而已矣。”谓“虞仲、夷逸，隐居放言，身中清，废中权。我则异于\n是，无可无不可。”",
    "translation": "古今被遗落的人才有伯夷、叔齐、虞仲、夷逸、朱张、柳下惠、少连。孔子道：“不动摇自己意志，不辱没自己身份，是伯夷、叔齐罢！”又说，“柳下惠、少连降低自己意志，屈辱自己身份了，可是言语合乎法度，行为经过思虑，那也不过如此罢了。”又说：“虞仲、夷逸逃世隐居，放肆直言。行为廉洁，被废弃也是他的权术。我就和他们这些人不同，没有什么可以，也没有什么不可以。 ”",
    "annotations": "【注释】⑴逸——同“佚”，《论语》两用“逸民”，义都如此。《孟子·公孙丑上》云：“柳下惠……遗佚而不怨，阨穷而不闵。”这一“逸”正是《孟子》“遗佚”之义。说本黄式三《论语后案》。⑵虞仲、夷逸、朱张、少连——四人言行多已不可考。虞仲前人认为就是吴太伯之弟仲雍，不可信。夷逸曾见《尸子》，有人劝他做官，他不肯。少连曾见《礼记·杂记》，孔子说他善于守孝。夏炘《景紫堂文集》卷三有〈逸民虞仲、夷逸、朱张皆无考说〉，于若干附会之说有所驳正。"
  },
  {
    "id": 511,
    "title": "微子 18.9",
    "text": "大师挚⑴适齐，亚饭干适楚，三饭缭适蔡，四饭缺适秦⑵，鼓方叔入于河，播鼗武入于汉，少师阳、击磬襄入于海。",
    "translation": "太师挚逃到了齐国，二饭乐师干逃到了楚国，三饭乐师缭逃到了蔡国，四饭乐师缺逃到了秦国，打鼓的方叔入居黄河之滨，摇小鼓的武入居汉水之涯，少师阳和击磬的襄入居海边。",
    "annotations": "【注释】⑴大师挚——泰伯篇第八有“师挚之始”，不知是不是此人。⑵亚饭——古代天子诸侯用饭都得奏乐，所以乐官有“亚饭”、“三饭”、“四饭”之名。这些人究竟是何时人，已经无法肯定。"
  },
  {
    "id": 512,
    "title": "微子 18.10",
    "text": "周公谓鲁公⑴曰：“君子不施⑵其亲，不使大臣怨乎不以。故旧无大故，则不弃也。无求备于一人！”",
    "translation": "周公对鲁公说道：“君子不怠慢他的亲族，不让大臣抱怨没被信用。老臣故人没有发生严重过失，就不要抛弃他。不要对某一人求全责备！”",
    "annotations": "【注释】⑴周公、鲁公——周公，周公旦，孔子心目中的圣人。鲁公是他的儿子伯禽。⑵施——同“弛”，有些本子卽作“弛”。"
  },
  {
    "id": 513,
    "title": "微子 18.11",
    "text": "周有八士：伯达、伯适、仲突、仲忽、叔夜、叔夏、季随、季騧⑴。",
    "translation": "周朝有八个有教养的人：伯达、伯适、仲突、仲忽、叔夜、叔夏、季随、季騧。",
    "annotations": "【注释】⑴伯达等八人——此八人已经无可考。前人看见此八人两人一列，依伯、仲、叔、季排列，而且各自押韵（达适一韵，突忽一韵，夜夏一韵，随騧一韵），便说这是四对双生子。"
  },
  {
    "id": 514,
    "title": "子張 19.1",
    "text": "子张曰：“士见危致命，见得思义，祭思敬，丧思哀，其可已矣。”",
    "translation": "子张说：“读书人看见危险便肯豁出生命，看见有所得便考虑是否\n该得，祭祀时候考虑严肃恭敬，居丧时候考虑悲痛哀伤，那也就可以了。”",
    "annotations": "【注释】"
  },
  {
    "id": 515,
    "title": "子張 19.2",
    "text": "子张曰：“执德不弘⑴，信道不笃，焉能为有？焉能为亡⑵？”",
    "translation": "子张说：“对于道德，行为不坚强，信仰不忠实，［这种人，］有他不为多，没他不为少。”",
    "annotations": "【注释】⑴弘——此“弘”字就是今之“强”字，说见章炳麟《广论语骈枝》。⑵焉能为有，焉能为亡——这两句疑是当日成语。何晏《论语集解》云：“言无所轻重”，所以译文也用今日俗语来表达此意。"
  },
  {
    "id": 516,
    "title": "子張 19.3",
    "text": "子夏之门人问交于子张。子张曰：“子夏云何？”\n对曰：“子夏曰：‘可者与之，其不可者拒之。’”\n子张曰：“异乎吾所闻：君子尊贤而容众，嘉善而矜不能。我之大贤与，于\n人何所不容？我之不贤与，人将拒我，如之何其拒人也？”",
    "translation": "子夏的学生向子张问怎样去交朋友。子张道：“子夏说了些什么？”\n答道：“子夏说，可以交的去交他，不可以交的拒绝他。”\n子张道：“我所听到的与此不同：君子尊敬贤人，也接纳普通人；鼓励好人，可怜无能的人。我是非常好的人吗，对什么人不能容纳呢？我是坏人吗，别人会拒绝我，我怎能去拒绝别人呢？”",
    "annotations": "【注释】"
  },
  {
    "id": 517,
    "title": "子張 19.4",
    "text": "子夏曰：“虽小道，必有可观者焉；致远恐泥，是以君子不为也。”",
    "translation": "子夏说道：“就是小技艺，一定有可取的地方；恐怕它妨碍远大事业，所以君子不从事于它。”",
    "annotations": "【注释】"
  },
  {
    "id": 518,
    "title": "子張 19.5",
    "text": "子夏曰：“日知其所亡，月无忘其所能，可谓好学也已矣。”",
    "translation": "子夏说：“每天知道所未知的，每月复习所已能的，可以说是好学了。”",
    "annotations": "【注释】"
  },
  {
    "id": 519,
    "title": "子張 19.6",
    "text": "子夏曰：“博学而笃志⑴，切问而近思，仁在其中矣。”",
    "translation": "子夏说：“广泛地学习，坚守自己志趣；恳切地发问，多考虑当前的问题，仁德就在这中间了。”",
    "annotations": "【注释】⑴志——孔注以为“志”与“识”同，那么，“博学笃志”便是“博闻强记”之意，说虽可通，但不及译文所解恰切。"
  },
  {
    "id": 520,
    "title": "子張 19.7",
    "text": "子夏曰：“百工居肆以成其事，君子学以致其道。”",
    "translation": "子夏说：“各种工人居住于其制造场所完成他们的工作，君子则用学习获得那个道。”",
    "annotations": "【注释】"
  },
  {
    "id": 521,
    "title": "子張 19.8",
    "text": "子夏曰：“小人之过也必文。”",
    "translation": "子夏说：“小人对于错误一定加以掩饰。”",
    "annotations": "【注释】"
  },
  {
    "id": 522,
    "title": "子張 19.9",
    "text": "子夏曰：“君子有三变：望之俨然，卽之也温，听其言也厉。”",
    "translation": "子夏说：“君子有三变：远远望着，庄严可畏；向他靠拢，温和可亲；听他的话，严厉不苟。”",
    "annotations": "【注释】"
  },
  {
    "id": 523,
    "title": "子張 19.10",
    "text": "子夏曰：“君子信而后劳其民；未信，则以为厉己也。信而后谏；未信，则以为谤己也。”",
    "translation": "子夏说：“君子必须得到信仰以后才去动员百姓；否则百姓会以为你在折磨他们。必须得到信任以后才去进谏，否则君上会以为你在毁谤他。”",
    "annotations": "【注释】"
  },
  {
    "id": 524,
    "title": "子張 19.11",
    "text": "子夏曰：“大德不踰闲，小德出入可也。”",
    "translation": "子夏说：“人的重大节操不能踰越界限，作风上的小节稍稍放松一点是可以的。”",
    "annotations": "【注释】"
  },
  {
    "id": 525,
    "title": "子張 19.12",
    "text": "子游曰：“子夏之门人小子，当洒扫应对进退，则可矣，抑末也。本之则无，如之何？”\n子夏闻之，曰：“噫！言游过矣！君子之道，孰先传焉？孰后倦焉？譬诸草木，区以别矣。君子之道，焉可诬也？有始有卒者，其惟圣人乎！”",
    "translation": "子游道：“子夏的学生，叫他们做做打扫、接待客人、应对进退的工作，那是可以的；不过这只是末节罢了。探讨他们的学术基础却没有，怎样可以呢？”\n子夏听了这话，便道：“咳！言游说错了！君子的学术，哪一项先传授呢？哪一项最后讲述呢？学术犹如草木，是要区别为各种类别的。君子的学术，如何\n可以歪曲？［依照一定的次序去传授而］有始有终的，大概只有圣人罢！”",
    "annotations": "【注释】"
  },
  {
    "id": 526,
    "title": "子張 19.13",
    "text": "子夏曰：“仕而优则学，学而优则仕。”",
    "translation": "子夏说：“做官了，有余力便去学习；学习了，有余力便去做官。”",
    "annotations": "【注释】"
  },
  {
    "id": 527,
    "title": "子張 19.14",
    "text": "子游曰：“丧致乎哀而止。”",
    "translation": "子游说：“居丧，充分表现了他的悲哀也就够了。”",
    "annotations": "【注释】"
  },
  {
    "id": 528,
    "title": "子張 19.15",
    "text": "子游曰：“吾友张也为难能也，然而未仁。”",
    "translation": "子游说：“我的朋友子张是难能可贵的了，然而还不能做到仁。”",
    "annotations": "【注释】"
  },
  {
    "id": 529,
    "title": "子張 19.16",
    "text": "曾子曰：“堂堂⑴乎张也，难与并为仁矣。”",
    "translation": "曾子说：“子张的为人高得不可攀了，难以携带别人一同进入仁德。 ”",
    "annotations": "【注释】⑴堂堂——这是迭两字而成的形容词，其具体意义如何，古今解释纷纭。《荀子·非十二子篇》云：“弟佗其冠，神禫其辞，禹行而舜趋，是子张氏之贱儒也。”这是对子张学派的具体描写，因此我把“堂堂”译为“高不可攀”。根据《论语》和后代儒家诸书，可以证明曾子的学问重在“正心诚意”，而子张则重在言语形貌，所以子游也批评子张“然而未仁”。"
  },
  {
    "id": 530,
    "title": "子張 19.17",
    "text": "曾子曰：“吾闻诸夫子：人未有自致者也，必也亲丧乎！”",
    "translation": "曾子说：“我听老师说过，平常时候，人不可能来自动地充分发挥感情，［如果有，］一定在父母死亡的时候罢！”",
    "annotations": "【注释】"
  },
  {
    "id": 531,
    "title": "子張 19.18",
    "text": "曾子曰：“吾闻诸夫子：孟庄子⑴之孝也，其它可能也；其不改父之臣\n与父之政，是难能也。”",
    "translation": "曾子说：“我听老师说过：孟庄子的孝，别的都容易做到；而留用他父亲的僚属，保持他父亲的政治设施，是难以做到的。”",
    "annotations": "【注释】⑴孟庄子——鲁大夫孟献子仲孙蔑之子，名速。其父死于鲁襄公十九年，本人死于二十三年，相距仅四年。这一章可以和“三年无改于父之道可谓孝矣”（1.11）结合来看。"
  },
  {
    "id": 532,
    "title": "子張 19.19",
    "text": "孟氏使阳肤⑴为士师，问于曾子。曾子曰：“上失其道，民散⑵久矣。如得其情，则哀矜而勿喜！”",
    "translation": "孟氏任命阳肤做法官，阳肤向曾子求教。曾子道：“现今在上位的人不依规矩行事，百姓早就离心离德了。你假若能够审出罪犯的真情，便应该同情他，可怜他，切不要自鸣得意！”",
    "annotations": "【注释】⑴阳肤——旧注说他是曾子弟子。⑵散——黄家岱《嬹艺轩杂着·论语多齐鲁方言述》云：“散训犯法，与上下文义方接。扬氏《方言》：‘虔散，杀也。东齐曰散，青徐淮楚之间曰虔。’虔散为贼杀义。曰民散久矣，用齐语也。”译文未取此说，録之以备参考。"
  },
  {
    "id": 533,
    "title": "子張 19.20",
    "text": "子贡曰：“纣⑴之不善，不如是之甚也。是以君子恶居下流，天下之恶皆归焉。”",
    "translation": "子贡说：“商纣的坏，不像现在传说的这么厉害。所以君子憎恨居于下流，一居下流，天下的什么坏名声都会集中在他身上了。”",
    "annotations": "【注释】⑴纣——殷商最末之君，为周武王所伐，自焚而死。"
  },
  {
    "id": 534,
    "title": "子張 19.21",
    "text": "子贡曰：“君子之过也，如日月之食焉：过也，人皆见之；更也，人皆仰之。”",
    "translation": "子贡说：“君子的过失好比日蚀月蚀：错误的时候，每个人都看得见；更改的时候，每个人都仰望着。”",
    "annotations": "【注释】"
  },
  {
    "id": 535,
    "title": "子張 19.22",
    "text": "卫公孙朝⑴问于子贡曰：“仲尼焉学？”子贡曰：“文武之道，未坠于地，在人。贤者识其大者，不贤者识其小者。莫不有文武之道焉。夫子焉不学？而亦何常师之有？”",
    "translation": "卫国的公孙朝向子贡问道：“孔仲尼的学问是从哪里学来的？”子贡道：“周文王武王之道，并没有失传，散在人间。贤能的人便抓住大处，不贤能的人只抓些末节。没有地方没有文王武王之道。我的老师何处不学，又为什么要有一定的老师，专门的传授呢？”",
    "annotations": "【注释】⑴卫公孙朝——翟灏《四书考异》云：“春秋时鲁有成大夫公孙朝，见昭二十六年传；楚有武城尹公孙朝，见哀十七年传；郑子产有弟曰公孙朝，见列子。记者故系‘卫’以别之。”"
  },
  {
    "id": 536,
    "title": "子張 19.23",
    "text": "叔孙武叔⑴语大夫于朝曰：“子贡贤于仲尼。”\n子服景伯以告子贡。\n子贡曰：“譬之宫墙⑵，赐之墙也及肩，窥见室家之好。夫子之墙数仞⑶，不得其门而入，不见宗庙之美，百官⑷之富。得其门者或寡矣。夫子之云，不亦宜乎！”",
    "translation": "叔孙武叔在朝廷中对官员们说：“子贡比他老师仲尼要强些。”\n子服景伯便把这话告诉子贡。\n子贡道：“拿房屋的围墙作比喻罢：我家的围墙只有肩膀那么高，谁都可以探望到房屋的美好。我老师的围墙却有几丈高，找不到大门走进去，就看不到他那宗庙的雄伟，房舍的多种多样。能够找着大门的人或许不多罢，那么，武叔他老人家的这话，不也是自然的吗？”",
    "annotations": "【注释】⑴叔孙武叔——鲁大夫，名州仇。⑵宫墙——“宫”有围障的意义，如《礼记·丧大记》：“君为庐宫之”。“宫墙”当系一词，犹如今天的“围墙”。⑶仞——七尺曰仞（此从程瑶田《通艺録·释仞》之说）。⑷官——“官”字的本义是房舍，其后才引申为官职之义，说见俞樾《羣经平议》卷三及遇夫先生《积微居小学金石论丛》卷一。这里也是指房舍而言。"
  },
  {
    "id": 537,
    "title": "子張 19.24",
    "text": "叔孙武叔毁仲尼。子贡曰：“无以⑴为也！仲尼不可毁也。他人之贤者，丘陵也，犹可踰也；仲尼，日月也，无得而踰焉。人虽欲自绝，其何伤于日月乎？多⑵见其不知量也⑶。”",
    "translation": "叔孙武叔毁谤仲尼。子贡道：“不要这样做，仲尼是毁谤不了的。别人的贤能，好比山邱，还可以超越过去；仲尼，简直是太阳和月亮，不可能超越它。人家纵是要自绝于太阳月亮，那对太阳月亮有什么损害呢？祗是表示他不自量罢了。”",
    "annotations": "【注释】⑴以——此也，这里作副词用。⑵多——副词，祗也，适也。⑶不知量也——皇侃《义疏》解此句为“不知圣人之度量”，译文从朱熹《集注》。“也”，用法同“耳”。"
  },
  {
    "id": 538,
    "title": "子張 19.25",
    "text": "陈子禽谓子贡曰：“子为恭也，仲尼岂贤于子乎？”\n子贡曰：“君子一言以为知，一言以为不知，言不可不慎也。夫子之不可及也，犹天之不可阶而升也。夫子之得邦家者，所谓立之斯立，道之斯行，绥之斯来，动之斯和。其生也荣，其死也哀，如之何其可及也？”",
    "translation": "陈子禽对子贡道：“您对仲尼是客气罢，是谦让罢，难道他真比您还强吗？”\n子贡道：“高贵人物由一句话表现他的有知，也由一句话表现他的无知，所以说话不可不谨慎。他老人家的不可以赶得上，犹如青天的不可以用阶梯爬上去。他老人家如果得国而为诸侯，或者得到采邑而为卿大夫，那正如我们所说的一叫百姓人人能立足于社会，百姓自会人人能立足于社会；一引导百姓，百姓自会前进；一安抚百姓，百姓自会从远方来投靠；一动员百姓，百姓自会同心协力。他老人家，生得光荣，死得可惜，怎么样能够赶得上呢？”",
    "annotations": "【注释】"
  },
  {
    "id": 539,
    "title": "堯曰 20.1",
    "text": "尧曰：“咨！尔舜！天之历数在尔躬，允执其中。四海困穷，天禄永终。 ”\n舜亦以命禹⑴。\n曰：“予小子履⑴敢用玄牡，敢昭告于皇皇后帝：有罪不敢赦。帝臣不蔽⑵，简在帝心。朕躬有罪，无以万方；万方有罪，罪在朕躬。”\n周有大赉，善人是富。“虽有周亲，不如仁人。百姓有过，在予一人⑴。”\n谨权量，审法度⑴，修废官⑵，四方之政行焉。兴灭国，继绝世，举逸民，天下之民归心焉。\n所重：民、食、丧、祭。\n宽则得众，信则民任焉此五字衍文⑴，敏则有功，公则说。",
    "translation": "尧［让位给舜的时候，］说道：“啧啧！你这位舜！上天的大命已经落到你的身上了，诚实地保持着那正确罢！假若天下的百姓都陷于困苦贫穷，上天给你的禄位也会永远地终止了。”\n舜［让位给禹的时候，］也说了这一番话。\n［汤］说：“我履谨用黑色牡牛作牺牲，明明白白地告于光明而伟大的天帝：有罪的人［我］不敢擅自去赦免他。您的臣仆［的善恶］我也不隐瞒掩盖，您心里也是早就晓得的。我本人若有罪，就不要牵连天下万方；天下万方若有罪，都归我一个人来承担。”\n周朝大封诸侯，使善人都富贵起来。“我虽然有至亲，却不如有仁德之人。百姓如果有罪过，应该由我来担承。”\n检验并审定度量衡，修复已废弃的机关工作，全国的政令就都会通行了。恢复被灭亡的国家，承续已断绝的后代，提拔被遗落的人才，天下的百姓就都会心悦诚服了。\n所重视的：人民、粮食、丧礼、祭祀。\n宽厚就会得到羣众的拥护，勤敏就会有功绩，公平就会使百姓高兴。",
    "annotations": "【注释】⑴这一章的文字前后不相连贯，从宋朝苏轼以来便有许多人疑心它有脱落。我只得把它分为若干段落，逐段译注，以便观览。\n【注释】⑴予小子履——“予小子”和“予一人”都是上古帝王自称之词。从《史记·殷本记》中知道汤名天乙，甲骨卜辞作“大乙”，相传汤又名履。⑵帝臣不蔽——《墨子·兼爱下篇》此句作“有善不敢蔽”，但郑玄注此句云：“言天简阅其善恶也。”译文从郑。《墨子·兼爱下篇》和《吕氏春秋·顺民篇》都说这是成汤战胜夏桀以后，遭逢大旱，向上天祈祷求雨之词。《国语·周语上》引汤誓“余一人有罪，无以万夫”，和这“朕躬有罪，无以万方”义近。\n【注释】⑴虽有周亲……一人——刘宝楠《论语正义》引宋翔凤说，“虽有周亲”四句是周武王封诸侯之辞，尤其像封姜太公于齐之辞。\n【注释】⑴谨权量，审法度——权就是量轻重的衡量，量就是容量，度就是长度。“法度”不是法律制度之意。《史记·秦始皇本纪》和秦权、秦量的刻辞中都有“法度”一词，都是指长度的分、寸、尺、丈、引而言。所以“谨权量，审法度”两句只是“齐一度量衡”一个意思。这一说法，清初阎若璩的《四书释地》又续已发其端。⑵废官——赵佑《四书温故録》云：“或有职而无其官，或有官而不举其职，皆曰废。”这以下都是孔子的话。从文章的风格来看，也和尧告舜、成汤求雨、武王封诸侯的文诰体不同。历代注释家多以为是孔子的话，大致可信。但是刘宝楠《正义》引《汉书·律历志》“孔子陈后王之法曰，谨权量，审法度，修废官，举逸民，四方之政行矣”说：“据《志》此文，是‘谨权量’以下皆孔子语，故何休《公羊》昭三十二年注引此节文冠以孔子曰”云云，则不足为证。因为汉人引《论语》，不论是否孔子之言，多称“孔子曰”。《困学纪闻》曾举出《汉书·艺文志》引“小道可观”（19.4），《后汉书·蔡邕传》引“致远恐泥”（同上）皆以子夏之言为孔子，其实不止于此，如后汉章帝长水校尉樊鯈奏言引“博学而笃志”三句（19.6），也以子夏之言为孔子之言，《史记·田叔传》赞曰“孔子称居是国必闻其政”，又以子禽之问（1.10）为孔子之言；刘向《说苑》引“孔子曰，君子务本”，又引“孔子曰，恭近于礼”，则以有子之言为孔子之言。甚至郑玄注《曲礼》、《玉藻》，以及王充着《论衡》，引乡党篇之文，都冠以“孔子曰”。则可见《论语》之书当时似别称“孔子”，如“孟子书”之称孟子者然。翟灏《四书考异》据《尸子·广泽篇》、“墨子贵兼，孔子贵公，皇子贵衷”云云，以为先儒以孔子杂诸子中；又据《论衡·率性篇》云“孔子道德之祖，诸子中最卓者也”谓当时等孔子于诸子，其言不为无据（说本《诂经精舍三集》吴承志〈汉人引孔门诸子言皆称孔子说〉）。若此，则刘氏所举不足为证矣。\n【注释】⑴信则民任焉——《汉石经》无此五字，《天文本校勘记》云：“皇本、唐本、津藩本、正平本均无此句。”足见这一句是因阳货篇“信则人任焉”而误\n增的。阳货篇作“人”，“人”是领导。此处误作“民”。“民”指百姓。有信实，就会被百姓任命，这种思想绝非孔子之所能有，尤其可见此句不是原文。"
  },
  {
    "id": 540,
    "title": "堯曰 20.2",
    "text": "子张问于孔子曰：“何如斯可以从政矣？” 子曰：“尊五美，屏⑴四恶，斯可以从政矣。” 子张曰：“何谓五美？” 子曰：“君子惠而不费，劳而不怨，欲而不贪⑵，泰而不骄，威而不猛。” 子张曰：“何谓惠而不费？” 子曰：“因民之所利而利之，斯不亦惠而不费乎？择可劳而劳之，又谁怨？\n欲仁而得仁，又焉贪？君子无众寡，无小大，无敢慢，斯不亦泰而不骄乎？君子正其衣冠，尊其瞻视，俨然人望而畏之，斯不亦威而不猛乎？” 子张曰：“何谓四恶？” 子曰：“不教而杀谓之虐；不戒视成谓之暴；慢令致期谓之贼；犹之⑶与人也，出纳⑷之吝谓之有司⑸。”",
    "translation": "子张向孔子问道：“怎样就可以治理政事呢？” 孔子道：“尊贵五种美德，排除四种恶政，这就可以治理政事了。” 子张道：“五种美德是些什么？” 孔子道：“君子给人民以好处，而自己却无所耗费；劳动百姓，百姓却不怨恨；自己欲仁欲义，却不能叫做贪；安泰矜持却不骄傲；威严却不凶猛。” 子张道：“给人民以好处，自己却无所耗费，这应该怎么办呢？”\n孔子道：“就着人民能得利益之处因而使他们有利，这也不是给人民以好处而自己却无所耗费吗？选择可以劳动的［时间、情况和人民］再去劳动他们，又有谁来怨恨呢？自己需要仁德便得到了仁德，又贪求什么呢？无论人多人少，无论势力大小，君子都不敢怠慢他们，这不也是安泰矜持却不骄傲吗？君子衣冠整齐，目不邪视，庄严地使人望而有所畏惧，这也不是威严却不凶猛吗？”\n子张道：“四种恶政又是些什么呢？”\n孔子道：“不加教育便加杀戮叫做虐；不加申诫便要成绩叫做暴；起先懈怠，突然限期叫做贼；同是给人以财物，出手悭吝，叫做小家子气。”",
    "annotations": "【注释】⑴屏——音丙，又去声音并，bíng，屏除。⑵欲而不贪——下文云：“欲仁而得仁，又焉贪？”可见此“欲”字是指欲仁欲义而言，因之皇侃《义疏》云：“欲仁义者为廉，欲财色者为贪。”译文本此。⑶犹之——王引之《释词》云：“犹之与人，均之与人也。”⑷出纳——出和纳（入）是两个意义相反的词，这里虽然在一起连用，却只有“出”的意义，没有“纳”的意义。说本俞樾《羣经平议》。⑸有司——古代管事者之称，职务卑微，这里意译为“小家子气”。"
  },
  {
    "id": 541,
    "title": "堯曰 20.3",
    "text": "孔子曰：“不知命，无以为君子也；不知礼，无以立也；不知言⑴，无以知人也。”",
    "translation": "孔子说：“不懂得命运，没有可能作为君子；不懂得礼，没有可能立足于社会；不懂得分辨人家的言语，没有可能认识人。”",
    "annotations": "【注释】⑴知言——这里“知言”的意义和《孟子·公孙丑上》的“我知言”的“知言”相同，善于分析别人的言语，辨其是非善恶的意思。"
  }
]
